export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  ISO8601Date: { input: string; output: string; }
  ISO8601DateTime: { input: string; output: string; }
  JSON: { input: Record<string, unknown>; output: Record<string, unknown>; }
  NonEmptyString: { input: string; output: string; }
};

/** Page description split by sections */
export type About = ResourceLike & {
  __typename: 'About';
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** DB ID */
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  members: UserRecordConnection;
  membersTitle: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  sections: Array<Section>;
  type: Scalars['String']['output'];
};


/** Page description split by sections */
export type AboutMembersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<UserFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum AbundanceIndexGaugeEnum {
  /** When the abundance index is >0.25 and <=0.5 */
  DECENT = 'DECENT',
  /** When the abundance index is >0.5 and <=0.99 */
  GOOD = 'GOOD',
  /** When the abundance index is >=1 */
  GREAT = 'GREAT',
  /** When the abundance index is >0 and <=0.25 */
  TRICKY = 'TRICKY',
  /** When the abundance index is 0 */
  UNKNOWN = 'UNKNOWN'
}

export type AbundancePotential = {
  __typename: 'AbundancePotential';
  abundanceIndex: Scalars['Float']['output'];
  abundanceIndexGauge: AbundanceIndexGaugeEnum;
  recentCatchCount: Scalars['Int']['output'];
  recentDaysThreshold: Scalars['Int']['output'];
};

/** An access method describing how a water is fished */
export type AccessMethod = {
  __typename: 'AccessMethod';
  coverImage: Maybe<Image>;
  displayName: Scalars['String']['output'];
  externalId: Scalars['String']['output'];
  localizedName: Scalars['String']['output'];
};


/** An access method describing how a water is fished */
export type AccessMethodCoverImageArgs = {
  croppingStrategy?: InputMaybe<CroppingStrategyEnum>;
  filterString?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<FormatEnum>;
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

/** An edge in a connection. */
export type AccessMethodEdge = {
  __typename: 'AccessMethodEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<AccessMethod>;
};

/** The connection type for AccessMethod. */
export type AccessMethodRecordConnection = {
  __typename: 'AccessMethodRecordConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<AccessMethodEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<AccessMethod>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Average of column for records beyond pagination (limited by scopes, if applicable) */
  totalAverage: Scalars['Float']['output'];
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};

export type AccumulatedSpeciesStatistics = {
  __typename: 'AccumulatedSpeciesStatistics';
  /** An array of the statistics data */
  bins: Array<StatisticsData>;
  /**
   * The corresponding species. If this value is null, the statistic
   * does not correspond to a single species (i.e multiple species)
   *
   */
  species: Maybe<Species>;
};

export type AccumulatedStatistics = {
  __typename: 'AccumulatedStatistics';
  /** An array of the statistics data */
  bins: Array<StatisticsData>;
};

/** Describes an action (in the form of a mutation) that thecurrent user can perform on the object containing the `Action` */
export type Action = {
  __typename: 'Action';
  args: Maybe<Array<Input>>;
  description: Maybe<Scalars['String']['output']>;
  /** Mutation's name as it is defined in the schema */
  name: Scalars['String']['output'];
};

export type ActiveOffer = {
  __typename: 'ActiveOffer';
  duration: Scalars['String']['output'];
  expiresAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Promotion slug (used as stable cache identifier) */
  id: Scalars['String']['output'];
};

export type ActiveStorageImageUpload = {
  /** signedId parameter returned by createDirectUploadUrl mutation */
  signedId: Scalars['String']['input'];
};

export type ActivityScoreBreakdown = {
  __typename: 'ActivityScoreBreakdown';
  /** Impact of the air temperature on the activity score */
  airTemperatureCondition: Maybe<AirTemperatureCondition>;
  /** Earliest date eligible for activity score for specified location */
  earliestAvailableDate: Scalars['ISO8601Date']['output'];
  /** Earliest hour of the day (0-23) for the activity score in location's local timezone */
  earliestAvailableHour: Scalars['Int']['output'];
  /** Earliest time of day eligible for activity score for specified location */
  earliestAvailableTimeOfDay: TimeOfDayTypes;
  /** Impact of light/cloud-cover conditions on the activity score */
  lightCondition: LightCondition;
  /** Impact of the current moon phase on the activity score */
  moonPhaseCondition: Maybe<MoonPhaseCondition>;
  /** Impact of the barometric pressure trend on the activity score */
  pressureTrendCondition: PressureTrendCondition;
  /** Overall activity score with a breakdown by condition */
  scoreDetails: ScoreDetails;
  /** Impact of the time of day on the activity score */
  timeBaseCondition: TimeBaseCondition;
  /** Impact of water temperature on the activity score */
  waterTemperatureCondition: WaterTemperatureCondition;
  /** Impact of wind conditions on the activity score */
  windCondition: WindCondition;
};

export type Ad = {
  __typename: 'Ad';
  id: Scalars['String']['output'];
  units: Scalars['Int']['output'];
};

/** Autogenerated input type of AddStaffMutation */
export type AddStaffMutationInput = {
  attributes: PageUsers;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
};

/** Autogenerated return type of AddStaffMutation. */
export type AddStaffMutationPayload = {
  __typename: 'AddStaffMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  page: Page;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

export type AdminInvitation = GroupInvitation & {
  __typename: 'AdminInvitation';
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  externalId: Scalars['String']['output'];
  group: Group;
  /**
   * DB ID
   * @deprecated Use `externalId` instead
   */
  id: Scalars['Int']['output'];
  invited: User;
  inviter: User;
};

/** An edge in a connection. */
export type AdminInvitationEdge = {
  __typename: 'AdminInvitationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<AdminInvitation>;
};

/** The connection type for AdminInvitation. */
export type AdminInvitationRecordConnection = {
  __typename: 'AdminInvitationRecordConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<AdminInvitationEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<AdminInvitation>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Average of column for records beyond pagination (limited by scopes, if applicable) */
  totalAverage: Scalars['Float']['output'];
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};

export type AirTemperatureCondition = {
  __typename: 'AirTemperatureCondition';
  /** Air temperature [K] */
  airTemperature: Scalars['Float']['output'];
  /** Condition name for the activity breakdown screen */
  displayName: Scalars['String']['output'];
  identifier: ConditionTypes;
  /** Long reason explaining condition impact on score */
  reasonLong: Scalars['String']['output'];
  /** Short reason explaining condition impact on score */
  reasonShort: Scalars['String']['output'];
  /** Conveys if the effect is positive, negative or neutral */
  stateKey: StateKeyTypes;
  /** Localized value of the weather condition */
  weatherConditionLocalizedValue: Scalars['String']['output'];
  /** World Weather Online identifier for the weather condition */
  weatherConditionWwoIdentifier: Scalars['ID']['output'];
};

export type AreaInput = {
  boundingBox?: InputMaybe<BoundingBoxInputObject>;
  boundingCircle?: InputMaybe<BoundingCircleInputObject>;
  fishingWaterExternalId?: InputMaybe<Scalars['String']['input']>;
};

export type AreaSpecies = {
  __typename: 'AreaSpecies';
  calculatedRecordLengthInM: Maybe<Scalars['Float']['output']>;
  calculatedRecordWeightInKg: Maybe<Scalars['Float']['output']>;
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** DB ID */
  id: Scalars['Int']['output'];
  recordLengthInM: Maybe<Scalars['Float']['output']>;
  recordWeightInKg: Maybe<Scalars['Float']['output']>;
  trophyLengthInM: Maybe<Scalars['Float']['output']>;
  trophyWeightInKg: Maybe<Scalars['Float']['output']>;
};

/** Autogenerated input type of AssociateProductUnitsToMeMutation */
export type AssociateProductUnitsToMeMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** One of externalIds or productUnitIds is required */
  externalIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Gear search id that led to this mutation */
  searchId?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of AssociateProductUnitsToMeMutation. */
export type AssociateProductUnitsToMeMutationPayload = {
  __typename: 'AssociateProductUnitsToMeMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  me: User;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

export type Attribute = {
  __typename: 'Attribute';
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  externalId: Scalars['String']['output'];
  /**
   * DB ID
   * @deprecated Use `externalId` instead
   */
  id: Scalars['Int']['output'];
  /** @deprecated The shop has been deprecated */
  marketplaceId: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

/** An edge in a connection. */
export type AttributeEdge = {
  __typename: 'AttributeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Attribute>;
};

/** The connection type for Attribute. */
export type AttributeRecordConnection = {
  __typename: 'AttributeRecordConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<AttributeEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<Attribute>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Average of column for records beyond pagination (limited by scopes, if applicable) */
  totalAverage: Scalars['Float']['output'];
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};

/** Autogenerated input type of AttributeTrialPromotionMutation */
export type AttributeTrialPromotionMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Promotional link for redemption */
  link: Scalars['String']['input'];
};

/** Autogenerated return type of AttributeTrialPromotionMutation. */
export type AttributeTrialPromotionMutationPayload = {
  __typename: 'AttributeTrialPromotionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Meta params of the link */
  metaParams: Maybe<Scalars['JSON']['output']>;
  /** Revenue cat offering reference/Paywall ID */
  offeringRef: Maybe<Scalars['String']['output']>;
  /** ID of partner of the promotion */
  partnerId: Maybe<Scalars['Int']['output']>;
  /** Reference of partner user who owns promotional link */
  partnerUserExternalRef: Maybe<Scalars['String']['output']>;
  /** Promotion key of the link */
  promotionKey: Maybe<Scalars['String']['output']>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

export type AttributeValue = {
  __typename: 'AttributeValue';
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  customGearStatus: CustomGearStatusTypes;
  externalId: Scalars['String']['output'];
  /**
   * DB ID
   * @deprecated Use `externalId` instead
   */
  id: Scalars['Int']['output'];
  /** @deprecated The shop has been deprecated */
  marketplaceId: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

/** The connection type for AttributeValue. */
export type AttributeValueConnection = {
  __typename: 'AttributeValueConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<AttributeValueEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<AttributeValue>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type AttributeValueEdge = {
  __typename: 'AttributeValueEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<AttributeValue>;
};

export type AttributeValueInputObject = {
  /** The external id of the attribute type for attribute value */
  attributeTypeExternalId?: InputMaybe<Scalars['String']['input']>;
  /** The external id of the existing attribute value */
  attributeValueExternalId?: InputMaybe<Scalars['String']['input']>;
  /** The name of the new attribute value */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type AttributesInputObject = {
  /** Pairs of attributeTypeExternalId and one of attributeValueExternalId or name for value. All not provided attributes are filled with default value. */
  attributeValues: Array<AttributeValueInputObject>;
  brandExternalId?: InputMaybe<Scalars['String']['input']>;
  brandImage?: InputMaybe<ActiveStorageImageUpload>;
  brandName?: InputMaybe<Scalars['String']['input']>;
  categoryExternalId: Scalars['String']['input'];
  productDescription?: InputMaybe<Scalars['String']['input']>;
  productExternalId?: InputMaybe<Scalars['String']['input']>;
  productImage?: InputMaybe<ActiveStorageImageUpload>;
  productName?: InputMaybe<Scalars['String']['input']>;
  /** Barcode */
  productUnitGtin?: InputMaybe<Scalars['String']['input']>;
  /** Model, SKU or manufacturer's part number */
  productUnitModel?: InputMaybe<Scalars['String']['input']>;
};

export type AutoFollowAttributes = {
  options: Scalars['String']['input'];
  preferredWaterKind: WaterKindTypes;
};

/** Autogenerated input type of AutoFollowMutation */
export type AutoFollowMutationInput = {
  attributes: AutoFollowAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AutoFollowMutation. */
export type AutoFollowMutationPayload = {
  __typename: 'AutoFollowMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

export type Bait = {
  __typename: 'Bait';
  /** External ID of the bait */
  externalId: Scalars['String']['output'];
  /** Origin of the bait */
  origin: BaitOriginTypes;
};

export type BaitColor = {
  __typename: 'BaitColor';
  image: Image;
  /** Bait color name */
  name: Scalars['String']['output'];
  thumbnailImage: Image;
};


export type BaitColorImageArgs = {
  croppingStrategy?: InputMaybe<CroppingStrategyEnum>;
  filterString?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<FormatEnum>;
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type BaitColorThumbnailImageArgs = {
  croppingStrategy?: InputMaybe<CroppingStrategyEnum>;
  filterString?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<FormatEnum>;
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type BaitDepth = {
  __typename: 'BaitDepth';
  /** Display name of the bait depth */
  displayName: Scalars['String']['output'];
  habitatReason: GenericBaitsInfoSection;
  /** Maximum bait depth */
  max: Scalars['Float']['output'];
  /** Minimum bait depth */
  min: Scalars['Float']['output'];
  presentationInstructions: GenericBaitsInfoSection;
  /** Target habitat of the bait depth */
  targetHabitat: Scalars['String']['output'];
  /** Unit of measurement */
  unitOfMeasurement: Maybe<Scalars['String']['output']>;
};

export type BaitFiltersInput = {
  /** Restrict bait recommendations to these bait origins. Defaults to ARTIFICIAL when omitted or empty. */
  baitOrigin?: InputMaybe<Array<BaitOriginTypes>>;
};

export enum BaitOriginTypes {
  ARTIFICIAL = 'ARTIFICIAL',
  NATURAL = 'NATURAL'
}

export type BaitRecommendation = {
  __typename: 'BaitRecommendation';
  /** Bait */
  bait: Bait;
  /** Bait action speed */
  baitActionSpeed: Maybe<Scalars['String']['output']>;
  /** Bait depth */
  baitDepth: BaitDepth;
  /** Bait size */
  baitSize: Maybe<BaitSize>;
  /**
   * Bait speed
   * @deprecated Use bait_action_speed instead
   */
  baitSpeed: Maybe<Scalars['String']['output']>;
  /** Color recommendations for this combination */
  colorRecommendation: Maybe<BaitRigCombinationColorRecommendation>;
  /** External ID of the recommended bait-rig combination */
  externalId: Scalars['String']['output'];
  highlight: Maybe<RecommendationHighlight>;
  /** How to fish section */
  howToFish: Maybe<GenericBaitsInfoSection>;
  image: Maybe<Image>;
  /** Name of the recommended bait-rig combination */
  name: Scalars['String']['output'];
  /** Presentation style */
  presentationStyle: GenericBaitsPresentationStyle;
  /** Rig */
  rig: Maybe<Rig>;
  /** Top reasons for recommendation */
  topReasonsForRecommendation: Array<Scalars['String']['output']>;
};


export type BaitRecommendationImageArgs = {
  croppingStrategy?: InputMaybe<CroppingStrategyEnum>;
  filterString?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<FormatEnum>;
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type BaitRigCombinationBaitColor = {
  __typename: 'BaitRigCombinationBaitColor';
  /** Catalog bait color */
  color: BaitColor;
  /** Image of this bait–rig combination in this color */
  image: Image;
};


export type BaitRigCombinationBaitColorImageArgs = {
  croppingStrategy?: InputMaybe<CroppingStrategyEnum>;
  filterString?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<FormatEnum>;
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type BaitRigCombinationColorRecommendation = {
  __typename: 'BaitRigCombinationColorRecommendation';
  /** Group of first recommended color */
  colorGroup: ColorGroupTypes;
  colorGroupDescription: Maybe<GenericBaitsInfoSection>;
  /** Localized name of the color group */
  colorGroupName: Scalars['String']['output'];
  colorGroupReason: Maybe<GenericBaitsInfoSection>;
  /** Title displayed for the recommended color section */
  displayName: Scalars['String']['output'];
  /** Detailed reasoning behind the color recommendations and their impact */
  longReason: Maybe<Scalars['String']['output']>;
  /** Recommended colors for this combination, with combination-specific images */
  recommendations: Maybe<Array<BaitRigCombinationBaitColor>>;
  /** Brief explanation of why these colors are effective */
  shortReason: Maybe<Scalars['String']['output']>;
  /** Water clarity condition for color recommendations */
  waterClarity: Maybe<WaterClarityTypes>;
};

export type BaitSize = {
  __typename: 'BaitSize';
  /** Display name of the bait size */
  displayName: Scalars['String']['output'];
  /** Maximum bait size */
  max: Scalars['Float']['output'];
  /** Minimum bait size */
  min: Scalars['Float']['output'];
  /** Unit of measurement */
  unitOfMeasurement: Maybe<Scalars['String']['output']>;
};

/** Bite forecast with activity scores for a species */
export type BiteForecast = {
  __typename: 'BiteForecast';
  biteScores: Array<BiteScore>;
};

/** Timeline entry with time windows and weather data */
export type BiteForecastTimeline = {
  __typename: 'BiteForecastTimeline';
  airTemperature: Scalars['Float']['output'];
  date: Scalars['ISO8601Date']['output'];
  exactTime: Scalars['ISO8601DateTime']['output'];
  timeOfDay: TimeOfDayTypes;
  timeWindowEnd: Scalars['ISO8601DateTime']['output'];
  timeWindowStart: Scalars['ISO8601DateTime']['output'];
  weatherConditionWwoIdentifier: Scalars['ID']['output'];
};

/** A single bite score forecast for a specific time window */
export type BiteScore = {
  __typename: 'BiteScore';
  /** Impact of the air temperature on the activity score */
  airTemperatureCondition: Maybe<AirTemperatureCondition>;
  /** Calendar date of the forecast */
  date: Scalars['ISO8601Date']['output'];
  /** Hour of the day (0-23) */
  hourOfDay: Scalars['Int']['output'];
  /** Impact of light/cloud-cover conditions on the activity score */
  lightCondition: LightCondition;
  /** Impact of the current moon phase on the activity score */
  moonPhaseCondition: Maybe<MoonPhaseCondition>;
  /** Impact of the barometric pressure trend on the activity score */
  pressureTrendCondition: PressureTrendCondition;
  /** Overall activity score with a breakdown by condition */
  scoreDetails: ScoreDetails;
  /** Impact of the time of day on the activity score */
  timeBaseCondition: TimeBaseCondition;
  /** Time-of-day bucket for this forecast entry (e.g. SUNRISE, MORNING) */
  timeOfDay: TimeOfDayTypes;
  /** Impact of water temperature on the activity score */
  waterTemperatureCondition: WaterTemperatureCondition;
  /** Impact of wind conditions on the activity score */
  windCondition: WindCondition;
};

/** A boundary layer representing a geographic area */
export type BoundaryLayer = {
  __typename: 'BoundaryLayer';
  /** Kind of area, e.g. country, state, region */
  boundaryType: Maybe<Scalars['String']['output']>;
  boundingBox: Maybe<BoundingBox>;
  /** ISO country code */
  countryCode: Maybe<Scalars['String']['output']>;
  /** Human-readable area name */
  name: Scalars['String']['output'];
  /** ISO state code */
  stateCode: Maybe<Scalars['String']['output']>;
};

export type BoundingBox = {
  __typename: 'BoundingBox';
  /** north-eastern corner */
  northEast: Position;
  /** south-western corner */
  southWest: Position;
};

export type BoundingBoxInputObject = {
  /** north-eastern corner */
  northEast: PositionInputObject;
  /** south-western corner */
  southWest: PositionInputObject;
};

export type BoundingCircleInputObject = {
  /** The center */
  center: PositionInputObject;
  /** Radius (in km) */
  delta: Scalars['Int']['input'];
};

export type Brand = {
  __typename: 'Brand';
  /** @deprecated This information has been moved to Page */
  aboutDescription: Maybe<Scalars['String']['output']>;
  /** @deprecated This information has been moved to Page */
  aboutTitle: Maybe<Scalars['String']['output']>;
  address: Maybe<Scalars['String']['output']>;
  categories: CategoryRecordConnection;
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  customGearStatus: CustomGearStatusTypes;
  externalId: Scalars['String']['output'];
  /** @deprecated Use `externalId` instead */
  id: Scalars['Int']['output'];
  /** @deprecated Use `logo` instead. */
  image: Maybe<BrandImage>;
  logo: Maybe<Image>;
  /** @deprecated The shop has been deprecated */
  marketplaceId: Maybe<Scalars['String']['output']>;
  /** @deprecated This information has been moved to Page */
  membersTitle: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  page: Maybe<Page>;
  products: ProductRecordConnection;
  /** @deprecated This information has been moved to Page */
  productsDescription: Maybe<Scalars['String']['output']>;
  /** @deprecated This information has been moved to Page */
  productsTitle: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
};


export type BrandCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<CategoryFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type BrandLogoArgs = {
  croppingStrategy?: InputMaybe<CroppingStrategyEnum>;
  filterString?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<FormatEnum>;
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type BrandProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ProductFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for Brand. */
export type BrandConnection = {
  __typename: 'BrandConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<BrandEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<Brand>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type BrandEdge = {
  __typename: 'BrandEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Brand>;
};

export type BrandFilters = {
  /** Return only brands which have products in given category or its descendants */
  forCategoryExternalId?: InputMaybe<Scalars['String']['input']>;
  /** Return only brands which the given string is in the name */
  nameContains?: InputMaybe<Scalars['String']['input']>;
  /** Return in ascending order by name */
  orderByName?: InputMaybe<Scalars['Boolean']['input']>;
  /** Return in descending order by popularity */
  orderByPopularity?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, return only brands with products */
  withProducts?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A brand image with url */
export type BrandImage = {
  __typename: 'BrandImage';
  url: Maybe<Scalars['String']['output']>;
};

/** The connection type for Brand. */
export type BrandRecordConnection = {
  __typename: 'BrandRecordConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<BrandEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<Brand>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Average of column for records beyond pagination (limited by scopes, if applicable) */
  totalAverage: Scalars['Float']['output'];
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};

/** Autogenerated input type of BulkCreateViewsMutation */
export type BulkCreateViewsMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  views: Array<ViewAttributes>;
};

/** Autogenerated return type of BulkCreateViewsMutation. */
export type BulkCreateViewsMutationPayload = {
  __typename: 'BulkCreateViewsMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** A generic call-to-action button */
export type Button = {
  __typename: 'Button';
  /** A 6 digit hex color code for the button background, #NNNNNN */
  backgroundColor: Maybe<Scalars['String']['output']>;
  /** The target href */
  href: Scalars['String']['output'];
  /** The call-to-action text */
  text: Scalars['String']['output'];
  /** A 6 digit hex color code for the button text, #NNNNNN */
  textColor: Maybe<Scalars['String']['output']>;
};

export type CallToAction = {
  __typename: 'CallToAction';
  /** A 6 digit hex color code for the call-to-action, #NNNNNN */
  backgroundColor: Scalars['String']['output'];
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  externalId: Scalars['String']['output'];
  /**
   * DB ID
   * @deprecated Use `externalId` instead
   */
  id: Scalars['Int']['output'];
  /** The call-to-action text */
  text: Scalars['String']['output'];
  /** The target URL */
  url: OpUrl;
};

export type CallToActionAttributes = {
  /** A 6 digit hex color code for the call-to-action, #NNNNNN */
  backgroundColor: Scalars['String']['input'];
  /** The call-to-action text */
  text: Scalars['String']['input'];
  /** The target URL */
  url: Scalars['String']['input'];
};

/** A specific fish caught by a user with details (time, gear, catch/release, etc...) */
export type Catch = {
  __typename: 'Catch';
  accessMethod: Maybe<AccessMethod>;
  /** The calculated length (in meters) of the catch based on the weight */
  calculatedLength: Maybe<Scalars['Float']['output']>;
  /** The calculated weight (in kgs) of the catch based on the length */
  calculatedWeight: Maybe<Scalars['Float']['output']>;
  catchAndRelease: Maybe<Scalars['Boolean']['output']>;
  /** Reasons why the catch is marked as invalid */
  catchInvalidReasons: CatchInvalidReasonRecordConnection;
  /** Species identifications for this catch from other users. */
  catchSpeciesIdentifications: CatchSpeciesIdentificationRecordConnection;
  caughtAtGmt: Maybe<Scalars['ISO8601DateTime']['output']>;
  caughtAtLocalTimeZone: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * Comments on this catch
   * @deprecated Use comments on the catch's post
   */
  comments: PostRecordConnection;
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * User provided description of the catch
   * @deprecated Use Op::text on the catch's post
   */
  description: Maybe<Scalars['String']['output']>;
  /**
   * A pair of objects (e.g. User/FishingMethod/etc...) used for rendering where a post item came from
   * @deprecated Use displayEntity
   */
  displayEntities: PostsFeedDisplayEntities;
  displayEntity: PostsFeedDisplayEntity;
  externalId: Scalars['String']['output'];
  fishingMethod: Maybe<FishingMethod>;
  fishingWater: Maybe<FishingWater>;
  /** Flag to indicate that catch has weather conditions or not */
  hasConditions: Scalars['Boolean']['output'];
  hasExactPosition: Scalars['Boolean']['output'];
  /** Flag to indicate that catch conditions are hidden behind the paywall for the current user */
  hasHiddenConditions: Scalars['Boolean']['output'];
  /**
   * Was the catch logged with a product unit we want to hide behind the paywall?
   * @deprecated Product units are no longer hidden behind paywall
   */
  hasHiddenProductUnit: Scalars['Boolean']['output'];
  /**
   * DB ID
   * @deprecated Use `externalId` instead
   */
  id: Scalars['Int']['output'];
  /** Whether this is the owner's earliest approved catch. */
  isFirstCatch: Scalars['Boolean']['output'];
  isPersonalBest: Scalars['Boolean']['output'];
  /** Is the catch pinned? */
  isPinned: Scalars['Boolean']['output'];
  isTrophyFish: Scalars['Boolean']['output'];
  latitude: Maybe<Scalars['Float']['output']>;
  /** User-specified length of the catch in m */
  length: Maybe<Scalars['Float']['output']>;
  /**
   * If the current user has liked this catch
   * @deprecated Use Post.likedByCurrentUser
   */
  likedByCurrentUser: Scalars['Boolean']['output'];
  /**
   * User who have liked the catch
   * @deprecated Use likers on catch's post
   */
  likers: UserRecordConnection;
  /** Level of publicity the catch owner has given to the catch location */
  locationPrivacy: CatchLocationPrivacyTypes;
  longitude: Maybe<Scalars['Float']['output']>;
  /** The moon phase when the catch was made. */
  moonIllumination: Maybe<MoonIlluminationTypes>;
  /** The moon position when the catch was made. */
  moonPosition: Maybe<SunPositionTypes>;
  /** @deprecated Use Post.images instead */
  photos: ImageRecordConnection;
  /** @deprecated Use Post.images instead */
  photosDetails: ImageRecordConnection;
  post: Post;
  privateFishingWater: Scalars['Boolean']['output'];
  /** Notes that only the catch owner can create, read, update and delete */
  privateNotes: Maybe<Scalars['String']['output']>;
  privatePosition: Scalars['Boolean']['output'];
  productUnits: ProductUnitRecordConnection;
  /** Uses catch location if possible to find recommendations for this catch */
  recommendedCatches: CatchRecordConnection;
  species: Maybe<Species>;
  staffPicked: Scalars['Boolean']['output'];
  /** A list of post-like objects suggested for this catch */
  suggestedItems: PostsFeedConnection;
  /** A suggested water name from the catch owner */
  suggestedWaterName: Maybe<SuggestedWaterName>;
  /** The sun position when the catch was made. */
  sunPosition: Maybe<SunPositionTypes>;
  /** Trip this catch is part of */
  trip: Maybe<Trip>;
  /** Owner of the catch */
  user: User;
  weatherAndMarineReading: Maybe<WeatherAndMarineReading>;
  /** User-specified weight of the catch in kg */
  weight: Maybe<Scalars['Float']['output']>;
};


/** A specific fish caught by a user with details (time, gear, catch/release, etc...) */
export type CatchCatchInvalidReasonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A specific fish caught by a user with details (time, gear, catch/release, etc...) */
export type CatchCatchSpeciesIdentificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A specific fish caught by a user with details (time, gear, catch/release, etc...) */
export type CatchCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<PostFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A specific fish caught by a user with details (time, gear, catch/release, etc...) */
export type CatchLikersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<UserFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A specific fish caught by a user with details (time, gear, catch/release, etc...) */
export type CatchPhotosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  croppingStrategy?: InputMaybe<CroppingStrategyEnum>;
  filterString?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  format?: InputMaybe<FormatEnum>;
  height?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


/** A specific fish caught by a user with details (time, gear, catch/release, etc...) */
export type CatchPhotosDetailsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  croppingStrategy?: InputMaybe<CroppingStrategyEnum>;
  filterString?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  format?: InputMaybe<FormatEnum>;
  height?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


/** A specific fish caught by a user with details (time, gear, catch/release, etc...) */
export type CatchProductUnitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ProductUnitFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A specific fish caught by a user with details (time, gear, catch/release, etc...) */
export type CatchRecommendedCatchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<CatchFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A specific fish caught by a user with details (time, gear, catch/release, etc...) */
export type CatchSuggestedItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  scopes?: InputMaybe<Array<PostFeedEnum>>;
  testData?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CatchAttributes = {
  accessMethodId?: InputMaybe<Scalars['String']['input']>;
  autoselectedSpeciesSuggestionId?: InputMaybe<Scalars['String']['input']>;
  catchAndRelease?: InputMaybe<Scalars['Boolean']['input']>;
  caughtAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fishingMethodId?: InputMaybe<Scalars['String']['input']>;
  fishingWaterId?: InputMaybe<Scalars['String']['input']>;
  isPersonalBest?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  locationPrivacy?: InputMaybe<CatchLocationPrivacyTypes>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /** An array of signed IDs from direct upload urls */
  photos?: InputMaybe<Array<Scalars['String']['input']>>;
  privacies?: InputMaybe<Array<CatchPrivacyTypes>>;
  privateFishingWater?: InputMaybe<Scalars['Boolean']['input']>;
  privateNotes?: InputMaybe<Scalars['String']['input']>;
  productUnitIds?: InputMaybe<Array<Scalars['String']['input']>>;
  speciesId?: InputMaybe<Scalars['String']['input']>;
  suggestedWaterNameId?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type CatchBatchReference = {
  __typename: 'CatchBatchReference';
  catchesAttributesCount: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['String']['output'];
  processingErrors: Maybe<Scalars['String']['output']>;
  /** The current state of the referenced batch */
  state: ReferenceProcessingStateTypes;
  user: User;
};

export enum CatchCalculationAttributes {
  LENGTH = 'LENGTH',
  WEIGHT = 'WEIGHT',
  WEIGHT_OR_CALCULATED_WEIGHT = 'WEIGHT_OR_CALCULATED_WEIGHT'
}

export type CatchConditions = {
  __typename: 'CatchConditions';
  /** Detailed breakdown of the activity score based on current fishing conditions */
  activityScore: Maybe<ActivityScoreBreakdown>;
  /** Bait recommendations based on current fishing conditions */
  baitRecommendations: Maybe<Array<BaitRecommendation>>;
  isLocked: Scalars['Boolean']['output'];
  /** Vegetation options with default value */
  vegetationOptions: Maybe<VegetationOptionsSet>;
  /** Water Clarity options with default value */
  waterClarityOptions: Maybe<WaterClarityOptionsSet>;
  /** Water Depth options with default value */
  waterDepthOptions: Maybe<WaterDepthOptionsSet>;
};

export type CatchConditionsInput = {
  area?: InputMaybe<AreaInput>;
  /** Filters to apply to bait recommendations. */
  baitFilters?: InputMaybe<BaitFiltersInput>;
  date?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Hour of the day (0-23) */
  hourOfDay?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Indicates hourly vs non-hourly context to assign the correct night bucket date \
   * and time_of_day value (e.g., hour 0..3 maps to previous day if non-hourly, otherwise current day)
   */
  hourlyContext?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  timeOfDay?: InputMaybe<TimeOfDayTypes>;
  vegetation?: InputMaybe<VegetationTypes>;
  waterClarity?: InputMaybe<WaterClarityTypes>;
  waterDepth?: InputMaybe<WaterDepthTypes>;
};

/** An edge representing a catch */
export type CatchEdge = {
  __typename: 'CatchEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Catch>;
  /** Why this catch is in this collection */
  reasons: Array<Scalars['String']['output']>;
};

export type CatchFilters = {
  accessMethodId?: InputMaybe<Scalars['String']['input']>;
  /** Only catches caught between these dates */
  caughtBetweenDates?: InputMaybe<DateRangeInputObject>;
  /** Only catches caught in the given list of months disregarding the year */
  caughtInMonths?: InputMaybe<Array<MonthEnum>>;
  /** Only catches caught in the given list of years */
  caughtInYears?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Excludes the catch with this externalId from the results */
  excludingCatch?: InputMaybe<Scalars['String']['input']>;
  /** Excludes catches from the trip with this id from the results */
  excludingTrip?: InputMaybe<Scalars['ID']['input']>;
  /** Exclude catches for the user specified by externalId */
  excludingUserExternalId?: InputMaybe<Scalars['String']['input']>;
  fishingMethodId?: InputMaybe<Scalars['String']['input']>;
  /** Return only public-location catches for the given fishing water */
  fishingWaterId?: InputMaybe<Scalars['String']['input']>;
  /** Only catches which have a length set */
  havingLength?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only those catches which have at least one product unit */
  havingProductUnits?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only catches whose post has a non-empty text */
  havingText?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only catches which have a weight set */
  havingWeight?: InputMaybe<Scalars['Boolean']['input']>;
  /** Return only personal bests */
  isPersonalBest?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only those catches which are pinned. */
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only catches created in the last N days */
  lastNDays?: InputMaybe<Scalars['Int']['input']>;
  /** Return in descending order by the time the catch was caught */
  orderByCaughtAt?: InputMaybe<Scalars['Boolean']['input']>;
  /** Return in descending order by length */
  orderByLength?: InputMaybe<Scalars['Boolean']['input']>;
  /** Return in descending order by length or calculated length if length is missing */
  orderByLengthOrCalculatedLength?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sort in descending order by number of likes */
  orderByLikes?: InputMaybe<Scalars['Boolean']['input']>;
  /** Return descending order by creation date / time */
  orderByRecent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Return in ascending order by trip rank. Only applicable on Trip.catches */
  orderByTripRank?: InputMaybe<Scalars['Boolean']['input']>;
  /** Return in descending order by weight */
  orderByWeight?: InputMaybe<Scalars['Boolean']['input']>;
  /** Return in descending order by weight or calculated weight if weight is missing */
  orderByWeightOrCalculatedWeight?: InputMaybe<Scalars['Boolean']['input']>;
  /** Return pinned catches first */
  pinnedCatchesFirst?: InputMaybe<Scalars['Boolean']['input']>;
  /** Return only catches logged with the given product unit */
  productUnitId?: InputMaybe<Scalars['String']['input']>;
  /** Only those catches which are approved to show in the shop. */
  shopFriendly?: InputMaybe<Scalars['Boolean']['input']>;
  speciesIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The water types where the species lives */
  speciesWaterSalinity?: InputMaybe<Array<WaterSalinity>>;
  /** Only catches which are deemed trophies. */
  trophyFish?: InputMaybe<Scalars['Boolean']['input']>;
  /** Return only catches for the user specified by externalId */
  userExternalId?: InputMaybe<Scalars['String']['input']>;
  /** Return only catches for the given bait */
  withBait?: InputMaybe<Scalars['String']['input']>;
  /** Only catches with invalid reasons */
  withInvalidReasons?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only catches that have photos */
  withPhotos?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only catches that have a latitude/longitude set and whose position is marked as public */
  withPublicPosition?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only catches without species */
  withoutSpecies?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CatchGuessGame = {
  __typename: 'CatchGuessGame';
  catches: Array<Catch>;
  id: Scalars['ID']['output'];
};

export type CatchGuessResult = {
  __typename: 'CatchGuessResult';
  actualLat: Maybe<Scalars['Float']['output']>;
  actualLon: Maybe<Scalars['Float']['output']>;
  distanceMeters: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
};

export type CatchInvalidReason = {
  __typename: 'CatchInvalidReason';
  createdAt: Scalars['ISO8601DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  reason: CatchInvalidReasonEnum;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** An edge in a connection. */
export type CatchInvalidReasonEdge = {
  __typename: 'CatchInvalidReasonEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<CatchInvalidReason>;
};

export enum CatchInvalidReasonEnum {
  INVALID_WEIGHT_LENGTH_RATIO = 'INVALID_WEIGHT_LENGTH_RATIO',
  LENGTH_DOES_NOT_MATCH_PHOTO = 'LENGTH_DOES_NOT_MATCH_PHOTO',
  LENGTH_EXCEEDS_SPECIES_MAX_LIMIT = 'LENGTH_EXCEEDS_SPECIES_MAX_LIMIT',
  LENGTH_EXCEEDS_SPECIES_RECORD = 'LENGTH_EXCEEDS_SPECIES_RECORD',
  LOCATION_ON_LAND = 'LOCATION_ON_LAND',
  WEIGHT_DOES_NOT_MATCH_PHOTO = 'WEIGHT_DOES_NOT_MATCH_PHOTO',
  WEIGHT_EXCEEDS_SPECIES_MAX_LIMIT = 'WEIGHT_EXCEEDS_SPECIES_MAX_LIMIT',
  WEIGHT_EXCEEDS_SPECIES_RECORD = 'WEIGHT_EXCEEDS_SPECIES_RECORD'
}

/** The connection type for CatchInvalidReason. */
export type CatchInvalidReasonRecordConnection = {
  __typename: 'CatchInvalidReasonRecordConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CatchInvalidReasonEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<CatchInvalidReason>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Average of column for records beyond pagination (limited by scopes, if applicable) */
  totalAverage: Scalars['Float']['output'];
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};

/** How the catch owner has shared the location of the catch. */
export enum CatchLocationPrivacyTypes {
  /** Only fishing water shared */
  COMPETITIVE = 'COMPETITIVE',
  /** Neither fishing water nor position shared */
  PRIVATE = 'PRIVATE',
  /** Fishing water and exact position shared */
  PUBLIC = 'PUBLIC'
}

export enum CatchPrivacyTypes {
  /** Catch will not be shown in the feed */
  no_feed = 'no_feed',
  /** Catch will not generate push notifications */
  no_push_notification = 'no_push_notification'
}

/** The connection type for Catch. */
export type CatchRecordConnection = {
  __typename: 'CatchRecordConnection';
  /** List of years with at least one catch */
  caughtYearSummary: Maybe<Array<Scalars['Int']['output']>>;
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CatchRecordEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<Catch>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** List of anglers for given set of catches */
  topAnglers: Maybe<TopAnglersConnection>;
  /** The top fishing methods for this set of catches */
  topFishingMethods: Array<FishingMethod>;
  /** The most used product units for this set of catches */
  topProductUnits: Array<ProductUnit>;
  /** The most caught species for this set of catches */
  topSpecies: Array<Species>;
  /** The top species for this set of catches */
  topSpeciesSummary: Maybe<TopSpeciesConnection>;
  /** The top 10 waters for this set of catches */
  topWaters: Array<TopWaters>;
  /** Average of column for records beyond pagination (limited by scopes, if applicable) */
  totalAverage: Scalars['Float']['output'];
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};


/** The connection type for Catch. */
export type CatchRecordConnectionTopAnglersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The connection type for Catch. */
export type CatchRecordConnectionTopSpeciesSummaryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The connection type for Catch. */
export type CatchRecordConnectionTotalAverageArgs = {
  attribute?: InputMaybe<CatchCalculationAttributes>;
};

/** An edge in a connection. */
export type CatchRecordEdge = {
  __typename: 'CatchRecordEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Catch>;
};

export enum CatchReportReasonTypes {
  BAD_LANGUAGE_IN_COMMENTS = 'BAD_LANGUAGE_IN_COMMENTS',
  BAD_LANGUAGE_IN_DESCRIPTION = 'BAD_LANGUAGE_IN_DESCRIPTION',
  CHILD_SEXUAL_CONTENT_OR_EXPLOITATION = 'CHILD_SEXUAL_CONTENT_OR_EXPLOITATION',
  FAKE_ACCOUNT_IMPERSONATION = 'FAKE_ACCOUNT_IMPERSONATION',
  FAKE_CONTENT_AI_GENERATED_CONTENT = 'FAKE_CONTENT_AI_GENERATED_CONTENT',
  GRAPHIC_VIOLENCE_OR_ANIMAL_CRUELTY = 'GRAPHIC_VIOLENCE_OR_ANIMAL_CRUELTY',
  HARASSMENT_OR_BULLYING = 'HARASSMENT_OR_BULLYING',
  HATE_SPEECH_THREATS = 'HATE_SPEECH_THREATS',
  ILLEGAL_ACTIVITY = 'ILLEGAL_ACTIVITY',
  LENGTH_INCORRECT = 'LENGTH_INCORRECT',
  LOCATION_INCORRECT = 'LOCATION_INCORRECT',
  NON_CONSENSUAL_CONTENT = 'NON_CONSENSUAL_CONTENT',
  NOT_A_CATCH = 'NOT_A_CATCH',
  NUDITY_OR_SEXUAL_CONTENT = 'NUDITY_OR_SEXUAL_CONTENT',
  OTHER = 'OTHER',
  PERSONAL_INFO_SHARED = 'PERSONAL_INFO_SHARED',
  SCAMMING_FOR_INFORMATION = 'SCAMMING_FOR_INFORMATION',
  SPAM_OR_POSTING_INDISCRIMINATELY = 'SPAM_OR_POSTING_INDISCRIMINATELY',
  SPECIES_INCORRECT = 'SPECIES_INCORRECT',
  SUICIDE_OR_SELF_HARM_RELATED = 'SUICIDE_OR_SELF_HARM_RELATED',
  UNAUTHORIZED_SALES_OR_PROMOTION = 'UNAUTHORIZED_SALES_OR_PROMOTION',
  WEIGHT_INCORRECT = 'WEIGHT_INCORRECT'
}

/** The connection type for Catch. */
export type CatchSearchConnection = {
  __typename: 'CatchSearchConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CatchSearchEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<Catch>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total count of records beyond pagination (limited by scopes, if applicable). */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CatchSearchEdge = {
  __typename: 'CatchSearchEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Catch>;
};

/** An identification of the species of a catch. */
export type CatchSpeciesIdentification = {
  __typename: 'CatchSpeciesIdentification';
  /** The catch being identified. */
  catch: Catch;
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  externalId: Scalars['String']['output'];
  /**
   * DB ID
   * @deprecated Use `externalId` instead
   */
  id: Scalars['Int']['output'];
  /** The species being identified. */
  species: Species;
  /** Extra context provided by the user who created the identification. */
  text: Maybe<Scalars['String']['output']>;
  /** The user who created the identification. */
  user: User;
};

/** An edge in a connection. */
export type CatchSpeciesIdentificationEdge = {
  __typename: 'CatchSpeciesIdentificationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<CatchSpeciesIdentification>;
};

/** The connection type for CatchSpeciesIdentification. */
export type CatchSpeciesIdentificationRecordConnection = {
  __typename: 'CatchSpeciesIdentificationRecordConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CatchSpeciesIdentificationEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<CatchSpeciesIdentification>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Average of column for records beyond pagination (limited by scopes, if applicable) */
  totalAverage: Scalars['Float']['output'];
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};

export type CatchStatistics = {
  __typename: 'CatchStatistics';
  /** Number of catches grouped by air pressure */
  airPressure: AccumulatedStatistics;
  /** Number of catches grouped by air temperature */
  airTemperature: AccumulatedStatistics;
  /** Catches that are missing some data and are excluded from the statistics */
  catchesWithMissingData: CatchesWithMissingDataConnection;
  /** The total number of catches */
  count: Scalars['Int']['output'];
  /**
   * Number of catches grouped by month
   * @deprecated Use `trends(groupBy: MONTH_OF_YEAR)` instead
   */
  monthly: Array<AccumulatedSpeciesStatistics>;
  /** Number of catches grouped by moon illumination */
  moonIllumination: AccumulatedStatistics;
  /** Number of catches grouped by moon position */
  moonPosition: AccumulatedStatistics;
  /**
   * Summarized catch statistics for specified species or for
   *                           all species if speciesExternalId is not specified
   */
  summarizedCatchStatistics: SummarizedCatchStatistics;
  /** Number of catches grouped by sun position */
  sunPosition: AccumulatedStatistics;
  /** Top bait product units used in the catches */
  topBaits: TopBaitProductUnitsConnection;
  /** Top waters where catches were logged */
  topWaters: TopFishingWatersConnection;
  /** Number of catches grouped over time */
  trends: Array<AccumulatedSpeciesStatistics>;
  /** Number of catches grouped by water temperature */
  waterTemperature: AccumulatedStatistics;
  /** Number of catches grouped by wind direction */
  windDirection: AccumulatedStatistics;
  /** Number of catches grouped by wind speed */
  windSpeed: AccumulatedStatistics;
};


export type CatchStatisticsCatchesWithMissingDataArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CatchStatisticsMonthlyArgs = {
  segments?: InputMaybe<Scalars['Int']['input']>;
};


export type CatchStatisticsTopBaitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CatchStatisticsTopWatersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CatchStatisticsTrendsArgs = {
  groupBy: CatchTrendsGroupBy;
  segments?: InputMaybe<Scalars['Int']['input']>;
};

export enum CatchTrendsGroupBy {
  /** Groups catches by calendar month within the selected period */
  MONTH = 'MONTH',
  /** Groups catches by month of year across all years */
  MONTH_OF_YEAR = 'MONTH_OF_YEAR',
  /** Groups catches by calendar week within the selected period */
  WEEK = 'WEEK'
}

/** Catches posted to page */
export type Catches = ResourceLike & {
  __typename: 'Catches';
  catches: CatchRecordConnection;
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** DB ID */
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};


/** Catches posted to page */
export type CatchesCatchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<CatchFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents an image displaying catches positions on a map */
export type CatchesMapImage = {
  __typename: 'CatchesMapImage';
  height: Scalars['Int']['output'];
  /** The url of the image */
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

/** The connection type for Catch. */
export type CatchesWithMissingDataConnection = {
  __typename: 'CatchesWithMissingDataConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CatchEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<Catch>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};

export type Category = {
  __typename: 'Category';
  /** Flag to indicate if brands can be added or edited under this category */
  allowBrandEditing: Scalars['Boolean']['output'];
  ancestors: Array<Category>;
  /** @deprecated Use `ancestors` instead */
  ancestry: Maybe<Scalars['String']['output']>;
  /** Returns a list of attributes types for provided leaf category */
  attributeTypes: Maybe<AttributeRecordConnection>;
  /** Brands with products in the given category, including sub-categories */
  brands: BrandRecordConnection;
  children: CategoryRecordConnection;
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  externalId: Scalars['String']['output'];
  icon: Maybe<Image>;
  /**
   * Category ID
   * @deprecated Use `externalId` instead
   */
  id: Scalars['Int']['output'];
  image: Image;
  /** @deprecated The shop has been deprecated */
  marketplaceId: Maybe<Scalars['String']['output']>;
  products: ProductRecordConnection;
  root: Category;
  /** Product units found in a user's tacklebox for this category */
  tackleboxUnits: ProductUnitRecordConnection;
  title: Scalars['String']['output'];
};


export type CategoryAttributeTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CategoryBrandsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<BrandFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CategoryChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<CategoryFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CategoryIconArgs = {
  croppingStrategy?: InputMaybe<CroppingStrategyEnum>;
  filterString?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<FormatEnum>;
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type CategoryImageArgs = {
  croppingStrategy?: InputMaybe<CroppingStrategyEnum>;
  filterString?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<FormatEnum>;
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type CategoryProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ProductFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CategoryTackleboxUnitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ProductUnitFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  userExternalId?: InputMaybe<Scalars['String']['input']>;
};

/** An edge in a connection. */
export type CategoryEdge = {
  __typename: 'CategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Category>;
};

export type CategoryFilters = {
  /** Return in descending order of popularity */
  orderByPopularity?: InputMaybe<Scalars['Boolean']['input']>;
  /** Return in ascending order by rank */
  orderByRank?: InputMaybe<Scalars['Boolean']['input']>;
  /** Return in rank order of root categories, then descending order of popularity within the specified user's (String is the user's externalId) tacklebox. */
  orderByRankAndPopularityWithinTacklebox?: InputMaybe<Scalars['String']['input']>;
  /** Return in ascending order by title */
  orderByTitle?: InputMaybe<Scalars['Boolean']['input']>;
  /** Show only top level categories */
  topLevel?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, return only categories with products */
  withProducts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Show only categories missing an icon */
  withoutIcon?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The connection type for Category. */
export type CategoryRecordConnection = {
  __typename: 'CategoryRecordConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CategoryEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<Category>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Average of column for records beyond pagination (limited by scopes, if applicable) */
  totalAverage: Scalars['Float']['output'];
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};

export enum ColorGroupTypes {
  BRIGHT = 'BRIGHT',
  DARK = 'DARK',
  NATURAL = 'NATURAL',
  REFLECTIVE = 'REFLECTIVE'
}

export type CommentAttributes = {
  text?: InputMaybe<Scalars['String']['input']>;
};

/** An edge in a connection. */
export type CommentEdge = {
  __typename: 'CommentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Post>;
};

export enum ConditionTypes {
  AIR_TEMPERATURE = 'AIR_TEMPERATURE',
  LIGHT = 'LIGHT',
  MOON_PHASE = 'MOON_PHASE',
  OVERALL_ACTIVITY = 'OVERALL_ACTIVITY',
  PRESSURE_TREND = 'PRESSURE_TREND',
  TIME_BASE = 'TIME_BASE',
  WATER_TEMPERATURE = 'WATER_TEMPERATURE',
  WIND = 'WIND'
}

/** Autogenerated input type of ConfirmEmailVerificationMutation */
export type ConfirmEmailVerificationMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Email token to validate */
  token: Scalars['String']['input'];
};

/** Autogenerated return type of ConfirmEmailVerificationMutation. */
export type ConfirmEmailVerificationMutationPayload = {
  __typename: 'ConfirmEmailVerificationMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
  verified: Maybe<Scalars['Boolean']['output']>;
};

export type Consent = {
  __typename: 'Consent';
  accepted: Scalars['Boolean']['output'];
  agreementUid: Maybe<Scalars['String']['output']>;
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** DB ID */
  id: Scalars['Int']['output'];
};

export type ConsentAttributes = {
  accepted: Scalars['Boolean']['input'];
  agreementUid: Scalars['String']['input'];
};

/** An edge in a connection. */
export type ConsentEdge = {
  __typename: 'ConsentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Consent>;
};

/** The connection type for Consent. */
export type ConsentRecordConnection = {
  __typename: 'ConsentRecordConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ConsentEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<Consent>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Average of column for records beyond pagination (limited by scopes, if applicable) */
  totalAverage: Scalars['Float']['output'];
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};

export type ContactAttributes = {
  /** Contact id */
  contactId?: InputMaybe<Scalars['String']['input']>;
  /** Phone contact emails */
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Phone contact numbers */
  numbers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ContactListAttributes = {
  /** Phone contact list */
  contacts?: InputMaybe<Array<ContactAttributes>>;
};

/** The connection type for User. */
export type ContactMatchesConnection = {
  __typename: 'ContactMatchesConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ContactMatchesEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<User>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ContactMatchesEdge = {
  __typename: 'ContactMatchesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<User>;
};

/** Geocoding context */
export type Context = {
  __typename: 'Context';
  name: Maybe<Scalars['String']['output']>;
};

export type ContextualPlace = {
  __typename: 'ContextualPlace';
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  externalId: Scalars['String']['output'];
  /**
   * DB ID
   * @deprecated Use `externalId` instead
   */
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  placeType: Scalars['String']['output'];
};

/** An edge in a connection. */
export type ContextualPlaceEdge = {
  __typename: 'ContextualPlaceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<ContextualPlace>;
};

/** The connection type for ContextualPlace. */
export type ContextualPlaceRecordConnection = {
  __typename: 'ContextualPlaceRecordConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ContextualPlaceEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<ContextualPlace>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Average of column for records beyond pagination (limited by scopes, if applicable) */
  totalAverage: Scalars['Float']['output'];
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};

/** A country in the world */
export type Country = {
  __typename: 'Country';
  catches: CatchRecordConnection;
  countryName: Scalars['String']['output'];
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Country Code */
  id: Scalars['String']['output'];
  /** A 2 letter code for the country, e.g. "US" */
  iso2: Scalars['String']['output'];
  /** A 3 letter code for the country, e.g. "USA" */
  iso3: Scalars['String']['output'];
  /** An ISO number representing the country */
  isoNo: Scalars['String']['output'];
  places: PlaceRecordConnection;
  /** A list of recent posts */
  recentItems: PostsFeedConnection;
  /** The top fishing waters for the country */
  topFishingWaters: FishingWaterRecordConnection;
  /** The top species for the country */
  topSpecies: TopSpeciesConnection;
};


/** A country in the world */
export type CountryCatchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<CatchFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A country in the world */
export type CountryPlacesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<PlaceFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A country in the world */
export type CountryRecentItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  regionCode?: InputMaybe<Scalars['NonEmptyString']['input']>;
};


/** A country in the world */
export type CountryTopFishingWatersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<FishingWaterFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A country in the world */
export type CountryTopSpeciesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** An edge in a connection. */
export type CountryEdge = {
  __typename: 'CountryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Country>;
};

export type CountryFilters = {
  /** Filter countries by name prefix (case-insensitive) */
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

/** The connection type for Country. */
export type CountryRecordConnection = {
  __typename: 'CountryRecordConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CountryEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<Country>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Average of column for records beyond pagination (limited by scopes, if applicable) */
  totalAverage: Scalars['Float']['output'];
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};

/** A county in a state */
export type County = {
  __typename: 'County';
  code: Maybe<Scalars['String']['output']>;
  country: Country;
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** DB ID */
  id: Scalars['Int']['output'];
  name: Maybe<Scalars['String']['output']>;
  region: Region;
};

/** An edge in a connection. */
export type CountyEdge = {
  __typename: 'CountyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<County>;
};

/** The connection type for County. */
export type CountyRecordConnection = {
  __typename: 'CountyRecordConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CountyEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<County>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Average of column for records beyond pagination (limited by scopes, if applicable) */
  totalAverage: Scalars['Float']['output'];
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};

export type CouponGroup = {
  __typename: 'CouponGroup';
  /** The code of this MULTIPLE usage Coupon Group. Returns NULL if the usage is ONCE  */
  code: Maybe<Scalars['String']['output']>;
  couponExternalId: Scalars['String']['output'];
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  durationInMonths: Scalars['Int']['output'];
  expiresAt: Scalars['ISO8601DateTime']['output'];
  /** DB ID */
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  percentOff: Scalars['Float']['output'];
  /** The External ID of the stripe plan of this coupon group */
  stripePlan: Scalars['String']['output'];
  /** The type of this coupon group */
  type: CouponGroupTypeEnum;
  /** The usage of this coupon group */
  usage: CouponGroupUsageEnum;
};

export type CouponGroupAttributes = {
  durationInMonths: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  percentOff: Scalars['Float']['input'];
  stripeCouponId: Scalars['String']['input'];
  /** External ID of the Stripe Plan */
  stripePlanId: Scalars['String']['input'];
  typeName: CouponGroupTypeEnum;
  usageName: CouponGroupUsageEnum;
};

/** The types of Coupon Groups */
export enum CouponGroupTypeEnum {
  /** Coupon Group of type discount */
  DISCOUNT = 'DISCOUNT',
  /** Coupon Group of type gift */
  GIFT = 'GIFT'
}

/** The usage frequency for Coupon Groups */
export enum CouponGroupUsageEnum {
  /** Coupon Group where Coupons can be used multiple times */
  MULTIPLE = 'MULTIPLE',
  /** Coupon Group where Coupons can only be used once */
  ONCE = 'ONCE'
}

export type CreateCatchAttributes = {
  accessMethodId?: InputMaybe<Scalars['String']['input']>;
  autoselectedSpeciesSuggestionId?: InputMaybe<Scalars['String']['input']>;
  /** The external ID of the page as which the catch is being logged, if applicable */
  byPageId?: InputMaybe<Scalars['String']['input']>;
  catchAndRelease?: InputMaybe<Scalars['Boolean']['input']>;
  caughtAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fishingMethodId?: InputMaybe<Scalars['String']['input']>;
  fishingWaterId?: InputMaybe<Scalars['String']['input']>;
  /** The external ID of the group to which the catch belongs, if applicable */
  groupId?: InputMaybe<Scalars['String']['input']>;
  isPersonalBest?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  locationPrivacy?: InputMaybe<CatchLocationPrivacyTypes>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /** An Array of external IDs of pages on which catch will be posted, if applicable */
  pageIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** An array of signed IDs from direct upload URLs to create new photos */
  photos?: InputMaybe<Array<Scalars['String']['input']>>;
  privacies?: InputMaybe<Array<CatchPrivacyTypes>>;
  privateFishingWater?: InputMaybe<Scalars['Boolean']['input']>;
  privateNotes?: InputMaybe<Scalars['String']['input']>;
  productUnitIds?: InputMaybe<Array<Scalars['String']['input']>>;
  speciesId?: InputMaybe<Scalars['String']['input']>;
  suggestedWaterNameId?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

/** Autogenerated input type of CreateCatchGuessGameMutation */
export type CreateCatchGuessGameMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateCatchGuessGameMutation. */
export type CreateCatchGuessGameMutationPayload = {
  __typename: 'CreateCatchGuessGameMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  game: Maybe<CatchGuessGame>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** Autogenerated input type of CreateCatchMutation */
export type CreateCatchMutationInput = {
  /** attributes to create the catch with */
  attributes: CreateCatchAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateCatchMutation. */
export type CreateCatchMutationPayload = {
  __typename: 'CreateCatchMutationPayload';
  catch: Maybe<Catch>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

export type CreateCatchSpeciesIdentificationAttributes = {
  catchId: Scalars['String']['input'];
  speciesId: Scalars['String']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of CreateCatchSpeciesIdentificationMutation */
export type CreateCatchSpeciesIdentificationMutationInput = {
  attributes: CreateCatchSpeciesIdentificationAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateCatchSpeciesIdentificationMutation. */
export type CreateCatchSpeciesIdentificationMutationPayload = {
  __typename: 'CreateCatchSpeciesIdentificationMutationPayload';
  catchSpeciesIdentification: Maybe<CatchSpeciesIdentification>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

export type CreateCatchesInBatchAttributes = {
  catchesAttributes: Array<CatchAttributes>;
};

/** Autogenerated input type of CreateCatchesInBatchMutation */
export type CreateCatchesInBatchMutationInput = {
  attributes: CreateCatchesInBatchAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateCatchesInBatchMutation. */
export type CreateCatchesInBatchMutationPayload = {
  __typename: 'CreateCatchesInBatchMutationPayload';
  catchBatchReference: Maybe<CatchBatchReference>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** Autogenerated input type of CreateCouponGroupMutation */
export type CreateCouponGroupMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Custom code for the coupons of this multiple use coupon group */
  code?: InputMaybe<Scalars['String']['input']>;
  groupAttributes: CouponGroupAttributes;
  /** The number of coupons to be created for this single use coupon group */
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of CreateCouponGroupMutation. */
export type CreateCouponGroupMutationPayload = {
  __typename: 'CreateCouponGroupMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  couponGroup: Maybe<CouponGroup>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

export type CreateCuratedSpeciesCatchAttributes = {
  catchExternalId: Scalars['String']['input'];
  speciesExternalId: Scalars['String']['input'];
};

/** Autogenerated input type of CreateCuratedSpeciesCatchMutation */
export type CreateCuratedSpeciesCatchMutationInput = {
  attributes: CreateCuratedSpeciesCatchAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateCuratedSpeciesCatchMutation. */
export type CreateCuratedSpeciesCatchMutationPayload = {
  __typename: 'CreateCuratedSpeciesCatchMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  newCuratedCatch: Maybe<Catch>;
  species: Maybe<Species>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** Autogenerated input type of CreateCustomGearMutation */
export type CreateCustomGearMutationInput = {
  attributes: AttributesInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateCustomGearMutation. */
export type CreateCustomGearMutationPayload = {
  __typename: 'CreateCustomGearMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  productUnit: Maybe<ProductUnit>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** Autogenerated input type of CreateDirectUploadURLMutation */
export type CreateDirectUploadUrlMutationInput = {
  attributes: ImageUploadAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateDirectUploadURLMutation. */
export type CreateDirectUploadUrlMutationPayload = {
  __typename: 'CreateDirectUploadURLMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  directUploadUrl: Maybe<DirectUploadUrl>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** Autogenerated input type of CreateDirectUploadURLsInBatchMutation */
export type CreateDirectUploadUrLsInBatchMutationInput = {
  attributes: Array<ImageUploadAttributes>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateDirectUploadURLsInBatchMutation. */
export type CreateDirectUploadUrLsInBatchMutationPayload = {
  __typename: 'CreateDirectUploadURLsInBatchMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  directUploadUrls: Maybe<Array<DirectUploadUrl>>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** Autogenerated input type of CreateEmailVerificationMutation */
export type CreateEmailVerificationMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateEmailVerificationMutation. */
export type CreateEmailVerificationMutationPayload = {
  __typename: 'CreateEmailVerificationMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** Autogenerated input type of CreateFishingWaterBookmarkMutation */
export type CreateFishingWaterBookmarkMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Identifier for the fishing water to bookmark */
  fishingWaterId: Scalars['String']['input'];
};

/** Autogenerated return type of CreateFishingWaterBookmarkMutation. */
export type CreateFishingWaterBookmarkMutationPayload = {
  __typename: 'CreateFishingWaterBookmarkMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The created bookmark */
  fishingWaterBookmark: Maybe<FishingWaterBookmark>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** Autogenerated input type of CreateFishingWaterReviewMutation */
export type CreateFishingWaterReviewMutationInput = {
  attributes: ReviewAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fishingWaterExternalId: Scalars['String']['input'];
};

/** Autogenerated return type of CreateFishingWaterReviewMutation. */
export type CreateFishingWaterReviewMutationPayload = {
  __typename: 'CreateFishingWaterReviewMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  review: Maybe<FishingWaterReview>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** Autogenerated input type of CreateGroupMutation */
export type CreateGroupMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  coverImage?: InputMaybe<ActiveStorageImageUpload>;
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  fishingWaterExternalId?: InputMaybe<Scalars['ID']['input']>;
  location?: InputMaybe<GroupLocation>;
  name: Scalars['NonEmptyString']['input'];
  /** IDs of topics */
  topics?: InputMaybe<Array<Scalars['ID']['input']>>;
  visibility: Visibility;
};

/** Autogenerated return type of CreateGroupMutation. */
export type CreateGroupMutationPayload = {
  __typename: 'CreateGroupMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  group: Maybe<Group>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** Autogenerated input type of Create */
export type CreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Conditions for the fishing plan */
  conditions: FishingPlanInput;
  /** User's specified departure time */
  departureTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** Autogenerated return type of Create. */
export type CreatePayload = {
  __typename: 'CreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Created fishing plan */
  fishingPlan: Maybe<FishingPlan>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** Autogenerated input type of CreatePostMutation */
export type CreatePostMutationInput = {
  attributes: PostWithPageAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  parentExternalId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreatePostMutation. */
export type CreatePostMutationPayload = {
  __typename: 'CreatePostMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  post: Maybe<Post>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** Autogenerated input type of CreatePostViewMutation */
export type CreatePostViewMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** For how long this post was seen */
  durationMs?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
};

/** Autogenerated return type of CreatePostViewMutation. */
export type CreatePostViewMutationPayload = {
  __typename: 'CreatePostViewMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  post: Post;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** Autogenerated input type of CreatePromotedCallToActionMutation */
export type CreatePromotedCallToActionMutationInput = {
  attributes: PromotedCallToActionAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  pageId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreatePromotedCallToActionMutation. */
export type CreatePromotedCallToActionMutationPayload = {
  __typename: 'CreatePromotedCallToActionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  promotedCallToAction: Maybe<PagesPromotedCallToAction>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** Autogenerated input type of CreateReviewMutation */
export type CreateReviewMutationInput = {
  attributes: ReviewAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  productExternalId: Scalars['String']['input'];
};

/** Autogenerated return type of CreateReviewMutation. */
export type CreateReviewMutationPayload = {
  __typename: 'CreateReviewMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  review: Maybe<Review>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

export type CreateTrashCollectionInputObject = {
  brandName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image: ActiveStorageImageUpload;
  position: PositionInputObject;
  weightInKg: Scalars['Float']['input'];
};

export type CreateTripAttributes = {
  catchesAttributes?: InputMaybe<Array<CreateTripCatchAttributes>>;
  description?: InputMaybe<Scalars['String']['input']>;
  endedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  startedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

export type CreateTripCatchAttributes = {
  accessMethodId?: InputMaybe<Scalars['String']['input']>;
  autoselectedSpeciesSuggestionId?: InputMaybe<Scalars['String']['input']>;
  catchAndRelease?: InputMaybe<Scalars['Boolean']['input']>;
  caughtAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fishingMethodId?: InputMaybe<Scalars['String']['input']>;
  fishingWaterId?: InputMaybe<Scalars['String']['input']>;
  isPersonalBest?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  locationPrivacy?: InputMaybe<CatchLocationPrivacyTypes>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /** An array of signed IDs from direct upload urls */
  photos?: InputMaybe<Array<Scalars['String']['input']>>;
  privacies?: InputMaybe<Array<CatchPrivacyTypes>>;
  privateFishingWater?: InputMaybe<Scalars['Boolean']['input']>;
  privateNotes?: InputMaybe<Scalars['String']['input']>;
  productUnitIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Order in which the catch should be displayed in the trip. When provided, the value must not be null */
  rank?: InputMaybe<Scalars['Int']['input']>;
  speciesId?: InputMaybe<Scalars['String']['input']>;
  suggestedWaterNameId?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

/** Autogenerated input type of CreateTripMutation */
export type CreateTripMutationInput = {
  attributes: CreateTripAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateTripMutation. */
export type CreateTripMutationPayload = {
  __typename: 'CreateTripMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  tripReference: Maybe<TripReference>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** Autogenerated input type of CreateUserReferralMutation */
export type CreateUserReferralMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  referrerId: Scalars['Int']['input'];
};

/** Autogenerated return type of CreateUserReferralMutation. */
export type CreateUserReferralMutationPayload = {
  __typename: 'CreateUserReferralMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

export type CreateUserReportAttributes = {
  catchReasons?: InputMaybe<Array<CatchReportReasonTypes>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  gearReasons?: InputMaybe<Array<GearReportReasonTypes>>;
  groupReasons?: InputMaybe<Array<GroupReportReasonTypes>>;
  ownInvalidCatchReasons?: InputMaybe<Array<OwnInvalidCatchReportReasonTypes>>;
  ownProfileReasons?: InputMaybe<Array<OwnProfileReportReasonTypes>>;
  postReasons?: InputMaybe<Array<PostReportReasonTypes>>;
  subjectId: Scalars['ID']['input'];
  subjectType: UserReportSubjectTypes;
  userReasons?: InputMaybe<Array<UserReportReasonTypes>>;
};

/** Autogenerated input type of CreateUserReportMutation */
export type CreateUserReportMutationInput = {
  attributes: CreateUserReportAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateUserReportMutation. */
export type CreateUserReportMutationPayload = {
  __typename: 'CreateUserReportMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** Autogenerated input type of CreateUserSuggestedChangeMutation */
export type CreateUserSuggestedChangeMutationInput = {
  attributes: UserSuggestedChangeAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateUserSuggestedChangeMutation. */
export type CreateUserSuggestedChangeMutationPayload = {
  __typename: 'CreateUserSuggestedChangeMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
  userSuggestedChanges: Maybe<Array<UserSuggestedChange>>;
};

/** Autogenerated input type of CreateWaypointMutation */
export type CreateWaypointMutationInput = {
  attributes: WaypointAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateWaypointMutation. */
export type CreateWaypointMutationPayload = {
  __typename: 'CreateWaypointMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
  waypoint: Maybe<Waypoint>;
};

export enum CroppingStrategyEnum {
  /** Focus on the center of the image (default) */
  CENTER = 'CENTER',
  /**
   * Will not crop the images, rather resize it with kept aspect
   * ratio to fit into the provided dimentions
   *
   */
  NO_CROP = 'NO_CROP',
  /** Cropping based on image recognition */
  SMART = 'SMART'
}

export type CurrentUser = PostsFeedDisplayEntity & {
  __typename: 'CurrentUser';
  /** Promotional offers the user currently has active */
  activeOffers: Array<ActiveOffer>;
  /**
   * Return if user is eligible for rewarded ads and configs for displaying Google Admob ads
   * @deprecated Admob is no longer supported, but we return a dummy object to satisfy older clients
   */
  admob: DisplayResult;
  avatar: Maybe<Image>;
  /** @deprecated Use `avatar` field instead */
  avatarImage: Maybe<Image>;
  biography: Maybe<Scalars['String']['output']>;
  /** Users who have blocked this user */
  blockedBy: UserRecordConnection;
  /** Users who this user blocks */
  blockedTargets: UserRecordConnection;
  catchSpeciesIdentifications: CatchSpeciesIdentificationRecordConnection;
  /** Aggregated statistics on all catches made by the current user */
  catchStatistics: CatchStatistics;
  catches: CatchRecordConnection;
  /** Equipment categories in this user's tacklebox */
  categories: CategoryRecordConnection;
  /** The consents of this user */
  consents: ConsentRecordConnection;
  contactMatches: Maybe<ContactMatchesConnection>;
  country: Country;
  countryCode: Scalars['String']['output'];
  coverImage: Maybe<Image>;
  /** Date record was added to the database */
  createdAt: Scalars['ISO8601DateTime']['output'];
  displayIcon: Image;
  displayName: Scalars['String']['output'];
  /** Promotional offers the user can activate */
  eligibleOffers: Array<EligibleOffer>;
  externalId: Scalars['String']['output'];
  firstName: Maybe<Scalars['String']['output']>;
  /** Fishing water bookmarks created by the current user */
  fishingWaterBookmarks: FishingWaterBookmarkRecordConnection;
  /** Flow unit preference for this user */
  flowUnit: Scalars['String']['output'];
  /** Recommendations */
  followRecommendations: Maybe<FollowRecommendationConnection>;
  /** Is this user followed by the current user? */
  followedByCurrentUser: Scalars['Boolean']['output'];
  /** Equipment brands followed by this user */
  followedEquipmentBrands: BrandRecordConnection;
  /** Get the relevanter feed for the user */
  followedFeed: PostsFeedConnection;
  /** Fishing methods used by this user */
  followedFishingMethods: FishingMethodRecordConnection;
  /** Fishing waters followed by this user */
  followedFishingWaters: FishingWaterRecordConnection;
  /** Species followed by this user */
  followedSpecies: SpeciesRecordConnection;
  followedUsers: UserRecordConnection;
  followers: UserRecordConnection;
  /** Is this user following the current user? */
  followingCurrentUser: Scalars['Boolean']['output'];
  groupInvitations: MemberInvitationRecordConnection;
  /** Returns all groups current user is a member of */
  groups: GroupRecordConnection;
  hasNewGroupActivity: Scalars['Boolean']['output'];
  /**
   * DB ID
   * @deprecated Use `externalId` instead
   */
  id: Scalars['Int']['output'];
  isAmbassador: Maybe<Scalars['Boolean']['output']>;
  /** Is this user blocked by the current user? */
  isBlocked: Scalars['Boolean']['output'];
  isPremium: Maybe<Scalars['Boolean']['output']>;
  /** Is this user somehow verified? */
  isVerified: Maybe<Scalars['Boolean']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  /** Length unit preference for this user */
  lengthUnit: Scalars['String']['output'];
  /** The pages this user can manage */
  manageablePages: PageRecordConnection;
  /** Can send message to this user by current user? */
  messageable: Scalars['Boolean']['output'];
  /** Status of Navionics depth maps subscription */
  navionicsSubscription: Maybe<NavionicsSubscription>;
  /** Unique identifying nickname for user */
  nickname: Scalars['String']['output'];
  offering: Offering;
  onboarded: Scalars['Boolean']['output'];
  /** The pages user can publish as */
  pagesCanPublishAs: PageRecordConnection;
  /** Recommended paywall to the current user */
  paywall: Paywall;
  /** Personal best catches of this User */
  personalBestCatches: CatchRecordConnection;
  posts: PostRecordConnection;
  /** Pro subscription end day for the current user */
  premiumEndDate: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Pressure unit preference for this user */
  pressureUnit: Scalars['String']['output'];
  /** Personally identifiable information (available only to the current user or administrators) */
  privateFields: UserPrivateFields;
  /** This user private reference uuid */
  privateUuid: Maybe<Scalars['String']['output']>;
  /** Product Units this user has saved to their tacklebox */
  productUnits: ProductUnitRecordConnection;
  /** Equipment products in this user's tacklebox */
  products: ProductRecordConnection;
  /** The pages this user has publisher rights to */
  publishablePages: PageRecordConnection;
  /** Recommended items from discover service */
  recommendedItems: PostsFeedConnection;
  /** Users which we think the user would want to follow */
  recommendedUsers: Maybe<UserRecommendationConnection>;
  /** Speed unit preference for this user */
  speedUnit: Scalars['String']['output'];
  state: Maybe<Scalars['String']['output']>;
  /** statistics for user */
  statistics: UserStatistics;
  /** Weekly streak information for this user */
  streak: Streak;
  /** A summary of the statistics of the current user's catches */
  summarizedCatchStatistics: SummarizedCatchStatisticsConnection;
  /** Temperature unit preference for this user */
  temperatureUnit: Scalars['String']['output'];
  trips: TripRecordConnection;
  /** Velocity unit preference for this user */
  velocityUnit: Scalars['String']['output'];
  waypoints: WaypointRecordConnection;
  /** Weight unit preference for this user */
  weightUnit: Scalars['String']['output'];
  /** Current users year in review */
  yearInReview: Maybe<YearInReview>;
};


export type CurrentUserAvatarArgs = {
  croppingStrategy?: InputMaybe<CroppingStrategyEnum>;
  filterString?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<FormatEnum>;
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type CurrentUserAvatarImageArgs = {
  croppingStrategy?: InputMaybe<CroppingStrategyEnum>;
  filterString?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<FormatEnum>;
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type CurrentUserBlockedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<UserFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CurrentUserBlockedTargetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<UserFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CurrentUserCatchSpeciesIdentificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CurrentUserCatchStatisticsArgs = {
  caughtBetweenDates?: InputMaybe<DateRangeInputObject>;
  speciesExternalId?: InputMaybe<Scalars['ID']['input']>;
};


export type CurrentUserCatchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<CatchFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fishingWaterId?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  speciesId?: InputMaybe<Scalars['Int']['input']>;
};


export type CurrentUserCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<CategoryFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CurrentUserConsentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CurrentUserContactMatchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contacts?: InputMaybe<Array<ContactAttributes>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CurrentUserCoverImageArgs = {
  croppingStrategy?: InputMaybe<CroppingStrategyEnum>;
  filterString?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<FormatEnum>;
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type CurrentUserDisplayIconArgs = {
  croppingStrategy?: InputMaybe<CroppingStrategyEnum>;
  filterString?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<FormatEnum>;
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type CurrentUserFishingWaterBookmarksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CurrentUserFollowRecommendationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
};


export type CurrentUserFollowedEquipmentBrandsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<BrandFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CurrentUserFollowedFeedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  options?: InputMaybe<Scalars['String']['input']>;
};


export type CurrentUserFollowedFishingMethodsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CurrentUserFollowedFishingWatersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<FishingWaterFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CurrentUserFollowedSpeciesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<SpeciesFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CurrentUserFollowedUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<UserFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CurrentUserFollowersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<UserFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CurrentUserGroupInvitationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CurrentUserGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<GroupFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CurrentUserHasNewGroupActivityArgs = {
  since: Scalars['ISO8601DateTime']['input'];
};


export type CurrentUserManageablePagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<PageFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CurrentUserNavionicsSubscriptionArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
};


export type CurrentUserOfferingArgs = {
  for: Scalars['NonEmptyString']['input'];
};


export type CurrentUserPagesCanPublishAsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<PageFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CurrentUserPersonalBestCatchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CurrentUserPostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<PostFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CurrentUserProductUnitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryExternalIds?: InputMaybe<Array<Scalars['String']['input']>>;
  filters?: InputMaybe<ProductUnitFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CurrentUserProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ProductFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CurrentUserPublishablePagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<PageFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CurrentUserRecommendedItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CurrentUserRecommendedUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CurrentUserStreakArgs = {
  currentLocalTime: Scalars['ISO8601DateTime']['input'];
};


export type CurrentUserSummarizedCatchStatisticsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CurrentUserTripsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<TripFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CurrentUserWaypointsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The different statuses a custom gear record can be in */
export enum CustomGearStatusTypes {
  approved = 'approved',
  being_moderated = 'being_moderated',
  new = 'new',
  official = 'official',
  rejected = 'rejected',
  scheduled_for_moderation = 'scheduled_for_moderation',
  verified = 'verified'
}

export type DateRangeInputObject = {
  /** End date of the range */
  endDate: Scalars['ISO8601DateTime']['input'];
  /** Start date of the range */
  startDate: Scalars['ISO8601DateTime']['input'];
};

/** A deep link version of the provided partner link. Used to redirect users back via the deep link. */
export type DeepLinkPromotionPartnerLink = {
  __typename: 'DeepLinkPromotionPartnerLink';
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  deepLink: Maybe<Scalars['String']['output']>;
  /** DB ID */
  id: Scalars['Int']['output'];
};

/** Autogenerated input type of DeletePromotedCallToActionMutation */
export type DeletePromotedCallToActionMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeletePromotedCallToActionMutation. */
export type DeletePromotedCallToActionMutationPayload = {
  __typename: 'DeletePromotedCallToActionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** Autogenerated input type of DeleteRecordByExternalIdMutation */
export type DeleteRecordByExternalIdMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
  mergedIntoExternalId?: InputMaybe<Scalars['String']['input']>;
  type: DeleteRecordByExternalIdTypeEnum;
};

/** Autogenerated return type of DeleteRecordByExternalIdMutation. */
export type DeleteRecordByExternalIdMutationPayload = {
  __typename: 'DeleteRecordByExternalIdMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

export enum DeleteRecordByExternalIdTypeEnum {
  CATCH_SPECIES_IDENTIFICATION = 'CATCH_SPECIES_IDENTIFICATION',
  FISHING_WATER = 'FISHING_WATER',
  FISHING_WATER_REVIEW = 'FISHING_WATER_REVIEW',
  GROUP = 'GROUP',
  POINT_OF_INTEREST_PROVIDER = 'POINT_OF_INTEREST_PROVIDER',
  POINT_OF_INTEREST_SOURCE = 'POINT_OF_INTEREST_SOURCE',
  POINT_OF_INTEREST_TYPE = 'POINT_OF_INTEREST_TYPE',
  POST = 'POST',
  PRODUCT_REVIEW = 'PRODUCT_REVIEW',
  SPECIES_TIP = 'SPECIES_TIP',
  WAYPOINT = 'WAYPOINT'
}

/** Autogenerated input type of DeleteTripMutation */
export type DeleteTripMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deleteCatches?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
};

/** Autogenerated return type of DeleteTripMutation. */
export type DeleteTripMutationPayload = {
  __typename: 'DeleteTripMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  tripReference: Maybe<TripReference>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** Autogenerated input type of DemoteGroupAdminMutation */
export type DemoteGroupAdminMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  groupId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of DemoteGroupAdminMutation. */
export type DemoteGroupAdminMutationPayload = {
  __typename: 'DemoteGroupAdminMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  group: Maybe<Group>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

export type DimensionsAverage = {
  __typename: 'DimensionsAverage';
  areaAverage: Maybe<Scalars['Float']['output']>;
  waterAverage: Maybe<Scalars['Float']['output']>;
};

export type DimensionsDistribution = {
  __typename: 'DimensionsDistribution';
  binCount: Maybe<Scalars['Int']['output']>;
  binMin: Maybe<Scalars['Float']['output']>;
};

export type DirectUploadRequestHeader = {
  __typename: 'DirectUploadRequestHeader';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type DirectUploadUrl = {
  __typename: 'DirectUploadURL';
  /** Headers to be used in PUT request */
  headers: Array<DirectUploadRequestHeader>;
  objectExpiresAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** ID with which content can be identified by backend. Use it to attach content to entities */
  signedId: Scalars['String']['output'];
  /** PUT content to the url */
  url: Scalars['String']['output'];
  urlExpiresAt: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Autogenerated input type of DisassociateProductUnitsFromMeMutation */
export type DisassociateProductUnitsFromMeMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  externalIds: Array<Scalars['String']['input']>;
};

/** Autogenerated return type of DisassociateProductUnitsFromMeMutation. */
export type DisassociateProductUnitsFromMeMutationPayload = {
  __typename: 'DisassociateProductUnitsFromMeMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  me: User;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

export type DisplayResult = {
  __typename: 'DisplayResult';
  nativeAds: Array<Ad>;
  nativeOn: Scalars['Boolean']['output'];
  rewardedAds: Array<Ad>;
  rewardedEligible: Scalars['Boolean']['output'];
  rewardedOn: Scalars['Boolean']['output'];
};

/** Autogenerated input type of EditCommentMutation */
export type EditCommentMutationInput = {
  attributes: CommentAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of EditCommentMutation. */
export type EditCommentMutationPayload = {
  __typename: 'EditCommentMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  comment: Maybe<Post>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** Autogenerated input type of EditPostMutation */
export type EditPostMutationInput = {
  attributes: PostAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of EditPostMutation. */
export type EditPostMutationPayload = {
  __typename: 'EditPostMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  post: Maybe<Post>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** Autogenerated input type of EditURLHostMutation */
export type EditUrlHostMutationInput = {
  attributes: UrlHostAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of EditURLHostMutation. */
export type EditUrlHostMutationPayload = {
  __typename: 'EditURLHostMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  host: Maybe<OpUrlHost>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** Autogenerated input type of EditURLMutation */
export type EditUrlMutationInput = {
  attributes: UrlAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of EditURLMutation. */
export type EditUrlMutationPayload = {
  __typename: 'EditURLMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  url: Maybe<OpUrl>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

export type EligibleOffer = {
  __typename: 'EligibleOffer';
  duration: Scalars['String']['output'];
  /** Promotion slug (used as stable cache identifier) */
  id: Scalars['String']['output'];
};

export type EquipmentAttributeValueSearchBoosts = {
  /** Boosts results for external ID for Equipment::AttributeType */
  attributeTypeId?: InputMaybe<Scalars['String']['input']>;
  /** Boosts results for attribute_values with current user as author if set to true */
  authorBoost?: InputMaybe<Scalars['Boolean']['input']>;
  /** Boosts results for external ID for Equipment::CategoryType */
  categoryId?: InputMaybe<Scalars['String']['input']>;
};

export type EquipmentAttributeValueSearchResult = {
  __typename: 'EquipmentAttributeValueSearchResult';
  /** AttributeValues matching the query */
  attributeValues: Maybe<AttributeValueConnection>;
  /** The internal id of the search, can be used for conversion tracking */
  searchId: Scalars['Int']['output'];
};


export type EquipmentAttributeValueSearchResultAttributeValuesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type EquipmentBrandSearchBoosts = {
  /** Boosts results for brands with current user as author if set to true */
  authorBoost?: InputMaybe<Scalars['Boolean']['input']>;
  /** Boosts results for external ID for Equipment::Category */
  categoryId?: InputMaybe<Scalars['String']['input']>;
};

export type EquipmentBrandSearchResult = {
  __typename: 'EquipmentBrandSearchResult';
  /** Brands matching the query */
  brands: Maybe<BrandConnection>;
  /** The internal id of the search, can be used for conversion tracking */
  searchId: Scalars['Int']['output'];
};


export type EquipmentBrandSearchResultBrandsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Top category or product unit
 *
 */
export type EquipmentGearType = Category | ProductUnit;

export type EquipmentProductSearchBoosts = {
  /** Boosts results for products with current user as author if set to true */
  authorBoost?: InputMaybe<Scalars['Boolean']['input']>;
  /** Boosts results for external ID for Equipment::Brand */
  brandId?: InputMaybe<Scalars['String']['input']>;
  /** Boosts results for external ID for Equipment::Category */
  categoryId?: InputMaybe<Scalars['String']['input']>;
};

export type EquipmentProductSearchResult = {
  __typename: 'EquipmentProductSearchResult';
  /** Products matching the query */
  products: Maybe<ProductConnection>;
  /** The internal id of the search, can be used for conversion tracking */
  searchId: Scalars['Int']['output'];
};


export type EquipmentProductSearchResultProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type EquipmentSearchFilters = {
  /** Restrict results to external IDs for Equipment::Brand(s) */
  brandIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Restrict results to external IDs for Equipment::Category(ies) */
  categoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type EquipmentSearchResult = {
  __typename: 'EquipmentSearchResult';
  /** Search query, cleaned by removing any selected brand(s) and/or category(ies) */
  cleanedQuery: Scalars['String']['output'];
  /** Products matching the query */
  products: Maybe<ProductConnection>;
  /** The internal id of the search, can be used for conversion tracking */
  searchId: Scalars['Int']['output'];
  /** Brands and categories for filtering of products, ordered by relevance according to query term */
  suggestedFilters: Maybe<Array<SearchResultFilterEntity>>;
};


export type EquipmentSearchResultProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A stable code a client can branch on to handle error */
export enum ErrorCode {
  CATCH_LIMIT_REACHED = 'CATCH_LIMIT_REACHED',
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  INVALID_PARAMETERS = 'INVALID_PARAMETERS',
  MESSAGING_GRANT_NOT_ALLOWED = 'MESSAGING_GRANT_NOT_ALLOWED',
  RECORD_NOT_FOUND = 'RECORD_NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED'
}

export type Feature = {
  __typename: 'Feature';
  /**
   * The call-to-action text
   * @deprecated Use call_to_action instead
   */
  action: Maybe<Scalars['String']['output']>;
  /** A call-to-action for this feature */
  callToAction: Maybe<Button>;
  /** A short description of the feature */
  description: Scalars['String']['output'];
  /** A detailed description of the feature */
  detailedDescription: Maybe<Scalars['String']['output']>;
  /** A URL to the icon visualizing the feature */
  icon: Image;
  /** An human readable identifier unique for this feature */
  identifier: Scalars['String']['output'];
  /** The name of the feature */
  name: Maybe<Scalars['String']['output']>;
  /** The title of the feature */
  title: Scalars['String']['output'];
};


export type FeatureIconArgs = {
  croppingStrategy?: InputMaybe<CroppingStrategyEnum>;
  format?: InputMaybe<FormatEnum>;
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

/** USPs for users to become Pro */
export type Features = {
  __typename: 'Features';
  /** A description of all USPs */
  description: Scalars['String']['output'];
  /** A list of features */
  features: Array<Feature>;
  tagline: Maybe<Scalars['String']['output']>;
  /** A title */
  title: Scalars['String']['output'];
};

/** Posts and Catches posted to page */
export type Feed = ResourceLike & {
  __typename: 'Feed';
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** DB ID */
  id: Scalars['Int']['output'];
  items: PostsFeedConnection;
  label: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};


/** Posts and Catches posted to page */
export type FeedItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Why a post is in the feed, for example the user follows its angler or its water. */
export enum FeedItemReasonEnum {
  /** The item is in a favourite fishing area of the user */
  FAVOURITE_FISHING_AREA = 'FAVOURITE_FISHING_AREA',
  /** The angler is followed by someone the user follows (friends of friends) */
  FOLLOWED_BY = 'FOLLOWED_BY',
  /** The user follows the angler who posted it */
  FOLLOW_ANGLER = 'FOLLOW_ANGLER',
  /** The user is a member of the group */
  FOLLOW_GROUP = 'FOLLOW_GROUP',
  /** The user follows the fishing method */
  FOLLOW_METHOD = 'FOLLOW_METHOD',
  /** The user follows the page */
  FOLLOW_PAGE = 'FOLLOW_PAGE',
  /** The user follows the species */
  FOLLOW_SPECIES = 'FOLLOW_SPECIES',
  /** The user follows the fishing water */
  FOLLOW_WATER = 'FOLLOW_WATER',
  /** Suggested by Relevanter, not from a follow */
  SUGGESTED = 'SUGGESTED'
}

/** A fishing method */
export type FishingMethod = PostsFeedDisplayEntity & {
  __typename: 'FishingMethod';
  catches: CatchRecordConnection;
  coverImage: Image;
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  displayIcon: Image;
  displayName: Scalars['String']['output'];
  externalId: Scalars['String']['output'];
  /** If the current user follows this method */
  followedByCurrentUser: Scalars['Boolean']['output'];
  /** Users who follow this species */
  followers: UserFollowersConnection;
  /**
   * DB ID
   * @deprecated Use `externalId` instead
   */
  id: Scalars['Int']['output'];
  localizedName: Scalars['String']['output'];
};


/** A fishing method */
export type FishingMethodCatchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<CatchFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A fishing method */
export type FishingMethodCoverImageArgs = {
  croppingStrategy?: InputMaybe<CroppingStrategyEnum>;
  filterString?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<FormatEnum>;
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


/** A fishing method */
export type FishingMethodDisplayIconArgs = {
  croppingStrategy?: InputMaybe<CroppingStrategyEnum>;
  filterString?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<FormatEnum>;
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


/** A fishing method */
export type FishingMethodFollowersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** An edge in a connection. */
export type FishingMethodEdge = {
  __typename: 'FishingMethodEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<FishingMethod>;
};

/** The connection type for FishingMethod. */
export type FishingMethodRecordConnection = {
  __typename: 'FishingMethodRecordConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<FishingMethodEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<FishingMethod>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Average of column for records beyond pagination (limited by scopes, if applicable) */
  totalAverage: Scalars['Float']['output'];
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};

export type FishingPlan = {
  __typename: 'FishingPlan';
  /** Conditions for the fishing plan */
  conditions: Maybe<FishingPlanConditions>;
  /** Date of the fishing plan */
  date: Maybe<Scalars['ISO8601Date']['output']>;
  /** User's specified departure time */
  departureTime: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Expiration time of the fishing plan */
  expirationTime: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Unique identifier for the fishing plan */
  externalId: Scalars['String']['output'];
  /** Fishing report for the fishing plan */
  fishingReport: Maybe<Array<FishingReport>>;
  /** Latitude of the location */
  latitude: Maybe<Scalars['Float']['output']>;
  /** Name of the location */
  locationName: Maybe<Scalars['String']['output']>;
  /** Longitude of the location */
  longitude: Maybe<Scalars['Float']['output']>;
  /** End of the time window */
  timeWindowEnd: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Start of the time window */
  timeWindowStart: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Conditions for a fishing plan, extracted from the conditions hash */
export type FishingPlanConditions = {
  __typename: 'FishingPlanConditions';
  /** Date of the fishing plan */
  date: Maybe<Scalars['ISO8601Date']['output']>;
  /** Latitude of the location */
  latitude: Maybe<Scalars['Float']['output']>;
  /** Longitude of the location */
  longitude: Maybe<Scalars['Float']['output']>;
  /** Time of day for fishing */
  timeOfDay: Maybe<TimeOfDayTypes>;
  /** Water clarity condition */
  waterClarity: Maybe<WaterClarityTypes>;
  /** Water depth condition */
  waterDepth: Maybe<WaterDepthTypes>;
};

export type FishingPlanInput = {
  area?: InputMaybe<AreaInput>;
  /** Filters to apply to bait recommendations. */
  baitFilters?: InputMaybe<BaitFiltersInput>;
  /** Best baits for the fishing plan */
  bestBaits: Scalars['String']['input'];
  date: Scalars['ISO8601Date']['input'];
  /** Hour of the day (0-23) */
  hourOfDay?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Indicates hourly vs non-hourly context to assign the correct night bucket date \
   * and time_of_day value (e.g., hour 0..3 maps to previous day if non-hourly, otherwise current day)
   */
  hourlyContext?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  timeOfDay: TimeOfDayTypes;
  vegetation?: InputMaybe<VegetationTypes>;
  waterClarity?: InputMaybe<WaterClarityTypes>;
  waterDepth?: InputMaybe<WaterDepthTypes>;
};

export type FishingReport = {
  __typename: 'FishingReport';
  /** Description of the fishing report */
  description: Maybe<Scalars['String']['output']>;
  /** Title of the fishing report */
  title: Maybe<Scalars['String']['output']>;
};

/** A fishing tip */
export type FishingTip = {
  __typename: 'FishingTip';
  /** The tip category */
  category: FishingTipCategory;
  /** The actual tip */
  content: Scalars['String']['output'];
};

export enum FishingTipCategory {
  gear_tactics = 'gear_tactics',
  seasonal_behavior = 'seasonal_behavior',
  structure_cover = 'structure_cover',
  times_conditions = 'times_conditions'
}

/** A fishing water */
export type FishingWater = PostsFeedDisplayEntity & ReviewableInterface & {
  __typename: 'FishingWater';
  /** If speciesExternalId is null returns abundance potential of the fishing water, if speciesExternalId is non null returns abundance potential for that species in the fishing water. Returns null for free users. */
  abundancePotential: Maybe<AbundancePotential>;
  /** The bookmark for the current user, null if not bookmarked */
  bookmark: Maybe<FishingWaterBookmark>;
  /** Aggregated statistics on all catches recorded in the given fishing water */
  catchStatistics: CatchStatistics;
  catches: CatchRecordConnection;
  /** The number of catches for this water */
  catchesCount: Scalars['Int']['output'];
  country: Maybe<Country>;
  county: Maybe<County>;
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  description: Maybe<Scalars['String']['output']>;
  /** Human readable string of water type. Treat as a key for translation purposes */
  descriptionOfWaterType: WaterTypes;
  /** Discussions authored on this fishing water. Null when discussions are not enabled for this water. */
  discussions: Maybe<PublicPostRecordConnection>;
  /** Free-text search for discussions authored on this fishing water. Null when discussions are not enabled for this water. */
  discussionsSearch: Maybe<FishingWaterDiscussionsSearchConnection>;
  displayIcon: Image;
  displayName: Scalars['String']['output'];
  externalId: Scalars['String']['output'];
  /** Reviews that either have text or title or they are owned by current user */
  filteredReviews: Maybe<ReviewInterfaceRecordConnection>;
  /** If the current user follows this water */
  followedByCurrentUser: Scalars['Boolean']['output'];
  followers: UserRecordConnection;
  /** The number of followers for this water */
  followersCount: Scalars['Int']['output'];
  formattedContext: Maybe<Scalars['String']['output']>;
  /** Returns true if the fishing water has abundance potential else false */
  hasAbundancePotential: Scalars['Boolean']['output'];
  /** Boolean indicating if the water has local guide info */
  hasLocalGuideInfo: Maybe<Scalars['Boolean']['output']>;
  /**
   * DB ID
   * @deprecated Use `externalId` instead
   */
  id: Scalars['Int']['output'];
  /** Counties whose geometries intersect with the fishing water shapes. This data relies on the availability of geometries for both waters and counties.Results currently only be available in US states where shapes have been added. */
  intersectingCounties: CountyRecordConnection;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  /** The metadata related to a fishing water */
  metadata: Array<FishingWaterMetadata>;
  /** Return the 10 most liked catches on a water. NOTE: This is cached weekly and is not realtime. */
  mostLikedCatches: Array<Catch>;
  /** Most relevant catches on a water, ranked by engagement, trophy status, and recency. */
  mostRelevantCatches: Array<Catch>;
  name: Maybe<Scalars['String']['output']>;
  /** The nearest Place to this water (within a max distance of 100km) */
  nearestPlace: Maybe<Place>;
  /** Property questions that can be answered in a review */
  propertyQuestions: ReviewPropertyQuestionInterfaceRecordConnection;
  /** A frequency breakdown of ratings from 1 to 5 for this reviewable object */
  ratingFrequencies: Scalars['JSON']['output'];
  region: Maybe<Region>;
  reviewedByCurrentUser: Scalars['Boolean']['output'];
  reviews: Maybe<ReviewInterfaceRecordConnection>;
  /** Waters suggested for this water, ranked by proximity, followers and catches */
  suggestedWaters: Array<FishingWater>;
  /** A summary of the catches statistics for the current fishing water */
  summarizedCatchStatistics: SummarizedCatchStatisticsConnection;
  /**
   * The most caught species in this water
   * @deprecated Use topSpeciesSummary instead
   */
  topSpecies: FishingWaterTopSpeciesConnection;
  /** The most caught species in this water. Note that providing a date range will be slower. */
  topSpeciesSummary: Maybe<TopSpeciesConnection>;
  /** Trending species in this water ordered by recent and seasonal catches. */
  trendingSpeciesSummary: Maybe<TrendingSpeciesConnection>;
  /** Trophy potential for the species in the fishing water */
  trophyPotential: Maybe<FishingWaterSpeciesTrophyPotential>;
  /** The fishing water's official website */
  url: Maybe<Scalars['String']['output']>;
  /** Link text to official website */
  urlLinkText: Maybe<Scalars['String']['output']>;
  waterType: Maybe<Scalars['Int']['output']>;
};


/** A fishing water */
export type FishingWaterAbundancePotentialArgs = {
  speciesExternalId?: InputMaybe<Scalars['String']['input']>;
};


/** A fishing water */
export type FishingWaterCatchStatisticsArgs = {
  caughtBetweenDates?: InputMaybe<DateRangeInputObject>;
  speciesExternalId?: InputMaybe<Scalars['ID']['input']>;
  withPhotos?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A fishing water */
export type FishingWaterCatchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<CatchFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A fishing water */
export type FishingWaterDiscussionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<FishingWaterDiscussionSort>;
};


/** A fishing water */
export type FishingWaterDiscussionsSearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


/** A fishing water */
export type FishingWaterDisplayIconArgs = {
  croppingStrategy?: InputMaybe<CroppingStrategyEnum>;
  filterString?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<FormatEnum>;
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


/** A fishing water */
export type FishingWaterFilteredReviewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ReviewInterfaceFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A fishing water */
export type FishingWaterFollowersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<UserFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A fishing water */
export type FishingWaterIntersectingCountiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A fishing water */
export type FishingWaterMostRelevantCatchesArgs = {
  limit: Scalars['Int']['input'];
};


/** A fishing water */
export type FishingWaterPropertyQuestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ReviewPropertyQuestionInterfaceFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A fishing water */
export type FishingWaterReviewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ReviewInterfaceFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A fishing water */
export type FishingWaterSummarizedCatchStatisticsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  withPhotos?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A fishing water */
export type FishingWaterTopSpeciesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A fishing water */
export type FishingWaterTopSpeciesSummaryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateRange?: InputMaybe<DateRangeInputObject>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  requireCatchPhotos?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A fishing water */
export type FishingWaterTrendingSpeciesSummaryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A fishing water */
export type FishingWaterTrophyPotentialArgs = {
  speciesId: Scalars['String']['input'];
};

/** A fishing water bookmark */
export type FishingWaterBookmark = {
  __typename: 'FishingWaterBookmark';
  /** Unique identifier that can be used to reference the record */
  externalId: Scalars['String']['output'];
  /** The bookmarked fishing water */
  fishingWater: FishingWater;
};

/** An edge in a connection. */
export type FishingWaterBookmarkEdge = {
  __typename: 'FishingWaterBookmarkEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<FishingWaterBookmark>;
};

/** The connection type for FishingWaterBookmark. */
export type FishingWaterBookmarkRecordConnection = {
  __typename: 'FishingWaterBookmarkRecordConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<FishingWaterBookmarkEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<FishingWaterBookmark>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Average of column for records beyond pagination (limited by scopes, if applicable) */
  totalAverage: Scalars['Float']['output'];
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};

export enum FishingWaterDiscussionSort {
  POPULAR = 'POPULAR',
  RECENT = 'RECENT'
}

/** The connection type for Post. */
export type FishingWaterDiscussionsSearchConnection = {
  __typename: 'FishingWaterDiscussionsSearchConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<FishingWaterDiscussionsSearchEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<Post>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type FishingWaterDiscussionsSearchEdge = {
  __typename: 'FishingWaterDiscussionsSearchEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Post>;
};

/** An edge in a connection. */
export type FishingWaterEdge = {
  __typename: 'FishingWaterEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The distance from the center of the search area in meters */
  distance: Maybe<Scalars['Float']['output']>;
  /** The distance from the center of the search area in local units */
  formattedDistance: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge. */
  node: Maybe<FishingWater>;
};

export type FishingWaterFilters = {
  /** Return fishing waters in descending order of catches count */
  orderByCatchesCount?: InputMaybe<Scalars['Boolean']['input']>;
  /** Return waters ordered by closest to the given coordinate first */
  orderByClosestToCoordinate?: InputMaybe<PositionInputObject>;
  /** Return waters in descending order of filtered catches count */
  orderByFilteredCatchesCount?: InputMaybe<OrderByFilteredCatchesCountInput>;
  /** Return fishing waters with overlap prioritization applied. Used to resolve disputes between waters in case of overlapping shapes. */
  orderByShapeOverlapPriority?: InputMaybe<PositionInputObject>;
  /** Return fishing waters ordered by trophy potential for the given species */
  orderBySpeciesTrophyPotential?: InputMaybe<Scalars['String']['input']>;
  /** Return fishing waters ordered by water potential */
  orderByWaterPotential?: InputMaybe<Scalars['Boolean']['input']>;
  /** Return fishing waters ordered by water potential for the given species */
  orderByWaterSpeciesPotential?: InputMaybe<Scalars['String']['input']>;
  /** Sort records alphabetically by name */
  orderedByName?: InputMaybe<Scalars['Boolean']['input']>;
  /** Returns only public waters (private and forbidden excluded) */
  publicOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter fishing waters by name prefix (case-insensitive) */
  startsWith?: InputMaybe<Scalars['String']['input']>;
  /** Return fishing waters that have catches */
  withCatches?: InputMaybe<Scalars['Boolean']['input']>;
  /** Return waters that have catches between the given dates */
  withCatchesCaughtBetweenDates?: InputMaybe<DateRangeInputObject>;
  /** Return waters that have catches in the given months */
  withCatchesCaughtInMonths?: InputMaybe<Array<MonthEnum>>;
  /** Return waters with catches for the given species ids */
  withCatchesForSpeciesIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Return fishing waters with at least one shape located at the given coordinates */
  withShapeLocatedAtCoordinates?: InputMaybe<PositionInputObject>;
  /** Return fishing waters that have at least one catch classified as trophy */
  withTrophyCatches?: InputMaybe<Scalars['Boolean']['input']>;
  /** Return fishing waters of the given water types. An empty list returns no waters. */
  withWaterTypes?: InputMaybe<Array<WaterTypes>>;
};

export type FishingWaterMetadata = {
  __typename: 'FishingWaterMetadata';
  description: Scalars['String']['output'];
  group: FishingWaterMetadataGroup;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  variant: FishingWaterMetadataVariants;
};

/** An edge in a connection. */
export type FishingWaterMetadataEdge = {
  __typename: 'FishingWaterMetadataEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<FishingWaterMetadata>;
};

export type FishingWaterMetadataGroup = {
  __typename: 'FishingWaterMetadataGroup';
  choice: FishingWaterMetadataGroupChoiceTypes;
  id: Scalars['String']['output'];
  metadata: Array<FishingWaterMetadata>;
  name: Scalars['String']['output'];
};

/** Determines if one or more metadata for the same group can apply at the same time */
export enum FishingWaterMetadataGroupChoiceTypes {
  /** More than one metadata value can apply */
  multiple = 'multiple',
  /** Only one can metadata value can apply */
  single = 'single'
}

/** An edge in a connection. */
export type FishingWaterMetadataGroupEdge = {
  __typename: 'FishingWaterMetadataGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<FishingWaterMetadataGroup>;
};

/** The connection type for FishingWaterMetadataGroup. */
export type FishingWaterMetadataGroupRecordConnection = {
  __typename: 'FishingWaterMetadataGroupRecordConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<FishingWaterMetadataGroupEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<FishingWaterMetadataGroup>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Average of column for records beyond pagination (limited by scopes, if applicable) */
  totalAverage: Scalars['Float']['output'];
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};

/** The connection type for FishingWaterMetadata. */
export type FishingWaterMetadataRecordConnection = {
  __typename: 'FishingWaterMetadataRecordConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<FishingWaterMetadataEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<FishingWaterMetadata>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Average of column for records beyond pagination (limited by scopes, if applicable) */
  totalAverage: Scalars['Float']['output'];
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};

export enum FishingWaterMetadataVariants {
  danger = 'danger',
  default = 'default',
  warning = 'warning'
}

/** The connection type for FishingWater. */
export type FishingWaterRecordConnection = {
  __typename: 'FishingWaterRecordConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<FishingWaterEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<FishingWater>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};

/** A review left by a user describing their experience with a fishing water */
export type FishingWaterReview = ReviewInterface & {
  __typename: 'FishingWaterReview';
  author: User;
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The product the review refers to (Equipment::Review only) */
  equipmentProduct: Maybe<Product>;
  externalId: Scalars['String']['output'];
  /** The fishing water the review refers to (FishingWaterReview only) */
  fishingWater: Maybe<FishingWater>;
  /**
   * DB ID - inaccessible
   * @deprecated Replaced by externalId
   */
  id: Maybe<Scalars['Int']['output']>;
  post: Post;
  /** The property answers belonging to the reviewable resource */
  propertyAnswers: Maybe<ReviewPropertyAnswerInterfaceRecordConnection>;
  rating: Scalars['Int']['output'];
};


/** A review left by a user describing their experience with a fishing water */
export type FishingWaterReviewPropertyAnswersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** An edge in a connection. */
export type FishingWaterReviewEdge = {
  __typename: 'FishingWaterReviewEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<FishingWaterReview>;
};

/** The property answer belonging to a fishing water review */
export type FishingWaterReviewPropertyAnswer = ReviewPropertyAnswerInterface & {
  __typename: 'FishingWaterReviewPropertyAnswer';
  /** +1 for LIKED, -1 for DISLIKED */
  answer: Scalars['Int']['output'];
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  externalId: Scalars['String']['output'];
  /**
   * DB ID - inaccessible
   * @deprecated Replaced by externalId
   */
  id: Maybe<Scalars['Int']['output']>;
  /** External ID for the related question */
  questionExternalId: Scalars['String']['output'];
};

/** The property question of a fishing water review */
export type FishingWaterReviewPropertyQuestion = ReviewPropertyQuestionInterface & {
  __typename: 'FishingWaterReviewPropertyQuestion';
  answers: Maybe<ReviewPropertyAnswerInterfaceRecordConnection>;
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  externalId: Scalars['String']['output'];
  /**
   * DB ID
   * @deprecated Use `externalId` instead
   */
  id: Scalars['Int']['output'];
  question: Scalars['String']['output'];
  summaryHeader: Maybe<Scalars['String']['output']>;
  /** @deprecated Use "question" instead */
  text: Scalars['String']['output'];
};


/** The property question of a fishing water review */
export type FishingWaterReviewPropertyQuestionAnswersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for FishingWaterReview. */
export type FishingWaterReviewRecordConnection = {
  __typename: 'FishingWaterReviewRecordConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<FishingWaterReviewEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<FishingWaterReview>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Average of column for records beyond pagination (limited by scopes, if applicable) */
  totalAverage: Scalars['Float']['output'];
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};

export type FishingWaterSpeciesTrophyPotential = {
  __typename: 'FishingWaterSpeciesTrophyPotential';
  recentCatchCount: Scalars['Int']['output'];
  totalCatchCount: Scalars['Int']['output'];
  trophyFishGauge: TrophyIndexGaugeEnum;
  trophyFishIndex: Scalars['Float']['output'];
  trophyFishWeight: Maybe<Scalars['Float']['output']>;
};

/** The connection type for Species. */
export type FishingWaterTopSpeciesConnection = {
  __typename: 'FishingWaterTopSpeciesConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<FishingWaterTopSpeciesEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<Species>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type FishingWaterTopSpeciesEdge = {
  __typename: 'FishingWaterTopSpeciesEdge';
  /** The number of distinct anglers that caught this species in the water */
  anglersCount: Scalars['Int']['output'];
  /** The number of catches of this species in the water */
  catchesCount: Scalars['Int']['output'];
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Species>;
};

/** Autogenerated input type of FollowPageMutation */
export type FollowPageMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of FollowPageMutation. */
export type FollowPageMutationPayload = {
  __typename: 'FollowPageMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  page: Maybe<Page>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** The connection type for PostsFeedDisplayEntity. */
export type FollowRecommendationConnection = {
  __typename: 'FollowRecommendationConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<FollowRecommendationEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<PostsFeedDisplayEntity>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type FollowRecommendationEdge = {
  __typename: 'FollowRecommendationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<PostsFeedDisplayEntity>;
  /** Why this user is recommended */
  reason: Scalars['String']['output'];
  /** From where this user is recommended */
  source: Scalars['String']['output'];
};

/** Autogenerated input type of FollowRecordsMutation */
export type FollowRecordsMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['ID']['input']>;
  type: FollowRecordsTypeEnum;
};

/** Autogenerated return type of FollowRecordsMutation. */
export type FollowRecordsMutationPayload = {
  __typename: 'FollowRecordsMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

export enum FollowRecordsTypeEnum {
  FISHING_METHOD = 'FISHING_METHOD',
  FISHING_WATER = 'FISHING_WATER',
  PAGE = 'PAGE',
  SPECIES = 'SPECIES',
  USER = 'USER',
  WAYPOINT = 'WAYPOINT'
}

export enum FormatEnum {
  /** JPEG (default) */
  JPEG = 'JPEG',
  /** PNG */
  PNG = 'PNG',
  /** WebP */
  WEBP = 'WEBP'
}

export type GameResult = {
  __typename: 'GameResult';
  totalScore: Scalars['Int']['output'];
};

/** Resource describes content tabs that a page has */
export type Gear = ResourceLike & {
  __typename: 'Gear';
  categories: CategoryRecordConnection;
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** DB ID */
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};


/** Resource describes content tabs that a page has */
export type GearCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<CategoryFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum GearReportReasonTypes {
  BAD_LANGUAGE_IN_DESCRIPTION = 'BAD_LANGUAGE_IN_DESCRIPTION',
  BRAND_IS_INCORRECT = 'BRAND_IS_INCORRECT',
  CATEGORY_IS_INCORRECT = 'CATEGORY_IS_INCORRECT',
  DUPLICATE_PRODUCT = 'DUPLICATE_PRODUCT',
  GRAPHIC_VIOLENCE_OR_ANIMAL_CRUELTY = 'GRAPHIC_VIOLENCE_OR_ANIMAL_CRUELTY',
  HAZARDOUS_MATERIALS = 'HAZARDOUS_MATERIALS',
  ILLEGAL_PRODUCT = 'ILLEGAL_PRODUCT',
  IMAGE_IS_INCORRECT = 'IMAGE_IS_INCORRECT',
  NOT_FISHING_GEAR = 'NOT_FISHING_GEAR',
  OTHER = 'OTHER',
  PRODUCT_IS_INCORRECT = 'PRODUCT_IS_INCORRECT',
  SEXUALLY_EXPLICIT_IMAGE = 'SEXUALLY_EXPLICIT_IMAGE',
  SPECS_ARE_INCORRECT = 'SPECS_ARE_INCORRECT',
  TITLE_DESCRIPTION_IS_INCORRECT = 'TITLE_DESCRIPTION_IS_INCORRECT'
}

export type GenericBaitsInfoSection = {
  __typename: 'GenericBaitsInfoSection';
  /** Content of the info section */
  content: Scalars['String']['output'];
  /** Display name of the info section */
  displayName: Scalars['String']['output'];
};

export type GenericBaitsPresentationStyle = {
  __typename: 'GenericBaitsPresentationStyle';
  /** Display name of the presentation style */
  displayName: Scalars['String']['output'];
  fishingTechnique: GenericBaitsInfoSection;
  presentationStyles: GenericBaitsInfoSection;
  /** Description of the presentation style */
  styleDescription: Scalars['String']['output'];
};

export type Grant = {
  __typename: 'Grant';
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  duration: Scalars['String']['output'];
  /** DB ID */
  id: Scalars['Int']['output'];
};

export type GrantAttributes = {
  promotionSlug: Scalars['String']['input'];
};

export type Group = PostsFeedDisplayEntity & {
  __typename: 'Group';
  actions: Array<Action>;
  admins: GroupAdminsConnection;
  coverImage: Maybe<Image>;
  /** @deprecated Use `coverImage` instead */
  coverImages: Maybe<ImageRecordConnection>;
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * A description of the group
   * @deprecated Use `optional_description` instead
   */
  description: Scalars['String']['output'];
  displayIcon: Image;
  displayName: Scalars['String']['output'];
  externalId: Scalars['String']['output'];
  feed: Maybe<PostRecordConnection>;
  followedByCurrentUser: Scalars['Boolean']['output'];
  /** @deprecated Private groups no longer have member limits. This field always returns true and will be removed in a future version. */
  hasNonPremiumSpots: Scalars['Boolean']['output'];
  /** Whether there is at least one post added since the last seen post for the current user. Stops at the first unseen post, so prefer this over `unseenPosts { totalCount }` when the exact count is not needed */
  hasUnseenPosts: Scalars['Boolean']['output'];
  /**
   * DB ID
   * @deprecated Use `externalId` instead
   */
  id: Scalars['Int']['output'];
  isMember: Scalars['Boolean']['output'];
  /** A geographic location assoiated with the group */
  location: Maybe<Location>;
  /** Users that are members of this group */
  members: GroupMembersConnection;
  /** A description of the group */
  optionalDescription: Maybe<Scalars['NonEmptyString']['output']>;
  /** The pinned post of this group, if any */
  pinnedPost: Maybe<Post>;
  /** A list of all possible actions (that may appear in the `actions` field) */
  possibleActions: Array<Action>;
  /** How many posts there are in last week */
  postsInAWeek: Scalars['Int']['output'];
  /** Posts added since */
  postsSince: Maybe<PostRecordConnection>;
  /** Users which we think the user would want to invite to the group */
  recommendedUsers: GroupsUserRecommendationConnection;
  topics: Maybe<InterestTopicRecordConnection>;
  /** Type of a group */
  type: Visibility;
  /** Posts added since the last seen post for the current users */
  unseenPosts: Maybe<GroupUnseenPostsConnection>;
};


export type GroupAdminsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<UserFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type GroupCoverImageArgs = {
  croppingStrategy?: InputMaybe<CroppingStrategyEnum>;
  filterString?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<FormatEnum>;
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type GroupCoverImagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  croppingStrategy?: InputMaybe<CroppingStrategyEnum>;
  filterString?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  format?: InputMaybe<FormatEnum>;
  height?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type GroupDisplayIconArgs = {
  croppingStrategy?: InputMaybe<CroppingStrategyEnum>;
  filterString?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<FormatEnum>;
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type GroupFeedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<PostFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type GroupHasUnseenPostsArgs = {
  since?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};


export type GroupMembersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<UserFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeAdmins?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type GroupPostsSinceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<PostFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  since: Scalars['ISO8601DateTime']['input'];
};


export type GroupRecommendedUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type GroupTopicsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type GroupUnseenPostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  since?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** The connection type for User. */
export type GroupAdminsConnection = {
  __typename: 'GroupAdminsConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<UserEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<User>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Show all pending admin invitations. Available to group admins only */
  pendingAdmins: AdminInvitationRecordConnection;
  /** Average of column for records beyond pagination (limited by scopes, if applicable) */
  totalAverage: Scalars['Float']['output'];
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};


/** The connection type for User. */
export type GroupAdminsConnectionPendingAdminsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** An edge in a connection. */
export type GroupEdge = {
  __typename: 'GroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Group>;
};

export type GroupFilters = {
  /** Only show groups where the name contains the search term (case-insensitive) */
  containingName?: InputMaybe<Scalars['String']['input']>;
  /** Only return groups where current user is not member (requires user session) */
  nonMember?: InputMaybe<Scalars['Boolean']['input']>;
  /** Orders groups by latest post (does not return groups with 0 posts) */
  orderByLatestPost?: InputMaybe<GroupLatestPostOrdering>;
  /** Orders groups by unseen posts (requires user session) */
  orderByUnseenPosts?: InputMaybe<GroupLatestPostOrdering>;
};

/** An invitation for a user to take on a new role in a group */
export type GroupInvitation = {
  group: Group;
  invited: User;
  inviter: User;
};

export enum GroupLatestPostOrdering {
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING'
}

export type GroupLocation = {
  coordinates: PositionInputObject;
  name: Scalars['String']['input'];
};

/** The connection type for User. */
export type GroupMembersConnection = {
  __typename: 'GroupMembersConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<UserEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<User>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Show all pending members invitations. Available to group admins only */
  pendingMembers: MemberInvitationRecordConnection;
  /** Average of column for records beyond pagination (limited by scopes, if applicable) */
  totalAverage: Scalars['Float']['output'];
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};


/** The connection type for User. */
export type GroupMembersConnectionPendingMembersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for Group. */
export type GroupRecordConnection = {
  __typename: 'GroupRecordConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<GroupEdge>>>;
  /** Invitations which invite you to be a group admin */
  groupAdminInvitations: AdminInvitationRecordConnection;
  /** Feed of recent posts found in groups returned by connection edges */
  latestPosts: PostRecordConnection;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<Group>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Average of column for records beyond pagination (limited by scopes, if applicable) */
  totalAverage: Scalars['Float']['output'];
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};


/** The connection type for Group. */
export type GroupRecordConnectionGroupAdminInvitationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The connection type for Group. */
export type GroupRecordConnectionLatestPostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum GroupReportReasonTypes {
  BAD_LANGUAGE_IN_DESCRIPTION = 'BAD_LANGUAGE_IN_DESCRIPTION',
  CHILD_SEXUAL_CONTENT_OR_EXPLOITATION = 'CHILD_SEXUAL_CONTENT_OR_EXPLOITATION',
  GRAPHIC_VIOLENCE_OR_ANIMAL_CRUELTY = 'GRAPHIC_VIOLENCE_OR_ANIMAL_CRUELTY',
  ILLEGAL_ACTIVITY = 'ILLEGAL_ACTIVITY',
  INAPPROPRIATE_COVER_IMAGE = 'INAPPROPRIATE_COVER_IMAGE',
  INCITING_TO_VIOLENCE_OR_TERRORISM = 'INCITING_TO_VIOLENCE_OR_TERRORISM',
  INVITE_SPAM = 'INVITE_SPAM',
  NUDITY_OR_SEXUAL_CONTENT = 'NUDITY_OR_SEXUAL_CONTENT',
  OTHER = 'OTHER',
  SCAMMING_FOR_INFORMATION = 'SCAMMING_FOR_INFORMATION',
  SPAM_OR_POSTING_INDISCRIMINATELY = 'SPAM_OR_POSTING_INDISCRIMINATELY',
  SUICIDE_OR_SELF_HARM_RELATED = 'SUICIDE_OR_SELF_HARM_RELATED',
  UNAUTHORIZED_SALES_OR_PROMOTION = 'UNAUTHORIZED_SALES_OR_PROMOTION'
}

export type GroupTopicsUpdateAttribute = {
  /** Topics for addition */
  add?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Topics for removal */
  remove?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** The connection type for Post. */
export type GroupUnseenPostsConnection = {
  __typename: 'GroupUnseenPostsConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<PostEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<Post>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};

/** The connection type for User. */
export type GroupsUserRecommendationConnection = {
  __typename: 'GroupsUserRecommendationConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<GroupsUserRecommendationEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<User>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Average of column for records beyond pagination (limited by scopes, if applicable) */
  totalAverage: Scalars['Float']['output'];
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type GroupsUserRecommendationEdge = {
  __typename: 'GroupsUserRecommendationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<User>;
  /** Why this user is recommended */
  reasons: Array<Scalars['String']['output']>;
  /** The group membership status */
  status: UserStatusEnum;
};

export type HelpfulVotePostAttributes = {
  postExternalId: Scalars['String']['input'];
  vote: HelpfulVotePostEnum;
};

export enum HelpfulVotePostEnum {
  HELPFUL = 'HELPFUL',
  NO_VOTE = 'NO_VOTE',
  UNHELPFUL = 'UNHELPFUL'
}

/** Autogenerated input type of HelpfulVotePostMutation */
export type HelpfulVotePostMutationInput = {
  attributes: HelpfulVotePostAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of HelpfulVotePostMutation. */
export type HelpfulVotePostMutationPayload = {
  __typename: 'HelpfulVotePostMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  post: Maybe<Post>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** Resource describes content tabs that a page has */
export type Home = ResourceLike & {
  __typename: 'Home';
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** DB ID */
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

/** Hourly timeline entry with weather data */
export type HourlyBiteForecastTimeline = {
  __typename: 'HourlyBiteForecastTimeline';
  /** Air pressure in Pa */
  airPressure: Scalars['Float']['output'];
  /** Air temperature in K */
  airTemperature: Scalars['Float']['output'];
  /** Calendar date of the forecast hour */
  date: Scalars['ISO8601Date']['output'];
  /** Hour of the day (0–23) in the location's local timezone */
  hourOfDay: Scalars['Int']['output'];
  /** WWO weather condition code identifier */
  weatherConditionWwoIdentifier: Scalars['ID']['output'];
  /** Wind angle in degrees */
  windAngle: Scalars['Float']['output'];
  /** Wind speed in m/s */
  windSpeed: Scalars['Float']['output'];
};

/** A specifically sized image attachment for a record */
export type Image = {
  __typename: 'Image';
  contentType: Scalars['String']['output'];
  height: Scalars['Int']['output'];
  /** Used to remove catch images using REST endpoint */
  id: Maybe<Scalars['Int']['output']>;
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ImageEdge = {
  __typename: 'ImageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Image>;
};

/** The connection type for Image. */
export type ImageRecordConnection = {
  __typename: 'ImageRecordConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ImageEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<Image>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Average of column for records beyond pagination (limited by scopes, if applicable) */
  totalAverage: Scalars['Float']['output'];
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};

export type ImageUploadAttributes = {
  /** Content size in bytes */
  byteSize: Scalars['Int']['input'];
  /** MD5 hash of content */
  checksum: Scalars['String']['input'];
  /** File's MIME type */
  contentType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  /** Content height in pixels */
  height: Scalars['Int']['input'];
  /** Content width in pixels */
  width: Scalars['Int']['input'];
};

export type Input = {
  __typename: 'Input';
  description: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type InterestTopic = {
  __typename: 'InterestTopic';
  category: Maybe<InterestTopicCategory>;
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** Translated name of topic */
  name: Scalars['String']['output'];
};

export type InterestTopicCategory = {
  __typename: 'InterestTopicCategory';
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  topics: InterestTopicRecordConnection;
};


export type InterestTopicCategoryTopicsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** An edge in a connection. */
export type InterestTopicCategoryEdge = {
  __typename: 'InterestTopicCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<InterestTopicCategory>;
};

/** The connection type for InterestTopicCategory. */
export type InterestTopicCategoryRecordConnection = {
  __typename: 'InterestTopicCategoryRecordConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<InterestTopicCategoryEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<InterestTopicCategory>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Average of column for records beyond pagination (limited by scopes, if applicable) */
  totalAverage: Scalars['Float']['output'];
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type InterestTopicEdge = {
  __typename: 'InterestTopicEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<InterestTopic>;
};

/** The connection type for InterestTopic. */
export type InterestTopicRecordConnection = {
  __typename: 'InterestTopicRecordConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<InterestTopicEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<InterestTopic>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Average of column for records beyond pagination (limited by scopes, if applicable) */
  totalAverage: Scalars['Float']['output'];
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};

export type Invitation = GroupInvitation & {
  __typename: 'Invitation';
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  externalId: Scalars['String']['output'];
  group: Group;
  /**
   * DB ID
   * @deprecated Use `externalId` instead
   */
  id: Scalars['Int']['output'];
  invited: User;
  inviter: User;
};

export enum InvitationActionEnum {
  ACCEPT = 'ACCEPT',
  DECLINE = 'DECLINE'
}

/** Autogenerated input type of JoinGroupMutation */
export type JoinGroupMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  groupId: Scalars['ID']['input'];
};

/** Autogenerated return type of JoinGroupMutation. */
export type JoinGroupMutationPayload = {
  __typename: 'JoinGroupMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  group: Maybe<Group>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** Autogenerated input type of LeaveGroupMutation */
export type LeaveGroupMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  groupId: Scalars['ID']['input'];
};

/** Autogenerated return type of LeaveGroupMutation. */
export type LeaveGroupMutationPayload = {
  __typename: 'LeaveGroupMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Indicates if the user was removed from the group */
  result: Scalars['Boolean']['output'];
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

export type LightCondition = {
  __typename: 'LightCondition';
  /** Cloud cover [Percent] */
  cloudCover: Scalars['Float']['output'];
  /** Condition name for the activity breakdown screen */
  displayName: Scalars['String']['output'];
  identifier: ConditionTypes;
  /** Long reason explaining condition impact on score */
  reasonLong: Scalars['String']['output'];
  /** Short reason explaining condition impact on score */
  reasonShort: Scalars['String']['output'];
  /** Conveys if the effect is positive, negative or neutral */
  stateKey: StateKeyTypes;
};

export enum LikePostActionEnum {
  LIKE = 'LIKE',
  UNLIKE = 'UNLIKE'
}

export type LikePostAttributes = {
  likeAction: LikePostActionEnum;
  postExternalId: Scalars['String']['input'];
};

/** Autogenerated input type of LikePostMutation */
export type LikePostMutationInput = {
  attributes: LikePostAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of LikePostMutation. */
export type LikePostMutationPayload = {
  __typename: 'LikePostMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  post: Maybe<Post>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** Autogenerated input type of LinkLoginProviderToMeMutation */
export type LinkLoginProviderToMeMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** User ID at the provider to link to me */
  providerId: Scalars['ID']['input'];
  /** Which external identity provider to link to */
  providerType: LinkLoginProviderToMeProviderTypeEnum;
};

/** Autogenerated return type of LinkLoginProviderToMeMutation. */
export type LinkLoginProviderToMeMutationPayload = {
  __typename: 'LinkLoginProviderToMeMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  me: User;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

export enum LinkLoginProviderToMeProviderTypeEnum {
  /** Sign in with Apple */
  APPLE = 'APPLE',
  /** Facebook */
  FACEBOOK = 'FACEBOOK',
  /** Google */
  GOOGLE = 'GOOGLE'
}

export type Location = {
  __typename: 'Location';
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** DB ID */
  id: Scalars['Int']['output'];
  /** latitude of the position */
  latitude: Scalars['Float']['output'];
  /** longitude of the position */
  longitude: Scalars['Float']['output'];
  /** The name of the location */
  name: Scalars['String']['output'];
};

export type LocationInput = {
  area?: InputMaybe<AreaInput>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
};

/** Answers about a geographic coordinate. */
export type LocationMetadata = {
  __typename: 'LocationMetadata';
  /** Saltwater relevance for the coordinate. */
  saltwater: SaltwaterMetadata;
};

/** Autogenerated input type of LogTrashCollectionMutation */
export type LogTrashCollectionMutationInput = {
  attributes: CreateTrashCollectionInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of LogTrashCollectionMutation. */
export type LogTrashCollectionMutationPayload = {
  __typename: 'LogTrashCollectionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  trashCollection: Maybe<TrashCollection>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

export type MapArea = {
  __typename: 'MapArea';
  catches: CatchSearchConnection;
  /** Returns true if map area supports trophy fish else false */
  hasTrophyFishSupport: Scalars['Boolean']['output'];
};


export type MapAreaCatchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  caughtInMonths?: InputMaybe<Array<MonthEnum>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  speciesIds?: InputMaybe<Array<Scalars['String']['input']>>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type MemberInvitation = GroupInvitation & {
  __typename: 'MemberInvitation';
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  externalId: Scalars['String']['output'];
  group: Group;
  /**
   * DB ID
   * @deprecated Use `externalId` instead
   */
  id: Scalars['Int']['output'];
  invited: User;
  inviter: User;
};

/** An edge in a connection. */
export type MemberInvitationEdge = {
  __typename: 'MemberInvitationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<MemberInvitation>;
};

/** The connection type for MemberInvitation. */
export type MemberInvitationRecordConnection = {
  __typename: 'MemberInvitationRecordConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<MemberInvitationEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<MemberInvitation>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Average of column for records beyond pagination (limited by scopes, if applicable) */
  totalAverage: Scalars['Float']['output'];
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};

/** A user metadata group containing dynamic key-value pairs */
export type MetadataGroup = {
  __typename: 'MetadataGroup';
  data: Scalars['JSON']['output'];
  group: Scalars['String']['output'];
};

export enum MonthEnum {
  /** April */
  APRIL = 'APRIL',
  /** August */
  AUGUST = 'AUGUST',
  /** December */
  DECEMBER = 'DECEMBER',
  /** February */
  FEBRUARY = 'FEBRUARY',
  /** January */
  JANUARY = 'JANUARY',
  /** July */
  JULY = 'JULY',
  /** June */
  JUNE = 'JUNE',
  /** March */
  MARCH = 'MARCH',
  /** May */
  MAY = 'MAY',
  /** November */
  NOVEMBER = 'NOVEMBER',
  /** October */
  OCTOBER = 'OCTOBER',
  /** September */
  SEPTEMBER = 'SEPTEMBER'
}

export enum MoonIlluminationTypes {
  FIRST_QUARTER = 'FIRST_QUARTER',
  FULL_MOON = 'FULL_MOON',
  LAST_QUARTER = 'LAST_QUARTER',
  NEW_MOON = 'NEW_MOON',
  WANING_CRESCENT = 'WANING_CRESCENT',
  WANING_GIBBOUS = 'WANING_GIBBOUS',
  WAXING_CRESCENT = 'WAXING_CRESCENT',
  WAXING_GIBBOUS = 'WAXING_GIBBOUS'
}

export type MoonPhaseCondition = {
  __typename: 'MoonPhaseCondition';
  /** Condition name for the activity breakdown screen */
  displayName: Scalars['String']['output'];
  identifier: ConditionTypes;
  moonPhase: MoonIlluminationTypes;
  /** Long reason explaining condition impact on score */
  reasonLong: Scalars['String']['output'];
  /** Short reason explaining condition impact on score */
  reasonShort: Scalars['String']['output'];
  /** Conveys if the effect is positive, negative or neutral */
  stateKey: StateKeyTypes;
};

export enum MostActiveWatersPeriodEnum {
  /** Last week */
  LAST_WEEK = 'LAST_WEEK'
}

export type Mutation = {
  __typename: 'Mutation';
  addStaffToPage: Maybe<AddStaffMutationPayload>;
  answerGroupAdminInvitation: Maybe<AnswerGroupAdminInvitationMutationPayload>;
  answerGroupInvitation: Maybe<AnswerGroupInvitationMutationPayload>;
  associateProductUnitsToMe: Maybe<AssociateProductUnitsToMeMutationPayload>;
  attributeTrialPromotion: Maybe<AttributeTrialPromotionMutationPayload>;
  autoFollow: Maybe<AutoFollowMutationPayload>;
  bulkCreatePostViews: Maybe<BulkCreateViewsMutationPayload>;
  cancelGroupAdminInvitation: Maybe<CancelGroupAdminInvitationMutationPayload>;
  cancelGroupMemberInvitation: Maybe<CancelGroupMemberInvitationMutationPayload>;
  confirmEmailVerification: Maybe<ConfirmEmailVerificationMutationPayload>;
  createCatch: Maybe<CreateCatchMutationPayload>;
  createCatchGuessGame: Maybe<CreateCatchGuessGameMutationPayload>;
  createCatchSpeciesIdentification: Maybe<CreateCatchSpeciesIdentificationMutationPayload>;
  createCatchesInBatch: Maybe<CreateCatchesInBatchMutationPayload>;
  createCouponGroup: Maybe<CreateCouponGroupMutationPayload>;
  createCuratedSpeciesCatch: Maybe<CreateCuratedSpeciesCatchMutationPayload>;
  createCustomGear: Maybe<CreateCustomGearMutationPayload>;
  createDirectUploadUrl: Maybe<CreateDirectUploadUrlMutationPayload>;
  createDirectUploadUrlsInBatch: Maybe<CreateDirectUploadUrLsInBatchMutationPayload>;
  createEmailVerification: Maybe<CreateEmailVerificationMutationPayload>;
  createEquipmentReview: Maybe<CreateReviewMutationPayload>;
  createFishingPlan: Maybe<CreatePayload>;
  createFishingWaterBookmark: Maybe<CreateFishingWaterBookmarkMutationPayload>;
  createFishingWaterDiscussion: Maybe<CreateFishingWaterDiscussionMutationPayload>;
  createFishingWaterReview: Maybe<CreateFishingWaterReviewMutationPayload>;
  createGroup: Maybe<CreateGroupMutationPayload>;
  createGroupInvitation: Maybe<CreateGroupInvitationMutationPayload>;
  createGroupPost: Maybe<CreateGroupPostMutationPayload>;
  createPost: Maybe<CreatePostMutationPayload>;
  createPostView: Maybe<CreatePostViewMutationPayload>;
  createPremiumGrant: Maybe<PremiumCreateGrantMutationPayload>;
  createPromotedCallToAction: Maybe<CreatePromotedCallToActionMutationPayload>;
  createTrip: Maybe<CreateTripMutationPayload>;
  createUserReferral: Maybe<CreateUserReferralMutationPayload>;
  createUserReport: Maybe<CreateUserReportMutationPayload>;
  createUserSuggestedChange: Maybe<CreateUserSuggestedChangeMutationPayload>;
  createWaypoint: Maybe<CreateWaypointMutationPayload>;
  deletePromotedCallToAction: Maybe<DeletePromotedCallToActionMutationPayload>;
  deleteRecordByExternalId: Maybe<DeleteRecordByExternalIdMutationPayload>;
  deleteTrip: Maybe<DeleteTripMutationPayload>;
  demoteGroupAdmin: Maybe<DemoteGroupAdminMutationPayload>;
  disassociateProductUnitsFromMe: Maybe<DisassociateProductUnitsFromMeMutationPayload>;
  editComment: Maybe<EditCommentMutationPayload>;
  editPost: Maybe<EditPostMutationPayload>;
  editUrl: Maybe<EditUrlMutationPayload>;
  editUrlHost: Maybe<EditUrlHostMutationPayload>;
  /** @deprecated Use followRecords */
  followPage: Maybe<FollowPageMutationPayload>;
  followRecords: Maybe<FollowRecordsMutationPayload>;
  /** @deprecated Use `grantOffer` mutation instead */
  grantGlimpseOfPro: Maybe<PremiumGrantGlimpseOfProMutationPayload>;
  grantOffer: Maybe<PremiumGrantOfferMutationPayload>;
  helpfulVotePost: Maybe<HelpfulVotePostMutationPayload>;
  joinGroup: Maybe<JoinGroupMutationPayload>;
  leaveGroup: Maybe<LeaveGroupMutationPayload>;
  likePost: Maybe<LikePostMutationPayload>;
  linkLoginProviderToMe: Maybe<LinkLoginProviderToMeMutationPayload>;
  logTrashCollection: Maybe<LogTrashCollectionMutationPayload>;
  personalBestCatch: Maybe<PersonalBestCatchMutationPayload>;
  pinCatchToMe: Maybe<PinCatchToMeMutationPayload>;
  pinPostToGroup: Maybe<PinPostToGroupMutationPayload>;
  promoteGroupAdmin: Maybe<PromoteGroupAdminMutationPayload>;
  redeemPromotion: Maybe<RedeemPartnerPromotionMutationPayload>;
  removeFishingWaterBookmark: Maybe<RemoveFishingWaterBookmarkMutationPayload>;
  removeGroupMember: Maybe<RemoveGroupMemberMutationPayload>;
  removePersonalBestCatch: Maybe<RemovePersonalBestCatchMutationPayload>;
  removeStaffFromPage: Maybe<RemoveStaffMutationPayload>;
  setUserDateOfBirth: Maybe<SetUserDateOfBirthMutationPayload>;
  submitCatchGuess: Maybe<SubmitCatchGuessMutationPayload>;
  /** @deprecated Use CreateUserSuggestedChangeMutation */
  suggestWaterName: Maybe<SuggestWaterNameMutationPayload>;
  /** @deprecated Use unfollowRecords */
  unfollowPage: Maybe<UnfollowPageMutationPayload>;
  unfollowRecords: Maybe<UnfollowRecordsMutationPayload>;
  unpinCatchFromMe: Maybe<UnpinCatchFromMeMutationPayload>;
  unpinPostFromGroup: Maybe<UnpinPostFromGroupMutationPayload>;
  updateBrand: Maybe<UpdateBrandMutationPayload>;
  updateCatch: Maybe<UpdateCatchMutationPayload>;
  updateEquipmentReview: Maybe<UpdateReviewMutationPayload>;
  updateFishingWaterReview: Maybe<UpdateFishingWaterReviewMutationPayload>;
  updateGroup: Maybe<UpdateGroupMutationPayload>;
  updatePage: Maybe<UpdatePageMutationPayload>;
  updatePromotedCallToAction: Maybe<UpdatePromotedCallToActionMutationPayload>;
  updateTrashCollection: Maybe<UpdateTrashCollectionMutationPayload>;
  updateTrip: Maybe<UpdateTripMutationPayload>;
  updateTripCatches: Maybe<UpdateTripCatchesMutationPayload>;
  updateUser: Maybe<UpdateUserMutationPayload>;
  updateUserOnboardingStatus: Maybe<UpdateUserOnboardingStatusMutationPayload>;
  updateWaypoint: Maybe<UpdateWaypointMutationPayload>;
  upsertConsent: Maybe<UpsertConsentMutationPayload>;
  upsertNavionicsSubscription: Maybe<UpsertNavionicsSubscriptionMutationPayload>;
  upsertUserMetadata: Maybe<UpsertUserMetadataMutationPayload>;
};


export type MutationAddStaffToPageArgs = {
  input: AddStaffMutationInput;
};


export type MutationAnswerGroupAdminInvitationArgs = {
  input: AnswerGroupAdminInvitationMutationInput;
};


export type MutationAnswerGroupInvitationArgs = {
  input: AnswerGroupInvitationMutationInput;
};


export type MutationAssociateProductUnitsToMeArgs = {
  input: AssociateProductUnitsToMeMutationInput;
};


export type MutationAttributeTrialPromotionArgs = {
  input: AttributeTrialPromotionMutationInput;
};


export type MutationAutoFollowArgs = {
  input: AutoFollowMutationInput;
};


export type MutationBulkCreatePostViewsArgs = {
  input: BulkCreateViewsMutationInput;
};


export type MutationCancelGroupAdminInvitationArgs = {
  input: CancelGroupAdminInvitationMutationInput;
};


export type MutationCancelGroupMemberInvitationArgs = {
  input: CancelGroupMemberInvitationMutationInput;
};


export type MutationConfirmEmailVerificationArgs = {
  input: ConfirmEmailVerificationMutationInput;
};


export type MutationCreateCatchArgs = {
  input: CreateCatchMutationInput;
};


export type MutationCreateCatchGuessGameArgs = {
  input: CreateCatchGuessGameMutationInput;
};


export type MutationCreateCatchSpeciesIdentificationArgs = {
  input: CreateCatchSpeciesIdentificationMutationInput;
};


export type MutationCreateCatchesInBatchArgs = {
  input: CreateCatchesInBatchMutationInput;
};


export type MutationCreateCouponGroupArgs = {
  input: CreateCouponGroupMutationInput;
};


export type MutationCreateCuratedSpeciesCatchArgs = {
  input: CreateCuratedSpeciesCatchMutationInput;
};


export type MutationCreateCustomGearArgs = {
  input: CreateCustomGearMutationInput;
};


export type MutationCreateDirectUploadUrlArgs = {
  input: CreateDirectUploadUrlMutationInput;
};


export type MutationCreateDirectUploadUrlsInBatchArgs = {
  input: CreateDirectUploadUrLsInBatchMutationInput;
};


export type MutationCreateEmailVerificationArgs = {
  input: CreateEmailVerificationMutationInput;
};


export type MutationCreateEquipmentReviewArgs = {
  input: CreateReviewMutationInput;
};


export type MutationCreateFishingPlanArgs = {
  input: CreateInput;
};


export type MutationCreateFishingWaterBookmarkArgs = {
  input: CreateFishingWaterBookmarkMutationInput;
};


export type MutationCreateFishingWaterDiscussionArgs = {
  input: CreateFishingWaterDiscussionMutationInput;
};


export type MutationCreateFishingWaterReviewArgs = {
  input: CreateFishingWaterReviewMutationInput;
};


export type MutationCreateGroupArgs = {
  input: CreateGroupMutationInput;
};


export type MutationCreateGroupInvitationArgs = {
  input: CreateGroupInvitationMutationInput;
};


export type MutationCreateGroupPostArgs = {
  input: CreateGroupPostMutationInput;
};


export type MutationCreatePostArgs = {
  input: CreatePostMutationInput;
};


export type MutationCreatePostViewArgs = {
  input: CreatePostViewMutationInput;
};


export type MutationCreatePremiumGrantArgs = {
  input: PremiumCreateGrantMutationInput;
};


export type MutationCreatePromotedCallToActionArgs = {
  input: CreatePromotedCallToActionMutationInput;
};


export type MutationCreateTripArgs = {
  input: CreateTripMutationInput;
};


export type MutationCreateUserReferralArgs = {
  input: CreateUserReferralMutationInput;
};


export type MutationCreateUserReportArgs = {
  input: CreateUserReportMutationInput;
};


export type MutationCreateUserSuggestedChangeArgs = {
  input: CreateUserSuggestedChangeMutationInput;
};


export type MutationCreateWaypointArgs = {
  input: CreateWaypointMutationInput;
};


export type MutationDeletePromotedCallToActionArgs = {
  input: DeletePromotedCallToActionMutationInput;
};


export type MutationDeleteRecordByExternalIdArgs = {
  input: DeleteRecordByExternalIdMutationInput;
};


export type MutationDeleteTripArgs = {
  input: DeleteTripMutationInput;
};


export type MutationDemoteGroupAdminArgs = {
  input: DemoteGroupAdminMutationInput;
};


export type MutationDisassociateProductUnitsFromMeArgs = {
  input: DisassociateProductUnitsFromMeMutationInput;
};


export type MutationEditCommentArgs = {
  input: EditCommentMutationInput;
};


export type MutationEditPostArgs = {
  input: EditPostMutationInput;
};


export type MutationEditUrlArgs = {
  input: EditUrlMutationInput;
};


export type MutationEditUrlHostArgs = {
  input: EditUrlHostMutationInput;
};


export type MutationFollowPageArgs = {
  input: FollowPageMutationInput;
};


export type MutationFollowRecordsArgs = {
  input: FollowRecordsMutationInput;
};


export type MutationGrantGlimpseOfProArgs = {
  input: PremiumGrantGlimpseOfProMutationInput;
};


export type MutationGrantOfferArgs = {
  input: PremiumGrantOfferMutationInput;
};


export type MutationHelpfulVotePostArgs = {
  input: HelpfulVotePostMutationInput;
};


export type MutationJoinGroupArgs = {
  input: JoinGroupMutationInput;
};


export type MutationLeaveGroupArgs = {
  input: LeaveGroupMutationInput;
};


export type MutationLikePostArgs = {
  input: LikePostMutationInput;
};


export type MutationLinkLoginProviderToMeArgs = {
  input: LinkLoginProviderToMeMutationInput;
};


export type MutationLogTrashCollectionArgs = {
  input: LogTrashCollectionMutationInput;
};


export type MutationPersonalBestCatchArgs = {
  input: PersonalBestCatchMutationInput;
};


export type MutationPinCatchToMeArgs = {
  input: PinCatchToMeMutationInput;
};


export type MutationPinPostToGroupArgs = {
  input: PinPostToGroupMutationInput;
};


export type MutationPromoteGroupAdminArgs = {
  input: PromoteGroupAdminMutationInput;
};


export type MutationRedeemPromotionArgs = {
  input: RedeemPartnerPromotionMutationInput;
};


export type MutationRemoveFishingWaterBookmarkArgs = {
  input: RemoveFishingWaterBookmarkMutationInput;
};


export type MutationRemoveGroupMemberArgs = {
  input: RemoveGroupMemberMutationInput;
};


export type MutationRemovePersonalBestCatchArgs = {
  input: RemovePersonalBestCatchMutationInput;
};


export type MutationRemoveStaffFromPageArgs = {
  input: RemoveStaffMutationInput;
};


export type MutationSetUserDateOfBirthArgs = {
  input: SetUserDateOfBirthMutationInput;
};


export type MutationSubmitCatchGuessArgs = {
  input: SubmitCatchGuessMutationInput;
};


export type MutationSuggestWaterNameArgs = {
  input: SuggestWaterNameMutationInput;
};


export type MutationUnfollowPageArgs = {
  input: UnfollowPageMutationInput;
};


export type MutationUnfollowRecordsArgs = {
  input: UnfollowRecordsMutationInput;
};


export type MutationUnpinCatchFromMeArgs = {
  input: UnpinCatchFromMeMutationInput;
};


export type MutationUnpinPostFromGroupArgs = {
  input: UnpinPostFromGroupMutationInput;
};


export type MutationUpdateBrandArgs = {
  input: UpdateBrandMutationInput;
};


export type MutationUpdateCatchArgs = {
  input: UpdateCatchMutationInput;
};


export type MutationUpdateEquipmentReviewArgs = {
  input: UpdateReviewMutationInput;
};


export type MutationUpdateFishingWaterReviewArgs = {
  input: UpdateFishingWaterReviewMutationInput;
};


export type MutationUpdateGroupArgs = {
  input: UpdateGroupMutationInput;
};


export type MutationUpdatePageArgs = {
  input: UpdatePageMutationInput;
};


export type MutationUpdatePromotedCallToActionArgs = {
  input: UpdatePromotedCallToActionMutationInput;
};


export type MutationUpdateTrashCollectionArgs = {
  input: UpdateTrashCollectionMutationInput;
};


export type MutationUpdateTripArgs = {
  input: UpdateTripMutationInput;
};


export type MutationUpdateTripCatchesArgs = {
  input: UpdateTripCatchesMutationInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserMutationInput;
};


export type MutationUpdateUserOnboardingStatusArgs = {
  input: UpdateUserOnboardingStatusMutationInput;
};


export type MutationUpdateWaypointArgs = {
  input: UpdateWaypointMutationInput;
};


export type MutationUpsertConsentArgs = {
  input: UpsertConsentMutationInput;
};


export type MutationUpsertNavionicsSubscriptionArgs = {
  input: UpsertNavionicsSubscriptionMutationInput;
};


export type MutationUpsertUserMetadataArgs = {
  input: UpsertUserMetadataMutationInput;
};

export type MyAreaFeedOptions = {
  speciesIds?: InputMaybe<Array<Scalars['String']['input']>>;
  waterSalinity?: InputMaybe<Array<WaterSalinity>>;
};

export type MyGroups = {
  __typename: 'MyGroups';
  groups: GroupRecordConnection;
  latestPosts: PostRecordConnection;
};


export type MyGroupsGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<GroupFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type MyGroupsLatestPostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<PostFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The belonging of a feed post */
export type NamedScope = {
  __typename: 'NamedScope';
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** DB ID */
  id: Scalars['Int']['output'];
};

export type NavionicsSubscription = {
  __typename: 'NavionicsSubscription';
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  customerId: Maybe<Scalars['String']['output']>;
  expiresAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** DB ID */
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
};

export type NearbyCircleFilterAttributes = {
  delta: Scalars['Int']['input'];
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};

/** The connection type for Place. */
export type NearbyPlacesConnection = {
  __typename: 'NearbyPlacesConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<NearbyPlacesEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<Place>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type NearbyPlacesEdge = {
  __typename: 'NearbyPlacesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The distance to this nearby place */
  distance: Scalars['Float']['output'];
  /** The unit in which the distance is returned (miles or km) */
  distanceUnit: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Place>;
};

export type Offering = {
  __typename: 'Offering';
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  packages: Array<SubscriptionProduct>;
};

/** A url from a post */
export type OpUrl = {
  __typename: 'OpUrl';
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** DB ID */
  id: Scalars['Int']['output'];
  longForm: Scalars['String']['output'];
};

/** A host shared in links */
export type OpUrlHost = {
  __typename: 'OpUrlHost';
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  hostname: Scalars['String']['output'];
  /** DB ID */
  id: Scalars['Int']['output'];
};

export type OrderByFilteredCatchesCountInput = {
  caughtBetweenDates?: InputMaybe<DateRangeInputObject>;
  caughtInMonths?: InputMaybe<Array<MonthEnum>>;
  speciesIds?: InputMaybe<Array<Scalars['String']['input']>>;
  trophyFish?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum OwnInvalidCatchReportReasonTypes {
  OTHER = 'OTHER'
}

export enum OwnProfileReportReasonTypes {
  AGE_UPDATE_REQUEST = 'AGE_UPDATE_REQUEST',
  OTHER = 'OTHER'
}

export type Page = PostsFeedDisplayEntity & {
  __typename: 'Page';
  admins: UserRecordConnection;
  ambassadors: UserRecordConnection;
  catches: CatchRecordConnection;
  coverImages: ImageRecordConnection;
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  description: Maybe<Scalars['String']['output']>;
  displayIcon: Image;
  displayName: Scalars['String']['output'];
  externalId: Scalars['String']['output'];
  feedItems: PostsFeedConnection;
  followedByCurrentUser: Scalars['Boolean']['output'];
  followers: PageFollowersConnection;
  /** DB ID */
  id: Scalars['Int']['output'];
  logo: Maybe<Image>;
  members: UserRecordConnection;
  membersTitle: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  pageable: Maybe<Pageable>;
  posts: PostRecordConnection;
  promotedCallToActions: PagesPromotedCallToActionRecordConnection;
  published: Scalars['Boolean']['output'];
  publishers: UserRecordConnection;
  resources: ResourceLikeRecordConnection;
};


export type PageAdminsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<UserFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type PageAmbassadorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<UserFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type PageCatchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<CatchFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type PageCoverImagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  croppingStrategy?: InputMaybe<CroppingStrategyEnum>;
  filterString?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  format?: InputMaybe<FormatEnum>;
  height?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type PageDisplayIconArgs = {
  croppingStrategy?: InputMaybe<CroppingStrategyEnum>;
  filterString?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<FormatEnum>;
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type PageFeedItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type PageFollowersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<UserFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type PageLogoArgs = {
  croppingStrategy?: InputMaybe<CroppingStrategyEnum>;
  filterString?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<FormatEnum>;
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type PageMembersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<UserFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type PagePostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<PostFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type PagePromotedCallToActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type PagePublishersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<UserFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type PageResourcesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ResourceLikeFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PageAttributes = {
  coverImages?: InputMaybe<Array<ActiveStorageImageUpload>>;
  description?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<ActiveStorageImageUpload>;
  membersTitle?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** An edge in a connection. */
export type PageEdge = {
  __typename: 'PageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Page>;
};

export type PageFilters = {
  /** Return only brands */
  brands?: InputMaybe<Scalars['Boolean']['input']>;
  /** Return only brands, ordered by name alphabetically */
  brandsOrderedByName?: InputMaybe<Scalars['Boolean']['input']>;
  /** For pages where the name contains the search term (case-insensitive) */
  containingName?: InputMaybe<Scalars['String']['input']>;
  orderByLatestPost?: InputMaybe<Scalars['Boolean']['input']>;
  /** Orders pages by popularity */
  orderByPopularity?: InputMaybe<PagePopularityOrdering>;
  /** Because sometimes you just gotta shake things up */
  orderRandomly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only show published pages */
  published?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The connection type for User. */
export type PageFollowersConnection = {
  __typename: 'PageFollowersConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<UserEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<User>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']['output']>;
};

export enum PagePopularityOrdering {
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING'
}

/** The connection type for Page. */
export type PageRecordConnection = {
  __typename: 'PageRecordConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<PageEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<Page>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Average of column for records beyond pagination (limited by scopes, if applicable) */
  totalAverage: Scalars['Float']['output'];
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};

export type PageUsers = {
  users: Array<UserWithRole>;
};

/**
 * `Pageable` defines anything that can be the source of a page'
 *
 */
export type Pageable = Brand | State;

export type PagesPromotedCallToAction = {
  __typename: 'PagesPromotedCallToAction';
  buttonText: Scalars['String']['output'];
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  headline: Scalars['String']['output'];
  /** ID */
  id: Scalars['Int']['output'];
  image: Image;
  subHeadline: Maybe<Scalars['String']['output']>;
  targetUrl: Scalars['String']['output'];
};


export type PagesPromotedCallToActionImageArgs = {
  croppingStrategy?: InputMaybe<CroppingStrategyEnum>;
  filterString?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<FormatEnum>;
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

/** An edge in a connection. */
export type PagesPromotedCallToActionEdge = {
  __typename: 'PagesPromotedCallToActionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<PagesPromotedCallToAction>;
};

/** The connection type for PagesPromotedCallToAction. */
export type PagesPromotedCallToActionRecordConnection = {
  __typename: 'PagesPromotedCallToActionRecordConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<PagesPromotedCallToActionEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<PagesPromotedCallToAction>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Average of column for records beyond pagination (limited by scopes, if applicable) */
  totalAverage: Scalars['Float']['output'];
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};

export type Paywall = {
  __typename: 'Paywall';
  id: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** Autogenerated input type of PersonalBestCatchMutation */
export type PersonalBestCatchMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
};

/** Autogenerated return type of PersonalBestCatchMutation. */
export type PersonalBestCatchMutationPayload = {
  __typename: 'PersonalBestCatchMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** Autogenerated input type of PinCatchToMeMutation */
export type PinCatchToMeMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
};

/** Autogenerated return type of PinCatchToMeMutation. */
export type PinCatchToMeMutationPayload = {
  __typename: 'PinCatchToMeMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  me: User;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** Autogenerated input type of PinPostToGroupMutation */
export type PinPostToGroupMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  groupId: Scalars['ID']['input'];
  postId: Scalars['ID']['input'];
};

/** Autogenerated return type of PinPostToGroupMutation. */
export type PinPostToGroupMutationPayload = {
  __typename: 'PinPostToGroupMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  group: Maybe<Group>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

export type Place = {
  __typename: 'Place';
  /** A set of catches in a radius of 50km for this place */
  catches: CatchRecordConnection;
  /** The country this place belongs to */
  country: Country;
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  description: Maybe<Scalars['String']['output']>;
  externalId: Scalars['String']['output'];
  /**
   * DB ID
   * @deprecated Use `externalId` instead
   */
  id: Scalars['Int']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  /** A set of places in a radius of this place lat/lon */
  nearbyPlaces: NearbyPlacesConnection;
  /** The region this place belongs to */
  region: Region;
  slug: Maybe<Scalars['String']['output']>;
  /** Waters suggested for this place, ranked by proximity, followers and catches */
  suggestedWaters: Array<FishingWater>;
  /**
   * The most caught species in a radius of 50km for this place
   * @deprecated Use top_species_summary instead
   */
  topSpecies: SpeciesRecordConnection;
  /** The most caught species in a radius of 50km for this place */
  topSpeciesSummary: TopSpeciesConnection;
  /** Top water reviews in 50km radius, ordered by helpful votes */
  topWaterReviews: FishingWaterReviewRecordConnection;
  /** An image for this place */
  unsplashImage: Maybe<UnsplashImage>;
};


export type PlaceCatchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<CatchFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type PlaceNearbyPlacesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  radius?: InputMaybe<Scalars['Int']['input']>;
};


export type PlaceTopSpeciesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<SpeciesFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type PlaceTopSpeciesSummaryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type PlaceTopWaterReviewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  minRating?: InputMaybe<Scalars['Int']['input']>;
  minTextLength?: InputMaybe<Scalars['Int']['input']>;
};

export type PlaceContext = {
  __typename: 'PlaceContext';
  kind: PlaceContextKind;
  name: Scalars['String']['output'];
};

export enum PlaceContextKind {
  CITY = 'CITY',
  COUNTRY = 'COUNTRY',
  COUNTY = 'COUNTY',
  REGION = 'REGION'
}

/** An edge in a connection. */
export type PlaceEdge = {
  __typename: 'PlaceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Place>;
};

export type PlaceFilters = {
  /** Filter places where the name contains the search term (case-insensitive) */
  containingName?: InputMaybe<Scalars['String']['input']>;
  /** Sort records alphabetically by name */
  orderedByName?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sort records descending by population */
  orderedByPopulation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter places by name prefix (case-insensitive) */
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

/** The connection type for Place. */
export type PlaceRecordConnection = {
  __typename: 'PlaceRecordConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<PlaceEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<Place>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Average of column for records beyond pagination (limited by scopes, if applicable) */
  totalAverage: Scalars['Float']['output'];
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};

/** A Legacy (RBFF) point of interest that can be found on the map */
export type PointOfInterest = {
  __typename: 'PointOfInterest';
  address: Maybe<Scalars['String']['output']>;
  availableTypes: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  county: Maybe<Scalars['String']['output']>;
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  description: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  externalId: Scalars['String']['output'];
  /**
   * DB ID
   * @deprecated Use `externalId` instead
   */
  id: Scalars['Int']['output'];
  latitude: Maybe<Scalars['Float']['output']>;
  longitude: Maybe<Scalars['Float']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  pointOfInterestType: PointOfInterestType;
  primaryName: Maybe<Scalars['String']['output']>;
  primaryType: Maybe<Scalars['Int']['output']>;
  rampSurface: Maybe<Scalars['String']['output']>;
  rampType: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  website: Maybe<Scalars['String']['output']>;
  zipcode: Maybe<Scalars['String']['output']>;
};

/** A point of interest type */
export type PointOfInterestType = {
  __typename: 'PointOfInterestType';
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  externalId: Scalars['String']['output'];
  iconRef: Scalars['String']['output'];
  /** DB ID */
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

export type Position = {
  __typename: 'Position';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type PositionInputObject = {
  /** latitude of a position */
  latitude: Scalars['Float']['input'];
  /** longitude of a position */
  longitude: Scalars['Float']['input'];
};

export type Post = {
  __typename: 'Post';
  /**
   * A call-to-action to be shown with this post
   * @deprecated Not used anywhere
   */
  callToAction: Maybe<CallToAction>;
  /** Catch details on this post */
  catch: Maybe<Catch>;
  /** Comments on this post */
  comments: PostCommentConnection;
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Did the logged in user find the this helpful?  Is null if the user has not voted */
  currentUserFoundHelpful: Maybe<Scalars['Boolean']['output']>;
  /** The date to display for this post */
  displayDate: Scalars['ISO8601DateTime']['output'];
  /**
   * A pair of objects (e.g. User/FishingMethod/etc...) used for rendering where a post item came from
   * @deprecated Use displayEntity
   */
  displayEntities: PostsFeedDisplayEntities;
  displayEntity: PostsFeedDisplayEntity;
  /** Units to display (i.e. in the feed).  Returns associated catch's units */
  displayProductUnits: ProductUnitRecordConnection;
  /** Comments on this post */
  experimentalComments: PostCommentConnection;
  externalId: Scalars['String']['output'];
  /** A fishing water associated with this post */
  fishingWater: Maybe<FishingWater>;
  helpfulDownvotesCount: Maybe<Scalars['Int']['output']>;
  helpfulUpvotesCount: Maybe<Scalars['Int']['output']>;
  /** If the post is hidden */
  hidden: Scalars['Boolean']['output'];
  /** Reason for the post to be hidden */
  hiddenReason: Maybe<Scalars['String']['output']>;
  /**
   * DB ID
   * @deprecated Use `externalId` instead
   */
  id: Scalars['Int']['output'];
  images: ImageRecordConnection;
  /** @deprecated Use images instead */
  imagesDetails: ImageRecordConnection;
  /** Whether the text of the post has been edited */
  isTextEdited: Maybe<Scalars['Boolean']['output']>;
  /** What this post is, so clients can differentiate without inspecting which fields are present */
  kind: PostKind;
  /** If the current page has liked this post */
  likedByCurrentPage: Scalars['Boolean']['output'];
  /** If the current user has liked this catch */
  likedByCurrentUser: Scalars['Boolean']['output'];
  /** Users and pages that likes this post */
  likers: PostsFeedDisplayEntityRecordConnection;
  /** Number of likes on this post. Note that this value does not account for the requesting users blocking of other users. If you need the correct value use likers.totalCount, but keep in mind that this will have a large performance impact. */
  likesCount: Scalars['Int']['output'];
  /**
   * This is the entity this post belongs to. For comments this is the parent post
   * @deprecated Use the direct fields instead, eg `catch`
   */
  postable: Postable;
  /** Product units which the user wants to share/discuss in their post */
  productUnits: ProductUnitRecordConnection;
  /** Date the post was published */
  publishedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** This post is has been shared by */
  sharedIn: PostRecordConnection;
  /** The shared post, if any */
  sharedPost: Maybe<Post>;
  /** Is this post sharing another post */
  sharingPost: Scalars['Boolean']['output'];
  staffPicked: Maybe<Scalars['Boolean']['output']>;
  /** A list of post-like objects suggested for this post */
  suggestedItems: PostsFeedConnection;
  /** The target (page, group) that this post was posted to */
  targetDisplayEntity: Maybe<PostsFeedDisplayEntity>;
  /** Text content in this post */
  text: Text;
  /**
   * The text of the post
   * @deprecated Use text { text } instead
   */
  textString: Maybe<Scalars['String']['output']>;
  /** Title of this post */
  title: Maybe<Title>;
  /** The title of the post (use `title` if you need the full Title object) */
  titleString: Maybe<Scalars['String']['output']>;
  trip: Maybe<Trip>;
  /** The user that created this post */
  user: User;
  /** Video in this post */
  video: Maybe<Video>;
  /** Users that viewed this post */
  viewers: UserRecordConnection;
};


export type PostCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<PostFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeReplies?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderByTop?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PostDisplayProductUnitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ProductUnitFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type PostExperimentalCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  focusOn?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type PostImagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  croppingStrategy?: InputMaybe<CroppingStrategyEnum>;
  filterString?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  format?: InputMaybe<FormatEnum>;
  height?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type PostImagesDetailsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  croppingStrategy?: InputMaybe<CroppingStrategyEnum>;
  filterString?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  format?: InputMaybe<FormatEnum>;
  height?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type PostLikersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type PostProductUnitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ProductUnitFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type PostSharedInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<PostFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type PostSuggestedItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  scopes?: InputMaybe<Array<PostFeedEnum>>;
  testData?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PostViewersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<UserFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PostAttributes = {
  /** The page this post should be posted as ("Page posted this") */
  byPageId?: InputMaybe<Scalars['ID']['input']>;
  /** Additional post images */
  images?: InputMaybe<Array<ActiveStorageImageUpload>>;
  location?: InputMaybe<PostLocation>;
  /** The pages this post should be posted to ("X posted this to Page") */
  pageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  productUnitExternalIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The date the post is scheduled to be published */
  publishedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** External id of the post that is being shared */
  sharedPostExternalId?: InputMaybe<Scalars['String']['input']>;
  /** New post's text */
  textString?: InputMaybe<Scalars['String']['input']>;
  /** New video. Note: Video can not be removed nor replaced, only added */
  video?: InputMaybe<VideoUpload>;
};

/** The connection type for Post. */
export type PostCommentConnection = {
  __typename: 'PostCommentConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CommentEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<Post>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total count of comments on this post */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PostEdge = {
  __typename: 'PostEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  displayEntity: Maybe<PostsFeedDisplayEntity>;
  /** The item at the end of the edge. */
  node: Maybe<Post>;
};

export enum PostFeedEnum {
  /** Only posts with images */
  WITH_IMAGES = 'WITH_IMAGES',
  /** Only posts with videos */
  WITH_VIDEO = 'WITH_VIDEO'
}

/** An edge in a connection. */
export type PostFeedItemEdge = {
  __typename: 'PostFeedItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** Arbitrary json with the event scoring breakdown. */
  debug: Maybe<Scalars['JSON']['output']>;
  displayEntity: Maybe<PostsFeedDisplayEntity>;
  /** The item at the end of the edge. */
  node: Maybe<PostsFeed>;
  /** Reasons why a post is in the feed */
  reasonTypes: Array<FeedItemReasonEnum>;
  /**
   * List of reasons forwarded from Relevanter.
   * Possible reasons: 'FOLLOW_ANGLER', 'FOLLOW_WATER', 'FOLLOW_SPECIES',
   * 'FOLLOW_METHOD', 'FOLLOW_PAGE', 'FOLLOW_GROUP', 'FAVOURITE_FISHING_AREA', 'SUGGESTED'.
   *
   */
  reasons: Maybe<Array<Scalars['String']['output']>>;
};

export type PostFilters = {
  /** Only show posts with videos */
  havingVideo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only return trip posts */
  onlyTrips?: InputMaybe<Scalars['Boolean']['input']>;
  /** Return descending order by published date / time */
  orderByRecent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only returns posts created by brands */
  postedByBrand?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only show published posts */
  published?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only return feed posts (not catches or catch posts) */
  topLevel?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only return top-level and trip posts */
  topLevelOrTrips?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only show unpublished posts. This will not show you another users posts unless you are admin. */
  unpublished?: InputMaybe<Scalars['Boolean']['input']>;
  /** Excludes posts that share other posts */
  withoutSharingPosts?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The kind of a post, derived from what it is posted on */
export enum PostKind {
  CATCH = 'CATCH',
  COMMENT = 'COMMENT',
  EQUIPMENT_REVIEW = 'EQUIPMENT_REVIEW',
  FEED_POST = 'FEED_POST',
  FISHING_WATER_DISCUSSION = 'FISHING_WATER_DISCUSSION',
  FISHING_WATER_REVIEW = 'FISHING_WATER_REVIEW',
  GROUP_POST = 'GROUP_POST',
  TRIP = 'TRIP'
}

export type PostLocation = {
  coordinates?: InputMaybe<PositionInputObject>;
  fishingWaterExternalId?: InputMaybe<Scalars['String']['input']>;
  fishingWaterId?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for Post. */
export type PostRecordConnection = {
  __typename: 'PostRecordConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<PostEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<Post>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Average of column for records beyond pagination (limited by scopes, if applicable) */
  totalAverage: Scalars['Float']['output'];
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};

export enum PostReportReasonTypes {
  BAD_LANGUAGE_IN_COMMENTS = 'BAD_LANGUAGE_IN_COMMENTS',
  BAD_LANGUAGE_IN_DESCRIPTION = 'BAD_LANGUAGE_IN_DESCRIPTION',
  CHILD_SEXUAL_CONTENT_OR_EXPLOITATION = 'CHILD_SEXUAL_CONTENT_OR_EXPLOITATION',
  GRAPHIC_VIOLENCE_OR_ANIMAL_CRUELTY = 'GRAPHIC_VIOLENCE_OR_ANIMAL_CRUELTY',
  HARASSMENT_OR_BULLYING = 'HARASSMENT_OR_BULLYING',
  HATE_SPEECH_THREATS = 'HATE_SPEECH_THREATS',
  ILLEGAL_ACTIVITY = 'ILLEGAL_ACTIVITY',
  NON_CONSENSUAL_CONTENT = 'NON_CONSENSUAL_CONTENT',
  NUDITY_OR_SEXUAL_CONTENT = 'NUDITY_OR_SEXUAL_CONTENT',
  OTHER = 'OTHER',
  PERSONAL_INFO_SHARED = 'PERSONAL_INFO_SHARED',
  SCAMMING_FOR_INFORMATION = 'SCAMMING_FOR_INFORMATION',
  SPAM_OR_POSTING_INDISCRIMINATELY = 'SPAM_OR_POSTING_INDISCRIMINATELY',
  SUICIDE_OR_SELF_HARM_RELATED = 'SUICIDE_OR_SELF_HARM_RELATED',
  UNAUTHORIZED_SALES_OR_PROMOTION = 'UNAUTHORIZED_SALES_OR_PROMOTION'
}

export type PostWithPageAttributes = {
  /** The page this post should be posted as ("Page posted this") */
  byPageId?: InputMaybe<Scalars['ID']['input']>;
  /** Additional post images */
  images?: InputMaybe<Array<ActiveStorageImageUpload>>;
  location?: InputMaybe<PostLocation>;
  /** The pages this post should be posted to ("X posted this to Page") */
  pageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  productUnitExternalIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The date the post is scheduled to be published */
  publishedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** External id of the post that is being shared */
  sharedPostExternalId?: InputMaybe<Scalars['String']['input']>;
  /** New post's text */
  textString?: InputMaybe<Scalars['String']['input']>;
  /** New video. Note: Video can not be removed nor replaced, only added */
  video?: InputMaybe<VideoUpload>;
};

/**
 * `Postable` defines anything that a post can belong to
 *
 */
export type Postable = Catch | FishingWater | Group | NamedScope | Post | Review;

/** A feed of 'post-like' objects.  Returns posts, but also catches */
export type PostsFeed = Catch | Post;

/** The connection type for PostsFeed. */
export type PostsFeedConnection = {
  __typename: 'PostsFeedConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<PostFeedItemEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<PostsFeed>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** A pair of objects (e.g. User/FishingMethod/etc...) used for rendering where a post item came from */
export type PostsFeedDisplayEntities = {
  __typename: 'PostsFeedDisplayEntities';
  from: PostsFeedDisplayEntity;
  to: Maybe<PostsFeedDisplayEntity>;
};

/** An object that can be returned for a PostsFeedDisplayEntities */
export type PostsFeedDisplayEntity = {
  displayIcon: Image;
  displayName: Scalars['String']['output'];
  externalId: Scalars['String']['output'];
  followedByCurrentUser: Scalars['Boolean']['output'];
  /**
   * ID of display entity for deep links
   * @deprecated Use `externalId` instead
   */
  id: Scalars['Int']['output'];
};


/** An object that can be returned for a PostsFeedDisplayEntities */
export type PostsFeedDisplayEntityDisplayIconArgs = {
  croppingStrategy?: InputMaybe<CroppingStrategyEnum>;
  format?: InputMaybe<FormatEnum>;
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

/** An edge in a connection. */
export type PostsFeedDisplayEntityEdge = {
  __typename: 'PostsFeedDisplayEntityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<PostsFeedDisplayEntity>;
};

/** The connection type for PostsFeedDisplayEntity. */
export type PostsFeedDisplayEntityRecordConnection = {
  __typename: 'PostsFeedDisplayEntityRecordConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<PostsFeedDisplayEntityEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<PostsFeedDisplayEntity>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Average of column for records beyond pagination (limited by scopes, if applicable) */
  totalAverage: Scalars['Float']['output'];
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};


/** The connection type for PostsFeedDisplayEntity. */
export type PostsFeedDisplayEntityRecordConnectionTotalAverageArgs = {
  column?: InputMaybe<Scalars['String']['input']>;
};


/** The connection type for PostsFeedDisplayEntity. */
export type PostsFeedDisplayEntityRecordConnectionTotalCountArgs = {
  column?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of PremiumCreateGrantMutation */
export type PremiumCreateGrantMutationInput = {
  attributes: GrantAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of PremiumCreateGrantMutation. */
export type PremiumCreateGrantMutationPayload = {
  __typename: 'PremiumCreateGrantMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  grant: Maybe<Grant>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** Autogenerated input type of PremiumGrantGlimpseOfProMutation */
export type PremiumGrantGlimpseOfProMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of PremiumGrantGlimpseOfProMutation. */
export type PremiumGrantGlimpseOfProMutationPayload = {
  __typename: 'PremiumGrantGlimpseOfProMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  grant: Maybe<Grant>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** Autogenerated input type of PremiumGrantOfferMutation */
export type PremiumGrantOfferMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  promotionSlug: Scalars['String']['input'];
};

/** Autogenerated return type of PremiumGrantOfferMutation. */
export type PremiumGrantOfferMutationPayload = {
  __typename: 'PremiumGrantOfferMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  grant: Maybe<Grant>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

export type PressureTrendCondition = {
  __typename: 'PressureTrendCondition';
  /** Air pressure [Pa] */
  airPressure: Scalars['Float']['output'];
  /** Condition name for the activity breakdown screen */
  displayName: Scalars['String']['output'];
  identifier: ConditionTypes;
  /** Pressure trend */
  pressureTrend: PressureTrendEnum;
  /** Long reason explaining condition impact on score */
  reasonLong: Scalars['String']['output'];
  /** Short reason explaining condition impact on score */
  reasonShort: Scalars['String']['output'];
  /** Conveys if the effect is positive, negative or neutral */
  stateKey: StateKeyTypes;
};

export enum PressureTrendEnum {
  /** Air pressure is falling */
  FALLING = 'FALLING',
  /** Air pressure is rising */
  RISING = 'RISING',
  /** Air pressure is steady */
  STEADY = 'STEADY'
}

/** Fields which represent a product */
export type Product = ReviewableInterface & {
  __typename: 'Product';
  brand: Brand;
  catches: CatchRecordConnection;
  categories: CategoryRecordConnection;
  category: Category;
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  customGearStatus: CustomGearStatusTypes;
  description: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  externalId: Scalars['String']['output'];
  /** Reviews that either have text or title or they are owned by current user */
  filteredReviews: Maybe<ReviewInterfaceRecordConnection>;
  /** URLs of the best images to be displayed for the product */
  heroImageUrls: Array<Scalars['String']['output']>;
  /**
   * DB ID
   * @deprecated Use `externalId` instead
   */
  id: Scalars['Int']['output'];
  image: Maybe<Image>;
  /**
   * The advert ID from the Marketplace GraphQL API for this product
   * @deprecated The shop has been deprecated
   */
  marketplaceId: Maybe<Scalars['String']['output']>;
  /**
   * The web URL for the Marketplace advert for this product
   * @deprecated The shop has been deprecated
   */
  marketplaceUrl: Maybe<Scalars['String']['output']>;
  /**
   * The web advert ID from the Marketplace website for this product
   * @deprecated The shop has been deprecated
   */
  marketplaceWebId: Maybe<Scalars['String']['output']>;
  /** @deprecated Use displayName instead */
  name: Scalars['String']['output'];
  /** Property questions that can be answered in a review */
  propertyQuestions: ReviewPropertyQuestionInterfaceRecordConnection;
  /** A frequency breakdown of ratings from 1 to 5 for this reviewable object */
  ratingFrequencies: Scalars['JSON']['output'];
  reviewedByCurrentUser: Scalars['Boolean']['output'];
  reviews: Maybe<ReviewInterfaceRecordConnection>;
  /**
   * An array of marketplace_ids of 'similar' products. Similarity is determined by an ML model based on transaction data in general not for the specific product.Think of it as 'bestsellers in general'.
   * @deprecated The shop has been deprecated
   */
  similarGenericProductsByTransaction: Maybe<Array<Scalars['String']['output']>>;
  /**
   * An array of marketplace_ids of 'similar' products. Similarity is determined by an ML model based on association rules. Think of it as 'What items frequently appear together'
   * @deprecated The shop has been deprecated
   */
  similarProductsByAssociationRules: Maybe<Array<Scalars['String']['output']>>;
  /**
   * An array of marketplace_ids of 'similar' products. Similarity is determined by an ML model (named 'SIMS') based on users' activity, think of it as, 'Other anglers viewed...'
   * @deprecated The shop has been deprecated
   */
  similarProductsByUserInteraction: Maybe<Array<Scalars['String']['output']>>;
  /**
   * An array of marketplace_ids of 'similar' products. Similarity is determined by an ML model based on transaction data. Think of it as 'Which items are similar in terms of how many times they were bought by the same user'.
   * @deprecated The shop has been deprecated
   */
  similarUniqueProductsByTransaction: Maybe<Array<Scalars['String']['output']>>;
  /** Product units found in a user's tacklebox for this product */
  tackleboxUnits: ProductUnitRecordConnection;
  units: ProductUnitRecordConnection;
  usedBy: UserRecordConnection;
};


/** Fields which represent a product */
export type ProductCatchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<CatchFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Fields which represent a product */
export type ProductCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<CategoryFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Fields which represent a product */
export type ProductFilteredReviewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ReviewInterfaceFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Fields which represent a product */
export type ProductImageArgs = {
  croppingStrategy?: InputMaybe<CroppingStrategyEnum>;
  filterString?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<FormatEnum>;
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


/** Fields which represent a product */
export type ProductPropertyQuestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ReviewPropertyQuestionInterfaceFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Fields which represent a product */
export type ProductReviewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ReviewInterfaceFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Fields which represent a product */
export type ProductTackleboxUnitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ProductUnitFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  userExternalId?: InputMaybe<Scalars['String']['input']>;
};


/** Fields which represent a product */
export type ProductUnitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ProductUnitFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Fields which represent a product */
export type ProductUsedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<UserFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for Product. */
export type ProductConnection = {
  __typename: 'ProductConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ProductEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<Product>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ProductEdge = {
  __typename: 'ProductEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Product>;
};

export type ProductFilters = {
  /** Show products of any status (admin only) */
  allStatuses?: InputMaybe<Scalars['Boolean']['input']>;
  /** Return products for this set of brand ids */
  brandExternalIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Return products for this set of category external ids */
  categoryExternalIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Return products for this set of external ids */
  externalIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Return products that are or have been in the shop */
  inShop?: InputMaybe<Scalars['Boolean']['input']>;
  /** Return only products which the given string is in the name */
  nameContains?: InputMaybe<Scalars['String']['input']>;
  /** Filter on product name or 9-digit web advert id */
  nameContainsOrWebAdvertId?: InputMaybe<Scalars['String']['input']>;
  /** Return products in ascending order by display name */
  orderByName?: InputMaybe<Scalars['Boolean']['input']>;
  /** Return in descending order by popularity */
  orderByPopularity?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Filter on list of web advert ids. The webAdvertId is a nine-digit integer displayed on
   * product pages and in the URL on marketplace.fishbrain.com'
   *
   */
  webAdvertIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** The connection type for Product. */
export type ProductRecordConnection = {
  __typename: 'ProductRecordConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ProductEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<Product>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Average of column for records beyond pagination (limited by scopes, if applicable) */
  totalAverage: Scalars['Float']['output'];
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};

/** Fields which represent a "product unit" (otherwise known as a variant or SKU) */
export type ProductUnit = {
  __typename: 'ProductUnit';
  attributeValues: UnitAttributeValueRecordConnection;
  author: Maybe<User>;
  /** Date record was added to the database */
  createdAt: Scalars['ISO8601DateTime']['output'];
  customGearStatus: CustomGearStatusTypes;
  /** @deprecated Use `gtin` instead */
  eans: Maybe<Array<Scalars['String']['output']>>;
  externalId: Scalars['String']['output'];
  gtin: Maybe<Scalars['String']['output']>;
  /**
   * DB ID
   * @deprecated Use `externalId` instead
   */
  id: Scalars['Int']['output'];
  image: Maybe<Image>;
  /**
   * The Marketplace Advert ID for the parent product
   * @deprecated The shop has been deprecated
   */
  marketplaceAdvertId: Maybe<Scalars['String']['output']>;
  /**
   * The ID from the Marketplace GraphQL API for this product unit
   * @deprecated The shop has been deprecated
   */
  marketplaceId: Maybe<Scalars['String']['output']>;
  /** Unique string identifying the product */
  model: Scalars['String']['output'];
  product: Product;
  /** 'similar' product units. Similarity is determined by a ML model using image recognition. */
  similarUnitsByImage: ProductUnitRecordConnection;
  topLevelCategory: Category;
  /** Is this unit in the current user's tacklebox? */
  usedByCurrentUser: Scalars['Boolean']['output'];
};


/** Fields which represent a "product unit" (otherwise known as a variant or SKU) */
export type ProductUnitAttributeValuesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Fields which represent a "product unit" (otherwise known as a variant or SKU) */
export type ProductUnitImageArgs = {
  croppingStrategy?: InputMaybe<CroppingStrategyEnum>;
  filterString?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<FormatEnum>;
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


/** Fields which represent a "product unit" (otherwise known as a variant or SKU) */
export type ProductUnitSimilarUnitsByImageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** An edge in a connection. */
export type ProductUnitEdge = {
  __typename: 'ProductUnitEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<ProductUnit>;
};

export type ProductUnitFilters = {
  /** Return units with the given custom gear status */
  customGearStatus?: InputMaybe<CustomGearStatusTypes>;
  /** Filter suggestions by external ID. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Return units for given product (all statuses, for admin only) */
  forProductAllStatuses?: InputMaybe<Scalars['String']['input']>;
  /** Return baits first */
  orderByBaitsFirst?: InputMaybe<Scalars['Boolean']['input']>;
  /** Return units in order of priority set by product direction; currently: bait units, units */
  orderByPrioritized?: InputMaybe<Scalars['Boolean']['input']>;
  /** Return product units sorted by product name and unit model */
  orderByProductNameAndModel?: InputMaybe<Scalars['Boolean']['input']>;
  /** Return product units sorted by product name and unit model, one unit per product at a time */
  orderByProductNameAndModelPerProduct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The connection type for ProductUnit. */
export type ProductUnitRecordConnection = {
  __typename: 'ProductUnitRecordConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ProductUnitEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<ProductUnit>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Average of column for records beyond pagination (limited by scopes, if applicable) */
  totalAverage: Scalars['Float']['output'];
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};

/** Autogenerated input type of PromoteGroupAdminMutation */
export type PromoteGroupAdminMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  groupId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of PromoteGroupAdminMutation. */
export type PromoteGroupAdminMutationPayload = {
  __typename: 'PromoteGroupAdminMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  group: Maybe<Group>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

export type PromotedCallToActionAttributes = {
  buttonText: Scalars['String']['input'];
  headline: Scalars['String']['input'];
  image: ActiveStorageImageUpload;
  subHeadline?: InputMaybe<Scalars['String']['input']>;
  targetUrl: Scalars['String']['input'];
};

export type PropertyAnswerAttributes = {
  /** The answer to the property question */
  answer: ReviewPropertyAnswerTypes;
  /** External ID of the property question */
  questionExternalId: Scalars['String']['input'];
};

/** The connection type for Post. */
export type PublicPostRecordConnection = {
  __typename: 'PublicPostRecordConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<PublicPostRecordEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<Post>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PublicPostRecordEdge = {
  __typename: 'PublicPostRecordEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Post>;
};

export type Query = {
  __typename: 'Query';
  /** For fetching a single access method */
  accessMethod: AccessMethod;
  accessMethods: AccessMethodRecordConnection;
  /** An array containing all published brand Pages in alphabetical order */
  allBrandPages: Array<Page>;
  /** Returns a search result of equipment attribute_values */
  attributeValueSearch: Maybe<EquipmentAttributeValueSearchResult>;
  /** For fetching a single brand (A company which sells fishing products) */
  brand: Brand;
  /** Returns a search result of equipment brands */
  brandSearch: Maybe<EquipmentBrandSearchResult>;
  /** Companies which sell fishing products */
  brands: BrandRecordConnection;
  /** For fetching a single catch */
  catch: Catch;
  /** For fetching a single catch batch reference */
  catchBatchReference: CatchBatchReference;
  catches: CatchRecordConnection;
  /** Equipment categories */
  categories: CategoryRecordConnection;
  /** For fetching a single category (Equipment Category) */
  category: Category;
  contextualPlaces: ContextualPlaceRecordConnection;
  /** List of countries */
  countries: CountryRecordConnection;
  /** For fetching a single country */
  country: Country;
  /**
   * Get the relevant feed for the user
   * @deprecated Use `{ me { followedFeed } }` instead
   */
  currentUserFollowed: PostsFeedConnection;
  /** Generate a Firebase dynamic link for the specified deep link. */
  deepLinkPartnerPromotionLink: Maybe<DeepLinkPromotionPartnerLink>;
  /** Returns a search result of equipment brands, categories and/or products */
  equipmentSearch: Maybe<EquipmentSearchResult>;
  /** For fetching a single fishing method */
  fishingMethod: FishingMethod;
  fishingMethods: FishingMethodRecordConnection;
  fishingPlan: Maybe<FishingPlan>;
  /** Fishing tips based on targeted species, location, and time. */
  fishingTips: Array<FishingTip>;
  /** For fetching a single fishing water */
  fishingWater: FishingWater;
  fishingWaterMetadata: FishingWaterMetadataRecordConnection;
  fishingWaterMetadataGroups: FishingWaterMetadataGroupRecordConnection;
  fishingWaters: FishingWaterRecordConnection;
  /** Returns a search result of fishing waters */
  fishingWatersSearch: FishingWaterRecordConnection;
  /** @deprecated Use me.followRecommendations */
  followRecommendations: Maybe<FollowRecommendationConnection>;
  /** Returns locations for given coordinates */
  geocodingLocationsSearch: Maybe<SearchResultRecordConnection>;
  /** For fetching a single group (Group) */
  group: Group;
  groups: GroupRecordConnection;
  /** Answers about a geographic coordinate, e.g. whether salt water is nearby. */
  locationMetadata: LocationMetadata;
  /** Represents part of the map within bounding box or circle */
  mapArea: MapArea;
  /** The currently logged in user */
  me: Maybe<CurrentUser>;
  /** A feed of recent catches and trips located within the user's favorite fishing area. */
  myAreaFeed: PublicPostRecordConnection;
  /** @deprecated Use `{ me { groups } }` instead */
  myGroups: MyGroups;
  /** For fetching a single page */
  page: Page;
  pages: PageRecordConnection;
  place: Place;
  /** Administrative and contextual places containing the given coordinate, ordered most-specific first (smallest area first, nulls last). Returns an empty list when no places match. */
  placeContext: Array<PlaceContext>;
  places: PlaceRecordConnection;
  /** For fetching a single point of interest */
  pointOfInterest: PointOfInterest;
  /** For fetching a single post */
  post: Post;
  /** Posts!!! */
  posts: PublicPostRecordConnection;
  proFeatures: Features;
  /** For fetching a single product */
  product: Product;
  /** Returns a search result of equipment products */
  productSearch: Maybe<EquipmentProductSearchResult>;
  /** Returns a product unit matching a given identifier */
  productUnit: Maybe<ProductUnit>;
  /** Equipment product units */
  productUnits: ProductUnitRecordConnection;
  /** Equipment products, excluding legacy baits */
  products: ProductRecordConnection;
  /** Returns the top gear for a species and location. If location is provided as a position or fishingWaterExternalId, region for that position or fishing water will be taken as a location. If no location is provided, region of users position will be taken as a location. If none of the above is present, users profile country will be taken as a location. If we do not have records for the selected region, records from regions country will be provided. */
  recommendedGearForSpeciesAndLocation: Array<EquipmentGearType>;
  /** For fetching a single region */
  region: Region;
  /** List of regions */
  regions: RegionRecordConnection;
  /**
   * The top level categories for gear
   * @deprecated Use `categories` with `topLevel: true, orderByRank: true` filters
   */
  rootEquipmentCategories: CategoryRecordConnection;
  /** For fetching a single single species */
  singleSpecies: Species;
  /** For fetching a single sourced point of interest */
  sourcedPointOfInterest: SourcedPointOfInterest;
  sourcedPointsOfInterest: SourcedPointOfInterestRecordConnection;
  species: SpeciesRecordConnection;
  /** Bite forecasts for available species at a location */
  speciesBiteForecast: SpeciesBiteForecastConnection;
  /** Total count of species with a bite forecast at a location */
  speciesBiteForecastTotalCount: Scalars['Int']['output'];
  /** A preview of the best condition to catch this single species. Null means not enough data */
  speciesForecastPreview: Maybe<Reading>;
  speciesGrouping: SpeciesGrouping;
  speciesGroupings: SpeciesGroupingRecordConnection;
  /** Returns a search result of species */
  speciesSearch: Maybe<SpeciesSearchResult>;
  /** Returns the top result of ML species suggestions if the species is autoselect eligible and the score thresholds are met */
  speciesSuggestion: Maybe<SpeciesSuggestion>;
  /** Suggested species based on ML recognition, recent catches, and popular species in region */
  speciesSuggestions: SpeciesSuggestionConnection;
  /** @deprecated Use `speciesBiteForecasts` instead */
  speciesWithBiteForecast: SpeciesBiteForecastConnection;
  statistics: Statistics;
  /** Suggested catch for the user id */
  suggestedCatch: Maybe<Catch>;
  /** Fishing waters supported by distance and popularity */
  suggestedFishingWaters: Array<FishingWater>;
  /** For fetching a single suggested water name */
  suggestedWaterName: SuggestedWaterName;
  suggestedWaterNames: SuggestedWaterNameRecordConnection;
  /** Returns surface type (water/land) for give coordinates */
  surfaceType: SurfaceTypes;
  tag: Maybe<Tag>;
  tags: TagRecordConnection;
  topProductUnits: Maybe<TopEquipmentProductUnitConnection>;
  /** Returns the top product units for a maximum of 20 species */
  topProductUnitsBySpecies: Maybe<TopEquipmentProductUnitsBySpeciesConnection>;
  /** The most caught species within a bounding box or radius from lat/long */
  topSpeciesNearLocation: TopSpeciesConnection;
  topics: Topics;
  /** A trash collection from sponsored campaigns */
  trashCollection: TrashCollection;
  /** Top 100 brands ranked by total approved trash collection weight. Note: admins see leaderboards based on all records */
  trashCollectionBrandLeaderboard: Array<TrashCollectionBrandLeaderboardEntry>;
  /** Leaderboard of states ranked by total approved trash collection weight. Note: admins see leaderboards based on all records */
  trashCollectionStateLeaderboard: Array<TrashCollectionStateLeaderboardEntry>;
  /** Trash collections from sponsored campaigns, approved and most recent first */
  trashCollections: TrashCollectionRecordConnection;
  /** For fetching a single trip */
  trip: Trip;
  /** For fetching a single trip reference */
  tripReference: TripReference;
  /** A user in the app */
  user: User;
  userMetadata: Array<MetadataGroup>;
  /** Search for users, supports post_id for mention relevance and messageable filter */
  userSearch: Maybe<UserSearch>;
  /** For fetching a single waypoint (Waypoint, a marker on the map) */
  waypoint: Waypoint;
  weatherAndMarineData: Maybe<WeatherAndMarineReading>;
};


export type QueryAccessMethodArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAccessMethodsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAttributeValueSearchArgs = {
  boosts?: InputMaybe<EquipmentAttributeValueSearchBoosts>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBrandArgs = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBrandSearchArgs = {
  boosts?: InputMaybe<EquipmentBrandSearchBoosts>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBrandsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<BrandFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCatchArgs = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCatchBatchReferenceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCatchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  boundingBox?: InputMaybe<BoundingBoxInputObject>;
  boundingCircle?: InputMaybe<BoundingCircleInputObject>;
  filters?: InputMaybe<CatchFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  random?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<CategoryFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  marketplaceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  titleContains?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCategoryArgs = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryContextualPlacesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  location: PositionInputObject;
};


export type QueryCountriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<CountryFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCountryArgs = {
  id: Scalars['String']['input'];
};


export type QueryCurrentUserFollowedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  options?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDeepLinkPartnerPromotionLinkArgs = {
  link: Scalars['String']['input'];
};


export type QueryEquipmentSearchArgs = {
  filters?: InputMaybe<EquipmentSearchFilters>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFishingMethodArgs = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFishingMethodsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFishingPlanArgs = {
  externalId: Scalars['ID']['input'];
};


export type QueryFishingTipsArgs = {
  fishingWaterId: Scalars['String']['input'];
  month: MonthEnum;
  speciesId: Scalars['String']['input'];
};


export type QueryFishingWaterArgs = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFishingWaterMetadataArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFishingWaterMetadataGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFishingWatersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  boundingBox?: InputMaybe<BoundingBoxInputObject>;
  externalIds?: InputMaybe<Array<Scalars['String']['input']>>;
  filters?: InputMaybe<FishingWaterFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  nearby?: InputMaybe<PositionInputObject>;
};


export type QueryFishingWatersSearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  coordinates?: InputMaybe<PositionInputObject>;
  filters?: InputMaybe<FishingWaterFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  radius?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFollowRecommendationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  only?: InputMaybe<Array<RecommendationTypes>>;
};


export type QueryGeocodingLocationsSearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  coordinates: PositionInputObject;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


export type QueryGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<GroupFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLocationMetadataArgs = {
  location: PositionInputObject;
};


export type QueryMapAreaArgs = {
  boundingBox?: InputMaybe<BoundingBoxInputObject>;
  boundingCircle?: InputMaybe<BoundingCircleInputObject>;
};


export type QueryMyAreaFeedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  boundingCircle: BoundingCircleInputObject;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  options?: InputMaybe<MyAreaFeedOptions>;
};


export type QueryPageArgs = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<PageFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPlaceArgs = {
  countryCode: Scalars['String']['input'];
  regionCode: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};


export type QueryPlaceContextArgs = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};


export type QueryPlacesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<PlaceFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPointOfInterestArgs = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPostArgs = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<PostFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductArgs = {
  advertId?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  webAdvertId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductSearchArgs = {
  boosts?: InputMaybe<EquipmentProductSearchBoosts>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductUnitArgs = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  gtin?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductUnitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ProductUnitFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductsArgs = {
  advertIds?: InputMaybe<Array<Scalars['String']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ProductFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  webAdvertIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryRecommendedGearForSpeciesAndLocationArgs = {
  fishingWaterExternalId?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<PositionInputObject>;
  speciesExternalId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRegionArgs = {
  id: Scalars['String']['input'];
};


export type QueryRegionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<RegionFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRootEquipmentCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<CategoryFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySingleSpeciesArgs = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySourcedPointOfInterestArgs = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySourcedPointsOfInterestArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySpeciesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  externalIds?: InputMaybe<Array<Scalars['String']['input']>>;
  filters?: InputMaybe<SpeciesFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySpeciesBiteForecastArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['ISO8601Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hourOfDay?: InputMaybe<Scalars['Int']['input']>;
  hourlyContext?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  location: LocationInput;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  speciesExternalIds?: InputMaybe<Array<Scalars['String']['input']>>;
  timelineLimit?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySpeciesBiteForecastTotalCountArgs = {
  location: LocationInput;
};


export type QuerySpeciesForecastPreviewArgs = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  speciesExternalId: Scalars['String']['input'];
};


export type QuerySpeciesGroupingArgs = {
  externalId: Scalars['String']['input'];
};


export type QuerySpeciesGroupingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCountry?: InputMaybe<Scalars['String']['input']>;
  inCountryState?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  speciesGroupingType?: InputMaybe<SpeciesGroupingTypes>;
};


export type QuerySpeciesSearchArgs = {
  geofilter?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<PositionInputObject>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySpeciesSuggestionArgs = {
  image: Scalars['String']['input'];
  position: PositionInputObject;
};


export type QuerySpeciesSuggestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fishingWaterExternalId?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  options?: InputMaybe<SpeciesSuggestionsOptionsInputObject>;
  position?: InputMaybe<PositionInputObject>;
};


export type QuerySpeciesWithBiteForecastArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  area: AreaInput;
  before?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['ISO8601Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  timeOfDay?: InputMaybe<TimeOfDayTypes>;
};


export type QuerySuggestedCatchArgs = {
  userId: Scalars['String']['input'];
};


export type QuerySuggestedFishingWatersArgs = {
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
};


export type QuerySuggestedWaterNameArgs = {
  id: Scalars['String']['input'];
};


export type QuerySuggestedWaterNamesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<SuggestedWaterNameFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySurfaceTypeArgs = {
  location: PositionInputObject;
};


export type QueryTagArgs = {
  label: Scalars['String']['input'];
};


export type QueryTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTopProductUnitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fishingWaterId?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  methodExternalId?: InputMaybe<Scalars['String']['input']>;
  speciesExternalId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTopProductUnitsBySpeciesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  boundingBox?: InputMaybe<BoundingBoxInputObject>;
  filterOptions?: InputMaybe<UnitsBySpeciesFilterInputObject>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fishingWaterId?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  speciesExternalId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTopSpeciesNearLocationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  boundingBox?: InputMaybe<BoundingBoxInputObject>;
  boundingCircle?: InputMaybe<BoundingCircleInputObject>;
  excludingSpeciesExternalIds?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  minimumSpeciesCount?: InputMaybe<Scalars['Int']['input']>;
  recentSinceDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  speciesWaterSalinity?: InputMaybe<Array<WaterSalinity>>;
};


export type QueryTrashCollectionArgs = {
  externalId: Scalars['String']['input'];
};


export type QueryTrashCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTripArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTripReferenceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  includeBlockedTargets?: InputMaybe<Scalars['Boolean']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserMetadataArgs = {
  lastUsedDeviceId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserSearchArgs = {
  messageable?: InputMaybe<Scalars['Boolean']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWaypointArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWeatherAndMarineDataArgs = {
  datetime: Scalars['ISO8601DateTime']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

/** A range with lower and upper bounds */
export type Range = {
  __typename: 'Range';
  lower: Scalars['Float']['output'];
  upper: Scalars['Float']['output'];
};

export type Reading = {
  __typename: 'Reading';
  /**
   * The rating based on the value of this reading (e.g. poor < 0.25 value)
   *
   */
  rating: Scalars['String']['output'];
  /** The date of this reading */
  readingAt: Scalars['ISO8601DateTime']['output'];
  value: Scalars['Float']['output'];
};

export type RecommendationHighlight = {
  __typename: 'RecommendationHighlight';
  /** Highlight text */
  text: Scalars['String']['output'];
  /** Kind of highlight: trophy fish or catch count */
  type: RecommendationHighlightKindEnum;
};

export enum RecommendationHighlightKindEnum {
  /** Catch count highlight */
  CATCH_COUNT = 'CATCH_COUNT',
  /** Trophy fish highlight */
  TROPHY_FISH = 'TROPHY_FISH'
}

export enum RecommendationTypes {
  /** Recommend groups */
  GROUPS = 'GROUPS',
  /**
   * Recommend influencers
   * @deprecated No longer a supported recommendation type
   */
  INFLUENCERS = 'INFLUENCERS',
  /** Recommend pages */
  PAGES = 'PAGES',
  /** Recommend users */
  USERS = 'USERS'
}

/** Autogenerated input type of RedeemPartnerPromotionMutation */
export type RedeemPartnerPromotionMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Promotional link for redemption */
  link: Scalars['String']['input'];
};

/** Autogenerated return type of RedeemPartnerPromotionMutation. */
export type RedeemPartnerPromotionMutationPayload = {
  __typename: 'RedeemPartnerPromotionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Meta params of the link */
  metaParams: Maybe<Scalars['JSON']['output']>;
  /** ID of partner of the promotion */
  partnerId: Maybe<Scalars['Int']['output']>;
  /** Reference of partner user who owns promotional link */
  partnerUserExternalRef: Maybe<Scalars['String']['output']>;
  /** Promotion key of the link */
  promotionKey: Maybe<Scalars['String']['output']>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

export enum ReferenceProcessingStateTypes {
  FAILURE = 'FAILURE',
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS'
}

/** A region (state, province, etc.) in a country */
export type Region = {
  __typename: 'Region';
  boundaryLayer: Maybe<BoundaryLayer>;
  catches: CatchRecordConnection;
  country: Country;
  countryCode: Maybe<Scalars['String']['output']>;
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  fishingWaters: FishingWaterRecordConnection;
  /** Region Code */
  id: Scalars['String']['output'];
  /** URL for redirecting users to for information about fishing licenses in the region */
  licenseInfoUrl: Maybe<Scalars['String']['output']>;
  localName: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  places: PlaceRecordConnection;
  regionCode: Maybe<Scalars['String']['output']>;
  /** The top fishing waters for the region */
  topFishingWaters: FishingWaterRecordConnection;
};


/** A region (state, province, etc.) in a country */
export type RegionCatchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<CatchFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A region (state, province, etc.) in a country */
export type RegionFishingWatersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<FishingWaterFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A region (state, province, etc.) in a country */
export type RegionPlacesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<PlaceFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A region (state, province, etc.) in a country */
export type RegionTopFishingWatersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<FishingWaterFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  speciesExternalId?: InputMaybe<Scalars['String']['input']>;
};

/** An edge in a connection. */
export type RegionEdge = {
  __typename: 'RegionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Region>;
};

export type RegionFilters = {
  /** Filter regions by name prefix (case-insensitive) */
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

/** The connection type for Region. */
export type RegionRecordConnection = {
  __typename: 'RegionRecordConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<RegionEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<Region>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Average of column for records beyond pagination (limited by scopes, if applicable) */
  totalAverage: Scalars['Float']['output'];
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};

/** Autogenerated input type of RemoveFishingWaterBookmarkMutation */
export type RemoveFishingWaterBookmarkMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Identifier for the fishing water to unbookmark */
  fishingWaterId: Scalars['String']['input'];
};

/** Autogenerated return type of RemoveFishingWaterBookmarkMutation. */
export type RemoveFishingWaterBookmarkMutationPayload = {
  __typename: 'RemoveFishingWaterBookmarkMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** Autogenerated input type of RemoveGroupMemberMutation */
export type RemoveGroupMemberMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  groupId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveGroupMemberMutation. */
export type RemoveGroupMemberMutationPayload = {
  __typename: 'RemoveGroupMemberMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  group: Maybe<Group>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** Autogenerated input type of RemovePersonalBestCatchMutation */
export type RemovePersonalBestCatchMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
};

/** Autogenerated return type of RemovePersonalBestCatchMutation. */
export type RemovePersonalBestCatchMutationPayload = {
  __typename: 'RemovePersonalBestCatchMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** Autogenerated input type of RemoveStaffMutation */
export type RemoveStaffMutationInput = {
  attributes: PageUsers;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
};

/** Autogenerated return type of RemoveStaffMutation. */
export type RemoveStaffMutationPayload = {
  __typename: 'RemoveStaffMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  page: Page;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** Geocoding resource */
export type Resource = {
  __typename: 'Resource';
  bbox: Maybe<Array<Scalars['Float']['output']>>;
  center: Maybe<Array<Scalars['Float']['output']>>;
  context: Maybe<Array<Context>>;
  formattedContext: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

/** Resource describes content tabs that a page has */
export type ResourceLike = {
  label: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

/** An edge in a connection. */
export type ResourceLikeEdge = {
  __typename: 'ResourceLikeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<ResourceLike>;
};

export type ResourceLikeFilters = {
  /** Find resource with specified position */
  position?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for ResourceLike. */
export type ResourceLikeRecordConnection = {
  __typename: 'ResourceLikeRecordConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ResourceLikeEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<ResourceLike>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Average of column for records beyond pagination (limited by scopes, if applicable) */
  totalAverage: Scalars['Float']['output'];
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};

/** A review left by a user describing their experience with a product */
export type Review = ReviewInterface & {
  __typename: 'Review';
  author: User;
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The product the review refers to (Equipment::Review only) */
  equipmentProduct: Maybe<Product>;
  externalId: Scalars['String']['output'];
  /** The fishing water the review refers to (FishingWaterReview only) */
  fishingWater: Maybe<FishingWater>;
  /**
   * DB ID
   * @deprecated Use `externalId` instead
   */
  id: Maybe<Scalars['Int']['output']>;
  post: Post;
  /** The property answers belonging to the reviewable resource */
  propertyAnswers: Maybe<ReviewPropertyAnswerInterfaceRecordConnection>;
  rating: Scalars['Int']['output'];
};


/** A review left by a user describing their experience with a product */
export type ReviewPropertyAnswersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ReviewAttributes = {
  /** Review images */
  images?: InputMaybe<Array<ActiveStorageImageUpload>>;
  /** Answers to property questions */
  propertyAnswers?: InputMaybe<Array<PropertyAnswerAttributes>>;
  /** Number of stars for rating */
  rating: Scalars['Int']['input'];
  /** Review text */
  textString?: InputMaybe<Scalars['String']['input']>;
  /** Review title */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Review video. Note: Video can not be removed nor replaced, only added */
  video?: InputMaybe<VideoUpload>;
};

/** Fields that represent a user's review of a reviewable resource */
export type ReviewInterface = {
  author: User;
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The product the review refers to (Equipment::Review only) */
  equipmentProduct: Maybe<Product>;
  externalId: Scalars['String']['output'];
  /** The fishing water the review refers to (FishingWaterReview only) */
  fishingWater: Maybe<FishingWater>;
  /**
   * DB ID
   * @deprecated Use `externalId` instead
   */
  id: Maybe<Scalars['Int']['output']>;
  post: Post;
  /** The property answers belonging to the reviewable resource */
  propertyAnswers: Maybe<ReviewPropertyAnswerInterfaceRecordConnection>;
  rating: Scalars['Int']['output'];
};


/** Fields that represent a user's review of a reviewable resource */
export type ReviewInterfacePropertyAnswersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum ReviewInterfaceCalculationAttributes {
  RATING = 'RATING'
}

/** An edge in a connection. */
export type ReviewInterfaceEdge = {
  __typename: 'ReviewInterfaceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<ReviewInterface>;
};

export type ReviewInterfaceFilters = {
  /** Only reviews that have five star ratings */
  havingFiveStarRating?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only reviews that have four star ratings */
  havingFourStarRating?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only reviews that have one star ratings */
  havingOneStarRating?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only reviews that have either a text or a title */
  havingTextOrTitle?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only reviews that have three star ratings */
  havingThreeStarRating?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only reviews that have two star ratings */
  havingTwoStarRating?: InputMaybe<Scalars['Boolean']['input']>;
  /** Order by best-review score (length, rating, recency, helpful votes) */
  orderByBestReviews?: InputMaybe<Scalars['Boolean']['input']>;
  /** Order descendingly by helpful votes and by creation date / time */
  orderByHelpfulVotes?: InputMaybe<Scalars['Boolean']['input']>;
  /** Order descendingly by creation date / time */
  orderByRecent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Order descendingly by rating and creation date / time */
  orderByTopReviews?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The connection type for ReviewInterface. */
export type ReviewInterfaceRecordConnection = {
  __typename: 'ReviewInterfaceRecordConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ReviewInterfaceEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<ReviewInterface>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Fishing water property questions that were answered in reviews */
  propertyQuestions: Maybe<ReviewPropertyQuestionInterfaceRecordConnection>;
  /** Average of column for records beyond pagination (limited by scopes, if applicable) */
  totalAverage: Scalars['Float']['output'];
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};


/** The connection type for ReviewInterface. */
export type ReviewInterfaceRecordConnectionPropertyQuestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ReviewPropertyQuestionInterfaceFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The connection type for ReviewInterface. */
export type ReviewInterfaceRecordConnectionTotalAverageArgs = {
  attribute?: InputMaybe<ReviewInterfaceCalculationAttributes>;
};

/** The property answer belonging to a product review */
export type ReviewPropertyAnswer = ReviewPropertyAnswerInterface & {
  __typename: 'ReviewPropertyAnswer';
  /** +1 for LIKED, -1 for DISLIKED */
  answer: Scalars['Int']['output'];
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  externalId: Scalars['String']['output'];
  /**
   * DB ID - inaccessible
   * @deprecated Replaced by externalId
   */
  id: Maybe<Scalars['Int']['output']>;
  /** External ID for the related question */
  questionExternalId: Scalars['String']['output'];
};

/** Fields that present a User's Review of an entity */
export type ReviewPropertyAnswerInterface = {
  /** +1 for LIKED, -1 for DISLIKED */
  answer: Scalars['Int']['output'];
  externalId: Scalars['String']['output'];
  /** External ID for the related question */
  questionExternalId: Scalars['String']['output'];
};

/** An edge in a connection. */
export type ReviewPropertyAnswerInterfaceEdge = {
  __typename: 'ReviewPropertyAnswerInterfaceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<ReviewPropertyAnswerInterface>;
};

/** The connection type for ReviewPropertyAnswerInterface. */
export type ReviewPropertyAnswerInterfaceRecordConnection = {
  __typename: 'ReviewPropertyAnswerInterfaceRecordConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ReviewPropertyAnswerInterfaceEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<ReviewPropertyAnswerInterface>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Average of column for records beyond pagination (limited by scopes, if applicable) */
  totalAverage: Scalars['Float']['output'];
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};

export enum ReviewPropertyAnswerTypes {
  NEGATIVE = 'NEGATIVE',
  NEUTRAL = 'NEUTRAL',
  POSITIVE = 'POSITIVE'
}

/** The property question of a product review */
export type ReviewPropertyQuestion = ReviewPropertyQuestionInterface & {
  __typename: 'ReviewPropertyQuestion';
  answers: Maybe<ReviewPropertyAnswerInterfaceRecordConnection>;
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  externalId: Scalars['String']['output'];
  /**
   * DB ID
   * @deprecated Use `externalId` instead
   */
  id: Scalars['Int']['output'];
  question: Scalars['String']['output'];
  summaryHeader: Maybe<Scalars['String']['output']>;
  /** @deprecated Use "question" instead */
  text: Scalars['String']['output'];
};


/** The property question of a product review */
export type ReviewPropertyQuestionAnswersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Fields that represent a Review Property Question */
export type ReviewPropertyQuestionInterface = {
  answers: Maybe<ReviewPropertyAnswerInterfaceRecordConnection>;
  externalId: Scalars['String']['output'];
  /**
   * DB ID - inaccessible
   * @deprecated Replaced by externalId
   */
  id: Maybe<Scalars['Int']['output']>;
  question: Scalars['String']['output'];
  summaryHeader: Maybe<Scalars['String']['output']>;
  /** @deprecated Use "question" instead */
  text: Scalars['String']['output'];
};


/** Fields that represent a Review Property Question */
export type ReviewPropertyQuestionInterfaceAnswersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ReviewPropertyQuestionInterfaceFilters = {
  /** Return highlighted property questions */
  highlighted?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The connection type for ReviewPropertyQuestionInterface. */
export type ReviewPropertyQuestionInterfaceRecordConnection = {
  __typename: 'ReviewPropertyQuestionInterfaceRecordConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ReviewPropertyQuestionRecordEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<ReviewPropertyQuestionInterface>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ReviewPropertyQuestionRecordEdge = {
  __typename: 'ReviewPropertyQuestionRecordEdge';
  /** The average score for a property question on a product */
  answersAverage: Scalars['Float']['output'];
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<ReviewPropertyQuestionInterface>;
};

/** Fields that represent a reviewable resource */
export type ReviewableInterface = {
  /** Reviews that either have text or title or they are owned by current user */
  filteredReviews: Maybe<ReviewInterfaceRecordConnection>;
  /** Property questions that can be answered in a review */
  propertyQuestions: ReviewPropertyQuestionInterfaceRecordConnection;
  /** A frequency breakdown of ratings from 1 to 5 for this reviewable object */
  ratingFrequencies: Scalars['JSON']['output'];
  reviewedByCurrentUser: Scalars['Boolean']['output'];
  reviews: Maybe<ReviewInterfaceRecordConnection>;
};


/** Fields that represent a reviewable resource */
export type ReviewableInterfaceFilteredReviewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ReviewInterfaceFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Fields that represent a reviewable resource */
export type ReviewableInterfacePropertyQuestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ReviewPropertyQuestionInterfaceFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Fields that represent a reviewable resource */
export type ReviewableInterfaceReviewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ReviewInterfaceFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type Rig = {
  __typename: 'Rig';
  buildDescription: GenericBaitsInfoSection;
  /** Display name of the rig */
  displayName: Scalars['String']['output'];
  /** Name of the rig */
  name: Scalars['String']['output'];
  riggingInstructions: GenericBaitsInfoSection;
};

export enum RolesEnum {
  /** Allows to manage page */
  ADMIN = 'ADMIN',
  /** Allows user to post content to a page */
  AMBASSADOR = 'AMBASSADOR',
  /** Allows user to act in the name of page, eg post/like content as a page */
  PUBLISHER = 'PUBLISHER'
}

/** Saltwater relevance for a geographic coordinate. */
export type SaltwaterMetadata = {
  __typename: 'SaltwaterMetadata';
  /** True when an EEZ polygon is within 100 miles of the coordinate. */
  nearby: Scalars['Boolean']['output'];
};

export type ScoreDetails = {
  __typename: 'ScoreDetails';
  /** Long reason explaining the overall score */
  reasonLong: Scalars['String']['output'];
  /** Short reason explaining the overall score */
  reasonShort: Scalars['String']['output'];
  /** Overall activity score between 0 and 10 */
  score: Scalars['Float']['output'];
  /** Conveys if the activity is slow, normal or active */
  stateKey: ScoreStateKeyEnum;
};

export enum ScoreStateKeyEnum {
  ACTIVE = 'ACTIVE',
  NORMAL = 'NORMAL',
  SLOW = 'SLOW'
}

/** Geocoding location map search result */
export type SearchResult = {
  __typename: 'SearchResult';
  context: Maybe<Array<Context>>;
  distance: Maybe<Scalars['Float']['output']>;
  formattedDistance: Maybe<Scalars['String']['output']>;
  resource: Maybe<Resource>;
};

/** An edge in a connection. */
export type SearchResultEdge = {
  __typename: 'SearchResultEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<SearchResult>;
};

/**
 * Entities by which to filter products, ordered by relevance
 *
 */
export type SearchResultFilterEntity = Brand | Category;

/** The connection type for SearchResult. */
export type SearchResultRecordConnection = {
  __typename: 'SearchResultRecordConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<SearchResultEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<SearchResult>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Average of column for records beyond pagination (limited by scopes, if applicable) */
  totalAverage: Scalars['Float']['output'];
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};

export type Section = {
  __typename: 'Section';
  description: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** Autogenerated input type of SetUserDateOfBirthMutation */
export type SetUserDateOfBirthMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth: Scalars['ISO8601Date']['input'];
};

/** Autogenerated return type of SetUserDateOfBirthMutation. */
export type SetUserDateOfBirthMutationPayload = {
  __typename: 'SetUserDateOfBirthMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  isAgeGated: Scalars['Boolean']['output'];
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
  wasUpdated: Scalars['Boolean']['output'];
};

/** A sourced point of interest */
export type SourcedPointOfInterest = {
  __typename: 'SourcedPointOfInterest';
  address: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  county: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  description: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  externalId: Scalars['String']['output'];
  /** DB ID */
  id: Scalars['Int']['output'];
  isPrimary: Scalars['Boolean']['output'];
  latitude: Maybe<Scalars['Float']['output']>;
  longitude: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  phone: Maybe<Scalars['String']['output']>;
  pointOfInterestType: Maybe<PointOfInterestType>;
  state: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  website: Maybe<Scalars['String']['output']>;
  zipcode: Maybe<Scalars['String']['output']>;
};

/** An edge in a connection. */
export type SourcedPointOfInterestEdge = {
  __typename: 'SourcedPointOfInterestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<SourcedPointOfInterest>;
};

/** The connection type for SourcedPointOfInterest. */
export type SourcedPointOfInterestRecordConnection = {
  __typename: 'SourcedPointOfInterestRecordConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<SourcedPointOfInterestEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<SourcedPointOfInterest>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Average of column for records beyond pagination (limited by scopes, if applicable) */
  totalAverage: Scalars['Float']['output'];
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};

/** A species */
export type Species = PostsFeedDisplayEntity & {
  __typename: 'Species';
  /** Abundance potential for the species in the fishing water */
  abundancePotential: Maybe<AbundancePotential>;
  /**
   * The times of the day this species is active
   * @deprecated Makes no sense globally
   */
  activeTimes: Maybe<Array<Scalars['String']['output']>>;
  /**
   * Activity score for the species based on current fishing conditions
   * @deprecated Use `catchConditions` instead
   */
  activityScore: Maybe<ActivityScoreBreakdown>;
  areaSpecies: Maybe<AreaSpecies>;
  /** @deprecated Was changed to commonLength, also now deprecated */
  avgLength: Maybe<Scalars['Float']['output']>;
  /** @deprecated Was changed to commonWeight, also now deprecated */
  avgWeight: Maybe<Scalars['Float']['output']>;
  /** Provides detailed catch conditions for the species, tailored to current fishing conditions such as location, weather, time, and water clarity */
  catchConditions: Maybe<CatchConditions>;
  catches: CatchRecordConnection;
  /**
   * The most common length for this species
   * @deprecated Not useful to anglers
   */
  commonLength: Maybe<Scalars['Float']['output']>;
  /**
   * The most common weight for this species
   * @deprecated Not useful to anglers
   */
  commonWeight: Maybe<Scalars['Float']['output']>;
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** A short description of the species */
  description: Maybe<Scalars['String']['output']>;
  dimensionsAverage: Maybe<DimensionsAverage>;
  dimensionsDistributions: Maybe<Array<DimensionsDistribution>>;
  displayIcon: Image;
  /** Default name for this species */
  displayName: Scalars['String']['output'];
  /** A curated catch or a popular one with an image from the last month */
  exampleCatchWithImage: Maybe<Catch>;
  externalId: Scalars['String']['output'];
  /** The first available localised name for this species. If there is no localised name, fallback to the default name (displayName). */
  firstLocalOrName: Scalars['String']['output'];
  /** The Fishbase URL for the species */
  fishReferenceLink: Maybe<Scalars['String']['output']>;
  /** The Fishbase name for the species */
  fishReferenceName: Maybe<Scalars['String']['output']>;
  /** The Fishbase ID for the species */
  fishbaseId: Maybe<Scalars['String']['output']>;
  /**
   * A csv string of FishRules species ids
   * @deprecated Use fishrulesIds as there may be more than one fishruleId per species.
   *
   */
  fishrulesId: Maybe<Scalars['String']['output']>;
  /** An array of FishRules species ids */
  fishrulesIds: Maybe<Array<Scalars['String']['output']>>;
  /** If the current user follows this species */
  followedByCurrentUser: Scalars['Boolean']['output'];
  /** Users who follow this species */
  followers: UserFollowersConnection;
  /** Returns true if the species has abundance potential in the provided fishing water else false */
  hasAbundancePotential: Scalars['Boolean']['output'];
  /** Returns true if the species has catch conditions available to the current user */
  hasCatchConditions: Scalars['Boolean']['output'];
  hasFishingTip: Scalars['Boolean']['output'];
  /** True if given species has trophy potential in the provided fishing water */
  hasTrophyPotential: Scalars['Boolean']['output'];
  /**
   * DB ID
   * @deprecated Use `externalId` instead
   */
  id: Scalars['Int']['output'];
  image: Image;
  imageArtist: Maybe<Scalars['String']['output']>;
  /** The type of attribution for the image */
  imageAttributionType: Maybe<Scalars['String']['output']>;
  /** The comment for the image */
  imageComment: Maybe<Scalars['String']['output']>;
  imageCopyrightExpiryDate: Maybe<Scalars['ISO8601DateTime']['output']>;
  imageCopyrightStatus: Maybe<Scalars['String']['output']>;
  /** Original source URL for the image. Not for app usage. */
  imageOriginalUrl: Maybe<Scalars['String']['output']>;
  imagePublisher: Maybe<Scalars['String']['output']>;
  /** The reference name for the image */
  imageReferenceName: Maybe<Scalars['String']['output']>;
  /** Returns true if given species has trophy potential above the big fish threshold in the provided fishing water else false */
  isBigFish: Scalars['Boolean']['output'];
  /** IUCN category code (https://en.wikipedia.org/wiki/IUCN_Red_List#Categories) */
  iucnStatus: Maybe<Scalars['String']['output']>;
  latinName: Scalars['String']['output'];
  /** @deprecated Not useful to anglers */
  maxAge: Maybe<Scalars['Int']['output']>;
  /** The max common depth of this species (in metres) */
  maxCommonDepth: Maybe<Scalars['Float']['output']>;
  /** The maximum length of this species (in metres) */
  maxLength: Scalars['Float']['output'];
  maxWeight: Scalars['Float']['output'];
  /** The min common depth of this species (in metres) */
  minCommonDepth: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use `displayName` instead */
  name: Scalars['String']['output'];
  /** The predicted length (in meters) of the species based on a given weight */
  predictedLength: Maybe<SpeciesPredictedWeightLength>;
  /** The predicted weight (in kgs) of the species based on a given length */
  predictedWeight: Maybe<SpeciesPredictedWeightLength>;
  /** The preferred bait origin for the species */
  preferredBaitOrigin: Maybe<BaitOriginTypes>;
  /**
   * The most popular catch of this species with an image from the last month.
   * @deprecated Use exampleCatchWithImage as it displays a curated catch or a recent one.
   *
   */
  recentCatchWithImage: Maybe<Catch>;
  /** The Sealifebase ID for the species */
  sealifebaseId: Maybe<Scalars['String']['output']>;
  /**
   * The spawning period for the species
   * @deprecated Does not make sense globally
   */
  spawningPeriod: Maybe<Scalars['String']['output']>;
  speciesGroupings: SpeciesGroupingRecordConnection;
  speciesTips: SpeciesTipRecordConnection;
  status: Maybe<Scalars['String']['output']>;
  /** Suggested waters for the species, based on distance and catch count */
  suggestedWaters: Array<FishingWater>;
  /** A list of threats to humans that this species poses */
  threatToHumans: Maybe<Array<Scalars['String']['output']>>;
  /** The most used bait products for this species. Returns only 3 baits for non pro users */
  topBaitProducts: TopProductsConnection;
  /** Trophy potential for the species in the fishing water */
  trophyPotential: Maybe<FishingWaterSpeciesTrophyPotential>;
  /** The types of water (saltwater, freshwater, mixed) this species can be found in */
  waterTypes: Array<Scalars['String']['output']>;
  /**
   * The weather conditions that are suitable for fishing this species
   * @deprecated Makes no sense globally
   */
  weatherConditions: Maybe<Array<Scalars['String']['output']>>;
};


/** A species */
export type SpeciesAbundancePotentialArgs = {
  fishingWaterId: Scalars['String']['input'];
};


/** A species */
export type SpeciesActivityScoreArgs = {
  date?: InputMaybe<Scalars['ISO8601Date']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  timeOfDay?: InputMaybe<TimeOfDayTypes>;
};


/** A species */
export type SpeciesAreaSpeciesArgs = {
  boundingBox?: InputMaybe<BoundingBoxInputObject>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  fishingWaterId?: InputMaybe<Scalars['String']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
};


/** A species */
export type SpeciesCatchConditionsArgs = {
  conditions: CatchConditionsInput;
};


/** A species */
export type SpeciesCatchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<CatchFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A species */
export type SpeciesDimensionsAverageArgs = {
  fishingWaterId: Scalars['String']['input'];
  unit: Unit;
};


/** A species */
export type SpeciesDimensionsDistributionsArgs = {
  fishingWaterId: Scalars['String']['input'];
  unit: Unit;
};


/** A species */
export type SpeciesDisplayIconArgs = {
  croppingStrategy?: InputMaybe<CroppingStrategyEnum>;
  filterString?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<FormatEnum>;
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


/** A species */
export type SpeciesFollowersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A species */
export type SpeciesHasAbundancePotentialArgs = {
  fishingWaterId: Scalars['String']['input'];
};


/** A species */
export type SpeciesHasCatchConditionsArgs = {
  fishingWaterId?: InputMaybe<Scalars['String']['input']>;
};


/** A species */
export type SpeciesHasFishingTipArgs = {
  fishingWaterId?: InputMaybe<Scalars['String']['input']>;
  month?: InputMaybe<MonthEnum>;
};


/** A species */
export type SpeciesHasTrophyPotentialArgs = {
  fishingWaterId: Scalars['String']['input'];
};


/** A species */
export type SpeciesImageArgs = {
  croppingStrategy?: InputMaybe<CroppingStrategyEnum>;
  filterString?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<FormatEnum>;
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


/** A species */
export type SpeciesIsBigFishArgs = {
  fishingWaterId: Scalars['String']['input'];
};


/** A species */
export type SpeciesPredictedLengthArgs = {
  weight: Scalars['Float']['input'];
};


/** A species */
export type SpeciesPredictedWeightArgs = {
  length: Scalars['Float']['input'];
};


/** A species */
export type SpeciesSpeciesGroupingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCountry?: InputMaybe<Scalars['String']['input']>;
  inCountryState?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  speciesGroupingType?: InputMaybe<SpeciesGroupingTypes>;
};


/** A species */
export type SpeciesSpeciesTipsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A species */
export type SpeciesSuggestedWatersArgs = {
  latitude: Scalars['Float']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  longitude: Scalars['Float']['input'];
  maxDistanceInKms?: InputMaybe<Scalars['Int']['input']>;
};


/** A species */
export type SpeciesTopBaitProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A species */
export type SpeciesTrophyPotentialArgs = {
  fishingWaterId: Scalars['String']['input'];
};

/** The connection type for SpeciesWithBiteForecast. */
export type SpeciesBiteForecastConnection = {
  __typename: 'SpeciesBiteForecastConnection';
  earliestAvailableDate: Scalars['ISO8601Date']['output'];
  /** Earliest hour of the day (0-23) for the activity score in the location's local timezone */
  earliestAvailableHour: Scalars['Int']['output'];
  earliestAvailableTimeOfDay: TimeOfDayTypes;
  /** A list of edges. */
  edges: Maybe<Array<Maybe<SpeciesWithBiteForecastEdge>>>;
  /** Hourly forecast timeline. Populated when hourlyContext argument is true, empty otherwise */
  hourlyTimeline: Array<HourlyBiteForecastTimeline>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<SpeciesWithBiteForecast>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Forecast timeline. Populated when hourlyContext argument is false, empty otherwise */
  timeline: Array<BiteForecastTimeline>;
  /** UTC offset in seconds for the queried location */
  utcOffset: Scalars['Int']['output'];
};

/** The connection type for Species. */
export type SpeciesConnection = {
  __typename: 'SpeciesConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<SpeciesEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<Species>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SpeciesEdge = {
  __typename: 'SpeciesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Species>;
};

export type SpeciesFilters = {
  /** ExternalID of a speciesGrouping */
  bySpeciesGrouping?: InputMaybe<Scalars['String']['input']>;
  /** Two-letter ISO country code. e.g., `FR`. */
  inCountry?: InputMaybe<Scalars['String']['input']>;
  /** Two-letter ISO codes, indicating country and state. For instance `US-FL` for Florida, USA */
  inCountryState?: InputMaybe<Scalars['String']['input']>;
  orderedByName?: InputMaybe<Scalars['Boolean']['input']>;
  orderedByPopularity?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter species by name prefix (case-insensitive) */
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SpeciesGrouping = {
  __typename: 'SpeciesGrouping';
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  externalId: Scalars['String']['output'];
  /**
   * DB ID
   * @deprecated Use `externalId` instead
   */
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  species: SpeciesRecordConnection;
  speciesGroupingType: SpeciesGroupingType;
};


export type SpeciesGroupingSpeciesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<SpeciesFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** An edge in a connection. */
export type SpeciesGroupingEdge = {
  __typename: 'SpeciesGroupingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<SpeciesGrouping>;
};

/** The connection type for SpeciesGrouping. */
export type SpeciesGroupingRecordConnection = {
  __typename: 'SpeciesGroupingRecordConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<SpeciesGroupingEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<SpeciesGrouping>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Average of column for records beyond pagination (limited by scopes, if applicable) */
  totalAverage: Scalars['Float']['output'];
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};

export type SpeciesGroupingType = {
  __typename: 'SpeciesGroupingType';
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  description: Scalars['String']['output'];
  externalId: Scalars['String']['output'];
  /**
   * DB ID
   * @deprecated Use `externalId` instead
   */
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export enum SpeciesGroupingTypes {
  ML_SPECIES_RECOGNITION = 'ML_SPECIES_RECOGNITION',
  SEO_SPECIES_GROUPING = 'SEO_SPECIES_GROUPING'
}

/** The predicted weight or length of a species */
export type SpeciesPredictedWeightLength = {
  __typename: 'SpeciesPredictedWeightLength';
  average: Maybe<Scalars['Float']['output']>;
  max: Maybe<Scalars['Float']['output']>;
  min: Maybe<Scalars['Float']['output']>;
};

/** The connection type for Species. */
export type SpeciesRecordConnection = {
  __typename: 'SpeciesRecordConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<SpeciesEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<Species>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Average of column for records beyond pagination (limited by scopes, if applicable) */
  totalAverage: Scalars['Float']['output'];
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};

export type SpeciesSearchResult = {
  __typename: 'SpeciesSearchResult';
  /** The internal id of the search, can be used for conversion tracking */
  searchId: Scalars['Int']['output'];
  /** Species matching the query */
  species: Maybe<SpeciesConnection>;
};


export type SpeciesSearchResultSpeciesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeciesSuggestion = {
  __typename: 'SpeciesSuggestion';
  mlRecognition: Scalars['Boolean']['output'];
  popularSpecies: Scalars['Boolean']['output'];
  recentCatch: Scalars['Boolean']['output'];
  score: Scalars['Int']['output'];
  species: Species;
};

/** The connection type for SpeciesSuggestion. */
export type SpeciesSuggestionConnection = {
  __typename: 'SpeciesSuggestionConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<SpeciesSuggestionEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<SpeciesSuggestion>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SpeciesSuggestionEdge = {
  __typename: 'SpeciesSuggestionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<SpeciesSuggestion>;
};

export type SpeciesSuggestionsOptionsInputObject = {
  /** Date used by recent catches - format %Y-%m-%d; default is Current Date */
  date?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Setting to true means ML species recognition results included; default: true */
  ml: Scalars['Boolean']['input'];
  /** Number of ML results to return; default is 20 */
  mlTopN?: InputMaybe<Scalars['Int']['input']>;
  /** Can be used as an alternative to current_user to identify a user forreturning recent catches (if current_user not available); default nil */
  nickname?: InputMaybe<Scalars['String']['input']>;
  /** Setting to true means popular species results included; default: true */
  popular: Scalars['Boolean']['input'];
  /** Setting to true means recent catches results included; default: true */
  recent: Scalars['Boolean']['input'];
};

/** A tip on how to catch this species */
export type SpeciesTip = {
  __typename: 'SpeciesTip';
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  externalId: Scalars['String']['output'];
  /**
   * DB ID
   * @deprecated Use `externalId` instead
   */
  id: Scalars['Int']['output'];
  /** The species associated with the tip */
  species: Species;
  tip: Scalars['String']['output'];
  /** Creator of the tip */
  user: User;
  userDescription: Maybe<Scalars['String']['output']>;
  /**
   * If set this will use the custom display name for the user, if not the user's full name will be returned.
   *
   */
  userDisplayName: Scalars['String']['output'];
};

/** An edge in a connection. */
export type SpeciesTipEdge = {
  __typename: 'SpeciesTipEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<SpeciesTip>;
};

/** The connection type for SpeciesTip. */
export type SpeciesTipRecordConnection = {
  __typename: 'SpeciesTipRecordConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<SpeciesTipEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<SpeciesTip>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Average of column for records beyond pagination (limited by scopes, if applicable) */
  totalAverage: Scalars['Float']['output'];
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};

/** A species */
export type SpeciesWithBiteForecast = PostsFeedDisplayEntity & {
  __typename: 'SpeciesWithBiteForecast';
  /** Abundance potential for the species in the fishing water */
  abundancePotential: Maybe<AbundancePotential>;
  /**
   * The times of the day this species is active
   * @deprecated Makes no sense globally
   */
  activeTimes: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated Use `biteForecast` instead */
  activityScore: Maybe<ActivityScoreBreakdown>;
  areaSpecies: Maybe<AreaSpecies>;
  /** @deprecated Was changed to commonLength, also now deprecated */
  avgLength: Maybe<Scalars['Float']['output']>;
  /** @deprecated Was changed to commonWeight, also now deprecated */
  avgWeight: Maybe<Scalars['Float']['output']>;
  biteForecast: Maybe<BiteForecast>;
  /** Provides detailed catch conditions for the species, tailored to current fishing conditions such as location, weather, time, and water clarity */
  catchConditions: Maybe<CatchConditions>;
  catches: CatchRecordConnection;
  catchesCount: Scalars['Int']['output'];
  /**
   * The most common length for this species
   * @deprecated Not useful to anglers
   */
  commonLength: Maybe<Scalars['Float']['output']>;
  /**
   * The most common weight for this species
   * @deprecated Not useful to anglers
   */
  commonWeight: Maybe<Scalars['Float']['output']>;
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** A short description of the species */
  description: Maybe<Scalars['String']['output']>;
  dimensionsAverage: Maybe<DimensionsAverage>;
  dimensionsDistributions: Maybe<Array<DimensionsDistribution>>;
  displayIcon: Image;
  /** Default name for this species */
  displayName: Scalars['String']['output'];
  /** A curated catch or a popular one with an image from the last month */
  exampleCatchWithImage: Maybe<Catch>;
  externalId: Scalars['String']['output'];
  /** The first available localised name for this species. If there is no localised name, fallback to the default name (displayName). */
  firstLocalOrName: Scalars['String']['output'];
  /** The Fishbase URL for the species */
  fishReferenceLink: Maybe<Scalars['String']['output']>;
  /** The Fishbase name for the species */
  fishReferenceName: Maybe<Scalars['String']['output']>;
  /** The Fishbase ID for the species */
  fishbaseId: Maybe<Scalars['String']['output']>;
  /**
   * A csv string of FishRules species ids
   * @deprecated Use fishrulesIds as there may be more than one fishruleId per species.
   *
   */
  fishrulesId: Maybe<Scalars['String']['output']>;
  /** An array of FishRules species ids */
  fishrulesIds: Maybe<Array<Scalars['String']['output']>>;
  /** If the current user follows this species */
  followedByCurrentUser: Scalars['Boolean']['output'];
  /** Users who follow this species */
  followers: UserFollowersConnection;
  /** Returns true if the species has abundance potential in the provided fishing water else false */
  hasAbundancePotential: Scalars['Boolean']['output'];
  /** Returns true if the species has catch conditions available to the current user */
  hasCatchConditions: Scalars['Boolean']['output'];
  hasFishingTip: Scalars['Boolean']['output'];
  /** True if given species has trophy potential in the provided fishing water */
  hasTrophyPotential: Scalars['Boolean']['output'];
  /**
   * DB ID
   * @deprecated Use `externalId` instead
   */
  id: Scalars['Int']['output'];
  image: Image;
  imageArtist: Maybe<Scalars['String']['output']>;
  /** The type of attribution for the image */
  imageAttributionType: Maybe<Scalars['String']['output']>;
  /** The comment for the image */
  imageComment: Maybe<Scalars['String']['output']>;
  imageCopyrightExpiryDate: Maybe<Scalars['ISO8601DateTime']['output']>;
  imageCopyrightStatus: Maybe<Scalars['String']['output']>;
  /** Original source URL for the image. Not for app usage. */
  imageOriginalUrl: Maybe<Scalars['String']['output']>;
  imagePublisher: Maybe<Scalars['String']['output']>;
  /** The reference name for the image */
  imageReferenceName: Maybe<Scalars['String']['output']>;
  /** Returns true if given species has trophy potential above the big fish threshold in the provided fishing water else false */
  isBigFish: Scalars['Boolean']['output'];
  isLocked: Scalars['Boolean']['output'];
  /** IUCN category code (https://en.wikipedia.org/wiki/IUCN_Red_List#Categories) */
  iucnStatus: Maybe<Scalars['String']['output']>;
  latinName: Scalars['String']['output'];
  /** @deprecated Not useful to anglers */
  maxAge: Maybe<Scalars['Int']['output']>;
  /** The max common depth of this species (in metres) */
  maxCommonDepth: Maybe<Scalars['Float']['output']>;
  /** The maximum length of this species (in metres) */
  maxLength: Scalars['Float']['output'];
  maxWeight: Scalars['Float']['output'];
  /** The min common depth of this species (in metres) */
  minCommonDepth: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use `displayName` instead */
  name: Scalars['String']['output'];
  /** The predicted length (in meters) of the species based on a given weight */
  predictedLength: Maybe<SpeciesPredictedWeightLength>;
  /** The predicted weight (in kgs) of the species based on a given length */
  predictedWeight: Maybe<SpeciesPredictedWeightLength>;
  /** The preferred bait origin for the species */
  preferredBaitOrigin: Maybe<BaitOriginTypes>;
  /**
   * The most popular catch of this species with an image from the last month.
   * @deprecated Use exampleCatchWithImage as it displays a curated catch or a recent one.
   *
   */
  recentCatchWithImage: Maybe<Catch>;
  /** The Sealifebase ID for the species */
  sealifebaseId: Maybe<Scalars['String']['output']>;
  /**
   * The spawning period for the species
   * @deprecated Does not make sense globally
   */
  spawningPeriod: Maybe<Scalars['String']['output']>;
  speciesGroupings: SpeciesGroupingRecordConnection;
  speciesTips: SpeciesTipRecordConnection;
  status: Maybe<Scalars['String']['output']>;
  /** Suggested waters for the species, based on distance and catch count */
  suggestedWaters: Array<FishingWater>;
  /** A list of threats to humans that this species poses */
  threatToHumans: Maybe<Array<Scalars['String']['output']>>;
  /** The most used bait products for this species. Returns only 3 baits for non pro users */
  topBaitProducts: TopProductsConnection;
  /** Trophy potential for the species in the fishing water */
  trophyPotential: Maybe<FishingWaterSpeciesTrophyPotential>;
  /** The types of water (saltwater, freshwater, mixed) this species can be found in */
  waterTypes: Array<Scalars['String']['output']>;
  /**
   * The weather conditions that are suitable for fishing this species
   * @deprecated Makes no sense globally
   */
  weatherConditions: Maybe<Array<Scalars['String']['output']>>;
};


/** A species */
export type SpeciesWithBiteForecastAbundancePotentialArgs = {
  fishingWaterId: Scalars['String']['input'];
};


/** A species */
export type SpeciesWithBiteForecastAreaSpeciesArgs = {
  boundingBox?: InputMaybe<BoundingBoxInputObject>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  fishingWaterId?: InputMaybe<Scalars['String']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
};


/** A species */
export type SpeciesWithBiteForecastCatchConditionsArgs = {
  conditions: CatchConditionsInput;
};


/** A species */
export type SpeciesWithBiteForecastCatchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<CatchFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A species */
export type SpeciesWithBiteForecastDimensionsAverageArgs = {
  fishingWaterId: Scalars['String']['input'];
  unit: Unit;
};


/** A species */
export type SpeciesWithBiteForecastDimensionsDistributionsArgs = {
  fishingWaterId: Scalars['String']['input'];
  unit: Unit;
};


/** A species */
export type SpeciesWithBiteForecastDisplayIconArgs = {
  croppingStrategy?: InputMaybe<CroppingStrategyEnum>;
  filterString?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<FormatEnum>;
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


/** A species */
export type SpeciesWithBiteForecastFollowersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A species */
export type SpeciesWithBiteForecastHasAbundancePotentialArgs = {
  fishingWaterId: Scalars['String']['input'];
};


/** A species */
export type SpeciesWithBiteForecastHasCatchConditionsArgs = {
  fishingWaterId?: InputMaybe<Scalars['String']['input']>;
};


/** A species */
export type SpeciesWithBiteForecastHasFishingTipArgs = {
  fishingWaterId?: InputMaybe<Scalars['String']['input']>;
  month?: InputMaybe<MonthEnum>;
};


/** A species */
export type SpeciesWithBiteForecastHasTrophyPotentialArgs = {
  fishingWaterId: Scalars['String']['input'];
};


/** A species */
export type SpeciesWithBiteForecastImageArgs = {
  croppingStrategy?: InputMaybe<CroppingStrategyEnum>;
  filterString?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<FormatEnum>;
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


/** A species */
export type SpeciesWithBiteForecastIsBigFishArgs = {
  fishingWaterId: Scalars['String']['input'];
};


/** A species */
export type SpeciesWithBiteForecastPredictedLengthArgs = {
  weight: Scalars['Float']['input'];
};


/** A species */
export type SpeciesWithBiteForecastPredictedWeightArgs = {
  length: Scalars['Float']['input'];
};


/** A species */
export type SpeciesWithBiteForecastSpeciesGroupingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inCountry?: InputMaybe<Scalars['String']['input']>;
  inCountryState?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  speciesGroupingType?: InputMaybe<SpeciesGroupingTypes>;
};


/** A species */
export type SpeciesWithBiteForecastSpeciesTipsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A species */
export type SpeciesWithBiteForecastSuggestedWatersArgs = {
  latitude: Scalars['Float']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  longitude: Scalars['Float']['input'];
  maxDistanceInKms?: InputMaybe<Scalars['Int']['input']>;
};


/** A species */
export type SpeciesWithBiteForecastTopBaitProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A species */
export type SpeciesWithBiteForecastTrophyPotentialArgs = {
  fishingWaterId: Scalars['String']['input'];
};

/** An edge in a connection. */
export type SpeciesWithBiteForecastEdge = {
  __typename: 'SpeciesWithBiteForecastEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<SpeciesWithBiteForecast>;
};

export type State = {
  __typename: 'State';
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** DB ID */
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  region: Region;
  /** The top fishing waters for the region */
  topFishingWaters: FishingWaterRecordConnection;
};


export type StateTopFishingWatersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<FishingWaterFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum StateKeyTypes {
  ACTIVE = 'ACTIVE',
  NEGATIVE = 'NEGATIVE',
  NEGATIVE_HIGH = 'NEGATIVE_HIGH',
  NEGATIVE_HIGH_EXTREME = 'NEGATIVE_HIGH_EXTREME',
  NEGATIVE_LOW = 'NEGATIVE_LOW',
  NEGATIVE_LOW_EXTREME = 'NEGATIVE_LOW_EXTREME',
  NEUTRAL = 'NEUTRAL',
  NEUTRAL_HIGH = 'NEUTRAL_HIGH',
  NEUTRAL_LOW = 'NEUTRAL_LOW',
  NORMAL = 'NORMAL',
  POSITIVE = 'POSITIVE',
  POSITIVE_HIGH = 'POSITIVE_HIGH',
  POSITIVE_LOW = 'POSITIVE_LOW',
  SLOW = 'SLOW'
}

export type Statistics = {
  __typename: 'Statistics';
  /** The fishing waters with the most catches. Cached once a week. */
  mostActiveWaters: Array<FishingWater>;
  /** Total number of catches on Fishbrain (cached every 12 hrs) */
  totalCatches: Scalars['Int']['output'];
};


export type StatisticsMostActiveWatersArgs = {
  period?: InputMaybe<MostActiveWatersPeriodEnum>;
};

export type StatisticsData = {
  __typename: 'StatisticsData';
  /** The number of data points with this value */
  count: Scalars['Int']['output'];
  /** An identifier for the stats. This may be the actual value */
  id: Scalars['ID']['output'];
};

/** Weekly streak status for a user */
export type Streak = {
  __typename: 'Streak';
  current: Scalars['Int']['output'];
  longest: Scalars['Int']['output'];
  status: StreakStatusEnum;
  weeks: Array<StreakWeek>;
};

export enum StreakStatusEnum {
  ACTIVE = 'ACTIVE',
  NONE = 'NONE',
  PENDING = 'PENDING'
}

/** Catch streak data for a single week */
export type StreakWeek = {
  __typename: 'StreakWeek';
  count: Scalars['Int']['output'];
  startsAt: Scalars['ISO8601Date']['output'];
};

export type SubmitCatchGuessInput = {
  catchId: Scalars['ID']['input'];
  gameId: Scalars['ID']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

/** Autogenerated input type of SubmitCatchGuessMutation */
export type SubmitCatchGuessMutationInput = {
  attributes: SubmitCatchGuessInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SubmitCatchGuessMutation. */
export type SubmitCatchGuessMutationPayload = {
  __typename: 'SubmitCatchGuessMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  gameResult: Maybe<GameResult>;
  guessResult: Maybe<CatchGuessResult>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

export type SubscriptionProduct = {
  __typename: 'SubscriptionProduct';
  id: Scalars['ID']['output'];
  platformSpecificId: Scalars['ID']['output'];
};

export type SuggestWaterNameAttributes = {
  /** Additional free text */
  additionalInformation?: InputMaybe<Scalars['String']['input']>;
  /** Contact email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Required if no position */
  fishingWaterExternalId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** Required if no fishingWaterExternalId */
  position?: InputMaybe<PositionInputObject>;
};

/** Autogenerated input type of SuggestWaterNameMutation */
export type SuggestWaterNameMutationInput = {
  attributes: SuggestWaterNameAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SuggestWaterNameMutation. */
export type SuggestWaterNameMutationPayload = {
  __typename: 'SuggestWaterNameMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  suggestedWaterName: Maybe<SuggestedWaterName>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

export type SuggestedWaterName = {
  __typename: 'SuggestedWaterName';
  additionalInformation: Maybe<Scalars['String']['output']>;
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  fishingWater: Maybe<FishingWater>;
  id: Scalars['String']['output'];
  latitude: Maybe<Scalars['Float']['output']>;
  longitude: Maybe<Scalars['Float']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

/** An edge in a connection. */
export type SuggestedWaterNameEdge = {
  __typename: 'SuggestedWaterNameEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<SuggestedWaterName>;
};

export type SuggestedWaterNameFilters = {
  /** Return suggestions for a specific fishing water */
  forFishingWaterExternalId?: InputMaybe<Scalars['String']['input']>;
  /** Return suggestions with the given status */
  forStatus?: InputMaybe<SuggestedWaterNameStatusTypes>;
  /** Return suggestions from a specific user */
  forUserExternalId?: InputMaybe<Scalars['String']['input']>;
  /** Return suggestions containing the given string in the name */
  nameContains?: InputMaybe<Scalars['String']['input']>;
  /** Order by when it was created. Most recent first. */
  orderByRecent?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The connection type for SuggestedWaterName. */
export type SuggestedWaterNameRecordConnection = {
  __typename: 'SuggestedWaterNameRecordConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<SuggestedWaterNameEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<SuggestedWaterName>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Average of column for records beyond pagination (limited by scopes, if applicable) */
  totalAverage: Scalars['Float']['output'];
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};

export enum SuggestedWaterNameStatusTypes {
  /** Admin user has accepted the suggestion */
  accepted = 'accepted',
  /** Admin user has rejected the suggestion */
  rejected = 'rejected',
  /** User has submitted the suggestion */
  submitted = 'submitted'
}

export type SummarizedCatchStatistics = {
  __typename: 'SummarizedCatchStatistics';
  /** The number of catches that the statistics are based on */
  count: Scalars['Int']['output'];
  /** The most common moon phase */
  moonIllumination: Maybe<MoonIlluminationTypes>;
  /** The associated species */
  species: Maybe<Species>;
  /** The most common sun position */
  sunPosition: Maybe<SunPositionTypes>;
  /** The most common water temperature range */
  waterTemperature: Maybe<Range>;
  /** The most common weather condition */
  weatherCondition: Maybe<WeatherCondition>;
};

/** The connection type for SummarizedCatchStatistics. */
export type SummarizedCatchStatisticsConnection = {
  __typename: 'SummarizedCatchStatisticsConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<SummarizedCatchStatisticsEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<SummarizedCatchStatistics>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SummarizedCatchStatisticsEdge = {
  __typename: 'SummarizedCatchStatisticsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<SummarizedCatchStatistics>;
};

export enum SunPositionTypes {
  DAWN = 'DAWN',
  DAY_END = 'DAY_END',
  DAY_START = 'DAY_START',
  DUSK = 'DUSK',
  MIDDAY = 'MIDDAY',
  MIDNIGHT = 'MIDNIGHT',
  NIGHT_END = 'NIGHT_END',
  NIGHT_START = 'NIGHT_START'
}

export enum SurfaceTypes {
  land = 'land',
  unknown = 'unknown',
  water = 'water'
}

export type Tag = {
  __typename: 'Tag';
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** DB ID */
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  posts: PostRecordConnection;
};


export type TagPostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<PostFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** An edge in a connection. */
export type TagEdge = {
  __typename: 'TagEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Tag>;
};

/** The connection type for Tag. */
export type TagRecordConnection = {
  __typename: 'TagRecordConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<TagEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<Tag>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Average of column for records beyond pagination (limited by scopes, if applicable) */
  totalAverage: Scalars['Float']['output'];
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};

export type Text = {
  __typename: 'Text';
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** DB ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Text and emoji-only preview of this post */
  preview: Scalars['String']['output'];
  text: Maybe<Scalars['String']['output']>;
};

export type TimeBaseCondition = {
  __typename: 'TimeBaseCondition';
  /** Condition name for the activity breakdown screen */
  displayName: Scalars['String']['output'];
  identifier: ConditionTypes;
  /** Long reason explaining condition impact on score */
  reasonLong: Scalars['String']['output'];
  /** Short reason explaining condition impact on score */
  reasonShort: Scalars['String']['output'];
  /** Conveys if the effect is positive, negative or neutral */
  stateKey: StateKeyTypes;
  timeOfDay: TimeOfDayTypes;
};

export enum TimeOfDayTypes {
  AFTERNOON = 'AFTERNOON',
  MORNING = 'MORNING',
  NIGHT = 'NIGHT',
  SUNRISE = 'SUNRISE',
  SUNSET = 'SUNSET'
}

/** The title of a post */
export type Title = {
  __typename: 'Title';
  body: Scalars['String']['output'];
  /** DB ID */
  id: Scalars['Int']['output'];
};

/** The connection type for User. */
export type TopAnglersConnection = {
  __typename: 'TopAnglersConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<TopAnglersEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<User>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of top anglers for a given set of catches */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TopAnglersEdge = {
  __typename: 'TopAnglersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<User>;
  /** The number of catches of a given user among given set of catches */
  numberOfCatches: Scalars['Int']['output'];
};

/** The connection type for ProductUnit. */
export type TopBaitProductUnitsConnection = {
  __typename: 'TopBaitProductUnitsConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<TopBaitProductUnitsEdge>>>;
  /** The heaviest catch that used one of these bait product units */
  heaviestCatch: Maybe<Catch>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<ProductUnit>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The number of distinct bait product units */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TopBaitProductUnitsEdge = {
  __typename: 'TopBaitProductUnitsEdge';
  /** The number of catches that used this bait product unit */
  catchesCount: Scalars['Int']['output'];
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<ProductUnit>;
};

/** The connection type for FishingWater. */
export type TopFishingWatersConnection = {
  __typename: 'TopFishingWatersConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<TopFishingWatersEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<FishingWater>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The number of distinct fishing waters */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TopFishingWatersEdge = {
  __typename: 'TopFishingWatersEdge';
  /** The number of catches logged in the fishing water */
  catchesCount: Scalars['Int']['output'];
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<FishingWater>;
};

/** The connection type for Product. */
export type TopProductsConnection = {
  __typename: 'TopProductsConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<TopProductsEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<Product>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TopProductsEdge = {
  __typename: 'TopProductsEdge';
  /** The number of catches for this species that used this product */
  catchesCount: Scalars['Int']['output'];
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Product>;
};

/** The connection type for Species. */
export type TopSpeciesConnection = {
  __typename: 'TopSpeciesConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<TopSpeciesSummaryEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<Species>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of top species for this water */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TopSpeciesSummaryEdge = {
  __typename: 'TopSpeciesSummaryEdge';
  /** The number of catches for this species */
  catchesCount: Scalars['Int']['output'];
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Species>;
  /** The number of recent catches for this species */
  recentCatchesCount: Maybe<Scalars['Int']['output']>;
};

export type TopWaters = {
  __typename: 'TopWaters';
  /** The number of catches within this set for this fishing water */
  catchesCount: Scalars['Int']['output'];
  /** For fetching a single example catch */
  exampleCatch: Catch;
  /** For fetching a single fishing water */
  fishingWater: FishingWater;
};


export type TopWatersExampleCatchArgs = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type TopWatersFishingWaterArgs = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type Topics = {
  __typename: 'Topics';
  categorized: InterestTopicCategoryRecordConnection;
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** DB ID */
  id: Scalars['Int']['output'];
  uncategorized: InterestTopicRecordConnection;
};


export type TopicsCategorizedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type TopicsUncategorizedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A collection of trash logged by a user */
export type TrashCollection = {
  __typename: 'TrashCollection';
  brandName: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  externalId: Scalars['String']['output'];
  /**
   * DB ID
   * @deprecated Use `externalId` instead
   */
  id: Scalars['Int']['output'];
  image: Image;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  stateCode: Maybe<Scalars['String']['output']>;
  stateName: Maybe<Scalars['String']['output']>;
  user: User;
  weightInKg: Scalars['Float']['output'];
};


/** A collection of trash logged by a user */
export type TrashCollectionImageArgs = {
  croppingStrategy?: InputMaybe<CroppingStrategyEnum>;
  filterString?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<FormatEnum>;
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type TrashCollectionBrandLeaderboardEntry = {
  __typename: 'TrashCollectionBrandLeaderboardEntry';
  brandName: Scalars['String']['output'];
  totalWeightInKgs: Scalars['Float']['output'];
};

/** An edge in a connection. */
export type TrashCollectionEdge = {
  __typename: 'TrashCollectionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<TrashCollection>;
};

/** The connection type for TrashCollection. */
export type TrashCollectionRecordConnection = {
  __typename: 'TrashCollectionRecordConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<TrashCollectionEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<TrashCollection>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
  /** Sum of weight_kgs for all records beyond pagination */
  totalWeightInKgs: Scalars['Float']['output'];
};

export type TrashCollectionStateLeaderboardEntry = {
  __typename: 'TrashCollectionStateLeaderboardEntry';
  stateCode: Scalars['String']['output'];
  stateName: Maybe<Scalars['String']['output']>;
  totalWeightInKgs: Scalars['Float']['output'];
};

/** The connection type for Species. */
export type TrendingSpeciesConnection = {
  __typename: 'TrendingSpeciesConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<TrendingSpeciesSummaryEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<Species>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of trending species for this water */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TrendingSpeciesSummaryEdge = {
  __typename: 'TrendingSpeciesSummaryEdge';
  /** The number of catches for this species */
  catchesCount: Scalars['Int']['output'];
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Species>;
};

export type Trip = {
  __typename: 'Trip';
  /** Exact catch positions in the trip that are visible to the current viewer. */
  catchPositions: Array<TripCatchPosition>;
  catches: CatchRecordConnection;
  /** Whether one of the trip's catches is the owner's earliest approved catch. */
  containsFirstCatch: Scalars['Boolean']['output'];
  /** Date record was added to the database */
  createdAt: Scalars['ISO8601DateTime']['output'];
  endedAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['String']['output'];
  /** Returns null if user is not owner/Pro or if no catches are public. */
  mapImage: Maybe<CatchesMapImage>;
  post: Post;
  startedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
};


export type TripCatchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<CatchFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type TripMapImageArgs = {
  hdpi?: InputMaybe<Scalars['Boolean']['input']>;
  height: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
};

/** A catch position in a trip */
export type TripCatchPosition = {
  __typename: 'TripCatchPosition';
  latitude: Scalars['Float']['output'];
  /** Level of publicity the catch owner has given to the catch location. */
  locationPrivacy: CatchLocationPrivacyTypes;
  longitude: Scalars['Float']['output'];
};

/** An edge in a connection. */
export type TripEdge = {
  __typename: 'TripEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Trip>;
};

export type TripFilters = {
  /** Order by when it was created. Most recent first. */
  orderByRecent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Order by trip start date. Most recent first. */
  orderByStartedAt?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The connection type for Trip. */
export type TripRecordConnection = {
  __typename: 'TripRecordConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<TripEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<Trip>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Average of column for records beyond pagination (limited by scopes, if applicable) */
  totalAverage: Scalars['Float']['output'];
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};

export type TripReference = {
  __typename: 'TripReference';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['String']['output'];
  processingErrors: Maybe<Scalars['String']['output']>;
  /** The current state of the referenced trip */
  state: ReferenceProcessingStateTypes;
  trip: Maybe<Trip>;
  user: User;
};

export enum TrophyIndexGaugeEnum {
  /** When the trophy index is >0.25 and <=0.5 */
  DECENT = 'DECENT',
  /** When the trophy index is >0.5 and <=0.99 */
  GOOD = 'GOOD',
  /** When the trophy index is >=1 */
  GREAT = 'GREAT',
  /** When the trophy index is >0 and <=0.25 */
  LIMITED = 'LIMITED',
  /** When the trophy index = 0 */
  UNKNOWN = 'UNKNOWN'
}

export type UrlAttributes = {
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UrlHostAttributes = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of UnfollowPageMutation */
export type UnfollowPageMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UnfollowPageMutation. */
export type UnfollowPageMutationPayload = {
  __typename: 'UnfollowPageMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  page: Maybe<Page>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** Autogenerated input type of UnfollowRecordsMutation */
export type UnfollowRecordsMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['ID']['input']>;
  type: UnfollowRecordsTypeEnum;
};

/** Autogenerated return type of UnfollowRecordsMutation. */
export type UnfollowRecordsMutationPayload = {
  __typename: 'UnfollowRecordsMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

export enum UnfollowRecordsTypeEnum {
  FISHING_METHOD = 'FISHING_METHOD',
  FISHING_WATER = 'FISHING_WATER',
  PAGE = 'PAGE',
  SPECIES = 'SPECIES',
  USER = 'USER',
  WAYPOINT = 'WAYPOINT'
}

export enum Unit {
  inch = 'inch',
  kg = 'kg',
  lb = 'lb',
  m = 'm'
}

export type UnitAttributeValue = {
  __typename: 'UnitAttributeValue';
  attribute: Maybe<Attribute>;
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** DB ID */
  id: Scalars['Int']['output'];
  value: Maybe<AttributeValue>;
};

/** An edge in a connection. */
export type UnitAttributeValueEdge = {
  __typename: 'UnitAttributeValueEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<UnitAttributeValue>;
};

/** The connection type for UnitAttributeValue. */
export type UnitAttributeValueRecordConnection = {
  __typename: 'UnitAttributeValueRecordConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<UnitAttributeValueEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<UnitAttributeValue>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Average of column for records beyond pagination (limited by scopes, if applicable) */
  totalAverage: Scalars['Float']['output'];
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};

export type UnitsBySpeciesFilterInputObject = {
  /** Only catches caught in the given list of months disregarding the year */
  caughtInMonths?: InputMaybe<Array<MonthEnum>>;
  /** Filter results for catches caught since n days ago, including nth day */
  caughtSinceDaysAgo?: InputMaybe<Scalars['Int']['input']>;
  /** Only feature artificial (non-natural) baits */
  onlyArtificialBaits?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only feature natural baits */
  onlyNaturalBaits?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of species to filter */
  speciesExternalIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Autogenerated input type of UnpinCatchFromMeMutation */
export type UnpinCatchFromMeMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
};

/** Autogenerated return type of UnpinCatchFromMeMutation. */
export type UnpinCatchFromMeMutationPayload = {
  __typename: 'UnpinCatchFromMeMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  me: User;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** Autogenerated input type of UnpinPostFromGroupMutation */
export type UnpinPostFromGroupMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  groupId: Scalars['ID']['input'];
};

/** Autogenerated return type of UnpinPostFromGroupMutation. */
export type UnpinPostFromGroupMutationPayload = {
  __typename: 'UnpinPostFromGroupMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  group: Maybe<Group>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

export type UnsplashImage = {
  __typename: 'UnsplashImage';
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** DB ID */
  id: Scalars['Int']['output'];
  /**
   * A URL for an image. If you use this make sure to read
   * the usage guidelines first -
   * https://help.unsplash.com/en/articles/2511245-unsplash-api-guidelines
   * You can also apply transformations to the image by altering the URL. See here
   * for more info - https://unsplash.com/documentation#dynamically-resizable-images
   *
   */
  imageUrl: Maybe<Scalars['String']['output']>;
  /** The name of the photographer. */
  photographerName: Maybe<Scalars['String']['output']>;
  /** The URL for the photographers Unsplash profile. Must be linked to w/ image. */
  photographerUrl: Maybe<Scalars['String']['output']>;
};

/**
 * Attributes for updating a brand and page. For a family of *_title and *_description
 *             arguments please refer to PageMutation
 */
export type UpdateBrandAttributes = {
  aboutDescription?: InputMaybe<Scalars['String']['input']>;
  aboutTitle?: InputMaybe<Scalars['String']['input']>;
  /** One line address, typically City, Country */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Use when creating custom gear */
  brandImage?: InputMaybe<ActiveStorageImageUpload>;
  /** Use when creating or updating a brand in Ornatus */
  logo?: InputMaybe<ActiveStorageImageUpload>;
  membersTitle?: InputMaybe<Scalars['String']['input']>;
  /** The name of the brand */
  name?: InputMaybe<Scalars['String']['input']>;
  productsDescription?: InputMaybe<Scalars['String']['input']>;
  productsTitle?: InputMaybe<Scalars['String']['input']>;
  /** The brand's website URL */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of UpdateBrandMutation */
export type UpdateBrandMutationInput = {
  attributes: UpdateBrandAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateBrandMutation. */
export type UpdateBrandMutationPayload = {
  __typename: 'UpdateBrandMutationPayload';
  brand: Maybe<Brand>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

export type UpdateCatchAttributes = {
  accessMethodId?: InputMaybe<Scalars['String']['input']>;
  autoselectedSpeciesSuggestionId?: InputMaybe<Scalars['String']['input']>;
  catchAndRelease?: InputMaybe<Scalars['Boolean']['input']>;
  caughtAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** An array of signed IDs from direct upload urls to create new photos */
  createPhotos?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  fishingMethodId?: InputMaybe<Scalars['String']['input']>;
  fishingWaterId?: InputMaybe<Scalars['String']['input']>;
  isPersonalBest?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  locationPrivacy?: InputMaybe<CatchLocationPrivacyTypes>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  privacies?: InputMaybe<Array<CatchPrivacyTypes>>;
  privateFishingWater?: InputMaybe<Scalars['Boolean']['input']>;
  privateNotes?: InputMaybe<Scalars['String']['input']>;
  productUnitIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** An array of photo IDs to remove from the catch */
  removePhotos?: InputMaybe<Array<Scalars['Int']['input']>>;
  speciesId?: InputMaybe<Scalars['String']['input']>;
  suggestedWaterNameId?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

/** Autogenerated input type of UpdateCatchMutation */
export type UpdateCatchMutationInput = {
  /** attributes to update the catch with */
  attributes: UpdateCatchAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** external ID of the catch to update */
  externalId: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateCatchMutation. */
export type UpdateCatchMutationPayload = {
  __typename: 'UpdateCatchMutationPayload';
  /** the updated catch */
  catch: Maybe<Catch>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** Autogenerated input type of UpdateFishingWaterReviewMutation */
export type UpdateFishingWaterReviewMutationInput = {
  attributes: ReviewAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateFishingWaterReviewMutation. */
export type UpdateFishingWaterReviewMutationPayload = {
  __typename: 'UpdateFishingWaterReviewMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  review: Maybe<FishingWaterReview>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** Autogenerated input type of UpdateGroupMutation */
export type UpdateGroupMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  coverImage?: InputMaybe<ActiveStorageImageUpload>;
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  fishingWaterExternalId?: InputMaybe<Scalars['ID']['input']>;
  groupId: Scalars['ID']['input'];
  location?: InputMaybe<GroupLocation>;
  name?: InputMaybe<Scalars['NonEmptyString']['input']>;
  topics?: InputMaybe<GroupTopicsUpdateAttribute>;
};

/** Autogenerated return type of UpdateGroupMutation. */
export type UpdateGroupMutationPayload = {
  __typename: 'UpdateGroupMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  group: Maybe<Group>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** Autogenerated input type of UpdatePageMutation */
export type UpdatePageMutationInput = {
  attributes: PageAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdatePageMutation. */
export type UpdatePageMutationPayload = {
  __typename: 'UpdatePageMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  page: Maybe<Page>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

export type UpdatePromotedCallToActionAttributes = {
  buttonText?: InputMaybe<Scalars['String']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<ActiveStorageImageUpload>;
  subHeadline?: InputMaybe<Scalars['String']['input']>;
  targetUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of UpdatePromotedCallToActionMutation */
export type UpdatePromotedCallToActionMutationInput = {
  attributes: UpdatePromotedCallToActionAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  promotedCallToActionId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdatePromotedCallToActionMutation. */
export type UpdatePromotedCallToActionMutationPayload = {
  __typename: 'UpdatePromotedCallToActionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  promotedCallToAction: Maybe<PagesPromotedCallToAction>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** Autogenerated input type of UpdateReviewMutation */
export type UpdateReviewMutationInput = {
  attributes: ReviewAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateReviewMutation. */
export type UpdateReviewMutationPayload = {
  __typename: 'UpdateReviewMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  review: Maybe<Review>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

export type UpdateTrashCollectionInputObject = {
  brandName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<ActiveStorageImageUpload>;
  position?: InputMaybe<PositionInputObject>;
  weightInKg?: InputMaybe<Scalars['Float']['input']>;
};

/** Autogenerated input type of UpdateTrashCollectionMutation */
export type UpdateTrashCollectionMutationInput = {
  attributes: UpdateTrashCollectionInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateTrashCollectionMutation. */
export type UpdateTrashCollectionMutationPayload = {
  __typename: 'UpdateTrashCollectionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  trashCollection: Maybe<TrashCollection>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

export type UpdateTripAttributes = {
  catchesAttributes?: InputMaybe<Array<UpsertTripCatchAttributes>>;
  deleteCatches?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  endedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  removeCatchesFromTrip?: InputMaybe<Array<Scalars['String']['input']>>;
  startedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

export type UpdateTripCatchesAttributes = {
  removeCatchesFromTrip?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Autogenerated input type of UpdateTripCatchesMutation */
export type UpdateTripCatchesMutationInput = {
  attributes: UpdateTripCatchesAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateTripCatchesMutation. */
export type UpdateTripCatchesMutationPayload = {
  __typename: 'UpdateTripCatchesMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  trip: Maybe<Trip>;
  tripReference: Maybe<TripReference>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** Autogenerated input type of UpdateTripMutation */
export type UpdateTripMutationInput = {
  attributes: UpdateTripAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateTripMutation. */
export type UpdateTripMutationPayload = {
  __typename: 'UpdateTripMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  trip: Maybe<Trip>;
  tripReference: Maybe<TripReference>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

export type UpdateUserAttributes = {
  email?: InputMaybe<Scalars['String']['input']>;
  preferredWaterKind?: InputMaybe<WaterKindTypes>;
};

/** Autogenerated input type of UpdateUserMutation */
export type UpdateUserMutationInput = {
  attributes: UpdateUserAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateUserMutation. */
export type UpdateUserMutationPayload = {
  __typename: 'UpdateUserMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  updated: Scalars['Boolean']['output'];
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** Autogenerated input type of UpdateUserOnboardingStatusMutation */
export type UpdateUserOnboardingStatusMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Onboarding completion status to be set */
  onboarded: Scalars['Boolean']['input'];
  /** External ID of the user to update. Defaults to current user if omitted */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of UpdateUserOnboardingStatusMutation. */
export type UpdateUserOnboardingStatusMutationPayload = {
  __typename: 'UpdateUserOnboardingStatusMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Updated onboarding completion status */
  onboarded: Scalars['Boolean']['output'];
  /** Determines whether the update was successful */
  updated: Scalars['Boolean']['output'];
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

export type UpdateWaypointAttributes = {
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<ActiveStorageImageUpload>;
  isUnlisted?: InputMaybe<Scalars['Boolean']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  symbol?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of UpdateWaypointMutation */
export type UpdateWaypointMutationInput = {
  attributes: UpdateWaypointAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateWaypointMutation. */
export type UpdateWaypointMutationPayload = {
  __typename: 'UpdateWaypointMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
  waypoint: Maybe<Waypoint>;
};

/** Autogenerated input type of UpsertConsentMutation */
export type UpsertConsentMutationInput = {
  attributes: ConsentAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpsertConsentMutation. */
export type UpsertConsentMutationPayload = {
  __typename: 'UpsertConsentMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  consent: Maybe<Consent>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** Autogenerated input type of UpsertNavionicsSubscriptionMutation */
export type UpsertNavionicsSubscriptionMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The country code (ISO 3166-1 alpha-2) of the user location. Used in selection of product. */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** The externalId of the user. If this argument is not given then the current user is used */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of UpsertNavionicsSubscriptionMutation. */
export type UpsertNavionicsSubscriptionMutationPayload = {
  __typename: 'UpsertNavionicsSubscriptionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  subscription: Maybe<NavionicsSubscription>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

export type UpsertTripCatchAttributes = {
  accessMethodId?: InputMaybe<Scalars['String']['input']>;
  autoselectedSpeciesSuggestionId?: InputMaybe<Scalars['String']['input']>;
  catchAndRelease?: InputMaybe<Scalars['Boolean']['input']>;
  caughtAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** When present, implies editing an existing catch in the trip. When absent, implies creating a new catch in the trip */
  externalId?: InputMaybe<Scalars['String']['input']>;
  fishingMethodId?: InputMaybe<Scalars['String']['input']>;
  fishingWaterId?: InputMaybe<Scalars['String']['input']>;
  isPersonalBest?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  locationPrivacy?: InputMaybe<CatchLocationPrivacyTypes>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /** An array of signed IDs from direct upload urls */
  photos?: InputMaybe<Array<Scalars['String']['input']>>;
  privacies?: InputMaybe<Array<CatchPrivacyTypes>>;
  privateFishingWater?: InputMaybe<Scalars['Boolean']['input']>;
  privateNotes?: InputMaybe<Scalars['String']['input']>;
  productUnitIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Order in which the catch should be displayed in the trip. When provided, the value must not be null */
  rank?: InputMaybe<Scalars['Int']['input']>;
  speciesId?: InputMaybe<Scalars['String']['input']>;
  suggestedWaterNameId?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

/** Autogenerated input type of UpsertUserMetadataMutation */
export type UpsertUserMetadataMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  lastUsedDeviceId: Scalars['String']['input'];
  metaParams: UserMetaParamsInput;
};

/** Autogenerated return type of UpsertUserMetadataMutation. */
export type UpsertUserMetadataMutationPayload = {
  __typename: 'UpsertUserMetadataMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  metadataGroups: Array<MetadataGroup>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

export type User = PostsFeedDisplayEntity & {
  __typename: 'User';
  avatar: Maybe<Image>;
  /** @deprecated Use `avatar` field instead */
  avatarImage: Maybe<Image>;
  biography: Maybe<Scalars['String']['output']>;
  /** Users who have blocked this user */
  blockedBy: UserRecordConnection;
  /** Users who this user blocks */
  blockedTargets: UserRecordConnection;
  catchSpeciesIdentifications: CatchSpeciesIdentificationRecordConnection;
  catches: CatchRecordConnection;
  /** Equipment categories in this user's tacklebox */
  categories: CategoryRecordConnection;
  /** The consents of this user */
  consents: ConsentRecordConnection;
  country: Country;
  countryCode: Scalars['String']['output'];
  coverImage: Maybe<Image>;
  /** Date record was added to the database */
  createdAt: Scalars['ISO8601DateTime']['output'];
  displayIcon: Image;
  displayName: Scalars['String']['output'];
  externalId: Scalars['String']['output'];
  firstName: Maybe<Scalars['String']['output']>;
  /** Is this user followed by the current user? */
  followedByCurrentUser: Scalars['Boolean']['output'];
  /** Equipment brands followed by this user */
  followedEquipmentBrands: BrandRecordConnection;
  /** Fishing methods used by this user */
  followedFishingMethods: FishingMethodRecordConnection;
  /** Fishing waters followed by this user */
  followedFishingWaters: FishingWaterRecordConnection;
  /** Species followed by this user */
  followedSpecies: SpeciesRecordConnection;
  followedUsers: UserRecordConnection;
  followers: UserRecordConnection;
  /** Is this user following the current user? */
  followingCurrentUser: Scalars['Boolean']['output'];
  groupInvitations: MemberInvitationRecordConnection;
  /**
   * DB ID
   * @deprecated Use `externalId` instead
   */
  id: Scalars['Int']['output'];
  isAmbassador: Maybe<Scalars['Boolean']['output']>;
  /** Is this user blocked by the current user? */
  isBlocked: Scalars['Boolean']['output'];
  isPremium: Maybe<Scalars['Boolean']['output']>;
  /** Is this user somehow verified? */
  isVerified: Maybe<Scalars['Boolean']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  /** The pages this user can manage */
  manageablePages: PageRecordConnection;
  /** Can send message to this user by current user? */
  messageable: Scalars['Boolean']['output'];
  /** Status of Navionics depth maps subscription */
  navionicsSubscription: Maybe<NavionicsSubscription>;
  /** Unique identifying nickname for user */
  nickname: Scalars['String']['output'];
  onboarded: Scalars['Boolean']['output'];
  /** The pages user can publish as */
  pagesCanPublishAs: PageRecordConnection;
  /** Personal best catches of this User */
  personalBestCatches: CatchRecordConnection;
  posts: PostRecordConnection;
  /** Personally identifiable information (available only to the current user or administrators) */
  privateFields: UserPrivateFields;
  /** Product Units this user has saved to their tacklebox */
  productUnits: ProductUnitRecordConnection;
  /** Equipment products in this user's tacklebox */
  products: ProductRecordConnection;
  /** The pages this user has publisher rights to */
  publishablePages: PageRecordConnection;
  /** Users which we think the user would want to follow */
  recommendedUsers: Maybe<UserRecommendationConnection>;
  state: Maybe<Scalars['String']['output']>;
  /** statistics for user */
  statistics: UserStatistics;
  /** Weekly streak information for this user */
  streak: Streak;
  trips: TripRecordConnection;
  waypoints: WaypointRecordConnection;
};


export type UserAvatarArgs = {
  croppingStrategy?: InputMaybe<CroppingStrategyEnum>;
  filterString?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<FormatEnum>;
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type UserAvatarImageArgs = {
  croppingStrategy?: InputMaybe<CroppingStrategyEnum>;
  filterString?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<FormatEnum>;
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type UserBlockedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<UserFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserBlockedTargetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<UserFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserCatchSpeciesIdentificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserCatchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<CatchFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  speciesId?: InputMaybe<Scalars['Int']['input']>;
};


export type UserCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<CategoryFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserConsentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserCoverImageArgs = {
  croppingStrategy?: InputMaybe<CroppingStrategyEnum>;
  filterString?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<FormatEnum>;
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type UserDisplayIconArgs = {
  croppingStrategy?: InputMaybe<CroppingStrategyEnum>;
  filterString?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<FormatEnum>;
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type UserFollowedEquipmentBrandsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<BrandFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserFollowedFishingMethodsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserFollowedFishingWatersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<FishingWaterFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserFollowedSpeciesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<SpeciesFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserFollowedUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<UserFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserFollowersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<UserFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserGroupInvitationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserManageablePagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<PageFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserNavionicsSubscriptionArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
};


export type UserPagesCanPublishAsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<PageFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserPersonalBestCatchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserPostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<PostFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserProductUnitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryExternalIds?: InputMaybe<Array<Scalars['String']['input']>>;
  filters?: InputMaybe<ProductUnitFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ProductFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserPublishablePagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<PageFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserRecommendedUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserStreakArgs = {
  currentLocalTime: Scalars['ISO8601DateTime']['input'];
};


export type UserTripsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<TripFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserWaypointsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for User. */
export type UserConnection = {
  __typename: 'UserConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<UserEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<User>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type UserEdge = {
  __typename: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<User>;
};

/** Mutation logic errors which can be shown to the end-user to give them context */
export type UserError = {
  __typename: 'UserError';
  /**
   * A string which can be used by a client to handle the user error
   *
   * The only code currently is `needsReverification`.  This could be returned from any mutation.
   * If it is returned by any of the user errors, the client must immediately re-verify the user.
   *
   * @deprecated Use `errorCode`. Kept for the legacy `needsReverification` value
   */
  code: Maybe<Scalars['String']['output']>;
  /** A stable code a client can branch on to handle error */
  errorCode: Maybe<ErrorCode>;
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path: Maybe<Array<Scalars['String']['output']>>;
};

export type UserFilters = {
  /** Sorts to prioritize users followed by the current user */
  currentUserFollowedFirst?: InputMaybe<Scalars['Boolean']['input']>;
  /** Returns only users followed by the currently logged in user */
  followedByCurrentUser?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only return users which have an avatar */
  havingAvatar?: InputMaybe<Scalars['Boolean']['input']>;
  /** Return only users where the nickname begins with the given string */
  nicknameStartsWith?: InputMaybe<Scalars['String']['input']>;
  /** Only return nonbanned users */
  nonbanned?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The connection type for User. */
export type UserFollowersConnection = {
  __typename: 'UserFollowersConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<UserFollowersEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<User>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserFollowersEdge = {
  __typename: 'UserFollowersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<User>;
};

export type UserMetaParamsInput = {
  metadataGroup: Scalars['String']['input'];
  metadataKey: Scalars['String']['input'];
  metadataValue: Scalars['JSON']['input'];
};

export type UserPrivateFields = {
  __typename: 'UserPrivateFields';
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Email of the current user */
  email: Maybe<Scalars['String']['output']>;
  /** DB ID */
  id: Scalars['Int']['output'];
};

/** The connection type for User. */
export type UserRecommendationConnection = {
  __typename: 'UserRecommendationConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<UserRecommendationEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<User>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type UserRecommendationEdge = {
  __typename: 'UserRecommendationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<User>;
  /** Why this user is recommended */
  reason: Scalars['String']['output'];
};

/** The connection type for User. */
export type UserRecordConnection = {
  __typename: 'UserRecordConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<UserEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<User>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Average of column for records beyond pagination (limited by scopes, if applicable) */
  totalAverage: Scalars['Float']['output'];
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};

export enum UserReportReasonTypes {
  ABUSIVE_DIRECT_MESSAGES = 'ABUSIVE_DIRECT_MESSAGES',
  BAD_LANGUAGE_IN_A_COMMENT = 'BAD_LANGUAGE_IN_A_COMMENT',
  BAD_LANGUAGE_IN_A_POST = 'BAD_LANGUAGE_IN_A_POST',
  FAKE_ACCOUNT_IMPERSONATION = 'FAKE_ACCOUNT_IMPERSONATION',
  FAKE_CONTENT_AI_GENERATED_CONTENT = 'FAKE_CONTENT_AI_GENERATED_CONTENT',
  HARASSMENT_OR_BULLYING = 'HARASSMENT_OR_BULLYING',
  INAPPROPRIATE_BIO = 'INAPPROPRIATE_BIO',
  INAPPROPRIATE_COVER_IMAGE = 'INAPPROPRIATE_COVER_IMAGE',
  INAPPROPRIATE_PROFILE_PICTURE = 'INAPPROPRIATE_PROFILE_PICTURE',
  INAPPROPRIATE_USERNAME = 'INAPPROPRIATE_USERNAME',
  OTHER = 'OTHER',
  SCAMMER_ACCOUNT = 'SCAMMER_ACCOUNT',
  SCAMMING_FOR_INFORMATION = 'SCAMMING_FOR_INFORMATION',
  SPAM_OR_POSTING_INDISCRIMINATELY = 'SPAM_OR_POSTING_INDISCRIMINATELY',
  UNAUTHORIZED_SALES_OR_PROMOTION = 'UNAUTHORIZED_SALES_OR_PROMOTION'
}

export enum UserReportSubjectTypes {
  CATCH = 'CATCH',
  GEAR = 'GEAR',
  GROUP = 'GROUP',
  OWN_INVALID_CATCH = 'OWN_INVALID_CATCH',
  OWN_PROFILE = 'OWN_PROFILE',
  POST = 'POST',
  USER = 'USER'
}

export type UserSearch = {
  __typename: 'UserSearch';
  users: UserConnection;
};


export type UserSearchUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type UserStatistics = {
  __typename: 'UserStatistics';
  /** The top 3 largest and heaviest catches from a user */
  bestCatches: Array<Catch>;
  /** The species that was caught the most times */
  mostCaughtSpecies: Species;
  /** Number of total catches for user */
  numberOfCatches: Scalars['Int']['output'];
  /** Number of catches for user for current year */
  numberOfCatchesThisYear: Scalars['Int']['output'];
  /** The water where the user has most catches */
  topFishingWater: FishingWater;
};

export enum UserStatusEnum {
  /** User is the admin of the group */
  ADMIN = 'ADMIN',
  /** User is not a member of the group and can be invited join */
  INVITABLE = 'INVITABLE',
  /** User has been invited to the group */
  INVITED = 'INVITED',
  /** User has join the group */
  MEMBER = 'MEMBER'
}

export type UserSuggestedChange = {
  __typename: 'UserSuggestedChange';
  additionalInformation: Maybe<Scalars['String']['output']>;
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  email: Maybe<Scalars['String']['output']>;
  externalId: Scalars['String']['output'];
  fishingWater: Maybe<FishingWater>;
  latitude: Maybe<Scalars['Float']['output']>;
  longitude: Maybe<Scalars['Float']['output']>;
  suggestedWaterName: Maybe<SuggestedWaterName>;
  url: Maybe<Scalars['String']['output']>;
  user: Maybe<User>;
  userSuggestedWaterMetadata: Maybe<UserSuggestedWaterMetadata>;
};

export type UserSuggestedChangeAttributes = {
  additionalInformation?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<Scalars['String']['input']>>;
  email?: InputMaybe<Scalars['String']['input']>;
  fishingWaterExternalId?: InputMaybe<Scalars['String']['input']>;
  fishingWaterMetadataExternalIds?: InputMaybe<Array<Scalars['String']['input']>>;
  newWaterName?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<PositionInputObject>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UserSuggestedWaterMetadata = {
  __typename: 'UserSuggestedWaterMetadata';
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  fishingWaterMetadata: FishingWaterMetadata;
  /** DB ID */
  id: Scalars['Int']['output'];
  userSuggestedChange: UserSuggestedChange;
};

export type UserWithRole = {
  /** External ID */
  externalId: Scalars['String']['input'];
  role: RolesEnum;
};

export type VegetationOption = {
  __typename: 'VegetationOption';
  /** Display name of the vegetation option */
  displayName: Scalars['String']['output'];
  type: VegetationTypes;
};

export type VegetationOptionsSet = {
  __typename: 'VegetationOptionsSet';
  defaultOption: VegetationTypes;
  options: Array<VegetationOption>;
};

export enum VegetationTypes {
  NO_VEGETATION = 'NO_VEGETATION',
  SURFACE = 'SURFACE',
  UNDERWATER = 'UNDERWATER'
}

/** The video of a post */
export type Video = {
  __typename: 'Video';
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Urls to streamable video */
  hlsUrl: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** Url to the original video */
  originalUrl: Scalars['String']['output'];
  screenshot: Image;
  /** @deprecated Use `original_url` instead */
  url: Scalars['String']['output'];
  /** Url to browser supported video */
  webUrl: Maybe<Scalars['String']['output']>;
};


/** The video of a post */
export type VideoScreenshotArgs = {
  croppingStrategy?: InputMaybe<CroppingStrategyEnum>;
  filterString?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<FormatEnum>;
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type VideoUpload = {
  /** File name of uploaded screenshot */
  screenshotFileName: Scalars['String']['input'];
  /** File name of uploaded video file */
  videoFileName: Scalars['String']['input'];
  /** Hash value returned by call to /upload_urls endpoint */
  videoHash: Scalars['String']['input'];
};

/** Video posts posted to page */
export type Videos = ResourceLike & {
  __typename: 'Videos';
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** DB ID */
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  videos: PostRecordConnection;
};


/** Video posts posted to page */
export type VideosVideosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<PostFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ViewAttributes = {
  /** For how long this post was seen */
  durationMs?: InputMaybe<Scalars['Int']['input']>;
  event: ViewEventEnum;
  externalId: Scalars['String']['input'];
  source: ViewSourceEnum;
};

export enum ViewEventEnum {
  EXPANDED = 'EXPANDED',
  SCROLLED_PAST = 'SCROLLED_PAST'
}

export enum ViewSourceEnum {
  DISCOVER = 'DISCOVER',
  FEED = 'FEED',
  GROUP = 'GROUP',
  NOTIFICATIONS = 'NOTIFICATIONS',
  PROFILE = 'PROFILE',
  RECOMMENDATIONS = 'RECOMMENDATIONS'
}

export enum Visibility {
  /** This group is hidden: it is invite-only and can't be found in searches */
  HIDDEN = 'HIDDEN',
  /** This group is public. Anybody can join it. It will be visible in search */
  PUBLIC = 'PUBLIC'
}

export type WaterClarityOption = {
  __typename: 'WaterClarityOption';
  /** Display name of the water clarity option */
  displayName: Scalars['String']['output'];
  type: WaterClarityTypes;
};

export type WaterClarityOptionsSet = {
  __typename: 'WaterClarityOptionsSet';
  defaultOption: WaterClarityTypes;
  options: Array<WaterClarityOption>;
};

export enum WaterClarityTypes {
  CLEAR = 'CLEAR',
  FROZEN = 'FROZEN',
  MUDDY = 'MUDDY',
  STAINED = 'STAINED'
}

export type WaterDepthOption = {
  __typename: 'WaterDepthOption';
  /** Display name of the water depth option */
  displayName: Scalars['String']['output'];
  type: WaterDepthTypes;
};

export type WaterDepthOptionsSet = {
  __typename: 'WaterDepthOptionsSet';
  defaultOption: WaterDepthTypes;
  options: Array<WaterDepthOption>;
};

export enum WaterDepthTypes {
  DEEP = 'DEEP',
  MEDIUM = 'MEDIUM',
  SHALLOW = 'SHALLOW',
  VERY_DEEP = 'VERY_DEEP'
}

export enum WaterKindTypes {
  BOTH = 'BOTH',
  FRESH = 'FRESH',
  SALT = 'SALT'
}

export enum WaterSalinity {
  freshwater = 'freshwater',
  mixed = 'mixed',
  saltwater = 'saltwater'
}

export type WaterTemperatureCondition = {
  __typename: 'WaterTemperatureCondition';
  /** Condition name for the activity breakdown screen */
  displayName: Scalars['String']['output'];
  identifier: ConditionTypes;
  /** Long reason explaining condition impact on score */
  reasonLong: Scalars['String']['output'];
  /** Short reason explaining condition impact on score */
  reasonShort: Scalars['String']['output'];
  /** Conveys if the effect is positive, negative or neutral */
  stateKey: StateKeyTypes;
  /** Water temperature [K] */
  waterTemperature: Maybe<Scalars['Float']['output']>;
};

export enum WaterTypes {
  /** Canal includes cuts, ditches and drains */
  canal = 'canal',
  /** Estuaries are where running water meets the ocean, including inlets */
  estuary = 'estuary',
  /** Lakes, reservoirs, ponds and other stillwaters */
  lake = 'lake',
  /** Oceans, seas and marine waters */
  ocean = 'ocean',
  /** Stream includes rivers (and their banks), brooks and other running water */
  stream = 'stream',
  /** Swamp includes marshes and wetland */
  swamp = 'swamp',
  /** Unknown water type */
  unknown = 'unknown'
}

/** A user-created waypoint */
export type Waypoint = {
  __typename: 'Waypoint';
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** User specified description */
  description: Maybe<Scalars['String']['output']>;
  externalId: Scalars['String']['output'];
  /**
   * DB ID
   * @deprecated Use `externalId` instead
   */
  id: Scalars['Int']['output'];
  image: Maybe<Image>;
  isUnlisted: Scalars['Boolean']['output'];
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  /** User specified name */
  name: Scalars['String']['output'];
  /** Identifier for the symbol representing the waypoint */
  symbol: Scalars['String']['output'];
  /** Owner of the waypoint */
  user: User;
};


/** A user-created waypoint */
export type WaypointImageArgs = {
  croppingStrategy?: InputMaybe<CroppingStrategyEnum>;
  filterString?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<FormatEnum>;
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type WaypointAttributes = {
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<ActiveStorageImageUpload>;
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  symbol?: InputMaybe<Scalars['String']['input']>;
};

/** An edge in a connection. */
export type WaypointEdge = {
  __typename: 'WaypointEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Waypoint>;
};

/** The connection type for Waypoint. */
export type WaypointRecordConnection = {
  __typename: 'WaypointRecordConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<WaypointEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<Waypoint>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Average of column for records beyond pagination (limited by scopes, if applicable) */
  totalAverage: Scalars['Float']['output'];
  /**
   * Total count of records beyond pagination (limited by scopes, if applicable).
   * Can optionally return count of non-NULL values if a `column` / `attribute` is given
   *
   */
  totalCount: Scalars['Int']['output'];
};

/** The weather and marine reading belonging to a catch */
export type WeatherAndMarineReading = {
  __typename: 'WeatherAndMarineReading';
  /** Air humidity [Percent] */
  airHumidity: Maybe<Scalars['Float']['output']>;
  /** Air pressure [Pa] */
  airPressure: Maybe<Scalars['Float']['output']>;
  /** Air temperature [K] */
  airTemperature: Maybe<Scalars['Float']['output']>;
  /** Cloud cover [Percent] */
  cloudCover: Maybe<Scalars['Float']['output']>;
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** DB ID */
  id: Scalars['Int']['output'];
  /** Water temperature [K] */
  waterTemperature: Maybe<Scalars['Float']['output']>;
  weatherCondition: Maybe<WeatherCondition>;
  windDirection: Maybe<WindDirection>;
  /** Wind speed [m/s] */
  windSpeed: Maybe<Scalars['Float']['output']>;
};

/** A weather condition */
export type WeatherCondition = {
  __typename: 'WeatherCondition';
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** DB ID */
  id: Scalars['Int']['output'];
  localizedValue: Scalars['String']['output'];
  /** Use this identifier to retrieve the relevant weather symbol icon from World Weather Online */
  worldWeatherOnlineIdentifier: Scalars['ID']['output'];
};

export type WindCondition = {
  __typename: 'WindCondition';
  /** Condition name for the activity breakdown screen */
  displayName: Scalars['String']['output'];
  identifier: ConditionTypes;
  /** Long reason explaining condition impact on score */
  reasonLong: Scalars['String']['output'];
  /** Short reason explaining condition impact on score */
  reasonShort: Scalars['String']['output'];
  /** Conveys if the effect is positive, negative or neutral */
  stateKey: StateKeyTypes;
  /** Wind angle in degrees */
  windAngle: Scalars['Float']['output'];
  /** Wind direction represented as cardinal or intercardinal compass points (eg. N, NE, etc.) */
  windDirection: Scalars['String']['output'];
  /** Wind speed in m/s */
  windSpeed: Scalars['Float']['output'];
};

/** A wind direction */
export type WindDirection = {
  __typename: 'WindDirection';
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  degrees: Maybe<Scalars['Float']['output']>;
  /** DB ID */
  id: Scalars['Int']['output'];
  localizedValue: Scalars['String']['output'];
  shortLocalizedValue: Scalars['String']['output'];
};

export type YearInReview = {
  __typename: 'YearInReview';
  catch: Maybe<Catch>;
  /** Catch caption */
  catchCaption: Maybe<Scalars['String']['output']>;
  /** Date record was added to the database */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  fishingWater: Maybe<FishingWater>;
  /** Fishing water caption */
  fishingWaterCaption: Maybe<Scalars['String']['output']>;
  /** DB ID */
  id: Scalars['Int']['output'];
  /** Randomly generated nickname for the user */
  nickname: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of answerGroupAdminInvitationMutation */
export type AnswerGroupAdminInvitationMutationInput = {
  action: InvitationActionEnum;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  groupId: Scalars['ID']['input'];
};

/** Autogenerated return type of answerGroupAdminInvitationMutation. */
export type AnswerGroupAdminInvitationMutationPayload = {
  __typename: 'answerGroupAdminInvitationMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  group: Maybe<Group>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** Autogenerated input type of answerGroupInvitationMutation */
export type AnswerGroupInvitationMutationInput = {
  action: InvitationActionEnum;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  groupId: Scalars['ID']['input'];
};

/** Autogenerated return type of answerGroupInvitationMutation. */
export type AnswerGroupInvitationMutationPayload = {
  __typename: 'answerGroupInvitationMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  group: Maybe<Group>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** Autogenerated input type of cancelGroupAdminInvitationMutation */
export type CancelGroupAdminInvitationMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The externalId of the corresponding group */
  groupExternalId: Scalars['ID']['input'];
  /** The externalId of the invited user. If this argument is not given then the current user is used */
  userExternalId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of cancelGroupAdminInvitationMutation. */
export type CancelGroupAdminInvitationMutationPayload = {
  __typename: 'cancelGroupAdminInvitationMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  group: Maybe<Group>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** Autogenerated input type of cancelGroupMemberInvitationMutation */
export type CancelGroupMemberInvitationMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The externalId of the corresponding group */
  groupExternalId: Scalars['ID']['input'];
  /** The externalId of the invited user. If this argument is not given then the current user is used */
  userExternalId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of cancelGroupMemberInvitationMutation. */
export type CancelGroupMemberInvitationMutationPayload = {
  __typename: 'cancelGroupMemberInvitationMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  group: Maybe<Group>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** Autogenerated input type of createFishingWaterDiscussionMutation */
export type CreateFishingWaterDiscussionMutationInput = {
  attributes: PostAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fishingWaterExternalId: Scalars['ID']['input'];
};

/** Autogenerated return type of createFishingWaterDiscussionMutation. */
export type CreateFishingWaterDiscussionMutationPayload = {
  __typename: 'createFishingWaterDiscussionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  post: Maybe<Post>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** Autogenerated input type of createGroupInvitationMutation */
export type CreateGroupInvitationMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  groupId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of createGroupInvitationMutation. */
export type CreateGroupInvitationMutationPayload = {
  __typename: 'createGroupInvitationMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** @deprecated Use memberInvitation instead */
  groupInvitation: Maybe<Invitation>;
  /** The created invitation */
  memberInvitation: Maybe<MemberInvitation>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

/** Autogenerated input type of createGroupPostMutation */
export type CreateGroupPostMutationInput = {
  attributes: PostAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  groupId: Scalars['ID']['input'];
};

/** Autogenerated return type of createGroupPostMutation. */
export type CreateGroupPostMutationPayload = {
  __typename: 'createGroupPostMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  post: Maybe<Post>;
  /** Mutation logic errors which can be shown to the end-user to give them context */
  userErrors: Array<UserError>;
};

export type TopEquipmentProductUnit = {
  __typename: 'topEquipmentProductUnit';
  /** Number of catches with product unit */
  numberOfCatches: Scalars['Int']['output'];
  /** Position of the product unit in the top listing */
  position: Scalars['Int']['output'];
  productUnit: ProductUnit;
};

/** The connection type for topEquipmentProductUnit. */
export type TopEquipmentProductUnitConnection = {
  __typename: 'topEquipmentProductUnitConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<TopEquipmentProductUnitEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<TopEquipmentProductUnit>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TopEquipmentProductUnitEdge = {
  __typename: 'topEquipmentProductUnitEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<TopEquipmentProductUnit>;
};

export type TopEquipmentProductUnitsBySpecies = {
  __typename: 'topEquipmentProductUnitsBySpecies';
  species: Species;
  topProductUnits: Array<TopEquipmentProductUnit>;
};

/** The connection type for topEquipmentProductUnitsBySpecies. */
export type TopEquipmentProductUnitsBySpeciesConnection = {
  __typename: 'topEquipmentProductUnitsBySpeciesConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<TopEquipmentProductUnitsBySpeciesEdge>>>;
  /**
   * A list of nodes.
   * @deprecated We have had problems with this field at Fishbrain
   */
  nodes: Maybe<Array<Maybe<TopEquipmentProductUnitsBySpecies>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TopEquipmentProductUnitsBySpeciesEdge = {
  __typename: 'topEquipmentProductUnitsBySpeciesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<TopEquipmentProductUnitsBySpecies>;
};

export type BrandId = { __typename: 'Brand', id: number };

export type FilterBrandNodeFields = { __typename: 'Brand', externalId: string, name: string, id: number };

export type CatchPostForPostsViewer = { __typename: 'Post', createdAt: string | null, likedByCurrentUser: boolean, likesCount: number, _id: string, catch: { __typename: 'Catch', caughtAtGmt: string | null, weight: number | null, length: number | null, _id: string, fishingWater: { __typename: 'FishingWater', displayName: string, latitude: number, longitude: number, _id: string } | null, species: { __typename: 'Species', displayName: string, _id: string } | null } | null, comments: { __typename: 'PostCommentConnection', totalCount: number }, displayProductUnits: { __typename: 'ProductUnitRecordConnection', totalCount: number }, images: { __typename: 'ImageRecordConnection', totalCount: number, edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null }, text: { __typename: 'Text', text: string | null }, user: { __typename: 'User', nickname: string, _id: string, avatar: { __typename: 'Image', height: number, width: number, url: string } | null }, displayEntity: { __typename: 'CurrentUser', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'FishingMethod', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'FishingWater', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Group', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Page', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Species', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'SpeciesWithBiteForecast', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'User', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } }, productUnits: { __typename: 'ProductUnitRecordConnection', edges: Array<{ __typename: 'ProductUnitEdge', node: { __typename: 'ProductUnit', model: string, id: number, image: { __typename: 'Image', width: number, height: number, url: string } | null, product: { __typename: 'Product', displayName: string, _id: string, legacyId: number, brand: { __typename: 'Brand', name: string, id: number } } } | null } | null> | null }, video: { __typename: 'Video', hlsUrl: string | null, webUrl: string | null, originalUrl: string, id: number, screenshot: { __typename: 'Image', width: number, height: number, url: string } } | null };

export type CatchFieldsForPostsViewer = { __typename: 'Catch', _id: string, post: { __typename: 'Post', createdAt: string | null, likedByCurrentUser: boolean, likesCount: number, _id: string, catch: { __typename: 'Catch', caughtAtGmt: string | null, weight: number | null, length: number | null, _id: string, fishingWater: { __typename: 'FishingWater', displayName: string, latitude: number, longitude: number, _id: string } | null, species: { __typename: 'Species', displayName: string, _id: string } | null } | null, comments: { __typename: 'PostCommentConnection', totalCount: number }, displayProductUnits: { __typename: 'ProductUnitRecordConnection', totalCount: number }, images: { __typename: 'ImageRecordConnection', totalCount: number, edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null }, text: { __typename: 'Text', text: string | null }, user: { __typename: 'User', nickname: string, _id: string, avatar: { __typename: 'Image', height: number, width: number, url: string } | null }, displayEntity: { __typename: 'CurrentUser', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'FishingMethod', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'FishingWater', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Group', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Page', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Species', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'SpeciesWithBiteForecast', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'User', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } }, productUnits: { __typename: 'ProductUnitRecordConnection', edges: Array<{ __typename: 'ProductUnitEdge', node: { __typename: 'ProductUnit', model: string, id: number, image: { __typename: 'Image', width: number, height: number, url: string } | null, product: { __typename: 'Product', displayName: string, _id: string, legacyId: number, brand: { __typename: 'Brand', name: string, id: number } } } | null } | null> | null }, video: { __typename: 'Video', hlsUrl: string | null, webUrl: string | null, originalUrl: string, id: number, screenshot: { __typename: 'Image', width: number, height: number, url: string } } | null } };

export type CatchId = { __typename: 'Catch', _id: string };

export type CatchFishingWaterName = { __typename: 'Catch', fishingWater: { __typename: 'FishingWater', displayName: string, latitude: number, longitude: number, _id: string } | null };

export type CatchSpeciesName = { __typename: 'Catch', species: { __typename: 'Species', displayName: string, _id: string } | null };

export type SpeciesCatchWithImageNodeFields = { __typename: 'Catch', _id: string, post: { __typename: 'Post', createdAt: string | null, _id: string, catch: { __typename: 'Catch', caughtAtGmt: string | null, weight: number | null, length: number | null, _id: string, fishingWater: { __typename: 'FishingWater', displayName: string, latitude: number, longitude: number, _id: string } | null, species: { __typename: 'Species', displayName: string, _id: string } | null } | null, displayProductUnits: { __typename: 'ProductUnitRecordConnection', totalCount: number }, images: { __typename: 'ImageRecordConnection', totalCount: number, edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null }, user: { __typename: 'User', nickname: string, _id: string } } };

export type SpeciesCatchDetailedNodeFields = { __typename: 'Catch', _id: string, post: { __typename: 'Post', textString: string | null, createdAt: string | null, _id: string, baitProductUnits: { __typename: 'ProductUnitRecordConnection', edges: Array<{ __typename: 'ProductUnitEdge', node: { __typename: 'ProductUnit', model: string, id: number, image: { __typename: 'Image', width: number, height: number, url: string } | null } | null } | null> | null }, catch: { __typename: 'Catch', caughtAtGmt: string | null, weight: number | null, length: number | null, _id: string, fishingWater: { __typename: 'FishingWater', displayName: string, latitude: number, longitude: number, _id: string } | null, species: { __typename: 'Species', displayName: string, _id: string } | null } | null, displayProductUnits: { __typename: 'ProductUnitRecordConnection', totalCount: number }, images: { __typename: 'ImageRecordConnection', totalCount: number, edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null }, user: { __typename: 'User', nickname: string, _id: string } } };

export type CatchMetadata = { __typename: 'Catch', createdAt: string | null, _id: string, legacyId: number };

export type SpeciesExampleCatchFields = { __typename: 'Catch', caughtAtGmt: string | null, createdAt: string | null, _id: string, legacyId: number, species: { __typename: 'Species', displayName: string, _id: string } | null, post: { __typename: 'Post', createdAt: string | null, likedByCurrentUser: boolean, likesCount: number, _id: string, displayProductUnits: { __typename: 'ProductUnitRecordConnection', totalCount: number }, catch: { __typename: 'Catch', _id: string, fishingWater: { __typename: 'FishingWater', displayName: string, latitude: number, longitude: number, _id: string } | null, species: { __typename: 'Species', displayName: string, _id: string } | null } | null, comments: { __typename: 'PostCommentConnection', totalCount: number }, images: { __typename: 'ImageRecordConnection', totalCount: number, edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null }, webPImages: { __typename: 'ImageRecordConnection', edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null }, text: { __typename: 'Text', text: string | null }, user: { __typename: 'User', nickname: string, isPremium: boolean | null, createdAt: string, _id: string, avatar: { __typename: 'Image', height: number, width: number, url: string } | null }, productUnits: { __typename: 'ProductUnitRecordConnection', edges: Array<{ __typename: 'ProductUnitEdge', node: { __typename: 'ProductUnit', model: string, id: number, image: { __typename: 'Image', width: number, height: number, url: string } | null, product: { __typename: 'Product', displayName: string, _id: string, legacyId: number, brand: { __typename: 'Brand', name: string, id: number } } } | null } | null> | null }, video: { __typename: 'Video', hlsUrl: string | null, webUrl: string | null, originalUrl: string, id: number, screenshot: { __typename: 'Image', width: number, height: number, url: string } } | null } };

export type CountryTopWaterRecentCatchNodeFields = { __typename: 'Catch', _id: string, post: { __typename: 'Post', createdAt: string | null, _id: string, catch: { __typename: 'Catch', caughtAtGmt: string | null, length: number | null, weight: number | null, _id: string, fishingWater: { __typename: 'FishingWater', displayName: string, _id: string } | null, species: { __typename: 'Species', displayName: string, _id: string } | null } | null, user: { __typename: 'User', nickname: string, _id: string }, displayProductUnits: { __typename: 'ProductUnitRecordConnection', totalCount: number }, images: { __typename: 'ImageRecordConnection', totalCount: number, edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null } } };

export type CatchLocation = { __typename: 'Catch', latitude: number | null, longitude: number | null };

export type CatchProductUnits = { __typename: 'Catch', productUnits: { __typename: 'ProductUnitRecordConnection', edges: Array<{ __typename: 'ProductUnitEdge', node: { __typename: 'ProductUnit', model: string, id: number, image: { __typename: 'Image', width: number, height: number, url: string } | null, product: { __typename: 'Product', displayName: string, _id: string, legacyId: number, brand: { __typename: 'Brand', name: string, id: number } } } | null } | null> | null } };

export type CatchFishingMethodName = { __typename: 'Catch', fishingMethod: { __typename: 'FishingMethod', displayName: string, _id: string } | null };

export type CatchWeatherFields = { __typename: 'Catch', weatherAndMarineReading: { __typename: 'WeatherAndMarineReading', airPressure: number | null, airHumidity: number | null, airTemperature: number | null, waterTemperature: number | null, windSpeed: number | null, id: number, weatherCondition: { __typename: 'WeatherCondition', localizedValue: string, worldWeatherOnlineIdentifier: string } | null, windDirection: { __typename: 'WindDirection', localizedValue: string, shortLocalizedValue: string, degrees: number | null, id: number } | null } | null };

export type CategoryId = { __typename: 'Category', id: number };

export type CategoryNodeFields = { __typename: 'Category', externalId: string, title: string, id: number, ancestors: Array<{ __typename: 'Category', title: string, id: number }> };

export type AllCategoriesConnectionFields = { __typename: 'CategoryRecordConnection', edges: Array<{ __typename: 'CategoryEdge', node: { __typename: 'Category', externalId: string, title: string, id: number, ancestors: Array<{ __typename: 'Category', title: string, id: number }> } | null } | null> | null };

export type CountryId = { __typename: 'Country', id: string };

export type CountryDetailFields = { __typename: 'Country', countryName: string, id: string };

export type FishingWaterCountryFields = { __typename: 'Country', countryName: string, id: string, topFishingWaters: { __typename: 'FishingWaterRecordConnection', edges: Array<{ __typename: 'FishingWaterEdge', node: { __typename: 'FishingWater', displayName: string, _id: string } | null } | null> | null }, topSpecies: { __typename: 'TopSpeciesConnection', edges: Array<{ __typename: 'TopSpeciesSummaryEdge', node: { __typename: 'Species', displayName: string, _id: string } | null } | null> | null } };

export type PlaceCountryFields = { __typename: 'Country', countryName: string, id: string, topFishingWaters: { __typename: 'FishingWaterRecordConnection', edges: Array<{ __typename: 'FishingWaterEdge', node: { __typename: 'FishingWater', displayName: string, _id: string } | null } | null> | null }, topSpecies: { __typename: 'TopSpeciesConnection', edges: Array<{ __typename: 'TopSpeciesSummaryEdge', node: { __typename: 'Species', displayName: string, _id: string } | null } | null> | null } };

export type RegionCountryFields = { __typename: 'Country', countryName: string, id: string, topFishingWaters: { __typename: 'FishingWaterRecordConnection', edges: Array<{ __typename: 'FishingWaterEdge', node: { __typename: 'FishingWater', displayName: string, _id: string } | null } | null> | null } };

export type CountyId = { __typename: 'County', id: number };

export type FishingWaterCountyFields = { __typename: 'County', name: string | null };

export type IntersectingCountyNodeFields = { __typename: 'County', name: string | null, country: { __typename: 'Country', countryName: string, id: string }, region: { __typename: 'Region', regionCode: string | null, name: string | null, localName: string | null } };

export type FishingMethodId = { __typename: 'FishingMethod', _id: string };

export type FishingWaterReviewId = { __typename: 'FishingWaterReview', _id: string };

export type FishingWaterReviewNodeFields = { __typename: 'FishingWaterReview', externalId: string, rating: number, createdAt: string | null, _id: string, author: { __typename: 'User', nickname: string, lastName: string | null, firstName: string | null, _id: string }, post: { __typename: 'Post', helpfulDownvotesCount: number | null, helpfulUpvotesCount: number | null, currentUserFoundHelpful: boolean | null, titleString: string | null, _id: string, text: { __typename: 'Text', text: string | null } } };

export type FishingWaterDetailAllReviewsFields = { __typename: 'ReviewInterfaceRecordConnection', totalCount: number, totalAverage: number };

export type FishingWaterDetailAmenityNodeFields = { __typename: 'FishingWaterReviewPropertyQuestion', summaryHeader: string | null };

export type FishingWaterId = { __typename: 'FishingWater', _id: string };

export type FishingWaterLocationFields = { __typename: 'FishingWater', latitude: number, longitude: number, country: { __typename: 'Country', countryName: string, id: string } | null, region: { __typename: 'Region', name: string | null, localName: string | null, licenseInfoUrl: string | null, id: string | null } | null };

export type FishingWaterLocationFieldsExtended = { __typename: 'FishingWater', latitude: number, longitude: number, county: { __typename: 'County', name: string | null } | null, intersectingCounties: { __typename: 'CountyRecordConnection', edges: Array<{ __typename: 'CountyEdge', node: { __typename: 'County', name: string | null, country: { __typename: 'Country', countryName: string, id: string }, region: { __typename: 'Region', regionCode: string | null, name: string | null, localName: string | null } } | null } | null> | null }, country: { __typename: 'Country', countryName: string, id: string, topFishingWaters: { __typename: 'FishingWaterRecordConnection', edges: Array<{ __typename: 'FishingWaterEdge', node: { __typename: 'FishingWater', displayName: string, _id: string } | null } | null> | null }, topSpecies: { __typename: 'TopSpeciesConnection', edges: Array<{ __typename: 'TopSpeciesSummaryEdge', node: { __typename: 'Species', displayName: string, _id: string } | null } | null> | null } } | null, region: { __typename: 'Region', name: string | null, localName: string | null, licenseInfoUrl: string | null, id: string | null } | null };

export type FishingWaterSummaryMetadataFields = { __typename: 'FishingWaterMetadata', id: string, description: string, name: string, variant: FishingWaterMetadataVariants, group: { __typename: 'FishingWaterMetadataGroup', id: string } };

export type FishingWaterDetailMetadataFields = { __typename: 'FishingWaterMetadata', id: string, description: string, name: string, variant: FishingWaterMetadataVariants, group: { __typename: 'FishingWaterMetadataGroup', id: string } };

export type PlaceTopWaterNodeFields = { __typename: 'FishingWater', catchesCount: number, displayName: string, latitude: number, longitude: number, _id: string, allReviews: { __typename: 'ReviewInterfaceRecordConnection', totalCount: number, totalAverage: number } | null, country: { __typename: 'Country', countryName: string, id: string } | null, region: { __typename: 'Region', name: string | null, localName: string | null, licenseInfoUrl: string | null, id: string | null } | null };

export type CountryTopWaterNodeFields = { __typename: 'FishingWater', catchesCount: number, displayName: string, latitude: number, longitude: number, _id: string, allReviews: { __typename: 'ReviewInterfaceRecordConnection', totalCount: number, totalAverage: number } | null, recentCatches: { __typename: 'CatchRecordConnection', edges: Array<{ __typename: 'CatchRecordEdge', node: { __typename: 'Catch', _id: string, post: { __typename: 'Post', createdAt: string | null, _id: string, catch: { __typename: 'Catch', caughtAtGmt: string | null, length: number | null, weight: number | null, _id: string, fishingWater: { __typename: 'FishingWater', displayName: string, _id: string } | null, species: { __typename: 'Species', displayName: string, _id: string } | null } | null, user: { __typename: 'User', nickname: string, _id: string }, displayProductUnits: { __typename: 'ProductUnitRecordConnection', totalCount: number }, images: { __typename: 'ImageRecordConnection', totalCount: number, edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null } } } | null } | null> | null }, country: { __typename: 'Country', countryName: string, id: string } | null, region: { __typename: 'Region', name: string | null, localName: string | null, licenseInfoUrl: string | null, id: string | null } | null };

export type RegionTopWaterNodeFields = { __typename: 'FishingWater', catchesCount: number, displayName: string, descriptionOfWaterType: WaterTypes, latitude: number, longitude: number, _id: string, allReviews: { __typename: 'ReviewInterfaceRecordConnection', totalCount: number, totalAverage: number } | null, recentCatches: { __typename: 'CatchRecordConnection', edges: Array<{ __typename: 'CatchRecordEdge', node: { __typename: 'Catch', _id: string, post: { __typename: 'Post', _id: string, images: { __typename: 'ImageRecordConnection', edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null } } } | null } | null> | null }, country: { __typename: 'Country', countryName: string, id: string } | null, region: { __typename: 'Region', name: string | null, localName: string | null, licenseInfoUrl: string | null, id: string | null } | null };

export type PlaceTopWaterWithCatchesNodeFields = { __typename: 'FishingWater', catchesCount: number, displayName: string, latitude: number, longitude: number, _id: string, recentCatches: { __typename: 'CatchRecordConnection', edges: Array<{ __typename: 'CatchRecordEdge', node: { __typename: 'Catch', _id: string, post: { __typename: 'Post', _id: string, images: { __typename: 'ImageRecordConnection', totalCount: number, edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null } } } | null } | null> | null }, allReviews: { __typename: 'ReviewInterfaceRecordConnection', totalCount: number, totalAverage: number } | null, country: { __typename: 'Country', countryName: string, id: string } | null, region: { __typename: 'Region', name: string | null, localName: string | null, licenseInfoUrl: string | null, id: string | null } | null };

export type FishingWaterWatersListItem = { __typename: 'FishingWater', latitude: number, longitude: number, displayName: string, catchesCount: number, followedByCurrentUser: boolean, _id: string, catches: { __typename: 'CatchRecordConnection', edges: Array<{ __typename: 'CatchRecordEdge', node: { __typename: 'Catch', _id: string, post: { __typename: 'Post', _id: string, images: { __typename: 'ImageRecordConnection', edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', id: number | null, width: number, height: number, url: string } | null } | null> | null } } } | null } | null> | null }, reviews: { __typename: 'ReviewInterfaceRecordConnection', totalCount: number, totalAverage: number } | null, topSpecies: { __typename: 'FishingWaterTopSpeciesConnection', edges: Array<{ __typename: 'FishingWaterTopSpeciesEdge', node: { __typename: 'Species', displayName: string, _id: string } | null } | null> | null } };

export type FishingWaterCarouselItem = { __typename: 'FishingWater', latitude: number, longitude: number, displayName: string, catchesCount: number, _id: string, reviews: { __typename: 'ReviewInterfaceRecordConnection', totalCount: number, totalAverage: number } | null, country: { __typename: 'Country', countryName: string, id: string } | null, region: { __typename: 'Region', name: string | null, localName: string | null, id: string | null } | null };

export type FishingWaterSummaryFields = { __typename: 'FishingWater', displayName: string, catchesCount: number, latitude: number, longitude: number, _id: string, metadata: Array<{ __typename: 'FishingWaterMetadata', id: string, description: string, name: string, variant: FishingWaterMetadataVariants, group: { __typename: 'FishingWaterMetadataGroup', id: string } }>, allReviews: { __typename: 'ReviewInterfaceRecordConnection', totalCount: number, totalAverage: number } | null, catches: { __typename: 'CatchRecordConnection', totalCount: number, pageInfo: { __typename: 'PageInfo', startCursor: string | null, hasNextPage: boolean, endCursor: string | null }, edges: Array<{ __typename: 'CatchRecordEdge', node: { __typename: 'Catch', _id: string, post: { __typename: 'Post', createdAt: string | null, likedByCurrentUser: boolean, likesCount: number, _id: string, catch: { __typename: 'Catch', caughtAtGmt: string | null, weight: number | null, length: number | null, _id: string, fishingWater: { __typename: 'FishingWater', displayName: string, latitude: number, longitude: number, _id: string } | null, species: { __typename: 'Species', displayName: string, _id: string } | null } | null, comments: { __typename: 'PostCommentConnection', totalCount: number }, displayProductUnits: { __typename: 'ProductUnitRecordConnection', totalCount: number }, images: { __typename: 'ImageRecordConnection', totalCount: number, edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null }, text: { __typename: 'Text', text: string | null }, user: { __typename: 'User', nickname: string, _id: string, avatar: { __typename: 'Image', height: number, width: number, url: string } | null }, displayEntity: { __typename: 'CurrentUser', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'FishingMethod', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'FishingWater', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Group', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Page', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Species', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'SpeciesWithBiteForecast', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'User', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } }, productUnits: { __typename: 'ProductUnitRecordConnection', edges: Array<{ __typename: 'ProductUnitEdge', node: { __typename: 'ProductUnit', model: string, id: number, image: { __typename: 'Image', width: number, height: number, url: string } | null, product: { __typename: 'Product', displayName: string, _id: string, legacyId: number, brand: { __typename: 'Brand', name: string, id: number } } } | null } | null> | null }, video: { __typename: 'Video', hlsUrl: string | null, webUrl: string | null, originalUrl: string, id: number, screenshot: { __typename: 'Image', width: number, height: number, url: string } } | null } } | null } | null> | null }, country: { __typename: 'Country', countryName: string, id: string } | null, region: { __typename: 'Region', name: string | null, localName: string | null, licenseInfoUrl: string | null, id: string | null } | null };

export type SuggestedWaterFields = { __typename: 'FishingWater', displayName: string, catchesCount: number, latitude: number, longitude: number, _id: string, newCatchCount: { __typename: 'CatchRecordConnection', totalCount: number }, topSpeciesSummary: { __typename: 'TopSpeciesConnection', edges: Array<{ __typename: 'TopSpeciesSummaryEdge', node: { __typename: 'Species', displayName: string } | null } | null> | null } | null, metadata: Array<{ __typename: 'FishingWaterMetadata', id: string, description: string, name: string, variant: FishingWaterMetadataVariants, group: { __typename: 'FishingWaterMetadataGroup', id: string } }>, country: { __typename: 'Country', countryName: string, id: string } | null, region: { __typename: 'Region', name: string | null, localName: string | null, licenseInfoUrl: string | null, id: string | null } | null };

export type FishingWaterDetailFields = { __typename: 'FishingWater', displayName: string, catchesCount: number, descriptionOfWaterType: WaterTypes, url: string | null, latitude: number, longitude: number, _id: string, metadata: Array<{ __typename: 'FishingWaterMetadata', id: string, description: string, name: string, variant: FishingWaterMetadataVariants, group: { __typename: 'FishingWaterMetadataGroup', id: string } }>, topAnglers: { __typename: 'CatchRecordConnection', anglers: { __typename: 'TopAnglersConnection', totalCount: number, edges: Array<{ __typename: 'TopAnglersEdge', node: { __typename: 'User', followedByCurrentUser: boolean, displayName: string, nickname: string, _id: string, displayIcon: { __typename: 'Image', url: string, width: number, height: number } } | null } | null> | null } | null }, catches: { __typename: 'CatchRecordConnection', edges: Array<{ __typename: 'CatchRecordEdge', node: { __typename: 'Catch', _id: string, post: { __typename: 'Post', createdAt: string | null, _id: string, catch: { __typename: 'Catch', caughtAtGmt: string | null, weight: number | null, length: number | null, _id: string, fishingWater: { __typename: 'FishingWater', displayName: string, latitude: number, longitude: number, _id: string } | null, species: { __typename: 'Species', displayName: string, _id: string } | null } | null, displayProductUnits: { __typename: 'ProductUnitRecordConnection', totalCount: number }, images: { __typename: 'ImageRecordConnection', totalCount: number, edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null }, user: { __typename: 'User', nickname: string, _id: string } } } | null } | null> | null }, allReviews: { __typename: 'ReviewInterfaceRecordConnection', totalCount: number, totalAverage: number } | null, reviews: { __typename: 'ReviewInterfaceRecordConnection', amenities: { __typename: 'ReviewPropertyQuestionInterfaceRecordConnection', edges: Array<{ __typename: 'ReviewPropertyQuestionRecordEdge', node: { __typename: 'FishingWaterReviewPropertyQuestion', summaryHeader: string | null } | { __typename: 'ReviewPropertyQuestion' } | null } | null> | null } | null } | null, county: { __typename: 'County', name: string | null } | null, intersectingCounties: { __typename: 'CountyRecordConnection', edges: Array<{ __typename: 'CountyEdge', node: { __typename: 'County', name: string | null, country: { __typename: 'Country', countryName: string, id: string }, region: { __typename: 'Region', regionCode: string | null, name: string | null, localName: string | null } } | null } | null> | null }, country: { __typename: 'Country', countryName: string, id: string, topFishingWaters: { __typename: 'FishingWaterRecordConnection', edges: Array<{ __typename: 'FishingWaterEdge', node: { __typename: 'FishingWater', displayName: string, _id: string } | null } | null> | null }, topSpecies: { __typename: 'TopSpeciesConnection', edges: Array<{ __typename: 'TopSpeciesSummaryEdge', node: { __typename: 'Species', displayName: string, _id: string } | null } | null> | null } } | null, region: { __typename: 'Region', name: string | null, localName: string | null, licenseInfoUrl: string | null, id: string | null } | null };

export type FishingWaterMetadataNodeFields = { __typename: 'FishingWaterMetadata', id: string, name: string, group: { __typename: 'FishingWaterMetadataGroup', id: string, name: string, choice: FishingWaterMetadataGroupChoiceTypes } };

export type TopWatersInfoNodeFields = { __typename: 'FishingWater', externalId: string, catchesCount: number, displayName: string, descriptionOfWaterType: WaterTypes, region: { __typename: 'Region', name: string | null, id: string | null } | null };

export type WatersInRegionBySpeciesNodeFields = { __typename: 'FishingWater', displayName: string, catchesCount: number, _id: string };

export type ImageFields = { __typename: 'Image', width: number, height: number, url: string };

export type FishingWaterDetailDisplayIconFields = { __typename: 'Image', url: string, width: number, height: number };

export type PageId = { __typename: 'Page', _id: string, legacyId: number };

export type ManageablePageStatusNodeFields = { __typename: 'Page', name: string | null, published: boolean, _id: string, legacyId: number };

export type ManageablePageCoverImagesFields = { __typename: 'ImageRecordConnection', edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null };

export type PromotedCtaNodeFields = { __typename: 'PagesPromotedCallToAction', id: number, headline: string, subHeadline: string | null, buttonText: string, targetUrl: string, image: { __typename: 'Image', url: string, width: number, height: number } };

export type ManageablePageNodeFields = { __typename: 'Page', name: string | null, published: boolean, description: string | null, _id: string, legacyId: number, logo: { __typename: 'Image', width: number, height: number, url: string } | null, coverImages: { __typename: 'ImageRecordConnection', edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null }, promotedCallToActions: { __typename: 'PagesPromotedCallToActionRecordConnection', edges: Array<{ __typename: 'PagesPromotedCallToActionEdge', node: { __typename: 'PagesPromotedCallToAction', id: number, headline: string, subHeadline: string | null, targetUrl: string, buttonText: string, image: { __typename: 'Image', width: number, height: number, url: string } } | null } | null> | null }, pageable: { __typename: 'Brand', id: number, externalId: string, url: string | null } | { __typename: 'State' } | null };

export type ManageablePageStatusEdgeFields = { __typename: 'PageEdge', node: { __typename: 'Page', name: string | null, published: boolean, _id: string, legacyId: number } | null };

export type DiscoveredBrandNodeFields = { __typename: 'Page', displayName: string, followedByCurrentUser: boolean, _id: string, legacyId: number, followers: { __typename: 'PageFollowersConnection', totalCount: number }, logo: { __typename: 'Image', url: string } | null, coverImages: { __typename: 'ImageRecordConnection', edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null } };

export type AllBrandsEntryFields = { __typename: 'Page', id: number, externalId: string, displayName: string };

export type PlaceId = { __typename: 'Place', _id: string };

export type NearbyPlaceNodeFields = { __typename: 'Place', name: string, slug: string | null, latitude: number, longitude: number, _id: string, country: { __typename: 'Country', countryName: string, id: string }, region: { __typename: 'Region', name: string | null, id: string | null } };

export type PlaceDetailFields = { __typename: 'Place', name: string, slug: string | null, latitude: number, longitude: number, _id: string, country: { __typename: 'Country', countryName: string, id: string, topFishingWaters: { __typename: 'FishingWaterRecordConnection', edges: Array<{ __typename: 'FishingWaterEdge', node: { __typename: 'FishingWater', displayName: string, _id: string } | null } | null> | null }, topSpecies: { __typename: 'TopSpeciesConnection', edges: Array<{ __typename: 'TopSpeciesSummaryEdge', node: { __typename: 'Species', displayName: string, _id: string } | null } | null> | null } }, region: { __typename: 'Region', regionCode: string | null, name: string | null, localName: string | null, licenseInfoUrl: string | null, id: string | null } };

export type PlaceMetadataFields = { __typename: 'Place', name: string, slug: string | null, latitude: number, longitude: number, _id: string, country: { __typename: 'Country', countryName: string, id: string }, region: { __typename: 'Region', regionCode: string | null, name: string | null, localName: string | null, id: string | null } };

export type PlaceTopAnglersFields = { __typename: 'TopAnglersConnection', totalCount: number, edges: Array<{ __typename: 'TopAnglersEdge', node: { __typename: 'User', followedByCurrentUser: boolean, displayName: string, nickname: string, _id: string, displayIcon: { __typename: 'Image', url: string, width: number, height: number } } | null } | null> | null };

export type RegionPlaceNodeFields = { __typename: 'Place', name: string, slug: string | null, _id: string };

export type CountryPlaceNodeFields = { __typename: 'Place', name: string, slug: string | null, latitude: number, longitude: number, _id: string, country: { __typename: 'Country', countryName: string, id: string }, region: { __typename: 'Region', name: string | null, id: string | null } };

export type PlaceCarouselItem = { __typename: 'Place', name: string, slug: string | null, latitude: number, longitude: number, _id: string, country: { __typename: 'Country', countryName: string, id: string }, region: { __typename: 'Region', name: string | null, localName: string | null, regionCode: string | null, id: string | null }, unsplashImage: { __typename: 'UnsplashImage', id: number, imageUrl: string | null } | null };

export type NearestPlaceFields = { __typename: 'Place', latitude: number, longitude: number, name: string, slug: string | null, _id: string, country: { __typename: 'Country', countryName: string, id: string }, region: { __typename: 'Region', name: string | null, id: string | null }, nearbyPlaces: { __typename: 'NearbyPlacesConnection', edges: Array<{ __typename: 'NearbyPlacesEdge', distanceUnit: string, node: { __typename: 'Place', name: string, slug: string | null, latitude: number, longitude: number, _id: string, country: { __typename: 'Country', countryName: string, id: string }, region: { __typename: 'Region', name: string | null, id: string | null } } | null } | null> | null } };

export type PointOfInterestId = { __typename: 'PointOfInterest', _id: string };

export type PostId = { __typename: 'Post', _id: string };

export type PostMetadata = { __typename: 'Post', createdAt: string | null, publishedAt: string | null, _id: string, legacyId: number };

export type DisplayProductUnits = { __typename: 'Post', displayProductUnits: { __typename: 'ProductUnitRecordConnection', totalCount: number, edges: Array<{ __typename: 'ProductUnitEdge', node: { __typename: 'ProductUnit', product: { __typename: 'Product', externalId: string, displayName: string, _id: string, legacyId: number, reviews: { __typename: 'ReviewInterfaceRecordConnection', totalCount: number, averageRating: number } | null, image: { __typename: 'Image', id: number | null, width: number, height: number, url: string } | null, brand: { __typename: 'Brand', name: string, id: number } } } | null } | null> | null } };

export type PostProductUnits = { __typename: 'Post', productUnits: { __typename: 'ProductUnitRecordConnection', edges: Array<{ __typename: 'ProductUnitEdge', node: { __typename: 'ProductUnit', model: string, id: number, image: { __typename: 'Image', width: number, height: number, url: string } | null, product: { __typename: 'Product', displayName: string, _id: string, legacyId: number, brand: { __typename: 'Brand', name: string, id: number } } } | null } | null> | null } };

export type PostDisplayEntities = { __typename: 'Post', displayEntity: { __typename: 'CurrentUser', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'FishingMethod', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'FishingWater', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Group', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Page', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Species', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'SpeciesWithBiteForecast', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'User', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } };

export type PostfirstImageSquared384 = { __typename: 'Post', images: { __typename: 'ImageRecordConnection', edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', id: number | null, width: number, height: number, url: string } | null } | null> | null } };

export type PostFishingWaterName = { __typename: 'Post', fishingWater: { __typename: 'FishingWater', displayName: string, _id: string } | null };

export type PostVideoFields = { __typename: 'Post', video: { __typename: 'Video', hlsUrl: string | null, webUrl: string | null, originalUrl: string, id: number, screenshot: { __typename: 'Image', width: number, height: number, url: string } } | null };

export type BrandPostNodeFields = { __typename: 'Post', createdAt: string | null, likedByCurrentUser: boolean, likesCount: number, _id: string, catch: { __typename: 'Catch', _id: string, fishingWater: { __typename: 'FishingWater', displayName: string, latitude: number, longitude: number, _id: string } | null, species: { __typename: 'Species', displayName: string, _id: string } | null } | null, comments: { __typename: 'PostCommentConnection', totalCount: number }, displayProductUnits: { __typename: 'ProductUnitRecordConnection', totalCount: number }, images: { __typename: 'ImageRecordConnection', totalCount: number, edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null }, text: { __typename: 'Text', text: string | null }, user: { __typename: 'User', nickname: string, _id: string, avatar: { __typename: 'Image', height: number, width: number, url: string } | null }, displayEntity: { __typename: 'CurrentUser', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'FishingMethod', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'FishingWater', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Group', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Page', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Species', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'SpeciesWithBiteForecast', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'User', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } }, productUnits: { __typename: 'ProductUnitRecordConnection', edges: Array<{ __typename: 'ProductUnitEdge', node: { __typename: 'ProductUnit', model: string, id: number, image: { __typename: 'Image', width: number, height: number, url: string } | null, product: { __typename: 'Product', displayName: string, _id: string, legacyId: number, brand: { __typename: 'Brand', name: string, id: number } } } | null } | null> | null }, video: { __typename: 'Video', hlsUrl: string | null, webUrl: string | null, originalUrl: string, id: number, screenshot: { __typename: 'Image', width: number, height: number, url: string } } | null };

export type CatchInMapPostFields = { __typename: 'Post', createdAt: string | null, likedByCurrentUser: boolean, likesCount: number, _id: string, catch: { __typename: 'Catch', _id: string, fishingWater: { __typename: 'FishingWater', displayName: string, latitude: number, longitude: number, _id: string } | null, species: { __typename: 'Species', displayName: string, _id: string } | null } | null, comments: { __typename: 'PostCommentConnection', totalCount: number }, displayProductUnits: { __typename: 'ProductUnitRecordConnection', totalCount: number }, images: { __typename: 'ImageRecordConnection', totalCount: number, edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null }, text: { __typename: 'Text', text: string | null }, user: { __typename: 'User', nickname: string, _id: string, avatar: { __typename: 'Image', height: number, width: number, url: string } | null }, productUnits: { __typename: 'ProductUnitRecordConnection', edges: Array<{ __typename: 'ProductUnitEdge', node: { __typename: 'ProductUnit', model: string, id: number, image: { __typename: 'Image', width: number, height: number, url: string } | null, product: { __typename: 'Product', displayName: string, _id: string, legacyId: number, brand: { __typename: 'Brand', name: string, id: number } } } | null } | null> | null }, video: { __typename: 'Video', hlsUrl: string | null, webUrl: string | null, originalUrl: string, id: number, screenshot: { __typename: 'Image', width: number, height: number, url: string } } | null };

export type PostCardFields = { __typename: 'Post', sharingPost: boolean, likedByCurrentUser: boolean, likesCount: number, createdAt: string | null, publishedAt: string | null, _id: string, legacyId: number, comments: { __typename: 'PostCommentConnection', totalCount: number }, likers: { __typename: 'PostsFeedDisplayEntityRecordConnection', totalCount: number }, user: { __typename: 'User', isPremium: boolean | null, firstName: string | null, lastName: string | null, createdAt: string, nickname: string, _id: string, avatar: { __typename: 'Image', height: number, width: number, url: string } | null }, trip: { __typename: 'Trip', id: string, createdAt: string, startedAt: string, endedAt: string, catches: { __typename: 'CatchRecordConnection', totalCount: number } } | null, catch: { __typename: 'Catch', isPersonalBest: boolean, weight: number | null, length: number | null, catchAndRelease: boolean | null, caughtAtLocalTimeZone: string | null, caughtAtGmt: string | null, hasExactPosition: boolean, locationPrivacy: CatchLocationPrivacyTypes, createdAt: string | null, _id: string, legacyId: number, species: { __typename: 'Species', displayName: string, legacyId: number, _id: string } | null, trip: { __typename: 'Trip', id: string, catches: { __typename: 'CatchRecordConnection', totalCount: number } } | null, fishingMethod: { __typename: 'FishingMethod', displayName: string, _id: string } | null, fishingWater: { __typename: 'FishingWater', displayName: string, latitude: number, longitude: number, _id: string } | null, productUnits: { __typename: 'ProductUnitRecordConnection', edges: Array<{ __typename: 'ProductUnitEdge', node: { __typename: 'ProductUnit', model: string, id: number, image: { __typename: 'Image', width: number, height: number, url: string } | null, product: { __typename: 'Product', displayName: string, _id: string, legacyId: number, brand: { __typename: 'Brand', name: string, id: number } } } | null } | null> | null } } | null, text: { __typename: 'Text', text: string | null }, displayEntity: { __typename: 'CurrentUser', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'FishingMethod', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'FishingWater', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Group', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Page', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Species', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'SpeciesWithBiteForecast', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'User', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } }, fishingWater: { __typename: 'FishingWater', displayName: string, _id: string } | null, video: { __typename: 'Video', hlsUrl: string | null, webUrl: string | null, originalUrl: string, id: number, screenshot: { __typename: 'Image', width: number, height: number, url: string } } | null };

export type PostEntryFields = { __typename: 'Post', sharingPost: boolean, likedByCurrentUser: boolean, likesCount: number, createdAt: string | null, publishedAt: string | null, _id: string, legacyId: number, images: { __typename: 'ImageRecordConnection', totalCount: number, edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null }, user: { __typename: 'User', isPremium: boolean | null, firstName: string | null, lastName: string | null, createdAt: string, nickname: string, _id: string, avatar: { __typename: 'Image', height: number, width: number, url: string } | null }, comments: { __typename: 'PostCommentConnection', totalCount: number }, likers: { __typename: 'PostsFeedDisplayEntityRecordConnection', totalCount: number }, trip: { __typename: 'Trip', id: string, createdAt: string, startedAt: string, endedAt: string, catches: { __typename: 'CatchRecordConnection', totalCount: number } } | null, catch: { __typename: 'Catch', isPersonalBest: boolean, weight: number | null, length: number | null, catchAndRelease: boolean | null, caughtAtLocalTimeZone: string | null, caughtAtGmt: string | null, hasExactPosition: boolean, locationPrivacy: CatchLocationPrivacyTypes, createdAt: string | null, _id: string, legacyId: number, species: { __typename: 'Species', displayName: string, legacyId: number, _id: string } | null, trip: { __typename: 'Trip', id: string, catches: { __typename: 'CatchRecordConnection', totalCount: number } } | null, fishingMethod: { __typename: 'FishingMethod', displayName: string, _id: string } | null, fishingWater: { __typename: 'FishingWater', displayName: string, latitude: number, longitude: number, _id: string } | null, productUnits: { __typename: 'ProductUnitRecordConnection', edges: Array<{ __typename: 'ProductUnitEdge', node: { __typename: 'ProductUnit', model: string, id: number, image: { __typename: 'Image', width: number, height: number, url: string } | null, product: { __typename: 'Product', displayName: string, _id: string, legacyId: number, brand: { __typename: 'Brand', name: string, id: number } } } | null } | null> | null } } | null, text: { __typename: 'Text', text: string | null }, productUnits: { __typename: 'ProductUnitRecordConnection', edges: Array<{ __typename: 'ProductUnitEdge', node: { __typename: 'ProductUnit', model: string, id: number, image: { __typename: 'Image', width: number, height: number, url: string } | null, product: { __typename: 'Product', displayName: string, _id: string, legacyId: number, brand: { __typename: 'Brand', name: string, id: number } } } | null } | null> | null }, displayProductUnits: { __typename: 'ProductUnitRecordConnection', totalCount: number, edges: Array<{ __typename: 'ProductUnitEdge', node: { __typename: 'ProductUnit', product: { __typename: 'Product', externalId: string, displayName: string, _id: string, legacyId: number, reviews: { __typename: 'ReviewInterfaceRecordConnection', totalCount: number, averageRating: number } | null, image: { __typename: 'Image', id: number | null, width: number, height: number, url: string } | null, brand: { __typename: 'Brand', name: string, id: number } } } | null } | null> | null }, displayEntity: { __typename: 'CurrentUser', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'FishingMethod', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'FishingWater', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Group', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Page', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Species', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'SpeciesWithBiteForecast', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'User', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } }, fishingWater: { __typename: 'FishingWater', displayName: string, _id: string } | null, video: { __typename: 'Video', hlsUrl: string | null, webUrl: string | null, originalUrl: string, id: number, screenshot: { __typename: 'Image', width: number, height: number, url: string } } | null };

export type UsersPostsEdgeFields = { __typename: 'PostEdge', node: { __typename: 'Post', sharingPost: boolean, likedByCurrentUser: boolean, likesCount: number, createdAt: string | null, publishedAt: string | null, _id: string, legacyId: number, displayProductUnits: { __typename: 'ProductUnitRecordConnection', totalCount: number }, images: { __typename: 'ImageRecordConnection', totalCount: number, edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null }, comments: { __typename: 'PostCommentConnection', totalCount: number }, likers: { __typename: 'PostsFeedDisplayEntityRecordConnection', totalCount: number }, user: { __typename: 'User', isPremium: boolean | null, firstName: string | null, lastName: string | null, createdAt: string, nickname: string, _id: string, avatar: { __typename: 'Image', height: number, width: number, url: string } | null }, trip: { __typename: 'Trip', id: string, createdAt: string, startedAt: string, endedAt: string, catches: { __typename: 'CatchRecordConnection', totalCount: number } } | null, catch: { __typename: 'Catch', isPersonalBest: boolean, weight: number | null, length: number | null, catchAndRelease: boolean | null, caughtAtLocalTimeZone: string | null, caughtAtGmt: string | null, hasExactPosition: boolean, locationPrivacy: CatchLocationPrivacyTypes, createdAt: string | null, _id: string, legacyId: number, species: { __typename: 'Species', displayName: string, legacyId: number, _id: string } | null, trip: { __typename: 'Trip', id: string, catches: { __typename: 'CatchRecordConnection', totalCount: number } } | null, fishingMethod: { __typename: 'FishingMethod', displayName: string, _id: string } | null, fishingWater: { __typename: 'FishingWater', displayName: string, latitude: number, longitude: number, _id: string } | null, productUnits: { __typename: 'ProductUnitRecordConnection', edges: Array<{ __typename: 'ProductUnitEdge', node: { __typename: 'ProductUnit', model: string, id: number, image: { __typename: 'Image', width: number, height: number, url: string } | null, product: { __typename: 'Product', displayName: string, _id: string, legacyId: number, brand: { __typename: 'Brand', name: string, id: number } } } | null } | null> | null } } | null, text: { __typename: 'Text', text: string | null }, productUnits: { __typename: 'ProductUnitRecordConnection', edges: Array<{ __typename: 'ProductUnitEdge', node: { __typename: 'ProductUnit', model: string, id: number, image: { __typename: 'Image', width: number, height: number, url: string } | null, product: { __typename: 'Product', displayName: string, _id: string, legacyId: number, brand: { __typename: 'Brand', name: string, id: number } } } | null } | null> | null }, displayEntity: { __typename: 'CurrentUser', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'FishingMethod', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'FishingWater', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Group', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Page', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Species', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'SpeciesWithBiteForecast', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'User', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } }, fishingWater: { __typename: 'FishingWater', displayName: string, _id: string } | null, video: { __typename: 'Video', hlsUrl: string | null, webUrl: string | null, originalUrl: string, id: number, screenshot: { __typename: 'Image', width: number, height: number, url: string } } | null } | null };

export type ProductId = { __typename: 'Product', _id: string, legacyId: number };

export type ProductBrandName = { __typename: 'Product', brand: { __typename: 'Brand', name: string, id: number } };

export type ProductListItem = { __typename: 'Product', displayName: string, _id: string, image: { __typename: 'Image', width: number, height: number, url: string } | null, brand: { __typename: 'Brand', name: string, id: number }, reviews: { __typename: 'ReviewInterfaceRecordConnection', totalCount: number, averageRating: number } | null };

export type ProductUnitId = { __typename: 'ProductUnit', id: number };

export type TopBaitProductUnitFields = { __typename: 'ProductUnit', id: number, image: { __typename: 'Image', width: number, height: number, url: string } | null, attributeValues: { __typename: 'UnitAttributeValueRecordConnection', edges: Array<{ __typename: 'UnitAttributeValueEdge', node: { __typename: 'UnitAttributeValue', value: { __typename: 'AttributeValue', name: string } | null } | null } | null> | null }, product: { __typename: 'Product', displayName: string, _id: string, legacyId: number, category: { __typename: 'Category', title: string }, brand: { __typename: 'Brand', name: string, id: number } } };

export type SpeciesTopBaitNodeFields = { __typename: 'topEquipmentProductUnit', numberOfCatches: number, position: number, productUnit: { __typename: 'ProductUnit', id: number, image: { __typename: 'Image', width: number, height: number, url: string } | null, attributeValues: { __typename: 'UnitAttributeValueRecordConnection', edges: Array<{ __typename: 'UnitAttributeValueEdge', node: { __typename: 'UnitAttributeValue', value: { __typename: 'AttributeValue', name: string } | null } | null } | null> | null }, product: { __typename: 'Product', displayName: string, _id: string, legacyId: number, category: { __typename: 'Category', title: string }, brand: { __typename: 'Brand', name: string, id: number } } } };

export type ProductUnitUsedByCurrentUser = { __typename: 'ProductUnit', usedByCurrentUser: boolean };

export type ProductUnitDetailNodeFields = { __typename: 'ProductUnit', externalId: string, model: string, id: number, usedByCurrentUser: boolean, image: { __typename: 'Image', width: number, height: number, url: string } | null, attributeValues: { __typename: 'UnitAttributeValueRecordConnection', edges: Array<{ __typename: 'UnitAttributeValueEdge', node: { __typename: 'UnitAttributeValue', attribute: { __typename: 'Attribute', name: string } | null, value: { __typename: 'AttributeValue', name: string } | null } | null } | null> | null } };

export type ProductUnitEdgeFields = { __typename: 'ProductUnitEdge', node: { __typename: 'ProductUnit', model: string, id: number, usedByCurrentUser: boolean, image: { __typename: 'Image', width: number, height: number, url: string } | null, attributeValues: { __typename: 'UnitAttributeValueRecordConnection', edges: Array<{ __typename: 'UnitAttributeValueEdge', node: { __typename: 'UnitAttributeValue', attribute: { __typename: 'Attribute', name: string } | null, value: { __typename: 'AttributeValue', name: string } | null } | null } | null> | null } } | null };

export type RegionId = { __typename: 'Region', id: string | null };

export type FishingWaterRegionFields = { __typename: 'Region', name: string | null, localName: string | null, licenseInfoUrl: string | null, id: string | null };

export type PlaceRegionFields = { __typename: 'Region', regionCode: string | null, name: string | null, localName: string | null, licenseInfoUrl: string | null, id: string | null };

export type RegionDetailFields = { __typename: 'Region', name: string | null, localName: string | null, licenseInfoUrl: string | null, id: string | null, boundaryLayer: { __typename: 'BoundaryLayer', countryCode: string | null, stateCode: string | null, boundingBox: { __typename: 'BoundingBox', northEast: { __typename: 'Position', latitude: number, longitude: number }, southWest: { __typename: 'Position', latitude: number, longitude: number } } | null } | null, country: { __typename: 'Country', countryName: string, id: string, topFishingWaters: { __typename: 'FishingWaterRecordConnection', edges: Array<{ __typename: 'FishingWaterEdge', node: { __typename: 'FishingWater', displayName: string, _id: string } | null } | null> | null } } };

export type SpeciesId = { __typename: 'Species', _id: string };

export type FishingWaterTopSpeciesNodeFields = { __typename: 'Species', displayName: string, fishrulesIds: Array<string> | null, _id: string, anglers: { __typename: 'CatchRecordConnection', topAnglers: { __typename: 'TopAnglersConnection', totalCount: number } | null }, image: { __typename: 'Image', width: number, height: number, url: string } };

export type SpeciesTipNodeFields = { __typename: 'SpeciesTip', externalId: string, tip: string, userDescription: string | null, userDisplayName: string, user: { __typename: 'User', _id: string, avatar: { __typename: 'Image', height: number, width: number, url: string } | null } };

export type SpeciesListNodeFields = { __typename: 'Species', externalId: string, displayName: string, _id: string, catches: { __typename: 'CatchRecordConnection', totalCount: number }, image: { __typename: 'Image', width: number, height: number, url: string }, exampleCatchWithImage: { __typename: 'Catch', _id: string, post: { __typename: 'Post', _id: string, images: { __typename: 'ImageRecordConnection', edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', id: number | null, width: number, height: number, url: string } | null } | null> | null }, webPImages: { __typename: 'ImageRecordConnection', edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', id: number | null, width: number, height: number, url: string } | null } | null> | null } } } | null };

export type SpeciesListEdgeFields = { __typename: 'SpeciesEdge', node: { __typename: 'Species', externalId: string, displayName: string, _id: string, catches: { __typename: 'CatchRecordConnection', totalCount: number }, image: { __typename: 'Image', width: number, height: number, url: string }, exampleCatchWithImage: { __typename: 'Catch', _id: string, post: { __typename: 'Post', _id: string, images: { __typename: 'ImageRecordConnection', edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', id: number | null, width: number, height: number, url: string } | null } | null> | null }, webPImages: { __typename: 'ImageRecordConnection', edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', id: number | null, width: number, height: number, url: string } | null } | null> | null } } } | null } | null };

export type SpeciesBasicInfoNodeFields = { __typename: 'Species', externalId: string, displayName: string, _id: string, image: { __typename: 'Image', width: number, height: number, url: string } };

export type RegionalSpeciesNodeFields = { __typename: 'Species', externalId: string, displayName: string, fishrulesIds: Array<string> | null, _id: string, image: { __typename: 'Image', width: number, height: number, url: string }, areaSpecies: { __typename: 'AreaSpecies', recordLengthInM: number | null, recordWeightInKg: number | null } | null, speciesGroupings: { __typename: 'SpeciesGroupingRecordConnection', edges: Array<{ __typename: 'SpeciesGroupingEdge', node: { __typename: 'SpeciesGrouping', externalId: string, name: string } | null } | null> | null } };

export type SpeciesImageNodeFields = { __typename: 'Species', imageCopyrightStatus: string | null, imageCopyrightExpiryDate: string | null, _id: string, image: { __typename: 'Image', url: string }, webPImage: { __typename: 'Image', url: string } };

export type TopSpeciesNearLocationNodeFields = { __typename: 'Species', externalId: string, displayName: string, legacyId: number, _id: string, image: { __typename: 'Image', width: number, height: number, url: string }, exampleCatchWithImage: { __typename: 'Catch', _id: string, post: { __typename: 'Post', _id: string, images: { __typename: 'ImageRecordConnection', edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', id: number | null, width: number, height: number, url: string } | null } | null> | null }, webPImages: { __typename: 'ImageRecordConnection', edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', id: number | null, width: number, height: number, url: string } | null } | null> | null } } } | null };

export type SingleSpeciesFields = { __typename: 'Species', followedByCurrentUser: boolean, latinName: string, displayName: string, description: string | null, maxLength: number, maxWeight: number, iucnStatus: string | null, threatToHumans: Array<string> | null, waterTypes: Array<string>, minCommonDepth: number | null, maxCommonDepth: number | null, legacyId: number, _id: string, catches: { __typename: 'CatchRecordConnection', totalCount: number }, newCatchCount: { __typename: 'CatchRecordConnection', totalCount: number }, exampleCatchWithImage: { __typename: 'Catch', caughtAtGmt: string | null, createdAt: string | null, _id: string, legacyId: number, species: { __typename: 'Species', displayName: string, _id: string } | null, post: { __typename: 'Post', createdAt: string | null, likedByCurrentUser: boolean, likesCount: number, _id: string, displayProductUnits: { __typename: 'ProductUnitRecordConnection', totalCount: number }, catch: { __typename: 'Catch', _id: string, fishingWater: { __typename: 'FishingWater', displayName: string, latitude: number, longitude: number, _id: string } | null, species: { __typename: 'Species', displayName: string, _id: string } | null } | null, comments: { __typename: 'PostCommentConnection', totalCount: number }, images: { __typename: 'ImageRecordConnection', totalCount: number, edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null }, webPImages: { __typename: 'ImageRecordConnection', edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null }, text: { __typename: 'Text', text: string | null }, user: { __typename: 'User', nickname: string, isPremium: boolean | null, createdAt: string, _id: string, avatar: { __typename: 'Image', height: number, width: number, url: string } | null }, productUnits: { __typename: 'ProductUnitRecordConnection', edges: Array<{ __typename: 'ProductUnitEdge', node: { __typename: 'ProductUnit', model: string, id: number, image: { __typename: 'Image', width: number, height: number, url: string } | null, product: { __typename: 'Product', displayName: string, _id: string, legacyId: number, brand: { __typename: 'Brand', name: string, id: number } } } | null } | null> | null }, video: { __typename: 'Video', hlsUrl: string | null, webUrl: string | null, originalUrl: string, id: number, screenshot: { __typename: 'Image', width: number, height: number, url: string } } | null } } | null, catchesWithImages: { __typename: 'CatchRecordConnection', edges: Array<{ __typename: 'CatchRecordEdge', node: { __typename: 'Catch', _id: string, post: { __typename: 'Post', createdAt: string | null, _id: string, catch: { __typename: 'Catch', caughtAtGmt: string | null, weight: number | null, length: number | null, _id: string, fishingWater: { __typename: 'FishingWater', displayName: string, latitude: number, longitude: number, _id: string } | null, species: { __typename: 'Species', displayName: string, _id: string } | null } | null, displayProductUnits: { __typename: 'ProductUnitRecordConnection', totalCount: number }, images: { __typename: 'ImageRecordConnection', totalCount: number, edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null }, user: { __typename: 'User', nickname: string, _id: string } } } | null } | null> | null }, followers: { __typename: 'UserFollowersConnection', totalCount: number }, speciesTips: { __typename: 'SpeciesTipRecordConnection', edges: Array<{ __typename: 'SpeciesTipEdge', node: { __typename: 'SpeciesTip', externalId: string, tip: string, userDescription: string | null, userDisplayName: string, user: { __typename: 'User', _id: string, avatar: { __typename: 'Image', height: number, width: number, url: string } | null } } | null } | null> | null } };

export type PlaceTopSpeciesNodeFields = { __typename: 'Species', displayName: string, fishrulesIds: Array<string> | null, _id: string, image: { __typename: 'Image', width: number, height: number, url: string } };

export type SpeciesGroupingId = { __typename: 'SpeciesGrouping', _id: string };

export type SpeciesGroupsInCountryNodeFields = { __typename: 'Species', displayName: string, _id: string, speciesGroupings: { __typename: 'SpeciesGroupingRecordConnection', edges: Array<{ __typename: 'SpeciesGroupingEdge', node: { __typename: 'SpeciesGrouping', name: string, _id: string } | null } | null> | null } };

export type SpeciesByGroupNodeFields = { __typename: 'Species', externalId: string, displayName: string, _id: string, catches: { __typename: 'CatchRecordConnection', totalCount: number }, image: { __typename: 'Image', width: number, height: number, url: string } };

export type PlaceTopSpeciesConnectionFields = { __typename: 'TopSpeciesConnection', edges: Array<{ __typename: 'TopSpeciesSummaryEdge', catchesCount: number, node: { __typename: 'Species', displayName: string, fishrulesIds: Array<string> | null, _id: string, image: { __typename: 'Image', width: number, height: number, url: string } } | null } | null> | null };

export type FishingWaterTopSpeciesSummaryFields = { __typename: 'TopSpeciesConnection', edges: Array<{ __typename: 'TopSpeciesSummaryEdge', node: { __typename: 'Species', displayName: string, fishrulesIds: Array<string> | null, _id: string, anglers: { __typename: 'CatchRecordConnection', topAnglers: { __typename: 'TopAnglersConnection', totalCount: number } | null }, image: { __typename: 'Image', width: number, height: number, url: string } } | null } | null> | null };

export type TagId = { __typename: 'Tag', id: string };

export type TripCommentNodeFields = { __typename: 'Post', createdAt: string | null, titleString: string | null, _id: string, user: { __typename: 'User', isPremium: boolean | null, nickname: string, _id: string, avatar: { __typename: 'Image', height: number, width: number, url: string } | null }, text: { __typename: 'Text', text: string | null } };

export type TripMapImageFields = { __typename: 'CatchesMapImage', height: number, width: number, url: string };

export type TripMapImagesFields = { __typename: 'Trip', id: string, mobileImage: { __typename: 'CatchesMapImage', height: number, width: number, url: string } | null, desktopImage: { __typename: 'CatchesMapImage', height: number, width: number, url: string } | null };

export type TripFields = { __typename: 'Trip', id: string, startedAt: string, endedAt: string, createdAt: string, post: { __typename: 'Post', likedByCurrentUser: boolean, likesCount: number, _id: string, text: { __typename: 'Text', text: string | null }, comments: { __typename: 'PostCommentConnection', totalCount: number, edges: Array<{ __typename: 'CommentEdge', node: { __typename: 'Post', createdAt: string | null, titleString: string | null, _id: string, user: { __typename: 'User', isPremium: boolean | null, nickname: string, _id: string, avatar: { __typename: 'Image', height: number, width: number, url: string } | null }, text: { __typename: 'Text', text: string | null } } | null } | null> | null } }, user: { __typename: 'User', isPremium: boolean | null, nickname: string, firstName: string | null, lastName: string | null, createdAt: string, _id: string, catches: { __typename: 'CatchRecordConnection', totalCount: number, edges: Array<{ __typename: 'CatchRecordEdge', node: { __typename: 'Catch', _id: string, post: { __typename: 'Post', createdAt: string | null, likedByCurrentUser: boolean, likesCount: number, _id: string, catch: { __typename: 'Catch', caughtAtGmt: string | null, weight: number | null, length: number | null, _id: string, fishingWater: { __typename: 'FishingWater', displayName: string, latitude: number, longitude: number, _id: string } | null, species: { __typename: 'Species', displayName: string, _id: string } | null } | null, comments: { __typename: 'PostCommentConnection', totalCount: number }, displayProductUnits: { __typename: 'ProductUnitRecordConnection', totalCount: number }, images: { __typename: 'ImageRecordConnection', totalCount: number, edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null }, text: { __typename: 'Text', text: string | null }, user: { __typename: 'User', nickname: string, _id: string, avatar: { __typename: 'Image', height: number, width: number, url: string } | null }, displayEntity: { __typename: 'CurrentUser', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'FishingMethod', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'FishingWater', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Group', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Page', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Species', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'SpeciesWithBiteForecast', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'User', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } }, productUnits: { __typename: 'ProductUnitRecordConnection', edges: Array<{ __typename: 'ProductUnitEdge', node: { __typename: 'ProductUnit', model: string, id: number, image: { __typename: 'Image', width: number, height: number, url: string } | null, product: { __typename: 'Product', displayName: string, _id: string, legacyId: number, brand: { __typename: 'Brand', name: string, id: number } } } | null } | null> | null }, video: { __typename: 'Video', hlsUrl: string | null, webUrl: string | null, originalUrl: string, id: number, screenshot: { __typename: 'Image', width: number, height: number, url: string } } | null } } | null } | null> | null }, avatar: { __typename: 'Image', height: number, width: number, url: string } | null }, catches: { __typename: 'CatchRecordConnection', totalCount: number, edges: Array<{ __typename: 'CatchRecordEdge', node: { __typename: 'Catch', _id: string, post: { __typename: 'Post', createdAt: string | null, likedByCurrentUser: boolean, likesCount: number, _id: string, catch: { __typename: 'Catch', caughtAtGmt: string | null, weight: number | null, length: number | null, _id: string, fishingWater: { __typename: 'FishingWater', displayName: string, latitude: number, longitude: number, _id: string } | null, species: { __typename: 'Species', displayName: string, _id: string } | null } | null, comments: { __typename: 'PostCommentConnection', totalCount: number }, displayProductUnits: { __typename: 'ProductUnitRecordConnection', totalCount: number }, images: { __typename: 'ImageRecordConnection', totalCount: number, edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null }, text: { __typename: 'Text', text: string | null }, user: { __typename: 'User', nickname: string, _id: string, avatar: { __typename: 'Image', height: number, width: number, url: string } | null }, displayEntity: { __typename: 'CurrentUser', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'FishingMethod', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'FishingWater', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Group', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Page', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Species', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'SpeciesWithBiteForecast', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'User', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } }, productUnits: { __typename: 'ProductUnitRecordConnection', edges: Array<{ __typename: 'ProductUnitEdge', node: { __typename: 'ProductUnit', model: string, id: number, image: { __typename: 'Image', width: number, height: number, url: string } | null, product: { __typename: 'Product', displayName: string, _id: string, legacyId: number, brand: { __typename: 'Brand', name: string, id: number } } } | null } | null> | null }, video: { __typename: 'Video', hlsUrl: string | null, webUrl: string | null, originalUrl: string, id: number, screenshot: { __typename: 'Image', width: number, height: number, url: string } } | null } } | null } | null> | null }, publicCatches: { __typename: 'CatchRecordConnection', totalCount: number } };

export type UserId = { __typename: 'User', _id: string };

export type CurrentUserId = { __typename: 'CurrentUser', _id: string };

export type UserAvatar = { __typename: 'User', avatar: { __typename: 'Image', height: number, width: number, url: string } | null };

export type CurrentUserAvatar = { __typename: 'CurrentUser', avatar: { __typename: 'Image', width: number, height: number, url: string } | null };

export type PostLikerUserFields = { __typename: 'User', firstName: string | null, lastName: string | null, nickname: string, _id: string, avatar: { __typename: 'Image', height: number, width: number, url: string } | null };

export type ProfileUserFields = { __typename: 'User', nickname: string, firstName: string | null, lastName: string | null, isPremium: boolean | null, biography: string | null, countryCode: string, legacyId: number, _id: string, avatar: { __typename: 'Image', height: number, width: number, url: string } | null, coverImage: { __typename: 'Image', width: number, height: number, url: string } | null, catches: { __typename: 'CatchRecordConnection', totalCount: number } };

export type CurrentUserFields = { __typename: 'CurrentUser', createdAt: string, isPremium: boolean | null, isVerified: boolean | null, firstName: string | null, lastName: string | null, nickname: string, countryCode: string, lengthUnit: string, pressureUnit: string, speedUnit: string, temperatureUnit: string, weightUnit: string, premiumEndDate: string | null, privateUuid: string | null, legacyId: number, _id: string, privateFields: { __typename: 'UserPrivateFields', email: string | null }, avatar: { __typename: 'Image', width: number, height: number, url: string } | null };

export type PostEntryUserFields = { __typename: 'User', isPremium: boolean | null, firstName: string | null, lastName: string | null, createdAt: string, nickname: string, _id: string, avatar: { __typename: 'Image', height: number, width: number, url: string } | null };

export type FishingWaterDetailTopAnglersFields = { __typename: 'TopAnglersConnection', totalCount: number, edges: Array<{ __typename: 'TopAnglersEdge', node: { __typename: 'User', followedByCurrentUser: boolean, displayName: string, nickname: string, _id: string, displayIcon: { __typename: 'Image', url: string, width: number, height: number } } | null } | null> | null };

export type VideoId = { __typename: 'Video', id: number };

export type WeatherAndMarineReadingId = { __typename: 'WeatherAndMarineReading', id: number };

export type WindDirectionId = { __typename: 'WindDirection', id: number };

export type AssociateProductUnitsToMeVariables = Exact<{
  input: AssociateProductUnitsToMeMutationInput;
}>;


export type AssociateProductUnitsToMe = { __typename: 'Mutation', associateProductUnitsToMe: { __typename: 'AssociateProductUnitsToMeMutationPayload', userErrors: Array<{ __typename: 'UserError', path: Array<string> | null, message: string }> } | null };

export type CreatePostMutationVariables = Exact<{
  input: CreatePostMutationInput;
}>;


export type CreatePostMutation = { __typename: 'Mutation', createPost: { __typename: 'CreatePostMutationPayload', post: { __typename: 'Post', externalId: string } | null, userErrors: Array<{ __typename: 'UserError', path: Array<string> | null, message: string }> } | null };

export type CreatePromotedCtaMutationVariables = Exact<{
  input: CreatePromotedCallToActionMutationInput;
}>;


export type CreatePromotedCtaMutation = { __typename: 'Mutation', createPromotedCallToAction: { __typename: 'CreatePromotedCallToActionMutationPayload', promotedCallToAction: { __typename: 'PagesPromotedCallToAction', id: number, headline: string, subHeadline: string | null, targetUrl: string, buttonText: string, image: { __typename: 'Image', url: string } } | null, userErrors: Array<{ __typename: 'UserError', path: Array<string> | null, message: string }> } | null };

export type CreateUserSuggestedChangeMutationVariables = Exact<{
  input: CreateUserSuggestedChangeMutationInput;
}>;


export type CreateUserSuggestedChangeMutation = { __typename: 'Mutation', createUserSuggestedChange: { __typename: 'CreateUserSuggestedChangeMutationPayload', userSuggestedChanges: Array<{ __typename: 'UserSuggestedChange', externalId: string }> | null, userErrors: Array<{ __typename: 'UserError', path: Array<string> | null, message: string }> } | null };

export type DeletePromotedCallToActionVariables = Exact<{
  input: DeletePromotedCallToActionMutationInput;
}>;


export type DeletePromotedCallToAction = { __typename: 'Mutation', deletePromotedCallToAction: { __typename: 'DeletePromotedCallToActionMutationPayload', userErrors: Array<{ __typename: 'UserError', path: Array<string> | null, message: string }> } | null };

export type LogTrashCollectionMutationVariables = Exact<{
  input: LogTrashCollectionMutationInput;
}>;


export type LogTrashCollectionMutation = { __typename: 'Mutation', logTrashCollection: { __typename: 'LogTrashCollectionMutationPayload', trashCollection: { __typename: 'TrashCollection', externalId: string } | null, userErrors: Array<{ __typename: 'UserError', message: string, path: Array<string> | null }> } | null };

export type AttributePromotionVariables = Exact<{
  attributePromotionInput: AttributeTrialPromotionMutationInput;
}>;


export type AttributePromotion = { __typename: 'Mutation', attributeTrialPromotion: { __typename: 'AttributeTrialPromotionMutationPayload', clientMutationId: string | null, metaParams: Record<string, unknown> | null, partnerId: number | null, offeringRef: string | null, partnerUserExternalRef: string | null, promotionKey: string | null, userErrors: Array<{ __typename: 'UserError', code: string | null, message: string, path: Array<string> | null }> } | null };

export type DisassociateProductUnitsFromMeVariables = Exact<{
  input: DisassociateProductUnitsFromMeMutationInput;
}>;


export type DisassociateProductUnitsFromMe = { __typename: 'Mutation', disassociateProductUnitsFromMe: { __typename: 'DisassociateProductUnitsFromMeMutationPayload', userErrors: Array<{ __typename: 'UserError', path: Array<string> | null, message: string }> } | null };

export type UpdatePageMutationVariables = Exact<{
  pageInput: UpdatePageMutationInput;
}>;


export type UpdatePageMutation = { __typename: 'Mutation', updatePage: { __typename: 'UpdatePageMutationPayload', page: { __typename: 'Page', published: boolean, description: string | null, _id: string } | null, userErrors: Array<{ __typename: 'UserError', path: Array<string> | null, message: string }> } | null };

export type UpdatePageMutationWithBrandVariables = Exact<{
  pageInput: UpdatePageMutationInput;
  brandInput: UpdateBrandMutationInput;
}>;


export type UpdatePageMutationWithBrand = { __typename: 'Mutation', updatePage: { __typename: 'UpdatePageMutationPayload', page: { __typename: 'Page', published: boolean, description: string | null, _id: string } | null, userErrors: Array<{ __typename: 'UserError', path: Array<string> | null, message: string }> } | null, updateBrand: { __typename: 'UpdateBrandMutationPayload', brand: { __typename: 'Brand', url: string | null, _id: string } | null, userErrors: Array<{ __typename: 'UserError', path: Array<string> | null, message: string }> } | null };

export type UpdatePromotedCallToActionVariables = Exact<{
  input: UpdatePromotedCallToActionMutationInput;
}>;


export type UpdatePromotedCallToAction = { __typename: 'Mutation', updatePromotedCallToAction: { __typename: 'UpdatePromotedCallToActionMutationPayload', promotedCallToAction: { __typename: 'PagesPromotedCallToAction', id: number, headline: string, subHeadline: string | null, targetUrl: string, buttonText: string, image: { __typename: 'Image', url: string } } | null, userErrors: Array<{ __typename: 'UserError', path: Array<string> | null, message: string }> } | null };

export type UpdateTrashCollectionMutationVariables = Exact<{
  input: UpdateTrashCollectionMutationInput;
}>;


export type UpdateTrashCollectionMutation = { __typename: 'Mutation', updateTrashCollection: { __typename: 'UpdateTrashCollectionMutationPayload', trashCollection: { __typename: 'TrashCollection', externalId: string, brandName: string | null, createdAt: string, description: string | null, stateName: string | null, latitude: number, longitude: number, weightInKg: number, image: { __typename: 'Image', url: string, width: number, height: number }, user: { __typename: 'User', displayName: string, nickname: string, avatar: { __typename: 'Image', url: string } | null } } | null, userErrors: Array<{ __typename: 'UserError', message: string, path: Array<string> | null }> } | null };

export type CreateDirectUploadUrlVariables = Exact<{
  input: CreateDirectUploadUrlMutationInput;
}>;


export type CreateDirectUploadUrl = { __typename: 'Mutation', createDirectUploadUrl: { __typename: 'CreateDirectUploadURLMutationPayload', directUploadUrl: { __typename: 'DirectUploadURL', signedId: string, url: string, headers: Array<{ __typename: 'DirectUploadRequestHeader', name: string, value: string }> } | null, userErrors: Array<{ __typename: 'UserError', path: Array<string> | null, message: string }> } | null };

export type UpsertConsentVariables = Exact<{
  input: UpsertConsentMutationInput;
}>;


export type UpsertConsent = { __typename: 'Mutation', upsertConsent: { __typename: 'UpsertConsentMutationPayload', userErrors: Array<{ __typename: 'UserError', path: Array<string> | null, message: string }> } | null };

export type GetAllBrandsVariables = Exact<{ [key: string]: never; }>;


export type GetAllBrands = { __typename: 'Query', entry: Array<{ __typename: 'Page', id: number, externalId: string, displayName: string }> };

export type FilterBrandsVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type FilterBrands = { __typename: 'Query', brands: { __typename: 'BrandRecordConnection', edges: Array<{ __typename: 'BrandEdge', node: { __typename: 'Brand', externalId: string, name: string, id: number } | null } | null> | null } };

export type GetDiscoveredBrandsVariables = Exact<{
  filters?: InputMaybe<PageFilters>;
}>;


export type GetDiscoveredBrands = { __typename: 'Query', entry: { __typename: 'PageRecordConnection', edges: Array<{ __typename: 'PageEdge', node: { __typename: 'Page', displayName: string, followedByCurrentUser: boolean, _id: string, legacyId: number, followers: { __typename: 'PageFollowersConnection', totalCount: number }, logo: { __typename: 'Image', url: string } | null, coverImages: { __typename: 'ImageRecordConnection', edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null } } | null } | null> | null } };

export type GetBrandIsFollowedVariables = Exact<{
  externalId: Scalars['String']['input'];
}>;


export type GetBrandIsFollowed = { __typename: 'Query', entry: { __typename: 'Page', followedByCurrentUser: boolean } };

export type GetCatchPostCommentsVariables = Exact<{
  externalId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCatchPostComments = { __typename: 'Query', post: { __typename: 'Post', likedByCurrentUser: boolean, likesCount: number, _id: string, comments: { __typename: 'PostCommentConnection', totalCount: number, edges: Array<{ __typename: 'CommentEdge', cursor: string, node: { __typename: 'Post', createdAt: string | null, likedByCurrentUser: boolean, likesCount: number, _id: string, text: { __typename: 'Text', text: string | null }, user: { __typename: 'User', nickname: string, _id: string, avatar: { __typename: 'Image', height: number, width: number, url: string } | null }, comments: { __typename: 'PostCommentConnection', totalCount: number, edges: Array<{ __typename: 'CommentEdge', node: { __typename: 'Post', createdAt: string | null, likedByCurrentUser: boolean, likesCount: number, _id: string, user: { __typename: 'User', nickname: string, _id: string, avatar: { __typename: 'Image', height: number, width: number, url: string } | null }, text: { __typename: 'Text', text: string | null } } | null } | null> | null } } | null } | null> | null } } };

export type GetCatchDetailsVariables = Exact<{
  externalId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCatchDetails = { __typename: 'Query', catchDetails: { __typename: 'Post', _id: string, catchConditions: { __typename: 'Catch', caughtAtLocalTimeZone: string | null, latitude: number | null, longitude: number | null, moonIllumination: MoonIlluminationTypes | null, sunPosition: SunPositionTypes | null, _id: string, weatherAndMarineReading: { __typename: 'WeatherAndMarineReading', airPressure: number | null, airTemperature: number | null, waterTemperature: number | null, windSpeed: number | null, id: number, weatherCondition: { __typename: 'WeatherCondition', localizedValue: string, worldWeatherOnlineIdentifier: string } | null, windDirection: { __typename: 'WindDirection', degrees: number | null, shortLocalizedValue: string } | null } | null } | null, catchPost: { __typename: 'Catch', catchAndRelease: boolean | null, caughtAtGmt: string | null, createdAt: string | null, hasExactPosition: boolean, length: number | null, locationPrivacy: CatchLocationPrivacyTypes, weight: number | null, _id: string, fishingMethod: { __typename: 'FishingMethod', displayName: string, _id: string } | null, fishingWater: { __typename: 'FishingWater', displayName: string, latitude: number, longitude: number, _id: string } | null, species: { __typename: 'Species', displayName: string, _id: string } | null, user: { __typename: 'User', nickname: string, _id: string, avatar: { __typename: 'Image', url: string } | null } } | null, trip: { __typename: 'Trip', id: string, catches: { __typename: 'CatchRecordConnection', totalCount: number } } | null, catchGear: { __typename: 'ProductUnitRecordConnection', edges: Array<{ __typename: 'ProductUnitEdge', node: { __typename: 'ProductUnit', id: number, product: { __typename: 'Product', displayName: string, _id: string, legacyId: number, brand: { __typename: 'Brand', name: string, id: number }, image: { __typename: 'Image', width: number, height: number, url: string } | null } } | null } | null> | null } } };

export type GetUserCatchesExcludingCatchVariables = Exact<{
  externalId: Scalars['String']['input'];
  excludeId: Scalars['String']['input'];
}>;


export type GetUserCatchesExcludingCatch = { __typename: 'Query', entry: { __typename: 'User', catches: { __typename: 'CatchRecordConnection', edges: Array<{ __typename: 'CatchRecordEdge', node: { __typename: 'Catch', createdAt: string | null, _id: string, legacyId: number, user: { __typename: 'User', nickname: string, isPremium: boolean | null, _id: string, avatar: { __typename: 'Image', height: number, width: number, url: string } | null }, post: { __typename: 'Post', _id: string, images: { __typename: 'ImageRecordConnection', totalCount: number, edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null } } } | null } | null> | null } } };

export type GetCatchMetadataVariables = Exact<{
  externalId: Scalars['String']['input'];
}>;


export type GetCatchMetadata = { __typename: 'Query', entry: { __typename: 'Catch', _id: string, species: { __typename: 'Species', displayName: string, _id: string } | null, fishingWater: { __typename: 'FishingWater', displayName: string, _id: string } | null, post: { __typename: 'Post', _id: string, text: { __typename: 'Text', text: string | null }, images: { __typename: 'ImageRecordConnection', edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null }, user: { __typename: 'User', nickname: string }, video: { __typename: 'Video', hlsUrl: string | null, webUrl: string | null, originalUrl: string, id: number, screenshot: { __typename: 'Image', width: number, height: number, url: string } } | null } } };

export type GetPostIdByCatchIdVariables = Exact<{
  externalId: Scalars['String']['input'];
}>;


export type GetPostIdByCatchId = { __typename: 'Query', entry: { __typename: 'Catch', _id: string, post: { __typename: 'Post', externalId: string, _id: string } } };

export type GetCatchesInMapBoundingBoxVariables = Exact<{
  boundingBox?: InputMaybe<BoundingBoxInputObject>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  caughtInMonths?: InputMaybe<Array<MonthEnum> | MonthEnum>;
  speciesIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetCatchesInMapBoundingBox = { __typename: 'Query', mapArea: { __typename: 'MapArea', catches: { __typename: 'CatchSearchConnection', totalCount: number, pageInfo: { __typename: 'PageInfo', startCursor: string | null, hasNextPage: boolean, endCursor: string | null }, edges: Array<{ __typename: 'CatchSearchEdge', node: { __typename: 'Catch', createdAt: string | null, caughtAtGmt: string | null, _id: string, post: { __typename: 'Post', createdAt: string | null, likedByCurrentUser: boolean, likesCount: number, _id: string, catch: { __typename: 'Catch', _id: string, fishingWater: { __typename: 'FishingWater', displayName: string, latitude: number, longitude: number, _id: string } | null, species: { __typename: 'Species', displayName: string, _id: string } | null } | null, comments: { __typename: 'PostCommentConnection', totalCount: number }, displayProductUnits: { __typename: 'ProductUnitRecordConnection', totalCount: number }, images: { __typename: 'ImageRecordConnection', totalCount: number, edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null }, text: { __typename: 'Text', text: string | null }, user: { __typename: 'User', nickname: string, _id: string, avatar: { __typename: 'Image', height: number, width: number, url: string } | null }, productUnits: { __typename: 'ProductUnitRecordConnection', edges: Array<{ __typename: 'ProductUnitEdge', node: { __typename: 'ProductUnit', model: string, id: number, image: { __typename: 'Image', width: number, height: number, url: string } | null, product: { __typename: 'Product', displayName: string, _id: string, legacyId: number, brand: { __typename: 'Brand', name: string, id: number } } } | null } | null> | null }, video: { __typename: 'Video', hlsUrl: string | null, webUrl: string | null, originalUrl: string, id: number, screenshot: { __typename: 'Image', width: number, height: number, url: string } } | null }, species: { __typename: 'Species', displayName: string, _id: string } | null } | null } | null> | null } } };

export type GetCatchCountInMapBoundingBoxVariables = Exact<{
  boundingBox?: InputMaybe<BoundingBoxInputObject>;
}>;


export type GetCatchCountInMapBoundingBox = { __typename: 'Query', mapArea: { __typename: 'MapArea', catches: { __typename: 'CatchSearchConnection', totalCount: number } } };

export type GetSingleCatchForViewerVariables = Exact<{
  externalId: Scalars['String']['input'];
}>;


export type GetSingleCatchForViewer = { __typename: 'Query', catch: { __typename: 'Catch', caughtAtGmt: string | null, createdAt: string | null, _id: string, species: { __typename: 'Species', displayName: string, _id: string } | null, post: { __typename: 'Post', createdAt: string | null, likedByCurrentUser: boolean, likesCount: number, _id: string, displayProductUnits: { __typename: 'ProductUnitRecordConnection', totalCount: number }, catch: { __typename: 'Catch', _id: string, fishingWater: { __typename: 'FishingWater', displayName: string, latitude: number, longitude: number, _id: string } | null, species: { __typename: 'Species', displayName: string, _id: string } | null } | null, comments: { __typename: 'PostCommentConnection', totalCount: number }, images: { __typename: 'ImageRecordConnection', totalCount: number, edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null }, text: { __typename: 'Text', text: string | null }, user: { __typename: 'User', nickname: string, _id: string, avatar: { __typename: 'Image', height: number, width: number, url: string } | null }, productUnits: { __typename: 'ProductUnitRecordConnection', edges: Array<{ __typename: 'ProductUnitEdge', node: { __typename: 'ProductUnit', model: string, id: number, image: { __typename: 'Image', width: number, height: number, url: string } | null, product: { __typename: 'Product', displayName: string, _id: string, legacyId: number, brand: { __typename: 'Brand', name: string, id: number } } } | null } | null> | null }, video: { __typename: 'Video', hlsUrl: string | null, webUrl: string | null, originalUrl: string, id: number, screenshot: { __typename: 'Image', width: number, height: number, url: string } } | null } } };

export type GetCountriesVariables = Exact<{ [key: string]: never; }>;


export type GetCountries = { __typename: 'Query', entry: { __typename: 'CountryRecordConnection', totalCount: number, edges: Array<{ __typename: 'CountryEdge', node: { __typename: 'Country', id: string, iso2: string, countryName: string } | null } | null> | null, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: string | null } } };

export type GetCountryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCountry = { __typename: 'Query', entry: { __typename: 'Country', countryName: string, id: string } };

export type GetCountryPlacesVariables = Exact<{
  id: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCountryPlaces = { __typename: 'Query', entry: { __typename: 'Country', id: string, places: { __typename: 'PlaceRecordConnection', edges: Array<{ __typename: 'PlaceEdge', node: { __typename: 'Place', name: string, slug: string | null, latitude: number, longitude: number, _id: string, country: { __typename: 'Country', countryName: string, id: string }, region: { __typename: 'Region', name: string | null, id: string | null } } | null } | null> | null } } };

export type GetCountryTopWatersVariables = Exact<{
  id: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  speciesIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetCountryTopWaters = { __typename: 'Query', entry: { __typename: 'Country', id: string, topFishingWaters: { __typename: 'FishingWaterRecordConnection', edges: Array<{ __typename: 'FishingWaterEdge', node: { __typename: 'FishingWater', catchesCount: number, displayName: string, latitude: number, longitude: number, _id: string, allReviews: { __typename: 'ReviewInterfaceRecordConnection', totalCount: number, totalAverage: number } | null, recentCatches: { __typename: 'CatchRecordConnection', edges: Array<{ __typename: 'CatchRecordEdge', node: { __typename: 'Catch', _id: string, post: { __typename: 'Post', createdAt: string | null, _id: string, catch: { __typename: 'Catch', caughtAtGmt: string | null, length: number | null, weight: number | null, _id: string, fishingWater: { __typename: 'FishingWater', displayName: string, _id: string } | null, species: { __typename: 'Species', displayName: string, _id: string } | null } | null, user: { __typename: 'User', nickname: string, _id: string }, displayProductUnits: { __typename: 'ProductUnitRecordConnection', totalCount: number }, images: { __typename: 'ImageRecordConnection', totalCount: number, edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null } } } | null } | null> | null }, country: { __typename: 'Country', countryName: string, id: string } | null, region: { __typename: 'Region', name: string | null, localName: string | null, licenseInfoUrl: string | null, id: string | null } | null } | null } | null> | null } } };

export type GetSpeciesGroupsInCountryVariables = Exact<{
  countryId: Scalars['String']['input'];
}>;


export type GetSpeciesGroupsInCountry = { __typename: 'Query', entry: { __typename: 'Country', id: string, topSpecies: { __typename: 'TopSpeciesConnection', edges: Array<{ __typename: 'TopSpeciesSummaryEdge', node: { __typename: 'Species', displayName: string, _id: string, speciesGroupings: { __typename: 'SpeciesGroupingRecordConnection', edges: Array<{ __typename: 'SpeciesGroupingEdge', node: { __typename: 'SpeciesGrouping', name: string, _id: string } | null } | null> | null } } | null } | null> | null } } };

export type GetSpeciesGroupsByCountryVariables = Exact<{
  countryId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetSpeciesGroupsByCountry = { __typename: 'Query', species: { __typename: 'SpeciesRecordConnection', edges: Array<{ __typename: 'SpeciesEdge', node: { __typename: 'Species', displayName: string, _id: string, speciesGroupings: { __typename: 'SpeciesGroupingRecordConnection', edges: Array<{ __typename: 'SpeciesGroupingEdge', node: { __typename: 'SpeciesGrouping', name: string, _id: string } | null } | null> | null } } | null } | null> | null } };

export type GetDirectoryFishingWatersVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDirectoryFishingWaters = { __typename: 'Query', entry: { __typename: 'FishingWaterRecordConnection', totalCount: number, edges: Array<{ __typename: 'FishingWaterEdge', cursor: string, node: { __typename: 'FishingWater', displayName: string, _id: string, region: { __typename: 'Region', name: string | null } | null, country: { __typename: 'Country', countryName: string } | null } | null } | null> | null, pageInfo: { __typename: 'PageInfo', endCursor: string | null, hasNextPage: boolean } } };

export type GetFishingWaterSummaryVariables = Exact<{
  externalId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetFishingWaterSummary = { __typename: 'Query', fishingWater: { __typename: 'FishingWater', displayName: string, catchesCount: number, latitude: number, longitude: number, _id: string, metadata: Array<{ __typename: 'FishingWaterMetadata', id: string, description: string, name: string, variant: FishingWaterMetadataVariants, group: { __typename: 'FishingWaterMetadataGroup', id: string } }>, allReviews: { __typename: 'ReviewInterfaceRecordConnection', totalCount: number, totalAverage: number } | null, catches: { __typename: 'CatchRecordConnection', totalCount: number, pageInfo: { __typename: 'PageInfo', startCursor: string | null, hasNextPage: boolean, endCursor: string | null }, edges: Array<{ __typename: 'CatchRecordEdge', node: { __typename: 'Catch', _id: string, post: { __typename: 'Post', createdAt: string | null, likedByCurrentUser: boolean, likesCount: number, _id: string, catch: { __typename: 'Catch', caughtAtGmt: string | null, weight: number | null, length: number | null, _id: string, fishingWater: { __typename: 'FishingWater', displayName: string, latitude: number, longitude: number, _id: string } | null, species: { __typename: 'Species', displayName: string, _id: string } | null } | null, comments: { __typename: 'PostCommentConnection', totalCount: number }, displayProductUnits: { __typename: 'ProductUnitRecordConnection', totalCount: number }, images: { __typename: 'ImageRecordConnection', totalCount: number, edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null }, text: { __typename: 'Text', text: string | null }, user: { __typename: 'User', nickname: string, _id: string, avatar: { __typename: 'Image', height: number, width: number, url: string } | null }, displayEntity: { __typename: 'CurrentUser', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'FishingMethod', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'FishingWater', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Group', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Page', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Species', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'SpeciesWithBiteForecast', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'User', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } }, productUnits: { __typename: 'ProductUnitRecordConnection', edges: Array<{ __typename: 'ProductUnitEdge', node: { __typename: 'ProductUnit', model: string, id: number, image: { __typename: 'Image', width: number, height: number, url: string } | null, product: { __typename: 'Product', displayName: string, _id: string, legacyId: number, brand: { __typename: 'Brand', name: string, id: number } } } | null } | null> | null }, video: { __typename: 'Video', hlsUrl: string | null, webUrl: string | null, originalUrl: string, id: number, screenshot: { __typename: 'Image', width: number, height: number, url: string } } | null } } | null } | null> | null }, country: { __typename: 'Country', countryName: string, id: string } | null, region: { __typename: 'Region', name: string | null, localName: string | null, licenseInfoUrl: string | null, id: string | null } | null } };

export type GetFishingWaterReviewsVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  orderByBestReviews?: InputMaybe<Scalars['Boolean']['input']>;
  orderByRecent?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetFishingWaterReviews = { __typename: 'Query', fishingWater: { __typename: 'FishingWater', _id: string, oneStarReviews: { __typename: 'ReviewInterfaceRecordConnection', totalCount: number } | null, twoStarReviews: { __typename: 'ReviewInterfaceRecordConnection', totalCount: number } | null, threeStarReviews: { __typename: 'ReviewInterfaceRecordConnection', totalCount: number } | null, fourStarReviews: { __typename: 'ReviewInterfaceRecordConnection', totalCount: number } | null, fiveStarReviews: { __typename: 'ReviewInterfaceRecordConnection', totalCount: number } | null, reviews: { __typename: 'ReviewInterfaceRecordConnection', totalCount: number, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: string | null }, edges: Array<{ __typename: 'ReviewInterfaceEdge', node: { __typename: 'FishingWaterReview', externalId: string, rating: number, createdAt: string | null, _id: string, author: { __typename: 'User', nickname: string, lastName: string | null, firstName: string | null, _id: string }, post: { __typename: 'Post', helpfulDownvotesCount: number | null, helpfulUpvotesCount: number | null, currentUserFoundHelpful: boolean | null, titleString: string | null, _id: string, text: { __typename: 'Text', text: string | null } } } | { __typename: 'Review', externalId: string, rating: number, createdAt: string | null, author: { __typename: 'User', nickname: string, lastName: string | null, firstName: string | null, _id: string }, post: { __typename: 'Post', helpfulDownvotesCount: number | null, helpfulUpvotesCount: number | null, currentUserFoundHelpful: boolean | null, titleString: string | null, _id: string, text: { __typename: 'Text', text: string | null } } } | null } | null> | null } | null } };

export type GetFishingWaterTopSpeciesVariables = Exact<{
  externalId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetFishingWaterTopSpecies = { __typename: 'Query', fishingWater: { __typename: 'FishingWater', _id: string, topSpeciesSummary: { __typename: 'TopSpeciesConnection', edges: Array<{ __typename: 'TopSpeciesSummaryEdge', node: { __typename: 'Species', displayName: string, fishrulesIds: Array<string> | null, _id: string, anglers: { __typename: 'CatchRecordConnection', topAnglers: { __typename: 'TopAnglersConnection', totalCount: number } | null }, image: { __typename: 'Image', width: number, height: number, url: string } } | null } | null> | null } | null } };

export type GetFishingWaterNearestPlaceVariables = Exact<{
  externalId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetFishingWaterNearestPlace = { __typename: 'Query', fishingWater: { __typename: 'FishingWater', _id: string, nearestPlace: { __typename: 'Place', latitude: number, longitude: number, name: string, slug: string | null, _id: string, country: { __typename: 'Country', countryName: string, id: string }, region: { __typename: 'Region', name: string | null, id: string | null }, nearbyPlaces: { __typename: 'NearbyPlacesConnection', edges: Array<{ __typename: 'NearbyPlacesEdge', distanceUnit: string, node: { __typename: 'Place', name: string, slug: string | null, latitude: number, longitude: number, _id: string, country: { __typename: 'Country', countryName: string, id: string }, region: { __typename: 'Region', name: string | null, id: string | null } } | null } | null> | null } } | null } };

export type GetFishingWaterNearbyWatersVariables = Exact<{
  externalId?: InputMaybe<Scalars['String']['input']>;
  recentCatchLimitDays?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetFishingWaterNearbyWaters = { __typename: 'Query', fishingWater: { __typename: 'FishingWater', _id: string, suggestedWaters: Array<{ __typename: 'FishingWater', displayName: string, catchesCount: number, latitude: number, longitude: number, _id: string, newCatchCount: { __typename: 'CatchRecordConnection', totalCount: number }, topSpeciesSummary: { __typename: 'TopSpeciesConnection', edges: Array<{ __typename: 'TopSpeciesSummaryEdge', node: { __typename: 'Species', displayName: string } | null } | null> | null } | null, metadata: Array<{ __typename: 'FishingWaterMetadata', id: string, description: string, name: string, variant: FishingWaterMetadataVariants, group: { __typename: 'FishingWaterMetadataGroup', id: string } }>, country: { __typename: 'Country', countryName: string, id: string } | null, region: { __typename: 'Region', name: string | null, localName: string | null, licenseInfoUrl: string | null, id: string | null } | null }> } };

export type GetFishingWaterSeoMetadataVariables = Exact<{
  externalId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetFishingWaterSeoMetadata = { __typename: 'Query', fishingWater: { __typename: 'FishingWater', displayName: string, latitude: number, longitude: number, _id: string, nearestPlace: { __typename: 'Place', name: string, _id: string } | null, country: { __typename: 'Country', countryName: string, id: string } | null, region: { __typename: 'Region', name: string | null, localName: string | null, licenseInfoUrl: string | null, id: string | null } | null } };

export type GetFishingWaterVariables = Exact<{
  externalId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetFishingWater = { __typename: 'Query', fishingWater: { __typename: 'FishingWater', displayName: string, catchesCount: number, descriptionOfWaterType: WaterTypes, url: string | null, latitude: number, longitude: number, _id: string, metadata: Array<{ __typename: 'FishingWaterMetadata', id: string, description: string, name: string, variant: FishingWaterMetadataVariants, group: { __typename: 'FishingWaterMetadataGroup', id: string } }>, topAnglers: { __typename: 'CatchRecordConnection', anglers: { __typename: 'TopAnglersConnection', totalCount: number, edges: Array<{ __typename: 'TopAnglersEdge', node: { __typename: 'User', followedByCurrentUser: boolean, displayName: string, nickname: string, _id: string, displayIcon: { __typename: 'Image', url: string, width: number, height: number } } | null } | null> | null } | null }, catches: { __typename: 'CatchRecordConnection', edges: Array<{ __typename: 'CatchRecordEdge', node: { __typename: 'Catch', _id: string, post: { __typename: 'Post', createdAt: string | null, _id: string, catch: { __typename: 'Catch', caughtAtGmt: string | null, weight: number | null, length: number | null, _id: string, fishingWater: { __typename: 'FishingWater', displayName: string, latitude: number, longitude: number, _id: string } | null, species: { __typename: 'Species', displayName: string, _id: string } | null } | null, displayProductUnits: { __typename: 'ProductUnitRecordConnection', totalCount: number }, images: { __typename: 'ImageRecordConnection', totalCount: number, edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null }, user: { __typename: 'User', nickname: string, _id: string } } } | null } | null> | null }, allReviews: { __typename: 'ReviewInterfaceRecordConnection', totalCount: number, totalAverage: number } | null, reviews: { __typename: 'ReviewInterfaceRecordConnection', amenities: { __typename: 'ReviewPropertyQuestionInterfaceRecordConnection', edges: Array<{ __typename: 'ReviewPropertyQuestionRecordEdge', node: { __typename: 'FishingWaterReviewPropertyQuestion', summaryHeader: string | null } | { __typename: 'ReviewPropertyQuestion' } | null } | null> | null } | null } | null, county: { __typename: 'County', name: string | null } | null, intersectingCounties: { __typename: 'CountyRecordConnection', edges: Array<{ __typename: 'CountyEdge', node: { __typename: 'County', name: string | null, country: { __typename: 'Country', countryName: string, id: string }, region: { __typename: 'Region', regionCode: string | null, name: string | null, localName: string | null } } | null } | null> | null }, country: { __typename: 'Country', countryName: string, id: string, topFishingWaters: { __typename: 'FishingWaterRecordConnection', edges: Array<{ __typename: 'FishingWaterEdge', node: { __typename: 'FishingWater', displayName: string, _id: string } | null } | null> | null }, topSpecies: { __typename: 'TopSpeciesConnection', edges: Array<{ __typename: 'TopSpeciesSummaryEdge', node: { __typename: 'Species', displayName: string, _id: string } | null } | null> | null } } | null, region: { __typename: 'Region', name: string | null, localName: string | null, licenseInfoUrl: string | null, id: string | null } | null } };

export type FishingWaterDetailCatchNodeFields = { __typename: 'Catch', _id: string, post: { __typename: 'Post', createdAt: string | null, _id: string, catch: { __typename: 'Catch', caughtAtGmt: string | null, weight: number | null, length: number | null, _id: string, fishingWater: { __typename: 'FishingWater', displayName: string, latitude: number, longitude: number, _id: string } | null, species: { __typename: 'Species', displayName: string, _id: string } | null } | null, displayProductUnits: { __typename: 'ProductUnitRecordConnection', totalCount: number }, images: { __typename: 'ImageRecordConnection', totalCount: number, edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null }, user: { __typename: 'User', nickname: string, _id: string } } };

export type GetFishingWaterForSuggestChangesVariables = Exact<{
  externalId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetFishingWaterForSuggestChanges = { __typename: 'Query', fishingWater: { __typename: 'FishingWater', displayName: string, latitude: number, longitude: number, url: string | null, _id: string, metadata: Array<{ __typename: 'FishingWaterMetadata', id: string, description: string, name: string, variant: FishingWaterMetadataVariants, group: { __typename: 'FishingWaterMetadataGroup', id: string } }> } };

export type GetFishingWaterForCardVariables = Exact<{
  externalId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetFishingWaterForCard = { __typename: 'Query', entry: { __typename: 'FishingWater', displayName: string, latitude: number, longitude: number, _id: string, country: { __typename: 'Country', countryName: string, id: string } | null, region: { __typename: 'Region', name: string | null, localName: string | null, licenseInfoUrl: string | null, id: string | null } | null } };

export type GetFishingWaterLocationVariables = Exact<{
  externalId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetFishingWaterLocation = { __typename: 'Query', entry: { __typename: 'FishingWater', latitude: number, longitude: number, _id: string } };

export type GetFishingWaterNameVariables = Exact<{
  externalId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetFishingWaterName = { __typename: 'Query', entry: { __typename: 'FishingWater', displayName: string, _id: string } };

export type GetFishingWaterNamesVariables = Exact<{
  externalIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<FishingWaterFilters>;
}>;


export type GetFishingWaterNames = { __typename: 'Query', entries: { __typename: 'FishingWaterRecordConnection', edges: Array<{ __typename: 'FishingWaterEdge', node: { __typename: 'FishingWater', displayName: string, _id: string } | null } | null> | null } };

export type GetNearbyFishingWatersVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  boundingBox?: InputMaybe<BoundingBoxInputObject>;
}>;


export type GetNearbyFishingWaters = { __typename: 'Query', entry: { __typename: 'FishingWaterRecordConnection', edges: Array<{ __typename: 'FishingWaterEdge', node: { __typename: 'FishingWater', catchesCount: number, displayName: string, latitude: number, longitude: number, _id: string, allReviews: { __typename: 'ReviewInterfaceRecordConnection', totalCount: number, totalAverage: number } | null, recentCatches: { __typename: 'CatchRecordConnection', edges: Array<{ __typename: 'CatchRecordEdge', node: { __typename: 'Catch', _id: string, post: { __typename: 'Post', _id: string, images: { __typename: 'ImageRecordConnection', totalCount: number, edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null } } } | null } | null> | null }, country: { __typename: 'Country', countryName: string, id: string } | null, region: { __typename: 'Region', name: string | null, localName: string | null, licenseInfoUrl: string | null, id: string | null } | null } | null } | null> | null } };

export type GetFishingWaterMetadataVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetFishingWaterMetadata = { __typename: 'Query', fishingWaterMetadata: { __typename: 'FishingWaterMetadataRecordConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor: string | null, startCursor: string | null }, edges: Array<{ __typename: 'FishingWaterMetadataEdge', node: { __typename: 'FishingWaterMetadata', id: string, name: string, group: { __typename: 'FishingWaterMetadataGroup', id: string, name: string, choice: FishingWaterMetadataGroupChoiceTypes } } | null } | null> | null } };

export type GetTopWatersInfoVariables = Exact<{
  externalIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetTopWatersInfo = { __typename: 'Query', fishingWaters: { __typename: 'FishingWaterRecordConnection', totalCount: number, edges: Array<{ __typename: 'FishingWaterEdge', node: { __typename: 'FishingWater', externalId: string, catchesCount: number, displayName: string, descriptionOfWaterType: WaterTypes, region: { __typename: 'Region', name: string | null, id: string | null } | null } | null } | null> | null } };

export type GetCurrentUserVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUser = { __typename: 'Query', currentUser: { __typename: 'CurrentUser', createdAt: string, isPremium: boolean | null, isVerified: boolean | null, firstName: string | null, lastName: string | null, nickname: string, countryCode: string, lengthUnit: string, pressureUnit: string, speedUnit: string, temperatureUnit: string, weightUnit: string, premiumEndDate: string | null, privateUuid: string | null, legacyId: number, _id: string, privateFields: { __typename: 'UserPrivateFields', email: string | null }, avatar: { __typename: 'Image', width: number, height: number, url: string } | null } | null };

export type GetManageablePageStatusesVariables = Exact<{ [key: string]: never; }>;


export type GetManageablePageStatuses = { __typename: 'Query', entry: { __typename: 'CurrentUser', _id: string, manageablePages: { __typename: 'PageRecordConnection', edges: Array<{ __typename: 'PageEdge', node: { __typename: 'Page', name: string | null, published: boolean, _id: string, legacyId: number } | null } | null> | null } } | null };

export type GetManageablePagesVariables = Exact<{ [key: string]: never; }>;


export type GetManageablePages = { __typename: 'Query', entry: { __typename: 'CurrentUser', _id: string, manageablePages: { __typename: 'PageRecordConnection', edges: Array<{ __typename: 'PageEdge', node: { __typename: 'Page', name: string | null, published: boolean, description: string | null, _id: string, legacyId: number, logo: { __typename: 'Image', width: number, height: number, url: string } | null, coverImages: { __typename: 'ImageRecordConnection', edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null }, promotedCallToActions: { __typename: 'PagesPromotedCallToActionRecordConnection', edges: Array<{ __typename: 'PagesPromotedCallToActionEdge', node: { __typename: 'PagesPromotedCallToAction', id: number, headline: string, subHeadline: string | null, targetUrl: string, buttonText: string, image: { __typename: 'Image', width: number, height: number, url: string } } | null } | null> | null }, pageable: { __typename: 'Brand', id: number, externalId: string, url: string | null } | { __typename: 'State' } | null } | null } | null> | null } } | null };

export type GetPublishablePagesVariables = Exact<{ [key: string]: never; }>;


export type GetPublishablePages = { __typename: 'Query', entry: { __typename: 'CurrentUser', _id: string, pagesCanPublishAs: { __typename: 'PageRecordConnection', edges: Array<{ __typename: 'PageEdge', node: { __typename: 'Page', name: string | null, externalId: string, _id: string, legacyId: number } | null } | null> | null } } | null };

export type GetUserProductUnitsVariables = Exact<{
  categoryExternalIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetUserProductUnits = { __typename: 'Query', entry: { __typename: 'CurrentUser', _id: string, productUnits: { __typename: 'ProductUnitRecordConnection', edges: Array<{ __typename: 'ProductUnitEdge', node: { __typename: 'ProductUnit', externalId: string, id: number, image: { __typename: 'Image', width: number, height: number, url: string } | null, attributeValues: { __typename: 'UnitAttributeValueRecordConnection', edges: Array<{ __typename: 'UnitAttributeValueEdge', node: { __typename: 'UnitAttributeValue', value: { __typename: 'AttributeValue', name: string } | null } | null } | null> | null }, product: { __typename: 'Product', displayName: string, _id: string, legacyId: number, brand: { __typename: 'Brand', name: string, id: number } } } | null } | null> | null } } | null };

export type GetConsentsVariables = Exact<{ [key: string]: never; }>;


export type GetConsents = { __typename: 'Query', me: { __typename: 'CurrentUser', _id: string, consents: { __typename: 'ConsentRecordConnection', edges: Array<{ __typename: 'ConsentEdge', node: { __typename: 'Consent', id: number, accepted: boolean, agreementUid: string | null } | null } | null> | null } } | null };

export type GetTrashCollectionStateLeaderboardVariables = Exact<{ [key: string]: never; }>;


export type GetTrashCollectionStateLeaderboard = { __typename: 'Query', trashCollectionStateLeaderboard: Array<{ __typename: 'TrashCollectionStateLeaderboardEntry', stateCode: string, stateName: string | null, totalWeightInKgs: number }> };

export type GetTrashCollectionBrandLeaderboardVariables = Exact<{ [key: string]: never; }>;


export type GetTrashCollectionBrandLeaderboard = { __typename: 'Query', trashCollectionBrandLeaderboard: Array<{ __typename: 'TrashCollectionBrandLeaderboardEntry', brandName: string, totalWeightInKgs: number }> };

export type BrandSearchVariables = Exact<{
  query: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BrandSearch = { __typename: 'Query', brandSearch: { __typename: 'EquipmentBrandSearchResult', brands: { __typename: 'BrandConnection', edges: Array<{ __typename: 'BrandEdge', node: { __typename: 'Brand', externalId: string, name: string } | null } | null> | null } | null } | null };

export type GetTrashCollectionVariables = Exact<{
  externalId: Scalars['String']['input'];
}>;


export type GetTrashCollection = { __typename: 'Query', trashCollection: { __typename: 'TrashCollection', externalId: string, brandName: string | null, createdAt: string, description: string | null, stateName: string | null, latitude: number, longitude: number, weightInKg: number, image: { __typename: 'Image', url: string, width: number, height: number }, user: { __typename: 'User', displayName: string, nickname: string, avatar: { __typename: 'Image', url: string } | null } } };

export type GetTrashCollectionsVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetTrashCollections = { __typename: 'Query', trashCollections: { __typename: 'TrashCollectionRecordConnection', totalCount: number, totalWeightInKgs: number, edges: Array<{ __typename: 'TrashCollectionEdge', node: { __typename: 'TrashCollection', createdAt: string, description: string | null, externalId: string, stateName: string | null, weightInKg: number, user: { __typename: 'User', displayName: string, avatar: { __typename: 'Image', url: string } | null }, image: { __typename: 'Image', url: string, width: number, height: number } } | null } | null> | null, pageInfo: { __typename: 'PageInfo', endCursor: string | null, hasNextPage: boolean } } };

export type GetSinglePageNameVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetSinglePageName = { __typename: 'Query', entry: { __typename: 'Page', displayName: string, externalId: string, _id: string, legacyId: number } };

export type GetPageVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetPage = { __typename: 'Query', entry: { __typename: 'Page', displayName: string, published: boolean, description: string | null, _id: string, legacyId: number, logo: { __typename: 'Image', width: number, height: number, url: string } | null, coverImages: { __typename: 'ImageRecordConnection', edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null }, posts: { __typename: 'PostRecordConnection', edges: Array<{ __typename: 'PostEdge', node: { __typename: 'Post', sharingPost: boolean, likedByCurrentUser: boolean, likesCount: number, createdAt: string | null, publishedAt: string | null, _id: string, legacyId: number, comments: { __typename: 'PostCommentConnection', totalCount: number }, likers: { __typename: 'PostsFeedDisplayEntityRecordConnection', totalCount: number }, user: { __typename: 'User', isPremium: boolean | null, firstName: string | null, lastName: string | null, createdAt: string, nickname: string, _id: string, avatar: { __typename: 'Image', height: number, width: number, url: string } | null }, trip: { __typename: 'Trip', id: string, createdAt: string, startedAt: string, endedAt: string, catches: { __typename: 'CatchRecordConnection', totalCount: number } } | null, catch: { __typename: 'Catch', isPersonalBest: boolean, weight: number | null, length: number | null, catchAndRelease: boolean | null, caughtAtLocalTimeZone: string | null, caughtAtGmt: string | null, hasExactPosition: boolean, locationPrivacy: CatchLocationPrivacyTypes, createdAt: string | null, _id: string, legacyId: number, species: { __typename: 'Species', displayName: string, legacyId: number, _id: string } | null, trip: { __typename: 'Trip', id: string, catches: { __typename: 'CatchRecordConnection', totalCount: number } } | null, fishingMethod: { __typename: 'FishingMethod', displayName: string, _id: string } | null, fishingWater: { __typename: 'FishingWater', displayName: string, latitude: number, longitude: number, _id: string } | null, productUnits: { __typename: 'ProductUnitRecordConnection', edges: Array<{ __typename: 'ProductUnitEdge', node: { __typename: 'ProductUnit', model: string, id: number, image: { __typename: 'Image', width: number, height: number, url: string } | null, product: { __typename: 'Product', displayName: string, _id: string, legacyId: number, brand: { __typename: 'Brand', name: string, id: number } } } | null } | null> | null } } | null, text: { __typename: 'Text', text: string | null }, displayEntity: { __typename: 'CurrentUser', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'FishingMethod', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'FishingWater', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Group', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Page', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Species', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'SpeciesWithBiteForecast', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'User', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } }, fishingWater: { __typename: 'FishingWater', displayName: string, _id: string } | null, video: { __typename: 'Video', hlsUrl: string | null, webUrl: string | null, originalUrl: string, id: number, screenshot: { __typename: 'Image', width: number, height: number, url: string } } | null } | null } | null> | null }, followers: { __typename: 'PageFollowersConnection', totalCount: number }, promotedCallToActions: { __typename: 'PagesPromotedCallToActionRecordConnection', edges: Array<{ __typename: 'PagesPromotedCallToActionEdge', node: { __typename: 'PagesPromotedCallToAction', id: number, headline: string, subHeadline: string | null, buttonText: string, targetUrl: string, image: { __typename: 'Image', url: string, width: number, height: number } } | null } | null> | null }, pageable: { __typename: 'Brand', url: string | null } | { __typename: 'State' } | null, resources: { __typename: 'ResourceLikeRecordConnection', edges: Array<{ __typename: 'ResourceLikeEdge', node: { __typename: 'About', label: string, position: number } | { __typename: 'Catches', label: string, position: number } | { __typename: 'Feed', label: string, position: number } | { __typename: 'Gear', label: string, position: number } | { __typename: 'Home', label: string, position: number } | { __typename: 'Videos', label: string, position: number } | null } | null> | null } } };

export type GetPageCatchesVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetPageCatches = { __typename: 'Query', entry: { __typename: 'Page', _id: string, legacyId: number, catches: { __typename: 'CatchRecordConnection', edges: Array<{ __typename: 'CatchRecordEdge', node: { __typename: 'Catch', createdAt: string | null, _id: string, legacyId: number, post: { __typename: 'Post', createdAt: string | null, likedByCurrentUser: boolean, likesCount: number, _id: string, catch: { __typename: 'Catch', caughtAtGmt: string | null, weight: number | null, length: number | null, _id: string, fishingWater: { __typename: 'FishingWater', displayName: string, latitude: number, longitude: number, _id: string } | null, species: { __typename: 'Species', displayName: string, _id: string } | null } | null, comments: { __typename: 'PostCommentConnection', totalCount: number }, displayProductUnits: { __typename: 'ProductUnitRecordConnection', totalCount: number }, images: { __typename: 'ImageRecordConnection', totalCount: number, edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null }, text: { __typename: 'Text', text: string | null }, user: { __typename: 'User', nickname: string, _id: string, avatar: { __typename: 'Image', height: number, width: number, url: string } | null }, displayEntity: { __typename: 'CurrentUser', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'FishingMethod', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'FishingWater', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Group', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Page', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Species', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'SpeciesWithBiteForecast', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'User', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } }, productUnits: { __typename: 'ProductUnitRecordConnection', edges: Array<{ __typename: 'ProductUnitEdge', node: { __typename: 'ProductUnit', model: string, id: number, image: { __typename: 'Image', width: number, height: number, url: string } | null, product: { __typename: 'Product', displayName: string, _id: string, legacyId: number, brand: { __typename: 'Brand', name: string, id: number } } } | null } | null> | null }, video: { __typename: 'Video', hlsUrl: string | null, webUrl: string | null, originalUrl: string, id: number, screenshot: { __typename: 'Image', width: number, height: number, url: string } } | null } } | null } | null> | null } } };

export type GetPagePostsVariables = Exact<{
  id: Scalars['String']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPagePosts = { __typename: 'Query', entry: { __typename: 'Page', _id: string, legacyId: number, posts: { __typename: 'PostRecordConnection', edges: Array<{ __typename: 'PostEdge', node: { __typename: 'Post', publishedAt: string | null, sharingPost: boolean, createdAt: string | null, likedByCurrentUser: boolean, likesCount: number, _id: string, catch: { __typename: 'Catch', _id: string, fishingWater: { __typename: 'FishingWater', displayName: string, latitude: number, longitude: number, _id: string } | null, species: { __typename: 'Species', displayName: string, _id: string } | null } | null, comments: { __typename: 'PostCommentConnection', totalCount: number }, displayProductUnits: { __typename: 'ProductUnitRecordConnection', totalCount: number }, images: { __typename: 'ImageRecordConnection', totalCount: number, edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null }, text: { __typename: 'Text', text: string | null }, user: { __typename: 'User', nickname: string, _id: string, avatar: { __typename: 'Image', height: number, width: number, url: string } | null }, displayEntity: { __typename: 'CurrentUser', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'FishingMethod', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'FishingWater', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Group', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Page', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Species', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'SpeciesWithBiteForecast', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'User', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } }, productUnits: { __typename: 'ProductUnitRecordConnection', edges: Array<{ __typename: 'ProductUnitEdge', node: { __typename: 'ProductUnit', model: string, id: number, image: { __typename: 'Image', width: number, height: number, url: string } | null, product: { __typename: 'Product', displayName: string, _id: string, legacyId: number, brand: { __typename: 'Brand', name: string, id: number } } } | null } | null> | null }, video: { __typename: 'Video', hlsUrl: string | null, webUrl: string | null, originalUrl: string, id: number, screenshot: { __typename: 'Image', width: number, height: number, url: string } } | null } | null } | null> | null, pageInfo: { __typename: 'PageInfo', endCursor: string | null, hasNextPage: boolean } } } };

export type GetBrandPostsVariables = Exact<{ [key: string]: never; }>;


export type GetBrandPosts = { __typename: 'Query', posts: { __typename: 'PublicPostRecordConnection', edges: Array<{ __typename: 'PublicPostRecordEdge', node: { __typename: 'Post', createdAt: string | null, likedByCurrentUser: boolean, likesCount: number, _id: string, catch: { __typename: 'Catch', _id: string, fishingWater: { __typename: 'FishingWater', displayName: string, latitude: number, longitude: number, _id: string } | null, species: { __typename: 'Species', displayName: string, _id: string } | null } | null, comments: { __typename: 'PostCommentConnection', totalCount: number }, displayProductUnits: { __typename: 'ProductUnitRecordConnection', totalCount: number }, images: { __typename: 'ImageRecordConnection', totalCount: number, edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null }, text: { __typename: 'Text', text: string | null }, user: { __typename: 'User', nickname: string, _id: string, avatar: { __typename: 'Image', height: number, width: number, url: string } | null }, displayEntity: { __typename: 'CurrentUser', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'FishingMethod', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'FishingWater', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Group', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Page', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Species', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'SpeciesWithBiteForecast', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'User', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } }, productUnits: { __typename: 'ProductUnitRecordConnection', edges: Array<{ __typename: 'ProductUnitEdge', node: { __typename: 'ProductUnit', model: string, id: number, image: { __typename: 'Image', width: number, height: number, url: string } | null, product: { __typename: 'Product', displayName: string, _id: string, legacyId: number, brand: { __typename: 'Brand', name: string, id: number } } } | null } | null> | null }, video: { __typename: 'Video', hlsUrl: string | null, webUrl: string | null, originalUrl: string, id: number, screenshot: { __typename: 'Image', width: number, height: number, url: string } } | null } | null } | null> | null } };

export type GetPlaceCoordinatesVariables = Exact<{
  countryCode: Scalars['String']['input'];
  regionCode: Scalars['String']['input'];
  placeSlug: Scalars['String']['input'];
}>;


export type GetPlaceCoordinates = { __typename: 'Query', entry: { __typename: 'Place', latitude: number, longitude: number, _id: string } };

export type GetPlaceVariables = Exact<{
  countryCode: Scalars['String']['input'];
  regionCode: Scalars['String']['input'];
  placeSlug: Scalars['String']['input'];
}>;


export type GetPlace = { __typename: 'Query', entry: { __typename: 'Place', name: string, slug: string | null, latitude: number, longitude: number, _id: string, catches: { __typename: 'CatchRecordConnection', edges: Array<{ __typename: 'CatchRecordEdge', node: { __typename: 'Catch', _id: string, post: { __typename: 'Post', createdAt: string | null, _id: string, catch: { __typename: 'Catch', caughtAtGmt: string | null, weight: number | null, length: number | null, _id: string, fishingWater: { __typename: 'FishingWater', displayName: string, latitude: number, longitude: number, _id: string } | null, species: { __typename: 'Species', displayName: string, _id: string } | null } | null, displayProductUnits: { __typename: 'ProductUnitRecordConnection', totalCount: number }, images: { __typename: 'ImageRecordConnection', totalCount: number, edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null }, user: { __typename: 'User', nickname: string, _id: string } } } | null } | null> | null }, country: { __typename: 'Country', countryName: string, id: string, topFishingWaters: { __typename: 'FishingWaterRecordConnection', edges: Array<{ __typename: 'FishingWaterEdge', node: { __typename: 'FishingWater', displayName: string, _id: string } | null } | null> | null }, topSpecies: { __typename: 'TopSpeciesConnection', edges: Array<{ __typename: 'TopSpeciesSummaryEdge', node: { __typename: 'Species', displayName: string, _id: string } | null } | null> | null } }, region: { __typename: 'Region', regionCode: string | null, name: string | null, localName: string | null, licenseInfoUrl: string | null, id: string | null } } };

export type GetPlaceMetadataVariables = Exact<{
  countryCode: Scalars['String']['input'];
  regionCode: Scalars['String']['input'];
  placeSlug: Scalars['String']['input'];
}>;


export type GetPlaceMetadata = { __typename: 'Query', entry: { __typename: 'Place', name: string, slug: string | null, latitude: number, longitude: number, _id: string, country: { __typename: 'Country', countryName: string, id: string }, region: { __typename: 'Region', regionCode: string | null, name: string | null, localName: string | null, id: string | null } } };

export type GetPlaceTopAnglersVariables = Exact<{
  countryCode: Scalars['String']['input'];
  regionCode: Scalars['String']['input'];
  placeSlug: Scalars['String']['input'];
  catchesDateRange: DateRangeInputObject;
}>;


export type GetPlaceTopAnglers = { __typename: 'Query', entry: { __typename: 'Place', _id: string, topAnglers: { __typename: 'CatchRecordConnection', anglers: { __typename: 'TopAnglersConnection', totalCount: number, edges: Array<{ __typename: 'TopAnglersEdge', node: { __typename: 'User', followedByCurrentUser: boolean, displayName: string, nickname: string, _id: string, displayIcon: { __typename: 'Image', url: string, width: number, height: number } } | null } | null> | null } | null } } };

export type GetPlaceNearbyPlacesVariables = Exact<{
  countryCode: Scalars['String']['input'];
  regionCode: Scalars['String']['input'];
  placeSlug: Scalars['String']['input'];
}>;


export type GetPlaceNearbyPlaces = { __typename: 'Query', entry: { __typename: 'Place', _id: string, nearbyPlaces: { __typename: 'NearbyPlacesConnection', edges: Array<{ __typename: 'NearbyPlacesEdge', distanceUnit: string, node: { __typename: 'Place', name: string, slug: string | null, latitude: number, longitude: number, _id: string, country: { __typename: 'Country', countryName: string, id: string }, region: { __typename: 'Region', name: string | null, id: string | null } } | null } | null> | null } } };

export type GetPlaceTopWatersVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  boundingBox?: InputMaybe<BoundingBoxInputObject>;
}>;


export type GetPlaceTopWaters = { __typename: 'Query', entry: { __typename: 'FishingWaterRecordConnection', edges: Array<{ __typename: 'FishingWaterEdge', node: { __typename: 'FishingWater', catchesCount: number, displayName: string, latitude: number, longitude: number, _id: string, recentCatches: { __typename: 'CatchRecordConnection', edges: Array<{ __typename: 'CatchRecordEdge', node: { __typename: 'Catch', _id: string, post: { __typename: 'Post', _id: string, images: { __typename: 'ImageRecordConnection', totalCount: number, edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null } } } | null } | null> | null }, allReviews: { __typename: 'ReviewInterfaceRecordConnection', totalCount: number, totalAverage: number } | null, country: { __typename: 'Country', countryName: string, id: string } | null, region: { __typename: 'Region', name: string | null, localName: string | null, licenseInfoUrl: string | null, id: string | null } | null } | null } | null> | null } };

export type GetDirectoryPlacesVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDirectoryPlaces = { __typename: 'Query', entry: { __typename: 'PlaceRecordConnection', totalCount: number, edges: Array<{ __typename: 'PlaceEdge', cursor: string, node: { __typename: 'Place', name: string, slug: string | null, _id: string, country: { __typename: 'Country', countryName: string, id: string }, region: { __typename: 'Region', name: string | null, id: string | null } } | null } | null> | null, pageInfo: { __typename: 'PageInfo', endCursor: string | null, hasNextPage: boolean } } };

export type GetPlaceTopSpeciesVariables = Exact<{
  countryCode: Scalars['String']['input'];
  regionCode: Scalars['String']['input'];
  placeSlug: Scalars['String']['input'];
}>;


export type GetPlaceTopSpecies = { __typename: 'Query', entry: { __typename: 'Place', _id: string, topSpeciesSummary: { __typename: 'TopSpeciesConnection', edges: Array<{ __typename: 'TopSpeciesSummaryEdge', catchesCount: number, node: { __typename: 'Species', displayName: string, fishrulesIds: Array<string> | null, _id: string, image: { __typename: 'Image', width: number, height: number, url: string } } | null } | null> | null } } };

export type GetPointOfInterestVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPointOfInterest = { __typename: 'Query', entry: { __typename: 'PointOfInterest', address: string | null, city: string | null, country: string | null, county: string | null, description: string | null, email: string | null, phone: string | null, primaryName: string | null, rampSurface: string | null, rampType: string | null, state: string | null, website: string | null, zipcode: string | null, primaryType: number | null, _id: string } };

export type GetPostVariables = Exact<{
  externalId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPost = { __typename: 'Query', entry: { __typename: 'Post', sharingPost: boolean, likedByCurrentUser: boolean, likesCount: number, createdAt: string | null, publishedAt: string | null, _id: string, legacyId: number, images: { __typename: 'ImageRecordConnection', totalCount: number, edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null }, user: { __typename: 'User', isPremium: boolean | null, firstName: string | null, lastName: string | null, createdAt: string, nickname: string, _id: string, avatar: { __typename: 'Image', height: number, width: number, url: string } | null }, comments: { __typename: 'PostCommentConnection', totalCount: number }, likers: { __typename: 'PostsFeedDisplayEntityRecordConnection', totalCount: number }, trip: { __typename: 'Trip', id: string, createdAt: string, startedAt: string, endedAt: string, catches: { __typename: 'CatchRecordConnection', totalCount: number } } | null, catch: { __typename: 'Catch', isPersonalBest: boolean, weight: number | null, length: number | null, catchAndRelease: boolean | null, caughtAtLocalTimeZone: string | null, caughtAtGmt: string | null, hasExactPosition: boolean, locationPrivacy: CatchLocationPrivacyTypes, createdAt: string | null, _id: string, legacyId: number, species: { __typename: 'Species', displayName: string, legacyId: number, _id: string } | null, trip: { __typename: 'Trip', id: string, catches: { __typename: 'CatchRecordConnection', totalCount: number } } | null, fishingMethod: { __typename: 'FishingMethod', displayName: string, _id: string } | null, fishingWater: { __typename: 'FishingWater', displayName: string, latitude: number, longitude: number, _id: string } | null, productUnits: { __typename: 'ProductUnitRecordConnection', edges: Array<{ __typename: 'ProductUnitEdge', node: { __typename: 'ProductUnit', model: string, id: number, image: { __typename: 'Image', width: number, height: number, url: string } | null, product: { __typename: 'Product', displayName: string, _id: string, legacyId: number, brand: { __typename: 'Brand', name: string, id: number } } } | null } | null> | null } } | null, text: { __typename: 'Text', text: string | null }, productUnits: { __typename: 'ProductUnitRecordConnection', edges: Array<{ __typename: 'ProductUnitEdge', node: { __typename: 'ProductUnit', model: string, id: number, image: { __typename: 'Image', width: number, height: number, url: string } | null, product: { __typename: 'Product', displayName: string, _id: string, legacyId: number, brand: { __typename: 'Brand', name: string, id: number } } } | null } | null> | null }, displayProductUnits: { __typename: 'ProductUnitRecordConnection', totalCount: number, edges: Array<{ __typename: 'ProductUnitEdge', node: { __typename: 'ProductUnit', product: { __typename: 'Product', externalId: string, displayName: string, _id: string, legacyId: number, reviews: { __typename: 'ReviewInterfaceRecordConnection', totalCount: number, averageRating: number } | null, image: { __typename: 'Image', id: number | null, width: number, height: number, url: string } | null, brand: { __typename: 'Brand', name: string, id: number } } } | null } | null> | null }, displayEntity: { __typename: 'CurrentUser', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'FishingMethod', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'FishingWater', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Group', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Page', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Species', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'SpeciesWithBiteForecast', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'User', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } }, fishingWater: { __typename: 'FishingWater', displayName: string, _id: string } | null, video: { __typename: 'Video', hlsUrl: string | null, webUrl: string | null, originalUrl: string, id: number, screenshot: { __typename: 'Image', width: number, height: number, url: string } } | null } };

export type GetPostMetadataVariables = Exact<{
  externalId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPostMetadata = { __typename: 'Query', entry: { __typename: 'Post', externalId: string, _id: string, catch: { __typename: 'Catch', _id: string } | null, text: { __typename: 'Text', text: string | null }, images: { __typename: 'ImageRecordConnection', edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null }, user: { __typename: 'User', nickname: string }, video: { __typename: 'Video', hlsUrl: string | null, webUrl: string | null, originalUrl: string, id: number, screenshot: { __typename: 'Image', width: number, height: number, url: string } } | null } };

export type GetPostExternalIdVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPostExternalId = { __typename: 'Query', entry: { __typename: 'Post', _id: string } };

export type GetPostCommentsVariables = Exact<{
  externalId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPostComments = { __typename: 'Query', entry: { __typename: 'Post', _id: string, comments: { __typename: 'PostCommentConnection', totalCount: number, pageInfo: { __typename: 'PageInfo', endCursor: string | null, startCursor: string | null, hasNextPage: boolean }, edges: Array<{ __typename: 'CommentEdge', cursor: string, node: { __typename: 'Post', createdAt: string | null, likedByCurrentUser: boolean, likesCount: number, _id: string, user: { __typename: 'User', nickname: string, _id: string, avatar: { __typename: 'Image', height: number, width: number, url: string } | null }, text: { __typename: 'Text', text: string | null }, comments: { __typename: 'PostCommentConnection', totalCount: number, edges: Array<{ __typename: 'CommentEdge', node: { __typename: 'Post', createdAt: string | null, likedByCurrentUser: boolean, likesCount: number, _id: string, user: { __typename: 'User', nickname: string, _id: string, avatar: { __typename: 'Image', height: number, width: number, url: string } | null }, text: { __typename: 'Text', text: string | null } } | null } | null> | null } } | null } | null> | null } } };

export type GetPostLikersVariables = Exact<{
  externalId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPostLikers = { __typename: 'Query', post: { __typename: 'Post', _id: string, likers: { __typename: 'PostsFeedDisplayEntityRecordConnection', edges: Array<{ __typename: 'PostsFeedDisplayEntityEdge', node: { __typename: 'CurrentUser' } | { __typename: 'FishingMethod' } | { __typename: 'FishingWater' } | { __typename: 'Group' } | { __typename: 'Page' } | { __typename: 'Species' } | { __typename: 'SpeciesWithBiteForecast' } | { __typename: 'User', firstName: string | null, lastName: string | null, nickname: string, _id: string, avatar: { __typename: 'Image', height: number, width: number, url: string } | null } | null } | null> | null } } };

export type GetPostLikesVariables = Exact<{
  externalId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPostLikes = { __typename: 'Query', post: { __typename: 'Post', likedByCurrentUser: boolean, likesCount: number, _id: string } };

export type GetAllCategoriesVariables = Exact<{ [key: string]: never; }>;


export type GetAllCategories = { __typename: 'Query', categories: { __typename: 'CategoryRecordConnection', edges: Array<{ __typename: 'CategoryEdge', node: { __typename: 'Category', externalId: string, title: string, id: number, ancestors: Array<{ __typename: 'Category', title: string, id: number }> } | null } | null> | null } };

export type GetTopLevelCategoriesVariables = Exact<{ [key: string]: never; }>;


export type GetTopLevelCategories = { __typename: 'Query', categories: { __typename: 'CategoryRecordConnection', edges: Array<{ __typename: 'CategoryEdge', node: { __typename: 'Category', externalId: string, title: string, id: number } | null } | null> | null } };

export type GetProductUnitsVariables = Exact<{
  externalId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProductUnits = { __typename: 'Query', entry: { __typename: 'Product', displayName: string, _id: string, legacyId: number, units: { __typename: 'ProductUnitRecordConnection', edges: Array<{ __typename: 'ProductUnitEdge', node: { __typename: 'ProductUnit', externalId: string, model: string, id: number, usedByCurrentUser: boolean, image: { __typename: 'Image', width: number, height: number, url: string } | null, attributeValues: { __typename: 'UnitAttributeValueRecordConnection', edges: Array<{ __typename: 'UnitAttributeValueEdge', node: { __typename: 'UnitAttributeValue', attribute: { __typename: 'Attribute', name: string } | null, value: { __typename: 'AttributeValue', name: string } | null } | null } | null> | null } } | null } | null> | null }, brand: { __typename: 'Brand', name: string, id: number } } };

export type FilterProductsVariables = Exact<{
  filters?: InputMaybe<ProductFilters>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type FilterProducts = { __typename: 'Query', products: { __typename: 'ProductRecordConnection', totalCount: number, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: string | null }, edges: Array<{ __typename: 'ProductEdge', node: { __typename: 'Product', displayName: string, _id: string, image: { __typename: 'Image', width: number, height: number, url: string } | null, brand: { __typename: 'Brand', name: string, id: number }, reviews: { __typename: 'ReviewInterfaceRecordConnection', totalCount: number, averageRating: number } | null } | null } | null> | null } };

export type GetRegionsVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetRegions = { __typename: 'Query', entry: { __typename: 'RegionRecordConnection', totalCount: number, edges: Array<{ __typename: 'RegionEdge', cursor: string, node: { __typename: 'Region', countryCode: string | null, regionCode: string | null, name: string | null, localName: string | null, country: { __typename: 'Country', countryName: string } } | null } | null> | null, pageInfo: { __typename: 'PageInfo', endCursor: string | null, hasNextPage: boolean } } };

export type GetRegionVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetRegion = { __typename: 'Query', entry: { __typename: 'Region', name: string | null, localName: string | null, licenseInfoUrl: string | null, id: string | null, boundaryLayer: { __typename: 'BoundaryLayer', countryCode: string | null, stateCode: string | null, boundingBox: { __typename: 'BoundingBox', northEast: { __typename: 'Position', latitude: number, longitude: number }, southWest: { __typename: 'Position', latitude: number, longitude: number } } | null } | null, country: { __typename: 'Country', countryName: string, id: string, topFishingWaters: { __typename: 'FishingWaterRecordConnection', edges: Array<{ __typename: 'FishingWaterEdge', node: { __typename: 'FishingWater', displayName: string, _id: string } | null } | null> | null } } } };

export type GetRegionPlacesVariables = Exact<{
  id: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetRegionPlaces = { __typename: 'Query', entry: { __typename: 'Region', id: string | null, places: { __typename: 'PlaceRecordConnection', edges: Array<{ __typename: 'PlaceEdge', node: { __typename: 'Place', name: string, slug: string | null, _id: string } | null } | null> | null } } };

export type GetRegionTopWatersVariables = Exact<{
  id: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  speciesIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetRegionTopWaters = { __typename: 'Query', entry: { __typename: 'Region', id: string | null, topFishingWaters: { __typename: 'FishingWaterRecordConnection', edges: Array<{ __typename: 'FishingWaterEdge', node: { __typename: 'FishingWater', catchesCount: number, displayName: string, descriptionOfWaterType: WaterTypes, latitude: number, longitude: number, _id: string, allReviews: { __typename: 'ReviewInterfaceRecordConnection', totalCount: number, totalAverage: number } | null, recentCatches: { __typename: 'CatchRecordConnection', edges: Array<{ __typename: 'CatchRecordEdge', node: { __typename: 'Catch', _id: string, post: { __typename: 'Post', _id: string, images: { __typename: 'ImageRecordConnection', edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null } } } | null } | null> | null }, country: { __typename: 'Country', countryName: string, id: string } | null, region: { __typename: 'Region', name: string | null, localName: string | null, licenseInfoUrl: string | null, id: string | null } | null } | null } | null> | null } } };

export type GetRegionFishingWatersVariables = Exact<{
  id: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  speciesIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetRegionFishingWaters = { __typename: 'Query', entry: { __typename: 'Region', id: string | null, boundaryLayer: { __typename: 'BoundaryLayer', stateCode: string | null, boundingBox: { __typename: 'BoundingBox', northEast: { __typename: 'Position', latitude: number, longitude: number }, southWest: { __typename: 'Position', latitude: number, longitude: number } } | null } | null, lake: { __typename: 'FishingWaterRecordConnection', totalCount: number, edges: Array<{ __typename: 'FishingWaterEdge', node: { __typename: 'FishingWater', catchesCount: number, displayName: string, descriptionOfWaterType: WaterTypes, latitude: number, longitude: number, _id: string, allReviews: { __typename: 'ReviewInterfaceRecordConnection', totalCount: number, totalAverage: number } | null, recentCatches: { __typename: 'CatchRecordConnection', edges: Array<{ __typename: 'CatchRecordEdge', node: { __typename: 'Catch', _id: string, post: { __typename: 'Post', _id: string, images: { __typename: 'ImageRecordConnection', edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null } } } | null } | null> | null }, country: { __typename: 'Country', countryName: string, id: string } | null, region: { __typename: 'Region', name: string | null, localName: string | null, licenseInfoUrl: string | null, id: string | null } | null } | null } | null> | null }, stream: { __typename: 'FishingWaterRecordConnection', totalCount: number, edges: Array<{ __typename: 'FishingWaterEdge', node: { __typename: 'FishingWater', catchesCount: number, displayName: string, descriptionOfWaterType: WaterTypes, latitude: number, longitude: number, _id: string, allReviews: { __typename: 'ReviewInterfaceRecordConnection', totalCount: number, totalAverage: number } | null, recentCatches: { __typename: 'CatchRecordConnection', edges: Array<{ __typename: 'CatchRecordEdge', node: { __typename: 'Catch', _id: string, post: { __typename: 'Post', _id: string, images: { __typename: 'ImageRecordConnection', edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null } } } | null } | null> | null }, country: { __typename: 'Country', countryName: string, id: string } | null, region: { __typename: 'Region', name: string | null, localName: string | null, licenseInfoUrl: string | null, id: string | null } | null } | null } | null> | null }, ocean: { __typename: 'FishingWaterRecordConnection', totalCount: number, edges: Array<{ __typename: 'FishingWaterEdge', node: { __typename: 'FishingWater', catchesCount: number, displayName: string, descriptionOfWaterType: WaterTypes, latitude: number, longitude: number, _id: string, allReviews: { __typename: 'ReviewInterfaceRecordConnection', totalCount: number, totalAverage: number } | null, recentCatches: { __typename: 'CatchRecordConnection', edges: Array<{ __typename: 'CatchRecordEdge', node: { __typename: 'Catch', _id: string, post: { __typename: 'Post', _id: string, images: { __typename: 'ImageRecordConnection', edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null } } } | null } | null> | null }, country: { __typename: 'Country', countryName: string, id: string } | null, region: { __typename: 'Region', name: string | null, localName: string | null, licenseInfoUrl: string | null, id: string | null } | null } | null } | null> | null }, canal: { __typename: 'FishingWaterRecordConnection', totalCount: number, edges: Array<{ __typename: 'FishingWaterEdge', node: { __typename: 'FishingWater', catchesCount: number, displayName: string, descriptionOfWaterType: WaterTypes, latitude: number, longitude: number, _id: string, allReviews: { __typename: 'ReviewInterfaceRecordConnection', totalCount: number, totalAverage: number } | null, recentCatches: { __typename: 'CatchRecordConnection', edges: Array<{ __typename: 'CatchRecordEdge', node: { __typename: 'Catch', _id: string, post: { __typename: 'Post', _id: string, images: { __typename: 'ImageRecordConnection', edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null } } } | null } | null> | null }, country: { __typename: 'Country', countryName: string, id: string } | null, region: { __typename: 'Region', name: string | null, localName: string | null, licenseInfoUrl: string | null, id: string | null } | null } | null } | null> | null }, swamp: { __typename: 'FishingWaterRecordConnection', totalCount: number, edges: Array<{ __typename: 'FishingWaterEdge', node: { __typename: 'FishingWater', catchesCount: number, displayName: string, descriptionOfWaterType: WaterTypes, latitude: number, longitude: number, _id: string, allReviews: { __typename: 'ReviewInterfaceRecordConnection', totalCount: number, totalAverage: number } | null, recentCatches: { __typename: 'CatchRecordConnection', edges: Array<{ __typename: 'CatchRecordEdge', node: { __typename: 'Catch', _id: string, post: { __typename: 'Post', _id: string, images: { __typename: 'ImageRecordConnection', edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null } } } | null } | null> | null }, country: { __typename: 'Country', countryName: string, id: string } | null, region: { __typename: 'Region', name: string | null, localName: string | null, licenseInfoUrl: string | null, id: string | null } | null } | null } | null> | null }, estuary: { __typename: 'FishingWaterRecordConnection', totalCount: number, edges: Array<{ __typename: 'FishingWaterEdge', node: { __typename: 'FishingWater', catchesCount: number, displayName: string, descriptionOfWaterType: WaterTypes, latitude: number, longitude: number, _id: string, allReviews: { __typename: 'ReviewInterfaceRecordConnection', totalCount: number, totalAverage: number } | null, recentCatches: { __typename: 'CatchRecordConnection', edges: Array<{ __typename: 'CatchRecordEdge', node: { __typename: 'Catch', _id: string, post: { __typename: 'Post', _id: string, images: { __typename: 'ImageRecordConnection', edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null } } } | null } | null> | null }, country: { __typename: 'Country', countryName: string, id: string } | null, region: { __typename: 'Region', name: string | null, localName: string | null, licenseInfoUrl: string | null, id: string | null } | null } | null } | null> | null } } };

export type RegionWaterTypeWaters = { __typename: 'FishingWaterRecordConnection', totalCount: number, edges: Array<{ __typename: 'FishingWaterEdge', node: { __typename: 'FishingWater', catchesCount: number, displayName: string, descriptionOfWaterType: WaterTypes, latitude: number, longitude: number, _id: string, allReviews: { __typename: 'ReviewInterfaceRecordConnection', totalCount: number, totalAverage: number } | null, recentCatches: { __typename: 'CatchRecordConnection', edges: Array<{ __typename: 'CatchRecordEdge', node: { __typename: 'Catch', _id: string, post: { __typename: 'Post', _id: string, images: { __typename: 'ImageRecordConnection', edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null } } } | null } | null> | null }, country: { __typename: 'Country', countryName: string, id: string } | null, region: { __typename: 'Region', name: string | null, localName: string | null, licenseInfoUrl: string | null, id: string | null } | null } | null } | null> | null };

export type GetRegionCatchesVariables = Exact<{
  id: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  lastNDays?: InputMaybe<Scalars['Int']['input']>;
  speciesIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetRegionCatches = { __typename: 'Query', entry: { __typename: 'Region', id: string | null, catches: { __typename: 'CatchRecordConnection', edges: Array<{ __typename: 'CatchRecordEdge', node: { __typename: 'Catch', _id: string, post: { __typename: 'Post', createdAt: string | null, _id: string, catch: { __typename: 'Catch', caughtAtGmt: string | null, weight: number | null, length: number | null, _id: string, fishingWater: { __typename: 'FishingWater', displayName: string, latitude: number, longitude: number, _id: string } | null, species: { __typename: 'Species', displayName: string, _id: string } | null } | null, displayProductUnits: { __typename: 'ProductUnitRecordConnection', totalCount: number }, images: { __typename: 'ImageRecordConnection', totalCount: number, edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null }, user: { __typename: 'User', nickname: string, _id: string } } } | null } | null> | null } } };

export type GetRegionCatchesDetailedVariables = Exact<{
  id: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  lastNDays?: InputMaybe<Scalars['Int']['input']>;
  speciesIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetRegionCatchesDetailed = { __typename: 'Query', entry: { __typename: 'Region', id: string | null, catches: { __typename: 'CatchRecordConnection', edges: Array<{ __typename: 'CatchRecordEdge', node: { __typename: 'Catch', _id: string, post: { __typename: 'Post', textString: string | null, createdAt: string | null, _id: string, baitProductUnits: { __typename: 'ProductUnitRecordConnection', edges: Array<{ __typename: 'ProductUnitEdge', node: { __typename: 'ProductUnit', model: string, id: number, image: { __typename: 'Image', width: number, height: number, url: string } | null } | null } | null> | null }, catch: { __typename: 'Catch', caughtAtGmt: string | null, weight: number | null, length: number | null, _id: string, fishingWater: { __typename: 'FishingWater', displayName: string, latitude: number, longitude: number, _id: string } | null, species: { __typename: 'Species', displayName: string, _id: string } | null } | null, displayProductUnits: { __typename: 'ProductUnitRecordConnection', totalCount: number }, images: { __typename: 'ImageRecordConnection', totalCount: number, edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null }, user: { __typename: 'User', nickname: string, _id: string } } } | null } | null> | null } } };

export type GetRegionNameVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetRegionName = { __typename: 'Query', region: { __typename: 'Region', name: string | null, localName: string | null, id: string | null, country: { __typename: 'Country', countryName: string, id: string } } };

export type GetDirectorySpeciesVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDirectorySpecies = { __typename: 'Query', entry: { __typename: 'SpeciesRecordConnection', totalCount: number, edges: Array<{ __typename: 'SpeciesEdge', cursor: string, node: { __typename: 'Species', externalId: string, displayName: string } | null } | null> | null, pageInfo: { __typename: 'PageInfo', endCursor: string | null, hasNextPage: boolean } } };

export type GetSingleSpeciesMetadataVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetSingleSpeciesMetadata = { __typename: 'Query', entry: { __typename: 'Species', displayName: string, _id: string, exampleCatchWithImage: { __typename: 'Catch', caughtAtGmt: string | null, species: { __typename: 'Species', displayName: string, _id: string } | null, post: { __typename: 'Post', _id: string, images: { __typename: 'ImageRecordConnection', totalCount: number, edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null } } } | null } };

export type GetSingleSpeciesVariables = Exact<{
  id: Scalars['String']['input'];
  recentCatchLimitDays?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetSingleSpecies = { __typename: 'Query', entry: { __typename: 'Species', followedByCurrentUser: boolean, latinName: string, displayName: string, description: string | null, maxLength: number, maxWeight: number, iucnStatus: string | null, threatToHumans: Array<string> | null, waterTypes: Array<string>, minCommonDepth: number | null, maxCommonDepth: number | null, legacyId: number, _id: string, catches: { __typename: 'CatchRecordConnection', totalCount: number }, newCatchCount: { __typename: 'CatchRecordConnection', totalCount: number }, exampleCatchWithImage: { __typename: 'Catch', caughtAtGmt: string | null, createdAt: string | null, _id: string, legacyId: number, species: { __typename: 'Species', displayName: string, _id: string } | null, post: { __typename: 'Post', createdAt: string | null, likedByCurrentUser: boolean, likesCount: number, _id: string, displayProductUnits: { __typename: 'ProductUnitRecordConnection', totalCount: number }, catch: { __typename: 'Catch', _id: string, fishingWater: { __typename: 'FishingWater', displayName: string, latitude: number, longitude: number, _id: string } | null, species: { __typename: 'Species', displayName: string, _id: string } | null } | null, comments: { __typename: 'PostCommentConnection', totalCount: number }, images: { __typename: 'ImageRecordConnection', totalCount: number, edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null }, webPImages: { __typename: 'ImageRecordConnection', edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null }, text: { __typename: 'Text', text: string | null }, user: { __typename: 'User', nickname: string, isPremium: boolean | null, createdAt: string, _id: string, avatar: { __typename: 'Image', height: number, width: number, url: string } | null }, productUnits: { __typename: 'ProductUnitRecordConnection', edges: Array<{ __typename: 'ProductUnitEdge', node: { __typename: 'ProductUnit', model: string, id: number, image: { __typename: 'Image', width: number, height: number, url: string } | null, product: { __typename: 'Product', displayName: string, _id: string, legacyId: number, brand: { __typename: 'Brand', name: string, id: number } } } | null } | null> | null }, video: { __typename: 'Video', hlsUrl: string | null, webUrl: string | null, originalUrl: string, id: number, screenshot: { __typename: 'Image', width: number, height: number, url: string } } | null } } | null, catchesWithImages: { __typename: 'CatchRecordConnection', edges: Array<{ __typename: 'CatchRecordEdge', node: { __typename: 'Catch', _id: string, post: { __typename: 'Post', createdAt: string | null, _id: string, catch: { __typename: 'Catch', caughtAtGmt: string | null, weight: number | null, length: number | null, _id: string, fishingWater: { __typename: 'FishingWater', displayName: string, latitude: number, longitude: number, _id: string } | null, species: { __typename: 'Species', displayName: string, _id: string } | null } | null, displayProductUnits: { __typename: 'ProductUnitRecordConnection', totalCount: number }, images: { __typename: 'ImageRecordConnection', totalCount: number, edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null }, user: { __typename: 'User', nickname: string, _id: string } } } | null } | null> | null }, followers: { __typename: 'UserFollowersConnection', totalCount: number }, speciesTips: { __typename: 'SpeciesTipRecordConnection', edges: Array<{ __typename: 'SpeciesTipEdge', node: { __typename: 'SpeciesTip', externalId: string, tip: string, userDescription: string | null, userDisplayName: string, user: { __typename: 'User', _id: string, avatar: { __typename: 'Image', height: number, width: number, url: string } | null } } | null } | null> | null } } };

export type GetSpeciesTopBaitsVariables = Exact<{
  speciesId?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
}>;


export type GetSpeciesTopBaits = { __typename: 'Query', topProductUnits: { __typename: 'topEquipmentProductUnitConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename: 'topEquipmentProductUnitEdge', node: { __typename: 'topEquipmentProductUnit', numberOfCatches: number, position: number, productUnit: { __typename: 'ProductUnit', id: number, image: { __typename: 'Image', width: number, height: number, url: string } | null, attributeValues: { __typename: 'UnitAttributeValueRecordConnection', edges: Array<{ __typename: 'UnitAttributeValueEdge', node: { __typename: 'UnitAttributeValue', value: { __typename: 'AttributeValue', name: string } | null } | null } | null> | null }, product: { __typename: 'Product', displayName: string, _id: string, legacyId: number, category: { __typename: 'Category', title: string }, brand: { __typename: 'Brand', name: string, id: number } } } } | null } | null> | null } | null };

export type GetSpeciesTopWatersVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  boundingBox?: InputMaybe<BoundingBoxInputObject>;
  speciesIDs?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetSpeciesTopWaters = { __typename: 'Query', entry: { __typename: 'FishingWaterRecordConnection', edges: Array<{ __typename: 'FishingWaterEdge', node: { __typename: 'FishingWater', catchesCount: number, displayName: string, latitude: number, longitude: number, _id: string, allReviews: { __typename: 'ReviewInterfaceRecordConnection', totalCount: number, totalAverage: number } | null, recentCatches: { __typename: 'CatchRecordConnection', edges: Array<{ __typename: 'CatchRecordEdge', node: { __typename: 'Catch', _id: string, post: { __typename: 'Post', _id: string, images: { __typename: 'ImageRecordConnection', totalCount: number, edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null } } } | null } | null> | null }, country: { __typename: 'Country', countryName: string, id: string } | null, region: { __typename: 'Region', name: string | null, localName: string | null, licenseInfoUrl: string | null, id: string | null } | null } | null } | null> | null } };

export type GetTopSpeciesNearLocationVariables = Exact<{
  boundingBox?: InputMaybe<BoundingBoxInputObject>;
  boundingCircle?: InputMaybe<BoundingCircleInputObject>;
  excludingSpeciesIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetTopSpeciesNearLocation = { __typename: 'Query', topSpeciesNearLocation: { __typename: 'TopSpeciesConnection', totalCount: number, pageInfo: { __typename: 'PageInfo', startCursor: string | null, hasNextPage: boolean, endCursor: string | null }, edges: Array<{ __typename: 'TopSpeciesSummaryEdge', catchesCount: number, node: { __typename: 'Species', externalId: string, displayName: string, legacyId: number, _id: string, image: { __typename: 'Image', width: number, height: number, url: string }, exampleCatchWithImage: { __typename: 'Catch', _id: string, post: { __typename: 'Post', _id: string, images: { __typename: 'ImageRecordConnection', edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', id: number | null, width: number, height: number, url: string } | null } | null> | null }, webPImages: { __typename: 'ImageRecordConnection', edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', id: number | null, width: number, height: number, url: string } | null } | null> | null } } } | null } | null } | null> | null } };

export type GetSingleSpeciesNameVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetSingleSpeciesName = { __typename: 'Query', species: { __typename: 'Species', displayName: string, _id: string } };

export type GetSpeciesImagesVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetSpeciesImages = { __typename: 'Query', species: { __typename: 'SpeciesRecordConnection', edges: Array<{ __typename: 'SpeciesEdge', node: { __typename: 'Species', imageCopyrightStatus: string | null, imageCopyrightExpiryDate: string | null, _id: string, image: { __typename: 'Image', url: string }, webPImage: { __typename: 'Image', url: string } } | null } | null> | null } };

export type GetSpeciesFromListVariables = Exact<{
  externalIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetSpeciesFromList = { __typename: 'Query', species: { __typename: 'SpeciesRecordConnection', edges: Array<{ __typename: 'SpeciesEdge', node: { __typename: 'Species', externalId: string, displayName: string, _id: string, catches: { __typename: 'CatchRecordConnection', totalCount: number }, image: { __typename: 'Image', width: number, height: number, url: string }, exampleCatchWithImage: { __typename: 'Catch', _id: string, post: { __typename: 'Post', _id: string, images: { __typename: 'ImageRecordConnection', edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', id: number | null, width: number, height: number, url: string } | null } | null> | null }, webPImages: { __typename: 'ImageRecordConnection', edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', id: number | null, width: number, height: number, url: string } | null } | null> | null } } } | null } | null } | null> | null } };

export type GetRegionalSpeciesFromListVariables = Exact<{
  first: Scalars['Int']['input'];
  externalIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetRegionalSpeciesFromList = { __typename: 'Query', species: { __typename: 'SpeciesRecordConnection', edges: Array<{ __typename: 'SpeciesEdge', node: { __typename: 'Species', externalId: string, displayName: string, fishrulesIds: Array<string> | null, _id: string, image: { __typename: 'Image', width: number, height: number, url: string }, areaSpecies: { __typename: 'AreaSpecies', recordLengthInM: number | null, recordWeightInKg: number | null } | null, speciesGroupings: { __typename: 'SpeciesGroupingRecordConnection', edges: Array<{ __typename: 'SpeciesGroupingEdge', node: { __typename: 'SpeciesGrouping', externalId: string, name: string } | null } | null> | null } } | null } | null> | null } };

export type GetBasicSpeciesInfoFromListVariables = Exact<{
  externalIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetBasicSpeciesInfoFromList = { __typename: 'Query', species: { __typename: 'SpeciesRecordConnection', edges: Array<{ __typename: 'SpeciesEdge', node: { __typename: 'Species', externalId: string, displayName: string, _id: string, image: { __typename: 'Image', width: number, height: number, url: string } } | null } | null> | null } };

export type GetSpeciesInSeasonNamesVariables = Exact<{
  externalIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetSpeciesInSeasonNames = { __typename: 'Query', species: { __typename: 'SpeciesRecordConnection', edges: Array<{ __typename: 'SpeciesEdge', node: { __typename: 'Species', displayName: string, _id: string } | null } | null> | null } };

export type GetWatersBySpeciesVariables = Exact<{
  boundingBox?: InputMaybe<BoundingBoxInputObject>;
  speciesIDs?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetWatersBySpecies = { __typename: 'Query', entry: { __typename: 'FishingWaterRecordConnection', totalCount: number } };

export type GetSpeciesGroupingVariables = Exact<{
  externalId: Scalars['String']['input'];
}>;


export type GetSpeciesGrouping = { __typename: 'Query', speciesGrouping: { __typename: 'SpeciesGrouping', externalId: string, name: string } };

export type GetSpeciesByGroupAndRegionVariables = Exact<{
  regionId: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  orderedByPopularity?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetSpeciesByGroupAndRegion = { __typename: 'Query', species: { __typename: 'SpeciesRecordConnection', edges: Array<{ __typename: 'SpeciesEdge', node: { __typename: 'Species', fishrulesIds: Array<string> | null, externalId: string, displayName: string, _id: string, catches: { __typename: 'CatchRecordConnection', totalCount: number }, image: { __typename: 'Image', width: number, height: number, url: string } } | null } | null> | null } };

export type GetSpeciesByGroupAndCountryVariables = Exact<{
  countryId: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  orderedByPopularity?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetSpeciesByGroupAndCountry = { __typename: 'Query', species: { __typename: 'SpeciesRecordConnection', edges: Array<{ __typename: 'SpeciesEdge', node: { __typename: 'Species', externalId: string, displayName: string, _id: string, catches: { __typename: 'CatchRecordConnection', totalCount: number }, image: { __typename: 'Image', width: number, height: number, url: string } } | null } | null> | null } };

export type GetMostActiveWatersVariables = Exact<{ [key: string]: never; }>;


export type GetMostActiveWaters = { __typename: 'Query', statistics: { __typename: 'Statistics', mostActiveWatersLastWeek: Array<{ __typename: 'FishingWater', latitude: number, longitude: number, displayName: string, catchesCount: number, _id: string, reviews: { __typename: 'ReviewInterfaceRecordConnection', totalCount: number, totalAverage: number } | null, country: { __typename: 'Country', countryName: string, id: string } | null, region: { __typename: 'Region', name: string | null, localName: string | null, id: string | null } | null }>, mostActiveWaters: Array<{ __typename: 'FishingWater', latitude: number, longitude: number, displayName: string, catchesCount: number, _id: string, reviews: { __typename: 'ReviewInterfaceRecordConnection', totalCount: number, totalAverage: number } | null, country: { __typename: 'Country', countryName: string, id: string } | null, region: { __typename: 'Region', name: string | null, localName: string | null, id: string | null } | null }> } };

export type GetTagVariables = Exact<{
  label: Scalars['String']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetTag = { __typename: 'Query', entry: { __typename: 'Tag', id: string, posts: { __typename: 'PostRecordConnection', totalCount: number, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: string | null }, edges: Array<{ __typename: 'PostEdge', node: { __typename: 'Post', createdAt: string | null, likedByCurrentUser: boolean, likesCount: number, _id: string, comments: { __typename: 'PostCommentConnection', totalCount: number }, catch: { __typename: 'Catch', _id: string, fishingWater: { __typename: 'FishingWater', displayName: string, latitude: number, longitude: number, _id: string } | null, species: { __typename: 'Species', displayName: string, _id: string } | null } | null, displayProductUnits: { __typename: 'ProductUnitRecordConnection', totalCount: number }, images: { __typename: 'ImageRecordConnection', totalCount: number, edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null }, text: { __typename: 'Text', text: string | null }, user: { __typename: 'User', nickname: string, _id: string, avatar: { __typename: 'Image', height: number, width: number, url: string } | null }, productUnits: { __typename: 'ProductUnitRecordConnection', edges: Array<{ __typename: 'ProductUnitEdge', node: { __typename: 'ProductUnit', model: string, id: number, image: { __typename: 'Image', width: number, height: number, url: string } | null, product: { __typename: 'Product', displayName: string, _id: string, legacyId: number, brand: { __typename: 'Brand', name: string, id: number } } } | null } | null> | null }, video: { __typename: 'Video', hlsUrl: string | null, webUrl: string | null, originalUrl: string, id: number, screenshot: { __typename: 'Image', width: number, height: number, url: string } } | null } | null } | null> | null } } | null };

export type GetTripVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetTrip = { __typename: 'Query', trip: { __typename: 'Trip', id: string, startedAt: string, endedAt: string, createdAt: string, post: { __typename: 'Post', likedByCurrentUser: boolean, likesCount: number, _id: string, text: { __typename: 'Text', text: string | null }, comments: { __typename: 'PostCommentConnection', totalCount: number, edges: Array<{ __typename: 'CommentEdge', node: { __typename: 'Post', createdAt: string | null, titleString: string | null, _id: string, user: { __typename: 'User', isPremium: boolean | null, nickname: string, _id: string, avatar: { __typename: 'Image', height: number, width: number, url: string } | null }, text: { __typename: 'Text', text: string | null } } | null } | null> | null } }, user: { __typename: 'User', isPremium: boolean | null, nickname: string, firstName: string | null, lastName: string | null, createdAt: string, _id: string, catches: { __typename: 'CatchRecordConnection', totalCount: number, edges: Array<{ __typename: 'CatchRecordEdge', node: { __typename: 'Catch', _id: string, post: { __typename: 'Post', createdAt: string | null, likedByCurrentUser: boolean, likesCount: number, _id: string, catch: { __typename: 'Catch', caughtAtGmt: string | null, weight: number | null, length: number | null, _id: string, fishingWater: { __typename: 'FishingWater', displayName: string, latitude: number, longitude: number, _id: string } | null, species: { __typename: 'Species', displayName: string, _id: string } | null } | null, comments: { __typename: 'PostCommentConnection', totalCount: number }, displayProductUnits: { __typename: 'ProductUnitRecordConnection', totalCount: number }, images: { __typename: 'ImageRecordConnection', totalCount: number, edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null }, text: { __typename: 'Text', text: string | null }, user: { __typename: 'User', nickname: string, _id: string, avatar: { __typename: 'Image', height: number, width: number, url: string } | null }, displayEntity: { __typename: 'CurrentUser', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'FishingMethod', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'FishingWater', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Group', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Page', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Species', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'SpeciesWithBiteForecast', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'User', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } }, productUnits: { __typename: 'ProductUnitRecordConnection', edges: Array<{ __typename: 'ProductUnitEdge', node: { __typename: 'ProductUnit', model: string, id: number, image: { __typename: 'Image', width: number, height: number, url: string } | null, product: { __typename: 'Product', displayName: string, _id: string, legacyId: number, brand: { __typename: 'Brand', name: string, id: number } } } | null } | null> | null }, video: { __typename: 'Video', hlsUrl: string | null, webUrl: string | null, originalUrl: string, id: number, screenshot: { __typename: 'Image', width: number, height: number, url: string } } | null } } | null } | null> | null }, avatar: { __typename: 'Image', height: number, width: number, url: string } | null }, catches: { __typename: 'CatchRecordConnection', totalCount: number, edges: Array<{ __typename: 'CatchRecordEdge', node: { __typename: 'Catch', _id: string, post: { __typename: 'Post', createdAt: string | null, likedByCurrentUser: boolean, likesCount: number, _id: string, catch: { __typename: 'Catch', caughtAtGmt: string | null, weight: number | null, length: number | null, _id: string, fishingWater: { __typename: 'FishingWater', displayName: string, latitude: number, longitude: number, _id: string } | null, species: { __typename: 'Species', displayName: string, _id: string } | null } | null, comments: { __typename: 'PostCommentConnection', totalCount: number }, displayProductUnits: { __typename: 'ProductUnitRecordConnection', totalCount: number }, images: { __typename: 'ImageRecordConnection', totalCount: number, edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null }, text: { __typename: 'Text', text: string | null }, user: { __typename: 'User', nickname: string, _id: string, avatar: { __typename: 'Image', height: number, width: number, url: string } | null }, displayEntity: { __typename: 'CurrentUser', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'FishingMethod', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'FishingWater', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Group', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Page', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Species', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'SpeciesWithBiteForecast', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'User', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } }, productUnits: { __typename: 'ProductUnitRecordConnection', edges: Array<{ __typename: 'ProductUnitEdge', node: { __typename: 'ProductUnit', model: string, id: number, image: { __typename: 'Image', width: number, height: number, url: string } | null, product: { __typename: 'Product', displayName: string, _id: string, legacyId: number, brand: { __typename: 'Brand', name: string, id: number } } } | null } | null> | null }, video: { __typename: 'Video', hlsUrl: string | null, webUrl: string | null, originalUrl: string, id: number, screenshot: { __typename: 'Image', width: number, height: number, url: string } } | null } } | null } | null> | null }, publicCatches: { __typename: 'CatchRecordConnection', totalCount: number } } };

export type GetTripMapImagesVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetTripMapImages = { __typename: 'Query', trip: { __typename: 'Trip', id: string, mobileImage: { __typename: 'CatchesMapImage', height: number, width: number, url: string } | null, desktopImage: { __typename: 'CatchesMapImage', height: number, width: number, url: string } | null } };

export type GetProfileMetadataVariables = Exact<{
  nickname: Scalars['String']['input'];
}>;


export type GetProfileMetadata = { __typename: 'Query', user: { __typename: 'User', firstName: string | null, lastName: string | null, _id: string, avatar: { __typename: 'Image', height: number, width: number, url: string } | null, catches: { __typename: 'CatchRecordConnection', totalCount: number } } };

export type GetProfileVariables = Exact<{
  nickname: Scalars['String']['input'];
}>;


export type GetProfile = { __typename: 'Query', user: { __typename: 'User', nickname: string, firstName: string | null, lastName: string | null, isPremium: boolean | null, biography: string | null, countryCode: string, legacyId: number, _id: string, avatar: { __typename: 'Image', height: number, width: number, url: string } | null, coverImage: { __typename: 'Image', width: number, height: number, url: string } | null, catches: { __typename: 'CatchRecordConnection', totalCount: number } } };

export type GetProfileByExternalIdVariables = Exact<{
  externalId: Scalars['String']['input'];
}>;


export type GetProfileByExternalId = { __typename: 'Query', user: { __typename: 'User', nickname: string, firstName: string | null, lastName: string | null, isPremium: boolean | null, biography: string | null, countryCode: string, legacyId: number, _id: string, avatar: { __typename: 'Image', height: number, width: number, url: string } | null, coverImage: { __typename: 'Image', width: number, height: number, url: string } | null, catches: { __typename: 'CatchRecordConnection', totalCount: number } } };

export type GetUserIsFollowedVariables = Exact<{
  nickname: Scalars['String']['input'];
}>;


export type GetUserIsFollowed = { __typename: 'Query', user: { __typename: 'User', followedByCurrentUser: boolean, _id: string } };

export type GetUsersCatchesVariables = Exact<{
  nickname: Scalars['String']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetUsersCatches = { __typename: 'Query', user: { __typename: 'User', _id: string, catches: { __typename: 'CatchRecordConnection', totalCount: number, pageInfo: { __typename: 'PageInfo', startCursor: string | null, hasNextPage: boolean, endCursor: string | null }, edges: Array<{ __typename: 'CatchRecordEdge', node: { __typename: 'Catch', _id: string, post: { __typename: 'Post', createdAt: string | null, likedByCurrentUser: boolean, likesCount: number, _id: string, catch: { __typename: 'Catch', caughtAtGmt: string | null, weight: number | null, length: number | null, _id: string, fishingWater: { __typename: 'FishingWater', displayName: string, latitude: number, longitude: number, _id: string } | null, species: { __typename: 'Species', displayName: string, _id: string } | null } | null, comments: { __typename: 'PostCommentConnection', totalCount: number }, displayProductUnits: { __typename: 'ProductUnitRecordConnection', totalCount: number }, images: { __typename: 'ImageRecordConnection', totalCount: number, edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null }, text: { __typename: 'Text', text: string | null }, user: { __typename: 'User', nickname: string, _id: string, avatar: { __typename: 'Image', height: number, width: number, url: string } | null }, displayEntity: { __typename: 'CurrentUser', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'FishingMethod', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'FishingWater', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Group', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Page', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Species', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'SpeciesWithBiteForecast', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'User', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } }, productUnits: { __typename: 'ProductUnitRecordConnection', edges: Array<{ __typename: 'ProductUnitEdge', node: { __typename: 'ProductUnit', model: string, id: number, image: { __typename: 'Image', width: number, height: number, url: string } | null, product: { __typename: 'Product', displayName: string, _id: string, legacyId: number, brand: { __typename: 'Brand', name: string, id: number } } } | null } | null> | null }, video: { __typename: 'Video', hlsUrl: string | null, webUrl: string | null, originalUrl: string, id: number, screenshot: { __typename: 'Image', width: number, height: number, url: string } } | null } } | null } | null> | null } } };

export type GetUsersPostsVariables = Exact<{
  nickname: Scalars['String']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUsersPosts = { __typename: 'Query', user: { __typename: 'User', _id: string, posts: { __typename: 'PostRecordConnection', pageInfo: { __typename: 'PageInfo', startCursor: string | null, hasNextPage: boolean, endCursor: string | null }, edges: Array<{ __typename: 'PostEdge', node: { __typename: 'Post', sharingPost: boolean, likedByCurrentUser: boolean, likesCount: number, createdAt: string | null, publishedAt: string | null, _id: string, legacyId: number, displayProductUnits: { __typename: 'ProductUnitRecordConnection', totalCount: number }, images: { __typename: 'ImageRecordConnection', totalCount: number, edges: Array<{ __typename: 'ImageEdge', node: { __typename: 'Image', width: number, height: number, url: string } | null } | null> | null }, comments: { __typename: 'PostCommentConnection', totalCount: number }, likers: { __typename: 'PostsFeedDisplayEntityRecordConnection', totalCount: number }, user: { __typename: 'User', isPremium: boolean | null, firstName: string | null, lastName: string | null, createdAt: string, nickname: string, _id: string, avatar: { __typename: 'Image', height: number, width: number, url: string } | null }, trip: { __typename: 'Trip', id: string, createdAt: string, startedAt: string, endedAt: string, catches: { __typename: 'CatchRecordConnection', totalCount: number } } | null, catch: { __typename: 'Catch', isPersonalBest: boolean, weight: number | null, length: number | null, catchAndRelease: boolean | null, caughtAtLocalTimeZone: string | null, caughtAtGmt: string | null, hasExactPosition: boolean, locationPrivacy: CatchLocationPrivacyTypes, createdAt: string | null, _id: string, legacyId: number, species: { __typename: 'Species', displayName: string, legacyId: number, _id: string } | null, trip: { __typename: 'Trip', id: string, catches: { __typename: 'CatchRecordConnection', totalCount: number } } | null, fishingMethod: { __typename: 'FishingMethod', displayName: string, _id: string } | null, fishingWater: { __typename: 'FishingWater', displayName: string, latitude: number, longitude: number, _id: string } | null, productUnits: { __typename: 'ProductUnitRecordConnection', edges: Array<{ __typename: 'ProductUnitEdge', node: { __typename: 'ProductUnit', model: string, id: number, image: { __typename: 'Image', width: number, height: number, url: string } | null, product: { __typename: 'Product', displayName: string, _id: string, legacyId: number, brand: { __typename: 'Brand', name: string, id: number } } } | null } | null> | null } } | null, text: { __typename: 'Text', text: string | null }, productUnits: { __typename: 'ProductUnitRecordConnection', edges: Array<{ __typename: 'ProductUnitEdge', node: { __typename: 'ProductUnit', model: string, id: number, image: { __typename: 'Image', width: number, height: number, url: string } | null, product: { __typename: 'Product', displayName: string, _id: string, legacyId: number, brand: { __typename: 'Brand', name: string, id: number } } } | null } | null> | null }, displayEntity: { __typename: 'CurrentUser', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'FishingMethod', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'FishingWater', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Group', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Page', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'Species', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'SpeciesWithBiteForecast', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } } | { __typename: 'User', displayName: string, _id: string, legacyId: number, displayIcon: { __typename: 'Image', width: number, height: number, url: string } }, fishingWater: { __typename: 'FishingWater', displayName: string, _id: string } | null, video: { __typename: 'Video', hlsUrl: string | null, webUrl: string | null, originalUrl: string, id: number, screenshot: { __typename: 'Image', width: number, height: number, url: string } } | null } | null } | null> | null } } };

export type GetNicknameVariables = Exact<{
  externalId: Scalars['String']['input'];
}>;


export type GetNickname = { __typename: 'Query', user: { __typename: 'User', nickname: string, _id: string } };

export type GetNicknameByIdVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetNicknameById = { __typename: 'Query', user: { __typename: 'User', nickname: string, _id: string } };

export type GetWaypointVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetWaypoint = { __typename: 'Query', waypoint: { __typename: 'Waypoint', lat: number, lng: number, name: string, description: string | null, symbol: string, _id: string, image: { __typename: 'Image', width: number, height: number, url: string } | null, user: { __typename: 'User', nickname: string, _id: string, avatar: { __typename: 'Image', height: number, width: number, url: string } | null } } };
